import React, { useEffect, useLayoutEffect, useRef, useState, useMemo, useCallback } from 'react';
import { createPortal, flushSync } from 'react-dom';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import '../../styles/HomePage.css';
import '../../styles/LoginPopup.css';
import DatingChatBot from '../DatingChatBot';
import PartnerSelectionChat from '../PartnerSelectionChat';
import PartnerGenerationChat from '../PartnerGenerationChat';
import InlineSurvey from '../InlineSurvey';
import PersonalityChart from '../PersonalityChart';
import { AGE_WHEEL_DEFAULT } from '../AgeWheel';
import Inbox from '../messaging/Inbox';
import UserMenuCollagesSection from '../userMenu/UserMenuCollagesSection';
import CouponRedeemModal from '../userMenu/CouponRedeemModal';
import CollageFriendModal from '../userMenu/CollageFriendModal';
import FoxChat from './FoxChat';
import PostedSponsoredDateIdeasCarousel from './PostedSponsoredDateIdeasCarousel';
import HeroMatrixAura from './HeroMatrixAura';
import VibeAuraVadSpace from './VibeAuraVadSpace';
import VisualVibeTransformerExplainer from './VisualVibeTransformerExplainer';
import PaidForDateExplainer from './PaidForDateExplainer';
import { DEFAULT_FOX_CHAT_COPY, FOX_OPS_CHAT_COPY } from './foxChatConfig';
import { FeedNicknameTile } from '../feed/FeedNicknameTile';
import { ReusedFeedImg } from '../feed/ReusedFeedImg';
import { CollageDetailsLuvLegend, lookingForGendersForFeedAd } from '../feed/CollageDetailsLuvLegend';
import { pinFeedImageUrl, registerFeedImage } from '../../utils/feedImageCache';
import {
  getTotalUnreadCount,
  getOrCreateConversation,
  sendMessage,
  DAILY_VIBE_SHARE_INVITE_TEXT,
} from '../../services/messagingService';
import {
  getDailyVibePeriodKey,
  hasDailyVibeCheckForPeriod,
  loadDailyVibeCheckForPeriod,
  reconcileVibeCheckStreakFromDailyChecks,
  syncVibeCheckStreakOnLogin,
  createDailyVibeShareInvite,
} from '../../utils/dailyVibeFirestore';
import { resolveAuraRgb } from '../../utils/auraColor';
import { ensureBrowserDisplayablePhotoFile, isLikelyPhotoFile } from '../../utils/ensureBrowserDisplayablePhotoFile';
import { countCollageTileChanges, hasCollageTileChanges } from '../../utils/collageTileChanges';
import { db, auth, storage } from '../../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { signInAnonymously, signOut } from 'firebase/auth';
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  collection,
  query,
  getDocs,
  limit,
  addDoc,
  increment,
  arrayUnion,
  serverTimestamp,
  orderBy,
  where,
  runTransaction,
} from 'firebase/firestore';
import { nanoid } from 'nanoid';
import { getRandomActivity, getTwoRandomActivities } from '../../data/activities';
import { activityEmojis } from '../../data/activityEmojis';
import { searchActivityPlusEmojisByQuery } from '../../utils/activityEmojiKeywordSearch';
import { allPlaces, getVariedPlacesSample, getRandomHeroSamplePlaces } from '../../data/placesSamples';
import {
  generatePartnerImagesReplicate,
  analyzeImageReplicate,
  analyzeExImageReplicate,
  editPartnerCutoutNanoBanana,
  generateBrandImageNanoBanana,
  searchSpiritGifs,
  searchBrandImages,
  searchPlaces,
  applyUserPhotoFoxMask,
  ensureMyAuraColor,
  driftMyAuraColor,
  sendDailyVibeEmailInviteApi,
} from '../../services/firebaseApiService';
import { getRandomWord } from '../../data/wordLibrary';
import { parseNicknameFromAnalysis, getRandomDominantPersonality } from '../../utils/jungianPrompt';
import { getPrimaryCollagePosterNickname } from '../../utils/mainCollageNickname';
import { getPrimarySavedPoster } from '../../utils/primaryCollage';
import { feedAdFindLuvIconFlags, posterFindLuvIconFlags } from '../../utils/posterFindLuv';
import { normalizeSavedPostersList } from '../../utils/savedPosterNormalize';
import {
  applyFoxMaskToSavedPoster,
  posterNeedsFoxMask,
  unmaskedUrlFromPoster,
} from '../../utils/applyFoxMaskToSavedPoster';
import {
  syncUserPublicPrimaryFromUserDocument,
  mergeFeedDetailAdWithSharedPosterDemographics,
} from '../../utils/userPublicPrimarySync';
import { rewardTilePersistenceKey } from '../../utils/rewardTilePersistence';
import {
  persistImageUrlToStorage as persistImageUrlToStorageUtil,
  persistHttpsImageToStorage,
  persistCollageImageBundle as persistCollageImageBundleUtil,
  buildPosterDoc,
  sanitizeForFirestore as sanitizePosterDocForFirestore,
} from '../../utils/collagePersistence';
import { REWARD_TILE_LIMIT_MESSAGE, rewardTileCountAtOrOverLimit } from '../../utils/rewardTileLimits';
import {
  recordDinnerGiveawayOptIn,
  deleteDinnerGiveawayOptInsForPoster,
  deleteDinnerGiveawayOptInsForPosters,
  normalizeGiveawayToPrimaryOnly,
  applyPrimarySwitchGiveaway,
} from '../../utils/dinnerGiveawayOptIn';
import {
  fetchBerkeleyFeaturedFeedAds,
  fetchSfFeaturedFeedAds,
  fetchSfNorthBeachFeaturedFeedAds,
  fetchSfSomaFeaturedFeedAds,
  fetchSfDowntownFeaturedFeedAds,
  attachAuraColorFromPublicPrimary,
  matchFriendPromptBountyDollars,
} from '../../utils/dinnerGiveawayFeed';
import { fetchPostedSponsoredDateIdeas } from '../../utils/sponsoredDateIdeasFeed';
import { registerCollageForFriendPoster, appendCollageForFriendContact } from '../../utils/collageForFriendFirestore';
import { seedFromString } from '../../utils/seedFromString';
import { isEduEmail, referFriendEmailValidationError } from '../../utils/berkeleyEmailAccess';
import {
  firestoreTimestampToMs,
  submitEduEmailForVerification,
} from '../../utils/eduEmailVerification';
import { useEduVerifyResendCooldown } from '../../hooks/useEduVerifyResendCooldown';
import PendingEduEmailField from '../auth/PendingEduEmailField';
import { buildPosterShareUrl } from '../../utils/posterReferralLink';
import { buildWeeklyFeaturedSlotUrl } from '../../utils/weeklyFeaturedSlots';
import { getRandomSampleCutout, getSelfGenderForSampleCutoutUrl, sampleCutouts } from '../../data/sampleCutouts';
import { getRandomBrandSamples, allBrands, getVariedBrandSample, getRandomHeroSampleSwags, warmInitialBrandSample } from '../../data/brandSamples';
import { SAMPLE_NICKNAMES } from '../../data/sampleNicknames';
import { lookupCouponReward, normalizeCouponCode } from '../../data/couponRewards';
import { getShuffledHelloGifsAll, getRandomMoodLocalGifs } from '../../data/localGifLibraries';
import heartOutline from '../../heart-outline.svg';
import forCutout from '../../for-cutout.webp';
import skilledatImage from '../../skills.webp';
import wantedCutoutImage from '../../WANTED-cutout.webp';
import posterpaperImage from '../../posterpaper.jpg';
import newspaperBg from '../../newspaperbg.webp';
import pressfoxImage from '../../pressfox.webp';
import makerealImage from '../../makereal.webp';
import runningImage from '../../running.webp';
import coffeeImage from '../../coffee.webp';
import eatingImage from '../../eating.webp';
import hikingImage from '../../hiking.webp';
import orheartImage from '../../orheart.webp';
import friendsImage from '../../friends.webp';
import logomaskImage from '../../logomask.png';
import theFoxMini from '../../TheFoxMini.png';
import calIcon from '../../cal.png';
import dollarIcon from '../../dollar.webp';
import voguImage from '../../vogu.webp';
import forbsImage from '../../forbs.webp';
import vanitImage from '../../vanit.webp';
import scissorsImage from '../../scissors.webp';
import klipyLogo from '../../KLIPYlogo.svg';
import spongebobGif from '../../Spongebob Squarepants Love GIF.gif';
import tiarasTwerkGif from '../../toddlers and tiaras twerk GIF.gif';
import bearloveGif from '../../bearlove.gif';
import sanFranciscoArtGif from '../../gifs/san francisco art GIF.gif';
import season3MoneyGif from '../../gifs/Season 3 Money GIF.gif';
import foxGifImage from '../../fox-gif.png';
import foxUnmaskImage from '../../fox-takeoff.png';
import foxDateImage from '../../fox-date.png';
import foxMaskFallback from '../../foxmask.png';
import FriendFoxMaskPlaceholderCutout from '../collage/FriendFoxMaskPlaceholderCutout';
import PartnerCutoutSpiritOverlay, {
  spiritOverlaySourcesFromAd,
} from '../collage/PartnerCutoutSpiritOverlay';
import { DEFAULT_USER_SPIN_BALANCE } from '../SpinWheel';
import { showFriendFoxMaskPlaceholder } from '../../utils/friendCollageCutoutPlaceholder';
import tapeImage from '../../tape.webp';

const HEART_GIFS = [tiarasTwerkGif, spongebobGif, bearloveGif, sanFranciscoArtGif, season3MoneyGif];

/** Warm browser cache + decode so hero sample <img> swaps don't flash the previous tile. */
function preloadImage(url) {
  return new Promise((resolve) => {
    if (!url || typeof url !== 'string') {
      resolve();
      return;
    }
    const img = new Image();
    img.decoding = 'async';
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      if (typeof img.decode === 'function') {
        img.decode().then(() => resolve()).catch(() => resolve());
      } else {
        resolve();
      }
    };
    img.onload = finish;
    img.onerror = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    img.src = url;
    if (img.complete) finish();
  });
}

const REACH_OUT_KLIPY_PAGE = 40;

function reachOutGifDedupeKey(g) {
  const u = (g && (g.fullUrl || g.gifUrl)) || '';
  return String(u).trim();
}

function mergeReachOutLocalThenKlipy(localGifs, remoteGifs) {
  const seen = new Set();
  const out = [];
  const push = (item) => {
    const k = reachOutGifDedupeKey(item);
    if (!k || seen.has(k)) return;
    seen.add(k);
    out.push(item);
  };
  (localGifs || []).forEach(push);
  (remoteGifs || []).forEach(push);
  return out;
}

function mergeReachOutKlipyThenLocal(remoteGifs, localGifs) {
  const seen = new Set();
  const out = [];
  const push = (item) => {
    const k = reachOutGifDedupeKey(item);
    if (!k || seen.has(k)) return;
    seen.add(k);
    out.push(item);
  };
  (remoteGifs || []).forEach(push);
  (localGifs || []).forEach(push);
  return out;
}

function renderPrimaryCollageLuvIcons(showFriend, showRomantic, variantClass = '') {
  if (!showFriend && !showRomantic) return null;
  return (
    <div
      className={`primary-collage-luv-icons${variantClass ? ` ${variantClass}` : ''}`.trim()}
      aria-hidden="true"
    >
      {showFriend ? (
        <img src={friendsImage} alt="" className="primary-collage-luv-icon primary-collage-luv-icon--friends" />
      ) : null}
      {showRomantic ? (
        <img src={orheartImage} alt="" className="primary-collage-luv-icon primary-collage-luv-icon--romantic" />
      ) : null}
    </div>
  );
}

/** When prize opt-in runs off a stale Firestore read, merge FoxChat / UI poster fields onto the row first. */
function overlayPosterProfileFromClient(baseRow, clientPoster) {
  if (!baseRow || !clientPoster) return baseRow;
  const next = { ...baseRow };
  if (Array.isArray(clientPoster.lookingForGenders) && clientPoster.lookingForGenders.length > 0) {
    next.lookingForGenders = [...clientPoster.lookingForGenders];
  }
  const age = clientPoster.selfAge;
  if (typeof age === 'number' && Number.isFinite(age) && age >= 18 && age <= 120) {
    next.selfAge = age;
  }
  if (clientPoster.selfGender && ['male', 'female', 'nb'].includes(clientPoster.selfGender)) {
    next.selfGender = clientPoster.selfGender;
  }
  return next;
}

async function syncPosterProfileFieldMirrors(firestore, mergedPosterRow) {
  if (!firestore || !mergedPosterRow?.id) return;
  const patch = {};
  if (Array.isArray(mergedPosterRow.lookingForGenders) && mergedPosterRow.lookingForGenders.length > 0) {
    patch.lookingForGenders = mergedPosterRow.lookingForGenders;
  }
  if (
    typeof mergedPosterRow.selfAge === 'number'
    && Number.isFinite(mergedPosterRow.selfAge)
    && mergedPosterRow.selfAge >= 18
    && mergedPosterRow.selfAge <= 120
  ) {
    patch.selfAge = mergedPosterRow.selfAge;
  }
  if (mergedPosterRow.selfGender && ['male', 'female', 'nb'].includes(mergedPosterRow.selfGender)) {
    patch.selfGender = mergedPosterRow.selfGender;
  }
  if (Object.keys(patch).length === 0) return;
  const safe = sanitizePosterDocForFirestore(patch);
  try {
    await setDoc(doc(firestore, 'sharedPosters', mergedPosterRow.id), safe, { merge: true });
  } catch (e) {
    console.error('Failed to mirror poster profile fields to sharedPosters:', e);
  }
  if (mergedPosterRow.feedAdId) {
    try {
      await updateDoc(doc(firestore, 'wantedFeed', mergedPosterRow.feedAdId), safe);
    } catch (e) {
      console.error('Failed to mirror poster profile fields to wantedFeed:', e);
    }
  }
}

const brandLululemon = `${process.env.PUBLIC_URL || ''}/brands/${encodeURIComponent('Lululemon Dual Pouch Wristlet BlackGold.png')}`;
const brandTraderJoes = `${process.env.PUBLIC_URL || ''}/brands/${encodeURIComponent('Trader Joes Mini Tote Bag Navy.webp')}`;
/** Trade-fox venue tiles (strada/mezzo/topdog assets removed from brands; use places-google). */
const brandStrada = `${process.env.PUBLIC_URL || ''}/places-google/${encodeURIComponent('Caffe Strada.webp')}`;
const brandMezzo = `${process.env.PUBLIC_URL || ''}/places-google/${encodeURIComponent('Mezzo.webp')}`;
const brandTopdog = `${process.env.PUBLIC_URL || ''}/places-google/${encodeURIComponent('Top Dog.webp')}`;
const brandLuvtote = `${process.env.PUBLIC_URL || ''}/brands/luvtote.png`;
const brandFoxshirt = `${process.env.PUBLIC_URL || ''}/brands/foxshirt.webp`;

const MAGAZINE_IMAGES = [voguImage, forbsImage, vanitImage];
const ROTATION_INTERVAL_MS = 1500;

/** Hero sample poster only: feed-style nickname strip above the mini collage. Set `true` to show again. */
const SHOW_HERO_SAMPLE_NICKNAME_STRIP = false;

/**
 * How long the user page reads "recalculating..." after a collage edit before revealing the
 * drifted vibe color, so the aura doesn't silently snap to a new color mid-navigation.
 */
const AURA_RECALC_REVEAL_MS = 5000;

/** Random FIND Luv flags for hero sample strip; never both false so layout matches feed when luv column is used. */
function randomSampleFeedFindLuvFlags() {
  let friend = Math.random() < 0.55;
  let romantic = Math.random() < 0.55;
  if (!friend && !romantic) {
    friend = true;
    romantic = true;
  }
  return { friend, romantic };
}

const TRADE_FOXES_IMAGES = [
  { id: 'strada', src: brandStrada, alt: 'Strada $20', price: 699 },
  { id: 'mezzo', src: brandMezzo, alt: 'Mezzo $20', price: 699 },
  { id: 'topdog', src: brandTopdog, alt: 'Top Dog $15', price: 499 },
];

const GOOGLE_PLACES_API_KEY = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;

/** Religion/spirituality emojis excluded from random activity grids (matches `activityEmojis.js` “Religion & Spirituality” row, including 🧘). */
const RELIGION_EMOJIS = ['🛐', '🧘', '⚛️', '🕉️', '✡️', '☸️', '☯️', '✝️', '☦️', '☪️', '☮️', '🕎', '🔯', '🪯'];

/** Chevron icon for FAQ accordion summaries; rotates 180° via CSS when its parent <details> is open. */
const FaqChevron = () => (
  <svg
    className="homepage-faq-chevron"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

/** Every tile image the collage-details popup paints for an ad (brands, places, spirit GIF). */
function feedAdDetailImageUrls(ad) {
  const urls = [];
  const push = (u) => {
    if (typeof u === 'string' && u && !urls.includes(u)) urls.push(u);
  };
  (ad?.swags || []).forEach((swag) => push(swag?.imageUrl || swag));
  (ad?.places || []).forEach((place) => push(place?.imageUrl));
  push(spiritOverlaySourcesFromAd(ad, orheartImage).animatedSrc);
  return urls;
}

/** Decode + pin the cutout so `ReusedFeedImg` can paint it synchronously on the popup's first frame. */
function preloadAndPinFeedImage(url) {
  return new Promise((resolve) => {
    if (!url || typeof url !== 'string') {
      resolve();
      return;
    }
    const img = new Image();
    img.decoding = 'async';
    img.onload = () => {
      registerFeedImage(url, img);
      if (typeof img.decode === 'function') img.decode().then(resolve, resolve);
      else resolve();
    };
    img.onerror = () => resolve();
    img.src = url;
  });
}

/**
 * Warm everything the collage-details popup shows for `ad` before opening it, so the card
 * lands fully painted instead of each image popping in. Capped so a hung request can't
 * block the open.
 */
function warmFeedAdDetailImages(ad, cutoutSrc, capMs = 2500) {
  const jobs = [
    preloadAndPinFeedImage(cutoutSrc),
    ...feedAdDetailImageUrls(ad).map((u) => preloadImage(u)),
  ];
  return Promise.race([
    Promise.all(jobs),
    new Promise((resolve) => { setTimeout(resolve, capMs); }),
  ]);
}

/** Same cutout URL the carousel card and collage-details preview must share (incl. local fallback). */
function feedAdCutoutSrc(ad, index, displayCount, feedCutoutUrls) {
  if (ad?.partnerCutout) return ad.partnerCutout;
  if (!Array.isArray(feedCutoutUrls) || feedCutoutUrls.length === 0) return null;
  const i = displayCount > 0 ? index % displayCount : index;
  return feedCutoutUrls[i % feedCutoutUrls.length] || null;
}

/** One WEEKLY FEATURED collage card. Memoized so the carousel's `activeIdx` scroll-state updates (dots + action bar) don't re-render the heavy collage trees. `spiritGifActive` is the exception: only the centered card mounts the animated spirit GIF. */
const WantedAdCard = React.memo(function WantedAdCard({
  ad,
  index,
  displayCount,
  feedCutoutUrls,
  savedPosters,
  currentUserId,
  onCardClick,
  registerCardRef,
  spiritGifActive = false,
  spiritCaptureStill = true,
}) {
  return (
    /* Plain container (not role="button"): the FeedNicknameTile <button> inside is the accessible target — nesting interactives breaks screen readers. onClick stays as a pointer-only convenience. */
    <div
      ref={(el) => registerCardRef(index, el)}
      className="wanted-ad-card wanted-ad-card-clickable"
      onClick={() => onCardClick(index, ad)}
      role="group"
      aria-roledescription="slide"
      aria-label={`${ad.posterNickname ?? ad.userName ?? 'Someone'}, ${index + 1} of ${displayCount}`}
    >
      <div className="wanted-poster wanted-poster-feed">
        <div className="poster-content">
          <FeedNicknameTile
            ad={ad}
            savedPosters={savedPosters}
            currentUserId={currentUserId}
            asButton
            onClick={(e) => { e.stopPropagation(); onCardClick(index, ad); }}
            ariaLabel={`View poster: ${ad.posterNickname ?? 'The One'}`}
            bountyAmount={ad.bountyAmount}
            showVibeAura
          />
          <div className="match-a-friend-collage">
          <div className="collage-poster-area">
          <div className="partner-swag-container">
            <div className="partner-swag-left">
              {ad.swags && ad.swags.length > 0 && (
                <div className="swag-images-left">
                  {ad.swags.map((swag, swagIndex) => {
                    const swagUrl = swag.imageUrl || swag;
                    if (!swagUrl) return null;
                    const seed = seedFromString(`${ad.id}-swag-${swagIndex}`);
                    const seedX = seedFromString(`${ad.id}-swag-x-${swagIndex}`);
                    const rotation = (seed * 30 - 15).toFixed(1);
                    const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                    const isStripCenter = index === Math.floor(displayCount / 2);
                    return (
                      <img
                        key={swag.id || swagIndex}
                        src={swagUrl}
                        alt={swag.name || 'Brand'}
                        className="swag-image"
                        loading={isStripCenter ? 'eager' : 'lazy'}
                        fetchPriority={isStripCenter ? 'high' : 'auto'}
                        decoding="async"
                        style={{
                          transform: `rotate(${rotation}deg)`,
                          marginLeft: `${horizontalOffset}px`
                        }}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className="partner-swag-center">
              <div className="partner-swag-center-stack">
                {(() => {
                  const cutJagged = (() => {
                    const v = 1 + Math.floor(seedFromString(`feed-cutout-${ad.id}`) * 3);
                    return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                  })();
                  const cutoutSrc = feedAdCutoutSrc(ad, index, displayCount, feedCutoutUrls);
                  const savedMatch = savedPosters.find((p) => p.feedAdId === ad.id || p.id === ad.id);
                  const mergedForFriendPh = savedMatch
                    ? {
                      ...ad,
                      friendCollageShare: ad.friendCollageShare ?? savedMatch.friendCollageShare,
                      friendFoxMaskPlaceholder:
                        ad.friendFoxMaskPlaceholder ?? savedMatch.friendFoxMaskPlaceholder,
                      surveyAnswers: ad.surveyAnswers || savedMatch.surveyAnswers,
                    }
                    : ad;
                  const {
                    animatedSrc: spiritSrc,
                    pauseOffCenter: spiritPauseOffCenter,
                  } = spiritOverlaySourcesFromAd(
                    mergedForFriendPh,
                    orheartImage,
                  );
                  if (showFriendFoxMaskPlaceholder(mergedForFriendPh) && ad.partnerCutout) {
                    return (
                      <FriendFoxMaskPlaceholderCutout
                        variant="feed"
                        jaggedClassName={cutJagged}
                        heartSrc={spiritSrc}
                        animateHeart={spiritGifActive}
                        pauseHeartOffCenter={spiritPauseOffCenter}
                        captureHeartStill={spiritCaptureStill}
                        heartClassName="partner-cutout-gif-overlay"
                      />
                    );
                  }
                  if (cutoutSrc) {
                    return (
                      <div className="final-partner-image-wrapper">
                        <img
                          src={cutoutSrc}
                          alt=""
                          className={`final-partner-image${cutJagged}`}
                          loading={index === Math.floor(displayCount / 2) ? 'eager' : 'lazy'}
                          fetchPriority={index === Math.floor(displayCount / 2) ? 'high' : 'auto'}
                          decoding="async"
                          ref={(el) => {
                            if (el) registerFeedImage(cutoutSrc, el);
                          }}
                          onLoad={(e) => registerFeedImage(cutoutSrc, e.currentTarget)}
                        />
                        <PartnerCutoutSpiritOverlay
                          src={spiritSrc}
                          animate={spiritGifActive}
                          pauseOffCenter={spiritPauseOffCenter}
                          captureStill={spiritCaptureStill}
                          alt=""
                          className="partner-cutout-gif-overlay"
                        />
                      </div>
                    );
                  }
                  return (
                    <div
                      className={`final-partner-image final-partner-image-placeholder${cutJagged}`}
                    >
                      {'\uD83D\uDC64'}
                    </div>
                  );
                })()}
              </div>
            </div>
            <div className="partner-swag-right">
              <div className="activities-emojis-right">
                {[ad.activityX, ad.activityY, ad.activityZ].filter(Boolean).map((label, i) => {
                  const seed = seedFromString(`${ad.id}-act-${i}`);
                  const seedX = seedFromString(`${ad.id}-act-x-${i}`);
                  const rotation = (seed * 30 - 15).toFixed(1);
                  const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                  const hue = 32 + seed * 20;
                  const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                  return (
                    <div
                      key={i}
                      className="activity-tile-outer"
                      style={{
                        transform: `rotate(${rotation}deg)`,
                        marginLeft: `${horizontalOffset}px`
                      }}
                    >
                      <div
                        className="activity-emoji-wrapper collage-activity-tile"
                        style={{ background: bgColor }}
                      >
                        <div
                          className="activity-emoji"
                          style={{ fontSize: `${(2.5 + seed * 1.5).toFixed(1)}rem` }}
                        >
                          {label}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {ad.places && ad.places.length > 0 && (
            <div className="collage-aspirations-row">
              <div className="collage-places-row-inner">
                <div className="aspiration-tile-outer">
                  <div className="collage-place-tile">
                    <img
                      src={ad.places[0].imageUrl}
                      alt={ad.places[0].name}
                      className="collage-place-img"
                      loading={index === Math.floor(displayCount / 2) ? 'eager' : 'lazy'}
                      fetchPriority={index === Math.floor(displayCount / 2) ? 'high' : 'auto'}
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          </div>
          </div>
        </div>
      </div>
    </div>
  );
});

/** WEEKLY FEATURED carousel: one collage per region (`dinnerGiveawayOptIns` regional flags + `sharedPosters`) in a single horizontal strip. */
const RegionalFeatureCarousel = React.memo(function RegionalFeatureCarousel({
  wantedAds,
  feedCutoutUrls,
  onTileClick,
  currentUserId,
  savedPosters,
  onBountyReachOutFromStrip,
  onBountyMatchFriendFromStrip,
  onBountyShareFromStrip,
  onBountyEditFromStrip,
  feedReady = false,
}) {
  const carouselRef = useRef(null);
  const cardRefs = useRef([]);
  /** Smoothed scale/opacity per card — eases jerk from sparse scroll events + scroll-snap jumps. */
  const depthSmoothRef = useRef([]);

  const displayAds = useMemo(() => (wantedAds || []).slice(0, 5), [wantedAds]);
  const displayCount = displayAds.length;
  const feedPending = !feedReady && displayCount === 0;
  /** Card nearest the strip center — drives the action buttons below the carousel. */
  const [activeIdx, setActiveIdx] = useState(0);
  /** Ref mirror of `activeIdx` for click handlers, so their identity stays stable (keeps `WantedAdCard` memo intact). */
  const activeIdxRef = useRef(0);
  /** iOS: smooth programmatic scroll + scroll-snap-stop:always often freezes mid-track — use instant scroll on coarse pointers (same guard as `useFiniteSnapCarousel`). */
  const smoothScrollOkRef = useRef(true);
  useEffect(() => {
    smoothScrollOkRef.current = !window.matchMedia('(pointer: coarse)').matches;
  }, []);

  /** Center pack first (cutout, then brand/place tiles), then the other cards. */
  const stripCenterIdx = Math.floor(displayCount / 2);
  /** `pending` = no GIF fetches; `center` = play/capture the middle pack; `rest` = freeze the others. */
  const [spiritLoadPhase, setSpiritLoadPhase] = useState('pending');

  useEffect(() => {
    if (displayCount === 0) {
      setSpiritLoadPhase('pending');
      return undefined;
    }
    setSpiritLoadPhase('pending');
    const cutoutUrl = (ad, i) => {
      if (!ad) return null;
      if (ad.partnerCutout) return ad.partnerCutout;
      if (!feedCutoutUrls.length) return null;
      return feedCutoutUrls[(displayCount > 0 ? i % displayCount : i) % feedCutoutUrls.length];
    };
    const tileUrls = (ad) => {
      if (!ad) return [];
      const urls = [];
      (ad.swags || []).forEach((swag) => {
        const url = swag.imageUrl || swag;
        if (typeof url === 'string' && url) urls.push(url);
      });
      const placeUrl = ad.places?.[0]?.imageUrl;
      if (typeof placeUrl === 'string' && placeUrl) urls.push(placeUrl);
      return urls;
    };
    const uniquePush = (list, seen, url) => {
      if (!url || seen.has(url)) return;
      seen.add(url);
      list.push(url);
    };

    const centerAd = displayAds[stripCenterIdx];
    const { animatedSrc: centerGifSrc, pauseOffCenter: centerGifAnimated } = spiritOverlaySourcesFromAd(centerAd, null);
    const centerGif = centerGifAnimated ? centerGifSrc : null;
    const centerCutout = cutoutUrl(centerAd, stripCenterIdx);
    const centerTiles = [];
    const restCutouts = [];
    const restTiles = [];
    const seen = new Set();
    if (centerCutout) seen.add(centerCutout);
    tileUrls(centerAd).forEach((url) => uniquePush(centerTiles, seen, url));
    if (centerGif) seen.add(centerGif);
    displayAds.forEach((ad, i) => {
      if (i === stripCenterIdx) return;
      uniquePush(restCutouts, seen, cutoutUrl(ad, i));
      tileUrls(ad).forEach((url) => uniquePush(restTiles, seen, url));
    });

    let cancelled = false;
    const loadOne = (url) => new Promise((resolve) => {
      if (!url || typeof url !== 'string') {
        resolve();
        return;
      }
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        registerFeedImage(url, img);
        resolve();
      };
      img.onerror = () => resolve();
      img.src = url;
    });
    const kick = (url) => {
      pinFeedImageUrl(url);
    };

    loadOne(centerCutout)
      .then(() => {
        if (cancelled) return undefined;
        return Promise.all(centerTiles.map(loadOne));
      })
      .then(() => {
        if (cancelled) return undefined;
        setSpiritLoadPhase('center');
        return loadOne(centerGif);
      })
      .then(() => {
        if (cancelled) return;
        setSpiritLoadPhase('rest');
        restCutouts.forEach(kick);
        restTiles.forEach(kick);
      });

    return () => {
      cancelled = true;
    };
  }, [displayAds, displayCount, feedCutoutUrls, stripCenterIdx]);

  /** Stable identity so `WantedAdCard`'s memo isn't defeated by a fresh ref callback each render. */
  const registerCardRef = useCallback((idx, el) => {
    cardRefs.current[idx] = el;
  }, []);

  /** Measured inline padding sync (no rAF deferral): WebKit can snap against layout before trailing space settles → first stop off-center, then jerky re-snap. Converges `--wanted-carousel-pad-after` synchronously. Optional `reindexScrollIdx` re-sets scrollLeft after padding (mounted center / programmatic index). */
  const syncWantedCarouselPadding = useCallback(
    (reindexScrollIdx = null) => {
      const el = carouselRef.current;
      if (!el) return;
      if (displayCount === 0) {
        el.style.removeProperty('--wanted-carousel-pad');
        el.style.removeProperty('--wanted-carousel-pad-after');
        return;
      }
      const first = cardRefs.current[0];
      if (!first) return;
      const trackW = el.clientWidth;
      const cardW = first.offsetWidth;
      const pad = Math.max(0, (trackW - cardW) / 2);
      el.style.setProperty('--wanted-carousel-pad', `${pad}px`);

      let trailerPx = 0;
      el.style.setProperty('--wanted-carousel-pad-after', '0px');

      const lastExtentDeficitPx = () => {
        const last = cardRefs.current[displayCount - 1];
        if (!last || displayCount < 2) return 0;
        void el.offsetHeight;
        const need = last.offsetLeft + last.offsetWidth / 2 - el.clientWidth / 2;
        const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
        return need - maxScroll;
      };

      for (let iter = 0; iter < 12; iter += 1) {
        void el.offsetHeight;
        const deficit = lastExtentDeficitPx();
        if (deficit <= 1) break;
        trailerPx += Math.max(1, Math.ceil(deficit));
        el.style.setProperty('--wanted-carousel-pad-after', `${trailerPx}px`);
      }

      if (displayCount < 2) {
        el.style.setProperty('--wanted-carousel-pad-after', '0px');
      }

      if (typeof reindexScrollIdx === 'number') {
        const card = cardRefs.current[reindexScrollIdx];
        if (card) {
          const raw =
            card.offsetLeft + card.offsetWidth / 2 - el.clientWidth / 2;
          const maxS = Math.max(0, el.scrollWidth - el.clientWidth);
          el.scrollLeft = Math.max(0, Math.min(maxS, Math.round(raw)));
        }
      }
    },
    [displayCount],
  );

  /** Depth: scale/opacity from each card’s distance to the container’s horizontal center (updates while scrolling). Values are exponentially smoothed so motion stays fluid between scroll samples and through scroll-snap. */
  const applyDepthTransforms = useCallback(() => {
    const container = carouselRef.current;
    if (!container) return;
    const cards = cardRefs.current.filter(Boolean);
    if (cards.length === 0) return;
    const smoothArr = depthSmoothRef.current;
    if (smoothArr.length !== cards.length) {
      depthSmoothRef.current = cards.map(() => null);
    }
    const smoothed = depthSmoothRef.current;

    const containerCenter = container.scrollLeft + container.clientWidth / 2;
    const slotWidth = Math.max(1, cards[0].offsetWidth + 16); // ~card + gap; floor avoids div-by-zero
    let nearestIdx = 0;
    let nearestDist = Infinity;
    cards.forEach((card, i) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const d = Math.abs(cardCenter - containerCenter);
      if (d < nearestDist) {
        nearestDist = d;
        nearestIdx = i;
      }
    });
    activeIdxRef.current = nearestIdx;
    setActiveIdx(nearestIdx);
    cards.forEach((card, i) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const rawDist = Math.abs(cardCenter - containerCenter);
      const dist = rawDist / slotWidth;
      const targetScale = Math.max(0.6, 1 - dist * 0.22);
      const targetOpacity = Math.max(0.55, 1 - dist * 0.22);

      let sm = smoothed[i];
      if (sm == null) {
        sm = { scale: targetScale, opacity: targetOpacity };
        smoothed[i] = sm;
      } else {
        /* Lower blend = gentler easing (more frames to converge); big-gap branch still catches snap jumps. */
        const blendScale = Math.abs(targetScale - sm.scale) > 0.08 ? 0.45 : 0.22;
        const blendOpacity = Math.abs(targetOpacity - sm.opacity) > 0.08 ? 0.45 : 0.22;
        sm.scale += (targetScale - sm.scale) * blendScale;
        sm.opacity += (targetOpacity - sm.opacity) * blendOpacity;
        if (Math.abs(targetScale - sm.scale) < 0.002) sm.scale = targetScale;
        if (Math.abs(targetOpacity - sm.opacity) < 0.002) sm.opacity = targetOpacity;
      }

      card.style.transform = `translateZ(0) scale(${sm.scale.toFixed(4)})`;
      card.style.opacity = sm.opacity.toFixed(4);
      card.style.zIndex = String(Math.round(100 - dist * 10));
    });
  }, []);

  /** Re-apply depth after `spiritGifActive` re-renders a card (imperative transform/opacity on the card node). */
  useLayoutEffect(() => {
    applyDepthTransforms();
  }, [activeIdx, applyDepthTransforms]);

  /** Dot click: smooth-scroll the chosen card to strip center (same centering math as the snap nudge). */
  const scrollToWantedIdx = useCallback((idx) => {
    const container = carouselRef.current;
    const card = cardRefs.current[idx];
    if (!container || !card) return;
    const raw = card.offsetLeft + card.offsetWidth / 2 - container.clientWidth / 2;
    const maxS = Math.max(0, container.scrollWidth - container.clientWidth);
    const exact = Math.max(0, Math.min(maxS, Math.round(raw)));
    if (smoothScrollOkRef.current) {
      container.scrollTo({ left: exact, behavior: 'smooth' });
    } else {
      container.scrollLeft = exact;
    }
  }, []);

  /** Card click: centered card opens the tile popup; a side card scrolls to center instead (standard carousel pattern). */
  const handleCardClick = useCallback((idx, ad) => {
    if (idx !== activeIdxRef.current) {
      scrollToWantedIdx(idx);
      return;
    }
    onTileClick(ad, feedAdCutoutSrc(ad, idx, displayCount, feedCutoutUrls));
  }, [scrollToWantedIdx, onTileClick, displayCount, feedCutoutUrls]);

  /** After scroll-snap / momentum ends, Safari can rest a few px off computed center (esp. last card); exact scroll fixes without a second gesture. */
  const nudgeWantedCarouselSnap = useCallback(() => {
    const container = carouselRef.current;
    if (!container || displayCount < 1) return;
    const cards = cardRefs.current.filter(Boolean);
    if (cards.length === 0) return;
    const midpoint = container.scrollLeft + container.clientWidth / 2;
    let best = 0;
    let bestD = Infinity;
    cards.forEach((c, i) => {
      const cx = c.offsetLeft + c.offsetWidth / 2;
      const d = Math.abs(cx - midpoint);
      if (d < bestD) {
        bestD = d;
        best = i;
      }
    });
    const card = cards[best];
    const raw =
      card.offsetLeft + card.offsetWidth / 2 - container.clientWidth / 2;
    const maxS = Math.max(0, container.scrollWidth - container.clientWidth);
    const exact = Math.max(0, Math.min(maxS, Math.round(raw)));
    const delta = Math.abs(container.scrollLeft - exact);
    if (delta <= 1) return;
    if (delta <= 4 || !smoothScrollOkRef.current) {
      /* Sub-4px correction is imperceptible — instant set avoids kicking off a scroll animation. Coarse pointers always go instant (iOS smooth+snap freeze). */
      container.scrollLeft = exact;
    } else {
      container.scrollTo({ left: exact, behavior: 'smooth' });
    }
  }, [displayCount]);

  /** Start centered on the middle prized collage when the list is known (finite strip — no copy wrap). */
  useLayoutEffect(() => {
    const container = carouselRef.current;
    if (!container) return;
    if (displayCount === 0) {
      container.style.removeProperty('--wanted-carousel-pad');
      container.style.removeProperty('--wanted-carousel-pad-after');
      return;
    }
    cardRefs.current.length = displayAds.length;
    depthSmoothRef.current = [];
    const centerIdx = Math.floor(displayCount / 2);
    syncWantedCarouselPadding(centerIdx);
    applyDepthTransforms();
    requestAnimationFrame(() => {
      nudgeWantedCarouselSnap();
      applyDepthTransforms();
    });
  }, [displayAds, displayCount, applyDepthTransforms, syncWantedCarouselPadding, nudgeWantedCarouselSnap]);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    let roRaf = null;
    const ro = new ResizeObserver(() => {
      /* Defer to next frame: style/layout writes here re-enter ResizeObserver and throw in some browsers. */
      if (roRaf !== null) return;
      roRaf = requestAnimationFrame(() => {
        roRaf = null;
        syncWantedCarouselPadding();
        nudgeWantedCarouselSnap();
        applyDepthTransforms();
      });
    });
    ro.observe(el);
    return () => {
      ro.disconnect();
      if (roRaf !== null) cancelAnimationFrame(roRaf);
    };
  }, [syncWantedCarouselPadding, nudgeWantedCarouselSnap, applyDepthTransforms]);

  /** Post-gesture (`scrollend` + debounced `scroll`): WebKit lands mandatory snap shy of analytical center unless we clamp `scrollLeft`. */
  useEffect(() => {
    const container = carouselRef.current;
    if (!container || displayCount < 1) return;

    let debounceId = null;
    const nudgeQuiet = () => {
      requestAnimationFrame(() => {
        nudgeWantedCarouselSnap();
        applyDepthTransforms();
      });
    };

    const onScrollArmDebounced = () => {
      if (debounceId !== null) window.clearTimeout(debounceId);
      debounceId = window.setTimeout(() => {
        debounceId = null;
        nudgeQuiet();
      }, 72);
    };

    container.addEventListener('scrollend', nudgeQuiet);
    container.addEventListener('scroll', onScrollArmDebounced, { passive: true });
    return () => {
      container.removeEventListener('scrollend', nudgeQuiet);
      container.removeEventListener('scroll', onScrollArmDebounced);
      if (debounceId !== null) window.clearTimeout(debounceId);
    };
  }, [displayCount, nudgeWantedCarouselSnap, applyDepthTransforms]);

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;
    let rafId = null;
    let lastScrollLeft = container.scrollLeft;
    let stableFrames = 0;

    /** Keep depth in sync during scroll-snap animation (scroll events can be sparse). */
    const tick = () => {
      const cur = container.scrollLeft;
      if (cur === lastScrollLeft) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
        lastScrollLeft = cur;
      }
      applyDepthTransforms();
      if (stableFrames < 22) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    };
    const schedule = () => {
      if (rafId !== null) return;
      stableFrames = 0;
      lastScrollLeft = container.scrollLeft;
      rafId = requestAnimationFrame(tick);
    };
    /* Resize is covered by the ResizeObserver effect above (container size changes re-run padding sync + depth). */
    container.addEventListener('scroll', schedule, { passive: true });
    return () => {
      container.removeEventListener('scroll', schedule);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, [applyDepthTransforms]);

  return (
    <div
      className={`regional-feature-block${feedPending ? ' regional-feature-block--pending' : ''}`}
      aria-busy={feedPending}
    >
      <div
        ref={carouselRef}
        className="wanted-ads-container"
        role="group"
        aria-roledescription="carousel"
        aria-label="Weekly featured profiles"
      >
        {feedPending ? (
          <div className="wanted-ad-card wanted-ad-card--pending" aria-hidden>
            <div className="wanted-poster wanted-poster-feed">
              <div className="poster-content">
                <div className="the-one-label the-one-label-feed feed-nickname-tile">&nbsp;</div>
                <div className="match-a-friend-collage">
                  <div className="collage-poster-area">
                    <div className="partner-swag-center">
                      <div className="final-partner-image-wrapper" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          displayAds.map((ad, index) => (
          <WantedAdCard
            key={ad.id}
            ad={ad}
            index={index}
            displayCount={displayCount}
            feedCutoutUrls={feedCutoutUrls}
            savedPosters={savedPosters}
            currentUserId={currentUserId}
            onCardClick={handleCardClick}
            registerCardRef={registerCardRef}
            spiritGifActive={
              spiritLoadPhase === 'center'
                ? index === stripCenterIdx
                : spiritLoadPhase === 'rest' && index === activeIdx
            }
            spiritCaptureStill={
              spiritLoadPhase === 'rest'
              || (spiritLoadPhase === 'center' && index === stripCenterIdx)
            }
          />
          ))
        )}
      </div>
      {(displayCount > 1 || feedPending) && (
        <div className="wanted-ads-dots" role="tablist" aria-label="Weekly featured profiles" aria-hidden={feedPending}>
          {feedPending ? (
            <span className="wanted-ads-dot" />
          ) : (
            displayAds.map((ad, i) => (
            <button
              key={ad.id}
              type="button"
              role="tab"
              aria-selected={i === activeIdx}
              aria-label={`Go to featured profile ${i + 1} of ${displayCount}`}
              className={`wanted-ads-dot${i === activeIdx ? ' wanted-ads-dot--active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                scrollToWantedIdx(i);
              }}
            />
            ))
          )}
        </div>
      )}
      {(displayCount > 0 || feedPending) && (
        <div
          className="wanted-ads-strip-actions feed-tile-detail-actions"
          role="group"
          aria-hidden={feedPending}
          aria-label={feedPending ? undefined : `Actions for ${displayAds[activeIdx]?.posterNickname ?? displayAds[activeIdx]?.userName ?? 'featured profile'}`}
        >
          {feedPending ? (
            <>
              <span className="feed-tile-detail-btn feed-tile-detail-btn-apply">UNMASK</span>
              <span className="feed-tile-detail-btn feed-tile-detail-btn-refer">MATCH A FRIEND</span>
            </>
          ) : (
          (() => {
            const ad = displayAds[activeIdx] ?? displayAds[0];
            if (!ad) return null;
            const isOwn = currentUserId && ad.userId === currentUserId;
            if (isOwn) {
              return (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                    onClick={(e) => {
                      e.stopPropagation();
                      onBountyShareFromStrip(ad);
                    }}
                  >
                    Share
                  </button>
                  <button
                    type="button"
                    className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                    onClick={(e) => {
                      e.stopPropagation();
                      onBountyEditFromStrip(ad);
                    }}
                  >
                    Edit
                  </button>
                </>
              );
            }
            return (
              <>
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                  onClick={(e) => {
                    e.stopPropagation();
                    onBountyReachOutFromStrip(ad);
                  }}
                >
                  UNMASK
                </button>
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onBountyMatchFriendFromStrip(ad);
                  }}
                >
                  MATCH A FRIEND
                </button>
              </>
            );
          })()
          )}
        </div>
      )}
    </div>
  );
});

const WantedAdsFeed = React.memo(function WantedAdsFeed({
  berkeleyWantedAds,
  sfWantedAds,
  sfNorthBeachWantedAds,
  sfSomaWantedAds,
  sfDowntownWantedAds,
  feedCutoutUrls,
  onTileClick,
  currentUserId,
  savedPosters,
  onBountyReachOutFromStrip,
  onBountyMatchFriendFromStrip,
  onBountyShareFromStrip,
  onBountyEditFromStrip,
  onWeeklyFeaturedOptInClick,
  onShowSignUp,
  feedReady = false,
}) {
  const carouselProps = {
    feedCutoutUrls,
    onTileClick,
    currentUserId,
    savedPosters,
    onBountyReachOutFromStrip,
    onBountyMatchFriendFromStrip,
    onBountyShareFromStrip,
    onBountyEditFromStrip,
    feedReady,
  };
  /** One card per region, merged into a single strip (dedupe guards a profile flagged for multiple regions). */
  const combinedWantedAds = useMemo(() => {
    const seen = new Set();
    return [sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds, berkeleyWantedAds]
      .map((ads) => (ads || [])[0])
      .filter((ad) => {
        if (!ad || seen.has(ad.id)) return false;
        seen.add(ad.id);
        return true;
      });
  }, [sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds, berkeleyWantedAds]);
  return (
    <div id="earn-foxes" className="wanted-ads-feed-section">
      <h3>
        <span className="wanted-ads-feed-title-line">FEATURED LUV PACKS</span>
      </h3>
      <p className="earn-foxes-subtitle fox-love-vibe-subtitle wanted-ads-feed-luv-legend">
        <span className="fox-love-vibe-chip">
          <span>friends</span>
          <img
            src={friendsImage}
            alt=""
            className="earn-foxes-luv-legend-icon earn-foxes-luv-legend-icon--friends"
            aria-hidden
          />
        </span>
        <span className="fox-love-vibe-sep" aria-hidden>
          {' | '}
        </span>
        <span className="fox-love-vibe-chip">
          <img
            src={orheartImage}
            alt=""
            className="earn-foxes-luv-legend-icon"
            aria-hidden
          />
          <span>romance</span>
        </span>
      </p>
      <div className="earn-foxes-subtitle-row">
        <div className="earn-foxes-subtitle-text">
          {currentUserId && typeof onWeeklyFeaturedOptInClick === 'function' ? (
            <button
              type="button"
              className="earn-foxes-subtitle earn-foxes-dinner-intro earn-foxes-dinner-intro--plain earn-foxes-dinner-intro-btn"
              onClick={onWeeklyFeaturedOptInClick}
            >
              Opt in your profile to be featured on our website for a week. If your profile is selected, get a Fox-Paid date when you match
              <span className="earn-foxes-dinner-intro-btn-inline-end">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="earn-foxes-matcha-arrow earn-foxes-dinner-intro-btn-arrow" aria-hidden><path d="M7 17 17 7M7 7h10v10" /></svg>
              </span>
            </button>
          ) : !currentUserId && typeof onShowSignUp === 'function' ? null : (
            <p className="earn-foxes-subtitle earn-foxes-dinner-intro earn-foxes-dinner-intro--plain">
              Opt in your profile to get featured. Get a Fox-Paid date when you find a match
            </p>
          )}
        </div>
      </div>
      <RegionalFeatureCarousel
        wantedAds={combinedWantedAds}
        {...carouselProps}
      />
      {!currentUserId && typeof onShowSignUp === 'function' ? (
      <div className="earn-foxes-subtitle-row earn-foxes-bounty-science-row">
        <div className="earn-foxes-subtitle-text">
            <button
              type="button"
              className="earn-foxes-subtitle earn-foxes-dinner-intro earn-foxes-dinner-intro--plain earn-foxes-dinner-intro-btn"
              onClick={() => onShowSignUp(null, 'feed')}
            >
              share a Fox-Paid date when you unmask
              <span className="earn-foxes-dinner-intro-btn-inline-end">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="earn-foxes-matcha-arrow earn-foxes-dinner-intro-btn-arrow" aria-hidden><path d="M7 17 17 7M7 7h10v10" /></svg>
              </span>
            </button>
        </div>
      </div>
      ) : null}
    </div>
  );
});

/** FIND Luv flags for a feed ad — matches `FeedNicknameTile` / `feedAdFindLuvIconFlags`. */
function feedTileDetailFindLuvFlags(ad, savedPosters, currentUserId) {
  const localPoster =
    currentUserId && ad?.userId === currentUserId
      ? (Array.isArray(savedPosters) ? savedPosters : []).find((p) => p.feedAdId === ad.id || p.id === ad.id) ?? null
      : null;
  return feedAdFindLuvIconFlags(ad, localPoster);
}

/** Collage-facing name for feed copy (nickname → user name → Someone). CSS uppercases `.feed-tile-detail-title`. */
function feedAdCollageNickname(ad) {
  if (!ad) return 'Someone';
  return (String(ad.posterNickname ?? ad.userName ?? 'Someone').trim() || 'Someone');
}

const FEED_MATCH_REFERRAL_SIGNUP_HINT =
  'Sign up to get a prize if your friend matches.';

const SPONSORED_DATE_IDEA_SIGNUP_MESSAGE =
  'Your date idea is submitted. Sign up to get your date sponsored if your idea is selected!';

const HomePage = ({
  onShowSurvey,
  onShowLoginPopup,
  onShowSignUp,
  currentUser,
  signUpPopupOpen = false,
  loginPopupOpen = false,
  deepLinkChatId,
  onDeepLinkChatHandled,
  deepLinkOpenMessagesTab = false,
  onDeepLinkOpenMessagesTabHandled,
  openMyCollagesNonce = 0,
  postLoginCollagesNonce = 0,
  postLoginRewardsNonce = 0,
  foxChatResetEmailAttachHooksRef = null,
  onLogoClick,
}) => {
  const backgroundRef = useRef(null);
  const animationStartTimeRef = useRef(null);
  // WANTED Poster Builder State
  const [activityX, setActivityX] = useState("");
  const [activityY, setActivityY] = useState("");
  const [selectedEmojis, setSelectedEmojis] = useState([]);
  const [generatedPartnerImage, setGeneratedPartnerImage] = useState(null);
  const [isImageGenerated, setIsImageGenerated] = useState(false);
  const [showEmojiSelection, setShowEmojiSelection] = useState(true);
  
  // WEEKLY FEATURED tiles (dinnerGiveawayOptIns regional flags + sharedPosters)
  const [berkeleyWantedAds, setBerkeleyWantedAds] = useState([]);
  const [sfWantedAds, setSfWantedAds] = useState([]);
  const [sfNorthBeachWantedAds, setSfNorthBeachWantedAds] = useState([]);
  const [sfSomaWantedAds, setSfSomaWantedAds] = useState([]);
  const [sfDowntownWantedAds, setSfDowntownWantedAds] = useState([]);
  const [weeklyFeaturedFeedReady, setWeeklyFeaturedFeedReady] = useState(false);
  const weeklyFeaturedAds = useMemo(
    () => [...sfWantedAds, ...sfNorthBeachWantedAds, ...sfSomaWantedAds, ...sfDowntownWantedAds, ...berkeleyWantedAds],
    [berkeleyWantedAds, sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds],
  );
  /** Poster id → short-link slot number (luv.wtf/1 …). Order must match WEEKLY_FEATURED_SLOTS in weeklyFeaturedSlots.js. */
  const weeklyFeaturedSlotByAdId = useMemo(() => {
    const map = new Map();
    [sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds, berkeleyWantedAds].forEach((ads, i) => {
      for (const ad of ads) {
        if (ad?.id && !map.has(ad.id)) map.set(ad.id, i + 1);
      }
    });
    return map;
  }, [berkeleyWantedAds, sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds]);
  const [postedSponsoredDateIdeas, setPostedSponsoredDateIdeas] = useState([]);
  const [postedSponsoredDateIdeasReady, setPostedSponsoredDateIdeasReady] = useState(false);

  // Existing state for DatingChatBot
  const [showDatingQuestions, setShowDatingQuestions] = useState(false);
  
  // Partner Selection Chat State
  const [showPartnerSelection, setShowPartnerSelection] = useState(false);
  const [selectedPartnerImage, setSelectedPartnerImage] = useState(null);
  
  // Single Image Generation State
  const [currentGeneratedImage, setCurrentGeneratedImage] = useState(null);
  const [generatedImagesList, setGeneratedImagesList] = useState([]);
  const [isGeneratingImage, setIsGeneratingImage] = useState(false);
  
  // Partner Generation Chat State
  const [showPartnerGenerationChat, setShowPartnerGenerationChat] = useState(false);
  const [partnerGenerationImage, setPartnerGenerationImage] = useState(null);
  const [isShowingAnimation, setIsShowingAnimation] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  // Inline Survey State
  const [showInlineSurvey, setShowInlineSurvey] = useState(false);
  const [surveyOnIntro, setSurveyOnIntro] = useState(true);
  const [surveyCompleted, setSurveyCompleted] = useState(false);
  const [selectedPartnerCutout, setSelectedPartnerCutout] = useState(null);
  const [partnerCutoutHintIndex, setPartnerCutoutHintIndex] = useState(0);
  const [partnerCutoutError, setPartnerCutoutError] = useState(null);
  const [showEditCutoutModal, setShowEditCutoutModal] = useState(false);
  const [editCutoutInput, setEditCutoutInput] = useState('');
  const [isEditingCutout, setIsEditingCutout] = useState(false);
  const [editCutoutHintIndex, setEditCutoutHintIndex] = useState(0);
  const [editCutoutError, setEditCutoutError] = useState(null);
  const [showCutoutReupload, setShowCutoutReupload] = useState(false);
  const [cutoutReuploadFile, setCutoutReuploadFile] = useState(null);
  const [cutoutReuploadPreview, setCutoutReuploadPreview] = useState(null);
  const [cutoutReuploadUploading, setCutoutReuploadUploading] = useState(false);
  const [cutoutReuploadProcessing, setCutoutReuploadProcessing] = useState(false);
  const [cutoutReuploadHintIndex, setCutoutReuploadHintIndex] = useState(0);
  const [cutoutReuploadEditedUrl, setCutoutReuploadEditedUrl] = useState(null);
  const [cutoutReuploadConfirming, setCutoutReuploadConfirming] = useState(false);
  const cutoutReuploadInputRef = useRef(null);
  const cutoutReuploadOriginalUrlRef = useRef(null);
  const [editCountForGuest, setEditCountForGuest] = useState(() => {
    try {
      return parseInt(sessionStorage.getItem('partnerCutoutEditCount') || '0', 10);
    } catch {
      return 0;
    }
  });
  const EDIT_CUTOUT_LIMIT_GUEST = 5;
  const [selectedSwags, setSelectedSwags] = useState([]);
  const [selectedWords, setSelectedWords] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [surveyAnswers, setSurveyAnswers] = useState(null);
  const [jungianAnalysisText, setJungianAnalysisText] = useState(null);
  const [jungianPersonality, setJungianPersonality] = useState(null);
  const [showPersonalityChart, setShowPersonalityChart] = useState(false);
  const [personalityConfirmed, setPersonalityConfirmed] = useState(false);
  const [pickingWord, setPickingWord] = useState(false);
  const [chartOpenedFromSurvey, setChartOpenedFromSurvey] = useState(false);
  const [generatedWordReadyForPopup, setGeneratedWordReadyForPopup] = useState(false);
  const [hasClosedPersonalityChartOnce, setHasClosedPersonalityChartOnce] = useState(false);
  const [feedPersonalityView, setFeedPersonalityView] = useState(null); // { nickname, dominantPersonality } when opening from a feed tile
  const [chartHideRing, setChartHideRing] = useState(false);
  const [editedPosterNickname, setEditedPosterNickname] = useState(null);
  const [showHeartPhotoUpload, setShowHeartPhotoUpload] = useState(false);
  const [heartPhotoFile, setHeartPhotoFile] = useState(null);
  const [heartPhotoPreview, setHeartPhotoPreview] = useState(null);
  const [heartPhotoUploading, setHeartPhotoUploading] = useState(false);
  const heartPhotoInputRef = useRef(null);
  const [heartGifs, setHeartGifs] = useState([]);
  const [heartGifSearch, setHeartGifSearch] = useState('');
  const [loadingHeartGifs, setLoadingHeartGifs] = useState(false);
  const [showHeartGifGrid, setShowHeartGifGrid] = useState(false);
  const surveyAnalysisPromiseRef = useRef(null);
  const surveyDescriptorPromiseRef = useRef(null);
  const personalityPickStartedRef = useRef(false);
  const jungianAnalysisTextRef = useRef(null);
  const [showFoxButton, setShowFoxButton] = useState(true);
  // User photo on the in-progress collage (vibe/survey/builder). Navbar/profile mirror primary via sync + Firestore snapshot.
  const [userPhotoUrl, setUserPhotoUrl] = useState(null);
  const PARTNER_CUTOUT_HINT_MESSAGES = ['Selecting magazines', 'Sharpening scissors', 'Cutting', 'Slicing', 'Dicing', 'Mincing', 'Carving', 'Tearing pages', 'Flipping through materials', 'Aligning edges', 'Tracing outlines', 'Marking cut lines', 'Snipping corners', 'Trimming excess', 'Shearing strips', 'Shaving thin layers', 'Scoring surfaces', 'Peeling back layers', 'Shredding pieces', 'Whittling shapes', 'Chopping sections', 'Splitting pieces', 'Notching edges', 'Punching holes', 'Perforating lines', 'Shaping contours', 'Sculpting details'];
  const [successPopupMessage, setSuccessPopupMessage] = useState(null); // Success popup for luv.wtf post or IRL confirm
  const [userProfilePhotoUrl, setUserProfilePhotoUrl] = useState(null); // User photo from profile (navbar dropdown)
  /** Unmasked user photo URL for the in-progress collage (survey / load poster / profile confirm). */
  const [collageUserPhotoOriginalUrl, setCollageUserPhotoOriginalUrl] = useState(null);
  /** Latest users/{uid}.userPhotoOriginalUrl from Firestore (for persist fallback). */
  const [profileUserPhotoOriginalUrl, setProfileUserPhotoOriginalUrl] = useState(null);
  const [feedTileDetailAd, setFeedTileDetailAd] = useState(null); // Ad for tile detail popup (Posted by + Looking for)
  /** Cutout URL the carousel card already decoded — preview clones this instead of refetching. */
  const feedTileDetailCutoutSrcRef = useRef(null);
  /** When set, main feed tile popup heading (not sub-views like SAY HELLO). Cleared when opening from feed grid or closing popup. */
  const [feedTileDetailTitleOverride, setFeedTileDetailTitleOverride] = useState(null);
  const [showReachOutGifPicker, setShowReachOutGifPicker] = useState(false);
  const [reachOutGifs, setReachOutGifs] = useState([]);
  const [reachOutGifSearch, setReachOutGifSearch] = useState('');
  const [loadingReachOutGifs, setLoadingReachOutGifs] = useState(false);
  const [reachOutSelectedGif, setReachOutSelectedGif] = useState(null);
  const [reachOutSubmitted, setReachOutSubmitted] = useState(false);
  const [reachOutSubmitting, setReachOutSubmitting] = useState(false);
  /** Reset when reach-out picker closes so each open triggers one KLIPY warmup (local grid + search). */
  const reachOutSpiritGifWarmupRef = useRef(false);
  const reachOutLocalBaseRef = useRef([]);
  const reachOutKlipyFetchGenRef = useRef(0);
  const reachOutGifGridScrollRef = useRef(null);
  const [isSavingPoster, setIsSavingPoster] = useState(false);
  const [editingActivityIndex, setEditingActivityIndex] = useState(null);
  /** Collage emoji activity picker: 9-tile grid + MORE OPTIONS + keyword search (matches InlineSurvey activities step). */
  const [activityPickerGrid, setActivityPickerGrid] = useState(() => {
    const filtered = activityEmojis.filter((e) => !RELIGION_EMOJIS.includes(e));
    return [...filtered].sort(() => Math.random() - 0.5).slice(0, 9);
  });
  const [activityPickerMoreClickCount, setActivityPickerMoreClickCount] = useState(0);
  const [showActivityPickerSearch, setShowActivityPickerSearch] = useState(false);
  const [activityPickerSearchQuery, setActivityPickerSearchQuery] = useState('');
  const [activityPickerSearchResults, setActivityPickerSearchResults] = useState([]);
  const [activityPickerSearchEmpty, setActivityPickerSearchEmpty] = useState(false);
  const [editingPlaceIndex, setEditingPlaceIndex] = useState(null);
  const [placePickerGrid, setPlacePickerGrid] = useState(() => getVariedPlacesSample(9));
  const [placePickerMoreClickCount, setPlacePickerMoreClickCount] = useState(0);
  const [showPlacePickerSearch, setShowPlacePickerSearch] = useState(false);
  const [placePickerSearchQuery, setPlacePickerSearchQuery] = useState('');
  const [placePickerSearchResults, setPlacePickerSearchResults] = useState([]);
  const [placePickerSearchLoading, setPlacePickerSearchLoading] = useState(false);
  const [placePickerSearchDone, setPlacePickerSearchDone] = useState(false);
  const [editingSwagIndex, setEditingSwagIndex] = useState(null);
  const [showBrandAddOwnInput, setShowBrandAddOwnInput] = useState(false);
  const [customBrandPrompt, setCustomBrandPrompt] = useState('');
  const [isGeneratingBrandImage, setIsGeneratingBrandImage] = useState(false);
  const [brandGenerateHintIndex, setBrandGenerateHintIndex] = useState(0);
  const [customBrandError, setCustomBrandError] = useState(null);
  const [showBrandSearch, setShowBrandSearch] = useState(false);
  const [brandSearchQuery, setBrandSearchQuery] = useState('');
  const [brandSearchResults, setBrandSearchResults] = useState([]);
  const [brandSearchLoading, setBrandSearchLoading] = useState(false);
  /** Last stuff-picker web search returned zero images (show hint under field). */
  const [brandPickerSearchEmpty, setBrandPickerSearchEmpty] = useState(false);
  /** Collage editor stuff tile: 9 options + MORE OPTIONS / search (matches inline survey brands step). */
  const [brandPickerOptions, setBrandPickerOptions] = useState(() => getVariedBrandSample(9));
  const [brandPickerMoreClickCount, setBrandPickerMoreClickCount] = useState(0);

  // Redeem Foxes / Cart / Orders state
  const [userCart, setUserCart] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [rewardsToRedeem, setRewardsToRedeem] = useState([]);
  const [couponRedeemModalOpen, setCouponRedeemModalOpen] = useState(false);
  const [collageFriendModalOpen, setCollageFriendModalOpen] = useState(false);
  const [yourRewardsConciergeKeys, setYourRewardsConciergeKeys] = useState([]);
  const [yourRewardsShare50SentKeys, setYourRewardsShare50SentKeys] = useState([]);
  const [userVibeAccuracy, setUserVibeAccuracy] = useState(null);
  const [userAuraRgb, setUserAuraRgb] = useState(null);
  // Tracks the uid we've already asked the server to assign an aura color for, so the
  // users/{uid} snapshot listener triggers the lazy ensure at most once per account.
  const auraEnsureRequestedForUidRef = useRef(null);
  /* Non-null while the post-edit vibe color is being held back; carries the pre-edit color to
     keep on screen until the reveal. Re-setting it restarts the window. */
  const [auraRecalc, setAuraRecalc] = useState(null);
  useEffect(() => {
    if (!auraRecalc) return undefined;
    const timer = setTimeout(() => setAuraRecalc(null), AURA_RECALC_REVEAL_MS);
    return () => clearTimeout(timer);
  }, [auraRecalc]);
  /* `userAuraRgb` already holds the drifted color during the window, so read this instead
     anywhere the aura is rendered. */
  const displayedAuraRgb = auraRecalc ? auraRecalc.prevRgb : userAuraRgb;
  const [userVibeCheckStreak, setUserVibeCheckStreak] = useState(0);
  const [userVibeCheckStreakLastPeriodKey, setUserVibeCheckStreakLastPeriodKey] = useState(null);
  const [redeemHintMessage, setRedeemHintMessage] = useState('');
  const [showCartPopup, setShowCartPopup] = useState(false);
  const [showOrderConfirmPopup, setShowOrderConfirmPopup] = useState(false);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [showMyCollagesInline, setShowMyCollagesInline] = useState(false);
  const [collageFriendFlowActive, setCollageFriendFlowActive] = useState(false);
  const [collageFriendInviteEmail, setCollageFriendInviteEmail] = useState(null);
  const [showCollageFriendSuccessPopup, setShowCollageFriendSuccessPopup] = useState(false);
  const [collageFriendSuccessPoster, setCollageFriendSuccessPoster] = useState(null);
  const [collageFriendLinkCopied, setCollageFriendLinkCopied] = useState(false);
  const [collageFriendEmailSent, setCollageFriendEmailSent] = useState(false);
  const [showFindsPopup, setShowFindsPopup] = useState(false);
  const [showMessagesPopup, setShowMessagesPopup] = useState(false);
  const [showFoxChatPopup, setShowFoxChatPopup] = useState(false);
  /** Drives {@link FoxChat} copy + ops send flow vs self-collage flow. */
  const [foxChatVariant, setFoxChatVariant] = useState('self');
  const [foxChatLauncherVisible, setFoxChatLauncherVisible] = useState(false);
  const heroStartBtnRef = useRef(null);
  const heroAuraZoneRef = useRef(null);
  const [inboxInitialConversationId, setInboxInitialConversationId] = useState(null);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
  /** Unread Fox daily-check row in Messages until the user responds with a GIF that day. */
  const [foxInboxUnread, setFoxInboxUnread] = useState(false);

  useEffect(() => {
    const scrollLocked = showFoxChatPopup || showMessagesPopup || !!feedTileDetailAd;
    if (!scrollLocked) return undefined;
    const prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevBodyOverflow;
    };
  }, [showFoxChatPopup, showMessagesPopup, feedTileDetailAd]);

  const [savedPosters, setSavedPosters] = useState([]);
  const [primaryCollageId, setPrimaryCollageId] = useState(null);
  const [loadingPosters, setLoadingPosters] = useState(false);
  /** uid whose saved posters have finished loading — used so post-login Fox Chat waits for `hasSavedCollage`. */
  const [postersHydratedUid, setPostersHydratedUid] = useState(null);
  /** Fire-and-forget after user doc writes so saves don’t wait on userPublicPrimary get+set. */
  const pushUserPublicPrimaryPreview = useCallback(
    () =>
      currentUser?.uid
        ? syncUserPublicPrimaryFromUserDocument(db, currentUser.uid, currentUser?.displayName).catch((e) => {
            console.warn('userPublicPrimary sync:', e);
          })
        : Promise.resolve(),
    [currentUser?.uid, currentUser?.displayName],
  );
  /** Once per sign-in: ensure chat peers can read userPublicPrimary even if primary was set server-side. */
  const ensuredUserPublicPrimaryUidRef = useRef(null);
  /** Poster ids we already tried to backfill a missed vibe-fox mask for this session. */
  const foxMaskBackfillAttemptedRef = useRef(new Set());
  const [posterDeleteConfirmId, setPosterDeleteConfirmId] = useState(null);
  const [showSavedPosterPopup, setShowSavedPosterPopup] = useState(false);
  const [savedPosterForPopup, setSavedPosterForPopup] = useState(null);
  const [savedPosterLinkCopied, setSavedPosterLinkCopied] = useState(false);
  /** 1 = MATCH WITH (genders), 2 = match intro + MEET PEOPLE (always COMPUTER MATCH). FIND + self gender set in nickname confirmation popup. */
  const [savedPosterFlowStep, setSavedPosterFlowStep] = useState(1);
  /** Up to 3 of 'male' | 'female' | 'nb' — MATCH WITH step */
  const [savedPosterLookingFor, setSavedPosterLookingFor] = useState([]);
  /** Saved poster: opt-in to five prizes / “win $100 for dinner” (promoteOnLuvwtfSocials on POST + savedWantedPosters). */
  const [promoteOnLuvwtfSocialsChecked, setPromoteOnLuvwtfSocialsChecked] = useState(true);
  const [showPromoteOnSocialsExplainer, setShowPromoteOnSocialsExplainer] = useState(false);
  const [showVerifiedUniversitiesPopup, setShowVerifiedUniversitiesPopup] = useState(false);
  const [showVisualVibeTransformerExplainer, setShowVisualVibeTransformerExplainer] = useState(false);
  /** 'default' = WIN $100 explainer; 'participating' = weekly $100 drop copy (hero ENROLL when signed in and not opted in on primary) */
  const [promoteOnSocialsExplainerVariant, setPromoteOnSocialsExplainerVariant] = useState('default');
  const [promoteOnSocialsExplainerOptInBusy, setPromoteOnSocialsExplainerOptInBusy] = useState(false);
  const closePromoteOnSocialsExplainer = useCallback(() => {
    setShowPromoteOnSocialsExplainer(false);
    setPromoteOnSocialsExplainerVariant('default');
    setPromoteOnSocialsExplainerOptInBusy(false);
  }, []);
  const openPromoteOnSocialsExplainer = useCallback((variant = 'default') => {
    setPromoteOnSocialsExplainerVariant(variant);
    setShowPromoteOnSocialsExplainer(true);
  }, []);
  const [matchFlowPoster, setMatchFlowPoster] = useState(null);
  const [matchFlowStep, setMatchFlowStep] = useState(null);
  const [matchFlowType, setMatchFlowType] = useState(null);
  const [matchFlowExistingPrivate, setMatchFlowExistingPrivate] = useState(null);
  const [matchFlowExistingPosted, setMatchFlowExistingPosted] = useState(null);
  /** Selections from POST / match flow when opening replace dialogs */
  const [matchFlowSelectionPrivate, setMatchFlowSelectionPrivate] = useState(true);
  const [matchFlowSelectionCommunity, setMatchFlowSelectionCommunity] = useState(true);
  /** If set, user is dropping a match channel vs their previous collage — confirm adding it back */
  const [matchFlowReductionPrompt, setMatchFlowReductionPrompt] = useState(null);
  /** True when confirm step is success after user-menu match removal (not add/replace flow). */
  const [matchFlowConfirmRemoval, setMatchFlowConfirmRemoval] = useState(false);
  const [matchFlowLoading, setMatchFlowLoading] = useState(false);
  const [giveawayOptOutConfirmOpen, setGiveawayOptOutConfirmOpen] = useState(false);
  const [giveawayOptOutSaving, setGiveawayOptOutSaving] = useState(false);
  const [giveawayOptInSaving, setGiveawayOptInSaving] = useState(false);
  const [showDuplicatePostPopup, setShowDuplicatePostPopup] = useState(false);
  const [showPostConfirmPopup, setShowPostConfirmPopup] = useState(false);
  const [dinnerOptInExplainerOpen, setDinnerOptInExplainerOpen] = useState(false);
  /** GET A SPIN: true while the random collage's images are warming before the popup opens. */
  const [matchaSpinLoading, setMatchaSpinLoading] = useState(false);
  const matchaSpinGenRef = useRef(0);
  const handleDinnerOptInExplainerOpen = useCallback(() => {
    setDinnerOptInExplainerOpen(true);
  }, []);
  const closeDinnerOptInExplainer = useCallback(() => {
    matchaSpinGenRef.current += 1;
    setMatchaSpinLoading(false);
    setDinnerOptInExplainerOpen(false);
  }, []);
  const [paidForDateExplainerOpen, setPaidForDateExplainerOpen] = useState(false);
  const handlePaidForDateExplainerOpen = useCallback(() => {
    setPaidForDateExplainerOpen(true);
  }, []);
  const [foxPaidDatesWeeklyOptInOpen, setFoxPaidDatesWeeklyOptInOpen] = useState(false);
  const [foxPaidDatesWeeklyOptOutOpen, setFoxPaidDatesWeeklyOptOutOpen] = useState(false);
  const [foxPaidDatesWeeklyOptInSuccessOpen, setFoxPaidDatesWeeklyOptInSuccessOpen] = useState(false);
  const [foxPaidDatesWeeklyOptOutSuccessOpen, setFoxPaidDatesWeeklyOptOutSuccessOpen] = useState(false);
  const openWeeklyFeaturedOptInOrOptOutPopup = () => {
    const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
    if (primary?.promoteOnLuvwtfSocials === true) {
      setFoxPaidDatesWeeklyOptOutOpen(true);
      return;
    }
    setFoxPaidDatesWeeklyOptInOpen(true);
  };
  const handleFoxPaidDatesWeeklyOptInConfirm = async () => {
    const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
    if (!primary?.id) {
      setFoxPaidDatesWeeklyOptInOpen(false);
      return;
    }
    if (primary.promoteOnLuvwtfSocials === true) {
      setFoxPaidDatesWeeklyOptInOpen(false);
      return;
    }
    const ok = await handleUserMenuPrimaryPromoteSet(primary.id, true, primary, 'fox_paid_dates');
    if (ok) {
      setFoxPaidDatesWeeklyOptInOpen(false);
      setFoxPaidDatesWeeklyOptInSuccessOpen(true);
    }
  };
  const handleFoxPaidDatesWeeklyOptOutConfirm = async () => {
    const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
    if (!primary?.id) {
      setFoxPaidDatesWeeklyOptOutOpen(false);
      return;
    }
    const ok = await handleUserMenuPrimaryPromoteSet(primary.id, false, primary, 'fox_paid_dates');
    if (ok) {
      setFoxPaidDatesWeeklyOptOutOpen(false);
      setFoxPaidDatesWeeklyOptOutSuccessOpen(true);
    }
  };
  /* `autoFocus` inside position:fixed popups makes the browser scroll the document toward the
     element's (meaningless) flow position — i.e. the top of the page. Focus without scrolling. */
  const focusPopupInputOnMount = useCallback((node) => {
    if (node) node.focus({ preventScroll: true });
  }, []);
  const [sponsoredDateIdeaPopupOpen, setSponsoredDateIdeaPopupOpen] = useState(false);
  const [sponsoredDateIdeaPlace, setSponsoredDateIdeaPlace] = useState('');
  const [sponsoredDateIdeaHighlights, setSponsoredDateIdeaHighlights] = useState('');
  const [sponsoredDateIdeaWhatToDo, setSponsoredDateIdeaWhatToDo] = useState('');
  const [sponsoredDateIdeaPlaceResults, setSponsoredDateIdeaPlaceResults] = useState([]);
  const [sponsoredDateIdeaSelectedPlace, setSponsoredDateIdeaSelectedPlace] = useState(null);
  const [sponsoredDateIdeaPlaceSearchLoading, setSponsoredDateIdeaPlaceSearchLoading] = useState(false);
  const [sponsoredDateIdeaSubmitting, setSponsoredDateIdeaSubmitting] = useState(false);
  const [sponsoredDateIdeaSubmitted, setSponsoredDateIdeaSubmitted] = useState(false);
  const [sponsoredDateIdeaError, setSponsoredDateIdeaError] = useState('');
  const sponsoredDateIdeaPlaceSearchDebounceRef = useRef(null);
  const sponsoredDateIdeaPlaceSearchSeqRef = useRef(0);
  const sponsoredDateIdeaOpenScrollYRef = useRef(0);
  const openSponsoredDateIdeaPopup = useCallback(() => {
    sponsoredDateIdeaOpenScrollYRef.current = window.scrollY;
    setSponsoredDateIdeaPopupOpen(true);
  }, []);
  const closeSponsoredDateIdeaPopup = useCallback(() => {
    sponsoredDateIdeaPlaceSearchSeqRef.current += 1;
    if (sponsoredDateIdeaPlaceSearchDebounceRef.current) {
      window.clearTimeout(sponsoredDateIdeaPlaceSearchDebounceRef.current);
      sponsoredDateIdeaPlaceSearchDebounceRef.current = null;
    }
    setSponsoredDateIdeaPopupOpen(false);
    setSponsoredDateIdeaPlace('');
    setSponsoredDateIdeaHighlights('');
    setSponsoredDateIdeaWhatToDo('');
    setSponsoredDateIdeaPlaceResults([]);
    setSponsoredDateIdeaSelectedPlace(null);
    setSponsoredDateIdeaPlaceSearchLoading(false);
    setSponsoredDateIdeaError('');
    setSponsoredDateIdeaSubmitted(false);
  }, []);
  const handleSponsoredDateIdeaSubmit = useCallback(async () => {
    const place = sponsoredDateIdeaPlace.trim();
    const highlights = sponsoredDateIdeaHighlights.trim();
    const whatToDo = sponsoredDateIdeaWhatToDo.trim();
    if (!place || !highlights || !whatToDo) {
      setSponsoredDateIdeaError('Please fill in Place, Highlights, and What to get / do.');
      return;
    }
    setSponsoredDateIdeaSubmitting(true);
    setSponsoredDateIdeaError('');
    try {
      const submission = {
        place,
        highlights,
        whatToGetOrDo: whatToDo,
        location: place,
        notes: `${highlights}\n\n${whatToDo}`,
        posted: false,
        createdAt: serverTimestamp(),
        userId: currentUser?.uid ?? null,
        userEmail: currentUser?.email ?? null,
      };
      if (sponsoredDateIdeaSelectedPlace) {
        const originalImageUrl = sponsoredDateIdeaSelectedPlace.imageUrl ?? null;
        let imageStorageUrl = null;
        if (originalImageUrl) {
          await auth.authStateReady();
          if (!auth.currentUser) {
            await signInAnonymously(auth);
          }
          imageStorageUrl = await persistHttpsImageToStorage(
            originalImageUrl,
            'sponsored_date_ideas',
            'jpg',
          );
        }
        submission.selectedPlace = {
          id: sponsoredDateIdeaSelectedPlace.id ?? null,
          name: sponsoredDateIdeaSelectedPlace.name ?? place,
          imageUrl: originalImageUrl,
          imageStorageUrl,
          imageUrls: Array.isArray(sponsoredDateIdeaSelectedPlace.imageUrls)
            ? sponsoredDateIdeaSelectedPlace.imageUrls
            : [],
        };
      }
      await addDoc(collection(db, 'sponsoredDateIdeaSubmissions'), submission);
      setSponsoredDateIdeaSubmitted(true);
    } catch (err) {
      console.error('sponsoredDateIdea submit:', err);
      setSponsoredDateIdeaError('Could not submit. Check your connection and try again.');
    } finally {
      setSponsoredDateIdeaSubmitting(false);
    }
  }, [
    sponsoredDateIdeaPlace,
    sponsoredDateIdeaHighlights,
    sponsoredDateIdeaWhatToDo,
    sponsoredDateIdeaSelectedPlace,
    currentUser?.uid,
    currentUser?.email,
  ]);

  useEffect(() => {
    if (!sponsoredDateIdeaPopupOpen || sponsoredDateIdeaSubmitted) return undefined;

    const query = sponsoredDateIdeaPlace.trim();
    if (sponsoredDateIdeaPlaceSearchDebounceRef.current) {
      window.clearTimeout(sponsoredDateIdeaPlaceSearchDebounceRef.current);
      sponsoredDateIdeaPlaceSearchDebounceRef.current = null;
    }

    if (!query) {
      setSponsoredDateIdeaPlaceResults([]);
      setSponsoredDateIdeaPlaceSearchLoading(false);
      return undefined;
    }

    sponsoredDateIdeaPlaceSearchDebounceRef.current = window.setTimeout(async () => {
      const seq = sponsoredDateIdeaPlaceSearchSeqRef.current + 1;
      sponsoredDateIdeaPlaceSearchSeqRef.current = seq;
      setSponsoredDateIdeaPlaceSearchLoading(true);
      try {
        const results = await searchPlaces(query);
        if (seq !== sponsoredDateIdeaPlaceSearchSeqRef.current) return;
        const list = (Array.isArray(results) ? results : []).slice(0, 2);
        setSponsoredDateIdeaPlaceResults(list);
      } catch (err) {
        if (seq !== sponsoredDateIdeaPlaceSearchSeqRef.current) return;
        console.error('sponsored date idea place search:', err);
        setSponsoredDateIdeaPlaceResults([]);
      } finally {
        if (seq === sponsoredDateIdeaPlaceSearchSeqRef.current) {
          setSponsoredDateIdeaPlaceSearchLoading(false);
        }
      }
    }, 400);

    return () => {
      if (sponsoredDateIdeaPlaceSearchDebounceRef.current) {
        window.clearTimeout(sponsoredDateIdeaPlaceSearchDebounceRef.current);
        sponsoredDateIdeaPlaceSearchDebounceRef.current = null;
      }
    };
  }, [sponsoredDateIdeaPlace, sponsoredDateIdeaPopupOpen, sponsoredDateIdeaSubmitted]);

  useEffect(() => {
    if (!sponsoredDateIdeaPopupOpen) return undefined;
    const y = sponsoredDateIdeaOpenScrollYRef.current;
    let raf2 = null;
    const raf1 = requestAnimationFrame(() => {
      window.scrollTo(0, y);
      raf2 = requestAnimationFrame(() => {
        window.scrollTo(0, y);
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      if (raf2 !== null) cancelAnimationFrame(raf2);
    };
  }, [sponsoredDateIdeaPopupOpen]);

  const sponsoredDateIdeaPlacePhotoTiles = useMemo(() => {
    const selectedId = sponsoredDateIdeaSelectedPlace?.id ?? null;
    const tiles = [];
    if (sponsoredDateIdeaSelectedPlace) {
      tiles.push({
        place: sponsoredDateIdeaSelectedPlace,
        key: `selected-${sponsoredDateIdeaSelectedPlace.id || 'place'}`,
        isSelected: true,
      });
    }
    (Array.isArray(sponsoredDateIdeaPlaceResults) ? sponsoredDateIdeaPlaceResults : [])
      .filter((p) => !selectedId || p.id !== selectedId)
      .slice(0, 2)
      .forEach((place, index) => {
        tiles.push({
          place,
          key: place.id || `search-${index}`,
          isSelected: false,
        });
      });
    return tiles;
  }, [sponsoredDateIdeaSelectedPlace, sponsoredDateIdeaPlaceResults]);

  const scrollToMatchAFriendSection = useCallback(() => {
    document.getElementById('earn-foxes')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  /**
   * Bring the top of the primary collage's nickname tile into view (used after saving a collage
   * edit instead of jumping to the top of Your collages). The section only renders once
   * `loadingPosters` clears, so poll for the tile rather than guessing a single delay.
   */
  const scrollToPrimaryNicknameTile = useCallback(() => {
    const deadline = Date.now() + 2000;
    const scrollNow = () => {
      const el = document.querySelector('.user-menu-main-nickname-tile-wrap');
      if (!el) return false;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };
    const tick = () => {
      if (scrollNow()) {
        /* Collage images settle after the first scroll and shift the tile; correct once. */
        window.setTimeout(scrollNow, 400);
        return;
      }
      if (Date.now() < deadline) window.setTimeout(tick, 60);
    };
    window.setTimeout(tick, 60);
  }, []);

  const promptFeedMatchReferSignupIfNeeded = useCallback(() => {
    if (currentUser) return;
    onShowSignUp?.(FEED_MATCH_REFERRAL_SIGNUP_HINT, 'feed');
  }, [currentUser, onShowSignUp]);
  const [promoteSocials, setPromoteSocials] = useState(true);
  const [showPostFlyersIrlConfirmPopup, setShowPostFlyersIrlConfirmPopup] = useState(false);
  const [currentPosterPostedIrl, setCurrentPosterPostedIrl] = useState(false);
  const [showPostTiktokConfirmPopup, setShowPostTiktokConfirmPopup] = useState(false);
  const [currentPosterPostedTiktok, setCurrentPosterPostedTiktok] = useState(false);
  const [showNicknameConflictPopup, setShowNicknameConflictPopup] = useState(false);
  const [userBerkeleyEmail, setUserBerkeleyEmail] = useState(null);
  const [userBerkeleyEmailVerifiedAddress, setUserBerkeleyEmailVerifiedAddress] = useState(null);
  const [showBerkeleyEmailPopup, setShowBerkeleyEmailPopup] = useState(false);
  const [berkeleyEmailInput, setBerkeleyEmailInput] = useState('');
  const [berkeleyEmailError, setBerkeleyEmailError] = useState('');
  const [berkeleyEmailSubmitting, setBerkeleyEmailSubmitting] = useState(false);
  const [berkeleyEmailSubmitted, setBerkeleyEmailSubmitted] = useState(false);
  const [berkeleyEmailPending, setBerkeleyEmailPending] = useState(false);
  const [berkeleyEmailVerified, setBerkeleyEmailVerified] = useState(false);
  const [berkeleyEmailVerifyLastSentMs, setBerkeleyEmailVerifyLastSentMs] = useState(0);
  const [berkeleyEmailVerifySendFailedMs, setBerkeleyEmailVerifySendFailedMs] = useState(0);
  const [profileVerified, setProfileVerified] = useState(null);
  const [userNotificationEmail, setUserNotificationEmail] = useState(null);
  const [suggestedNicknameInPopup, setSuggestedNicknameInPopup] = useState('');
  const [feedShareLinkCopied, setFeedShareLinkCopied] = useState(false);
  const [showReferOptions, setShowReferOptions] = useState(false);
  const [showReferEmailInput, setShowReferEmailInput] = useState(false);
  const [referFriendEmail, setReferFriendEmail] = useState('');
  const [referFriendEmailError, setReferFriendEmailError] = useState('');
  const [referFriendSubmitted, setReferFriendSubmitted] = useState(false);
  const [showReferIgInput, setShowReferIgInput] = useState(false);
  const [referFriendIg, setReferFriendIg] = useState('');
  const [referFriendIgError, setReferFriendIgError] = useState('');
  const [referFriendIgSubmitted, setReferFriendIgSubmitted] = useState(false);
  const [feedReferLinkCopied, setFeedReferLinkCopied] = useState(false);
  /** Primary collage: "Share your collage" opens same refer-a-friend UI as feed (poster id = shared poster doc). */
  const [userMenuPrimaryReferPosterId, setUserMenuPrimaryReferPosterId] = useState(null);
  /** Friend collage editor: same “Share collage” UI as feed COLLAGE DETAILS */
  const [showFriendCollageReferPopup, setShowFriendCollageReferPopup] = useState(false);
  const [friendCollageReferPhase, setFriendCollageReferPhase] = useState('menu');
  const [friendCollageReferLinkCopied, setFriendCollageReferLinkCopied] = useState(false);
  /** Poster id for Refer-a-friend popup after SEND TO FRIEND save (React state; reliable before next paint). */
  const [friendCollageReferPosterId, setFriendCollageReferPosterId] = useState(null);
  const [currentPosterAlreadySaved, setCurrentPosterAlreadySaved] = useState(false);
  const [editingSavedPosterId, setEditingSavedPosterId] = useState(null);
  /** When true, hide FRIEND/ROMANTIC LUV icons under cutout in main editor (Your collages → Edit primary). */
  const [suppressPrimaryLuvIconsOnEditorCanvas, setSuppressPrimaryLuvIconsOnEditorCanvas] = useState(false);
  /** FIND step: self gender + friend/romantic Luv (set in nickname popup; persisted on save). */
  const [collageFinderSelfGender, setCollageFinderSelfGender] = useState(null);
  const [collageFinderFriendLuv, setCollageFinderFriendLuv] = useState(false);
  const [collageFinderRomanticLuv, setCollageFinderRomanticLuv] = useState(false);
  /** Romantic match gender prefs (male | female | nb) — mirrors FoxChat `lookingForGenders`. */
  const [collageFinderLookingForGenders, setCollageFinderLookingForGenders] = useState([]);
  /** Self age for FIND strip + save — same wheel as FoxChat (18–120). */
  const [collageFinderSelfAge, setCollageFinderSelfAge] = useState(AGE_WHEEL_DEFAULT);
  /** Verified profile changed age in nickname popup: confirm re-verification before applying. */
  const [ageReverifyConfirmOpen, setAgeReverifyConfirmOpen] = useState(false);
  const [ageReverifySaving, setAgeReverifySaving] = useState(false);
  /** Saved-poster self age when the nickname popup opened — baseline for "age changed" detection. */
  const chartOpenSelfAgeRef = useRef(null);
  const [editingFeedAdId, setEditingFeedAdId] = useState(null);
  const [posterDetailFromList, setPosterDetailFromList] = useState(null);
  /** Heading for collage-details popup (e.g. SAVED! after edit-from-detail save). */
  const [posterDetailFromListTitleOverride, setPosterDetailFromListTitleOverride] = useState(null);
  /** When set, successful save of this saved-poster id reopens list collage-details with title override. */
  const reopenPosterDetailAfterSaveIdRef = useRef(null);
  const [posterDetailLinkCopied, setPosterDetailLinkCopied] = useState(false);
  const [showUnpostConfirm, setShowUnpostConfirm] = useState(false);
  /** From draft list: replace primary — { currentPrimary, newPrimary } */
  const [makePrimaryReplaceConfirm, setMakePrimaryReplaceConfirm] = useState(null);
  const [makePrimaryReplaceLoading, setMakePrimaryReplaceLoading] = useState(false);
  const skipNextPosterChangeCheckRef = useRef(false);
  /** After first-time save, open Your collages when Saved! popup closes (avoids swapping layout under the modal). */
  const openCollagesAfterSavedPosterPopupRef = useRef(false);
  /**
   * When set, the `privateUpdate` popup ("UPDATE YOUR PRIMARY COLLAGE?") is being driven by the
   * FoxChat post-save flow rather than HomePage's InlineSurvey. The UPDATE button should perform
   * a silent swap (no `confirm` step popup, no SAVED! popup re-open on dismiss) — FoxChat already
   * gave the user inline SAVED! feedback and the user is already on "Your collages."
   *
   * Cleared in `handleMatchFlowClose` (any path) and at the end of the silent UPDATE handler.
   */
  const matchFlowQuietPrivateSwapRef = useRef(false);
  /** FoxChat save: poster snapshot until HomePage shows PRIZE OPT-IN after Your collages redirect. */
  const pendingFoxChatBountyPosterRef = useRef(null);
  const [foxChatBountyPromptOpen, setFoxChatBountyPromptOpen] = useState(false);
  const [foxChatDeferredBountyPoster, setFoxChatDeferredBountyPoster] = useState(null);
  const foxChatBountyPromptOpenRef = useRef(false);
  const bountyPopupAnalyticsSourceRef = useRef('foxchat_bounty_optin');
  const handledPostLoginCollagesNonceRef = useRef(0);
  const handledPostLoginRewardsNonceRef = useRef(0);
  useEffect(() => {
    foxChatBountyPromptOpenRef.current = foxChatBountyPromptOpen;
  }, [foxChatBountyPromptOpen]);
  useEffect(() => {
    if (!currentUser?.uid) {
      handledPostLoginCollagesNonceRef.current = 0;
      handledPostLoginRewardsNonceRef.current = 0;
    }
  }, [currentUser?.uid]);

  const mainPrivateMatchPosterNickname = useMemo(
    () => getPrimaryCollagePosterNickname(savedPosters, primaryCollageId),
    [savedPosters, primaryCollageId],
  );

  const primaryCollageLuvPrefsOnCanvas = useMemo(() => {
    const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
    if (!primary || !editingSavedPosterId || primary.id !== editingSavedPosterId) {
      return { show: false, friend: false, romantic: false };
    }
    const { friend, romantic } = posterFindLuvIconFlags(primary);
    return { show: true, friend, romantic };
  }, [savedPosters, primaryCollageId, editingSavedPosterId]);

  /** Saved poster row for the collage open in the main editor — drives feed-style nickname strip (gender + FIND Luv). */
  const collageEditorSavedPosterForNickname = useMemo(() => {
    if (editingSavedPosterId) {
      return savedPosters.find((p) => p.id === editingSavedPosterId) || null;
    }
    if (editingFeedAdId) {
      return savedPosters.find((p) => p.feedAdId === editingFeedAdId) || null;
    }
    return null;
  }, [savedPosters, editingSavedPosterId, editingFeedAdId]);

  /** Friend-oriented UI (SEND TO FRIEND, friend survey copy): active creator flow or saved “I collaged a friend” poster — not recipient who saved from shared link (`savedFromFriendShareLink`). */
  const friendCollageCopyActive = useMemo(() => {
    if (collageFriendFlowActive) return true;
    const row = collageEditorSavedPosterForNickname;
    return !!(row && row.friendCollageShare && !row.savedFromFriendShareLink);
  }, [collageFriendFlowActive, collageEditorSavedPosterForNickname]);

  const [friendCutoutReplacedSinceSurvey, setFriendCutoutReplacedSinceSurvey] = useState(false);

  const showFriendSessionFoxPlaceholder =
    friendCollageCopyActive &&
    !friendCutoutReplacedSinceSurvey &&
    !surveyAnswers?.user_photo;

  /** Standard collage: survey completed but user skipped masked photo upload (fox fallback cutout). */
  const showSelfSessionFoxPlaceholder =
    !friendCollageCopyActive &&
    !friendCutoutReplacedSinceSurvey &&
    !surveyAnswers?.user_photo;

  const showSessionFoxMaskPlaceholder =
    showFriendSessionFoxPlaceholder || showSelfSessionFoxPlaceholder;

  /** Shapes the saved row passed into `FeedNicknameTile` as `editorSavedPoster` (gender/age + FIND Luv + looking-for). */
  const collageNicknameStripPoster = useMemo(() => {
    const fromList =
      (editingSavedPosterId && savedPosters.find((p) => p.id === editingSavedPosterId)) ||
      (editingFeedAdId && savedPosters.find((p) => p.feedAdId === editingFeedAdId)) ||
      null;
    const base = fromList || collageEditorSavedPosterForNickname;
    if (base) {
      const lfFromFinder =
        collageFinderRomanticLuv &&
        Array.isArray(collageFinderLookingForGenders) &&
        collageFinderLookingForGenders.length > 0
          ? [...collageFinderLookingForGenders]
          : null;
      const lfFromBase =
        Array.isArray(base.lookingForGenders) && base.lookingForGenders.length > 0
          ? [...base.lookingForGenders]
          : null;
      return {
        ...base,
        selfGender: collageFinderSelfGender ?? base.selfGender,
        friendLuv: collageFinderFriendLuv,
        romanticLuv: collageFinderRomanticLuv,
        selfAge: collageFinderSelfAge,
        lookingForGenders: collageFinderRomanticLuv
          ? (lfFromFinder || lfFromBase || [])
          : lfFromBase,
      };
    }
    if (collageFinderSelfGender && (collageFinderFriendLuv || collageFinderRomanticLuv)) {
      return {
        selfGender: collageFinderSelfGender,
        selfAge: collageFinderSelfAge,
        friendLuv: collageFinderFriendLuv,
        romanticLuv: collageFinderRomanticLuv,
        lookingForGenders:
          collageFinderRomanticLuv &&
          Array.isArray(collageFinderLookingForGenders) &&
          collageFinderLookingForGenders.length > 0
            ? [...collageFinderLookingForGenders]
            : undefined,
      };
    }
    return null;
  }, [
    savedPosters,
    editingSavedPosterId,
    editingFeedAdId,
    collageEditorSavedPosterForNickname,
    collageFinderSelfGender,
    collageFinderFriendLuv,
    collageFinderRomanticLuv,
    collageFinderLookingForGenders,
    collageFinderSelfAge,
  ]);

  const prevShowPersonalityChartRef = useRef(false);
  useEffect(() => {
    const justOpened = showPersonalityChart && !prevShowPersonalityChartRef.current;
    prevShowPersonalityChartRef.current = showPersonalityChart;
    if (!showPersonalityChart || feedPersonalityView || !justOpened) return;
    const p = collageEditorSavedPosterForNickname;
    chartOpenSelfAgeRef.current = null;
    if (!p) return;
    setCollageFinderSelfGender(
      p.selfGender && ['male', 'female', 'nb'].includes(p.selfGender) ? p.selfGender : null,
    );
    const fl = posterFindLuvIconFlags(p);
    setCollageFinderFriendLuv(typeof p.friendLuv === 'boolean' ? p.friendLuv : fl.friend);
    setCollageFinderRomanticLuv(typeof p.romanticLuv === 'boolean' ? p.romanticLuv : fl.romantic);
    setCollageFinderLookingForGenders(
      Array.isArray(p.lookingForGenders) && p.lookingForGenders.length ? [...p.lookingForGenders] : [],
    );
    {
      const n = typeof p.selfAge === 'number' ? p.selfAge : NaN;
      const validAge = Number.isFinite(n) && n >= 18 && n <= 120 ? n : null;
      chartOpenSelfAgeRef.current = validAge;
      setCollageFinderSelfAge(validAge ?? AGE_WHEEL_DEFAULT);
    }
  }, [showPersonalityChart, feedPersonalityView, collageEditorSavedPosterForNickname]);

  const posterDetailFromListIsPrimary = useMemo(() => {
    if (!posterDetailFromList) return false;
    const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
    return !!(primary && primary.id === posterDetailFromList.id);
  }, [posterDetailFromList, savedPosters, primaryCollageId]);

  // Focus was on a row/tile that unmounts; Safari moves focus to the first tabbable in the new dialog (the ×).
  // Blur the close button so it does not show a system focus ring on open.
  useEffect(() => {
    if (!posterDetailFromList && !feedTileDetailAd) return;
    let cancelled = false;
    const id1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (cancelled) return;
        const closeBtn =
          document.querySelector('.collage-details-popup .feed-tile-detail-close') ||
          document.querySelector('.feed-tile-detail-popup--feed .feed-tile-detail-close');
        if (closeBtn && document.activeElement === closeBtn) closeBtn.blur();
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(id1);
    };
  }, [posterDetailFromList, feedTileDetailAd]);

  // Advance hint messages while personality chart is still open (once through, stop at last)
  useEffect(() => {
    if (hasClosedPersonalityChartOnce || !selectedPartnerCutout) {
      setPartnerCutoutHintIndex(0);
      return;
    }
    const id = setInterval(() => {
      setPartnerCutoutHintIndex((i) => Math.min(i + 1, PARTNER_CUTOUT_HINT_MESSAGES.length - 1));
    }, 1500);
    return () => clearInterval(id);
  }, [hasClosedPersonalityChartOnce, selectedPartnerCutout]);

  // Advance hint messages during cutout re-upload
  const CUTOUT_REUPLOAD_HINTS = [
    'Sharpening scissors (5)', 'Sharpening scissors (4)', 'Sharpening scissors (3)', 'Sharpening scissors (2)', 'Sharpening scissors (1)',
    'Adding fox mask.. (4)', 'Adding fox mask.. (3)', 'Adding fox mask.. (2)', 'Adding fox mask.. (1)',
    'Adding fox mask...',
  ];
  useEffect(() => {
    if (!cutoutReuploadUploading && !cutoutReuploadProcessing) {
      setCutoutReuploadHintIndex(0);
      return;
    }
    let idx = 0;
    const tick = () => {
      idx += 1;
      setCutoutReuploadHintIndex(Math.min(idx, CUTOUT_REUPLOAD_HINTS.length - 1));
      const delay =
        idx < 5 ? 1000 : idx === 5 ? 1500 : idx < 9 ? 1000 : 1500;
      timerId = setTimeout(tick, delay);
    };
    let timerId = setTimeout(tick, 1000);
    return () => clearTimeout(timerId);
  }, [cutoutReuploadUploading, cutoutReuploadProcessing]);

  // Advance hint messages during edit cutout (once through, stop at last)
  useEffect(() => {
    if (!isEditingCutout) {
      setEditCutoutHintIndex(0);
      return;
    }
    const id = setInterval(() => {
      setEditCutoutHintIndex((i) => Math.min(i + 1, PARTNER_CUTOUT_HINT_MESSAGES.length - 1));
    }, 1500);
    return () => clearInterval(id);
  }, [isEditingCutout]);

  // Advance hint messages during brand image generation (once through, stop at last)
  useEffect(() => {
    if (!isGeneratingBrandImage) {
      setBrandGenerateHintIndex(0);
      return;
    }
    const id = setInterval(() => {
      setBrandGenerateHintIndex((i) => Math.min(i + 1, PARTNER_CUTOUT_HINT_MESSAGES.length - 1));
    }, 1500);
    return () => clearInterval(id);
  }, [isGeneratingBrandImage]);

  // Image Upload State (for Analyze IG)
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [uploadMode, setUploadMode] = useState(null); // 'ig' or 'ex'
  
  // Ex Image Upload State (for Recycle your ex)
  const [showExImageUpload, setShowExImageUpload] = useState(false);
  const [uploadedExImage, setUploadedExImage] = useState(null);
  const [exImagePreview, setExImagePreview] = useState(null);
  const [isAnalyzingEx, setIsAnalyzingEx] = useState(false);

  // Sample Poster State (for home page collage). The partner cutout is initialized synchronously
  // (not in an effect) so a cutout is painted on the very first render, with no post-mount delay.
  // Start with the first cutout — it's the only one preloaded in index.html, so it shows instantly;
  // rotation randomizes from there.
  const [samplePartnerCutout, setSamplePartnerCutout] = useState(() => sampleCutouts[0]);
  const [sampleSwags, setSampleSwags] = useState([]);
  const [sampleActivities, setSampleActivities] = useState([]);
  const [heartGifIndex, setHeartGifIndex] = useState(0);
  const [sampleActivityEmojis, setSampleActivityEmojis] = useState([]);
  const [samplePlaces, setSamplePlaces] = useState([]);
  const [sampleNicknameIndex, setSampleNicknameIndex] = useState(0);
  const [sampleFeedFindLuv, setSampleFeedFindLuv] = useState(() => randomSampleFeedFindLuvFlags());
  const [tapeRotation, setTapeRotation] = useState(-4);
  const [feedCutoutUrls, setFeedCutoutUrls] = useState([]);
  /** Random offset/rotation for "make real" image on sample poster – updated every 1s with sample rotation */
  const [sampleMakerealOffset, setSampleMakerealOffset] = useState({ dx: 0, dy: 0, rot: 0 });
  /** Random jagged clip-path variant for partner cutout (1–3, same for initial and final poster) */
  const [partnerCutoutJaggedClass] = useState(() => {
    const v = Math.floor(Math.random() * 3) + 1;
    return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
  });
  /** Tilt and offset stay with a tile set. Recomputing them in render jiggles the first cutout
   *  every time the rest of the page updates. */
  const sampleSwagLayouts = useMemo(
    () => (sampleSwags || []).map(() => ({
      rotation: (Math.random() * 30 - 15).toFixed(1),
      horizontalOffset: (Math.random() * 40 - 20).toFixed(1),
    })),
    [sampleSwags],
  );
  const sampleEmojiLayouts = useMemo(
    () => (sampleActivityEmojis || []).map(() => ({
      rotation: (Math.random() * 30 - 15).toFixed(1),
      horizontalOffset: (Math.random() * 40 - 20).toFixed(1),
      background: `hsl(${(35 + Math.random() * 15).toFixed(0)}, ${(85 + Math.random() * 15).toFixed(0)}%, ${(65 + Math.random() * 15).toFixed(0)}%)`,
      fontSize: `${(2.5 + Math.random() * 1.5).toFixed(1)}rem`,
    })),
    [sampleActivityEmojis],
  );

  // Hero sample poster — PRIORITY 2: once the cutout photo has finished loading, fill in the
  // surrounding brand / emoji / place / gif + activity tiles. Runs once on initial load.
  useEffect(() => {
    if (!samplePartnerCutout) return;
    if (sampleSwags.length > 0) return; // tiles already populated (initial load only)
    let cancelled = false;
    let done = false;
    const loadTiles = () => {
      if (cancelled || done) return;
      done = true;
      setSampleSwags(getRandomHeroSampleSwags(3));
      const filteredEmojis = activityEmojis.filter(emoji => !RELIGION_EMOJIS.includes(emoji));
      const shuffled = [...filteredEmojis].sort(() => Math.random() - 0.5);
      setSampleActivityEmojis(shuffled.slice(0, 3));
      const nextPlaces = getRandomHeroSamplePlaces(1);
      preloadImage(nextPlaces[0]?.imageUrl).then(() => {
        if (cancelled) return;
        setSamplePlaces(nextPlaces);
      });
      setSampleFeedFindLuv(randomSampleFeedFindLuvFlags());
      const activityImages = [
        { id: 'running', name: 'Running', imageUrl: runningImage },
        { id: 'coffee', name: 'Coffee', imageUrl: coffeeImage },
        { id: 'eating', name: 'Eating', imageUrl: eatingImage },
        { id: 'hiking', name: 'Hiking', imageUrl: hikingImage }
      ];
      const shuffledActivities = [...activityImages].sort(() => Math.random() - 0.5);
      setSampleActivities(shuffledActivities.slice(0, 3));
    };
    const img = new Image();
    img.onload = loadTiles;
    img.onerror = loadTiles;
    img.src = samplePartnerCutout;
    if (img.complete) loadTiles(); // cached image: onload may not fire
    return () => { cancelled = true; };
  }, [samplePartnerCutout]);

  // Keep ref in sync for async pick-word flow (read latest analysis in onPersonalityConfirmed)
  useEffect(() => {
    jungianAnalysisTextRef.current = jungianAnalysisText;
  }, [jungianAnalysisText]);

  // Warm searchSpiritGifs when reach-out picker opens — signed-in only (anon uses local GIFs only).
  useEffect(() => {
    if (!showReachOutGifPicker) {
      reachOutSpiritGifWarmupRef.current = false;
      return;
    }
    if (!currentUser?.uid) return;
    if (reachOutSpiritGifWarmupRef.current) return;
    reachOutSpiritGifWarmupRef.current = true;
    searchSpiritGifs('warmup', currentUser.uid).catch(() => {});
  }, [showReachOutGifPicker, currentUser?.uid]);

  const appendReachOutKlipyGifs = useCallback(async (query, isSearch = false) => {
    if (!currentUser?.uid) return;
    const gen = ++reachOutKlipyFetchGenRef.current;
    setLoadingReachOutGifs(true);
    try {
      const customerId = currentUser.uid;
      const remote = await searchSpiritGifs(query, customerId, REACH_OUT_KLIPY_PAGE);
      if (gen !== reachOutKlipyFetchGenRef.current) return;
      const merged = isSearch
        ? mergeReachOutKlipyThenLocal(remote, reachOutLocalBaseRef.current)
        : mergeReachOutLocalThenKlipy(reachOutLocalBaseRef.current, remote);
      setReachOutGifs(merged);
      if (isSearch) {
        requestAnimationFrame(() => {
          const el = reachOutGifGridScrollRef.current;
          if (el) el.scrollTop = 0;
        });
      }
    } catch (error) {
      console.error('Error fetching reach-out GIFs:', error);
    } finally {
      if (gen === reachOutKlipyFetchGenRef.current) {
        setLoadingReachOutGifs(false);
      }
    }
  }, [currentUser?.uid]);

  useEffect(() => {
    if (!showReachOutGifPicker || !currentUser?.uid) return;
    void appendReachOutKlipyGifs('hello', false);
  }, [showReachOutGifPicker, currentUser?.uid, appendReachOutKlipyGifs]);

  // Initialize activities with random values
  useEffect(() => {
    const [randomX, randomY] = getTwoRandomActivities();
    setActivityX(randomX);
    setActivityY(randomY);
  }, []);

  /** Show the floating Fox chat launcher once the user has scrolled past the hero START button.
   * Sticky: once visible, stays visible for the rest of the session even if user scrolls back up. */
  useEffect(() => {
    let revealed = false;
    const checkScroll = () => {
      if (revealed) return;
      const btn = heroStartBtnRef.current;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      if (rect.bottom < 0) {
        revealed = true;
        setFoxChatLauncherVisible(true);
        window.removeEventListener('scroll', checkScroll);
        window.removeEventListener('resize', checkScroll);
      }
    };
    checkScroll();
    window.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll);
    return () => {
      window.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  // Rotate sample cutouts and tiles on the initial poster (before survey). Wait until the
  // next cutout + place images are cached/decoded before swapping src — avoids blank/stale flashes.
  useEffect(() => {
    if (showInlineSurvey || surveyCompleted) return;
    const filteredEmojis = activityEmojis.filter(emoji => !RELIGION_EMOJIS.includes(emoji));
    let cancelled = false;
    let timeoutId = null;
    let loadGeneration = 0;
    let currentIdx = sampleCutouts.indexOf(samplePartnerCutout);
    if (currentIdx < 0) currentIdx = 0;

    const applyRotation = (nextIdx, nextPlaces, nextSwags) => {
      if (cancelled) return;
      currentIdx = nextIdx;
      setSamplePartnerCutout(sampleCutouts[nextIdx]);
      setSampleActivityEmojis(() => {
        const shuffled = [...filteredEmojis].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, 3);
      });
      setSamplePlaces(nextPlaces);
      setSampleSwags(nextSwags);
      setHeartGifIndex((prev) => (prev + 1) % HEART_GIFS.length);
      setSampleNicknameIndex((prev) => (prev + 1) % SAMPLE_NICKNAMES.length);
      setSampleFeedFindLuv(randomSampleFeedFindLuvFlags());
      setTapeRotation(Math.random() * 16 - 8);
      setSampleMakerealOffset({
        dx: Math.random() * 24 - 12,
        dy: Math.random() * 24 - 12,
        rot: Math.random() * 20 - 10
      });
      setMagazinePair(() => {
        const shuffled = [...MAGAZINE_IMAGES].sort(() => Math.random() - 0.5);
        return {
          left: { src: shuffled[0], rot: (Math.random() * 20 - 10).toFixed(1), dx: (Math.random() * 16 - 8).toFixed(1) },
          right: { src: shuffled[1], rot: (Math.random() * 20 - 10).toFixed(1), dx: (Math.random() * 16 - 8).toFixed(1) },
        };
      });
      setScissorsOffset({
        left: { rot: (Math.random() * 60 - 30).toFixed(1), dx: (Math.random() * 30 - 15).toFixed(1), dy: (Math.random() * 20 - 10).toFixed(1) },
        right: { rot: (Math.random() * 60 - 30).toFixed(1), dx: (Math.random() * 30 - 15).toFixed(1), dy: (Math.random() * 20 - 10).toFixed(1) },
      });
      timeoutId = setTimeout(tick, ROTATION_INTERVAL_MS);
    };

    const tick = () => {
      if (cancelled) return;
      const nextIdx = (currentIdx + 1) % sampleCutouts.length;
      const nextPlaces = getRandomHeroSamplePlaces(1);
      /* Pick the brands now so their images decode before the swap. Otherwise each tile takes its
         new tilt and offset while still showing the old logo, then the new logo pops in. */
      const nextSwags = getRandomHeroSampleSwags(3);
      const gen = ++loadGeneration;
      Promise.all([
        preloadImage(sampleCutouts[nextIdx]),
        preloadImage(nextPlaces[0]?.imageUrl),
        ...nextSwags.map((swag) => preloadImage(swag?.imageUrl)),
      ]).then(() => {
        if (cancelled || gen !== loadGeneration) return;
        applyRotation(nextIdx, nextPlaces, nextSwags);
      });
    };

    timeoutId = setTimeout(tick, ROTATION_INTERVAL_MS);
    return () => {
      cancelled = true;
      loadGeneration += 1;
      if (timeoutId != null) clearTimeout(timeoutId);
    };
  // samplePartnerCutout intentionally omitted — index is seeded once when rotation starts
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInlineSurvey, surveyCompleted]);

  // Feed fallback cutouts — use local sample cutouts instead of legacy Firestore partner_cutouts collection
  useEffect(() => {
    const shuffled = [...sampleCutouts].sort(() => Math.random() - 0.5);
    setFeedCutoutUrls(shuffled);
  }, []);

  // Auto-close success popup after 3 seconds
  useEffect(() => {
    if (!successPopupMessage) return;
    const t = setTimeout(() => setSuccessPopupMessage(null), 3000);
    return () => clearTimeout(t);
  }, [successPopupMessage]);

  // WEEKLY FEATURED: Berkeley + SF regional flags on `dinnerGiveawayOptIns` — deferred after initial render
  useEffect(() => {
    let cancelled = false;
    const loadDinnerGiveawayFeed = async () => {
      try {
        const [berkeleyAds, sfAds, sfNorthBeachAds, sfSomaAds, sfDowntownAds] = await Promise.all([
          fetchBerkeleyFeaturedFeedAds(db),
          fetchSfFeaturedFeedAds(db),
          fetchSfNorthBeachFeaturedFeedAds(db),
          fetchSfSomaFeaturedFeedAds(db),
          fetchSfDowntownFeaturedFeedAds(db),
        ]);
        if (cancelled) return;
        setBerkeleyWantedAds(berkeleyAds);
        setSfWantedAds(sfAds);
        setSfNorthBeachWantedAds(sfNorthBeachAds);
        setSfSomaWantedAds(sfSomaAds);
        setSfDowntownWantedAds(sfDowntownAds);
        setWeeklyFeaturedFeedReady(true);
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading weekly featured feed:', err);
          setWeeklyFeaturedFeedReady(true);
        }
      }
    };
    const id = typeof requestIdleCallback !== 'undefined'
      ? requestIdleCallback(() => { if (!cancelled) loadDinnerGiveawayFeed(); })
      : setTimeout(() => { if (!cancelled) loadDinnerGiveawayFeed(); }, 500);
    return () => {
      cancelled = true;
      if (typeof cancelIdleCallback !== 'undefined') cancelIdleCallback(id);
      else clearTimeout(id);
    };
  }, []);

  /* WEEKLY FEATURED aura backfill: the feed fetch above often races auth restore (idle callback
     fires before Firebase re-authenticates, especially on mobile), so the signed-in
     `userPublicPrimary` aura read fails silently. Re-attach aura colors once auth is ready. */
  useEffect(() => {
    if (!currentUser?.uid) return;
    let cancelled = false;
    const backfill = async (ads, setAds) => {
      if (!ads.length || ads.every((ad) => ad.auraColor)) return;
      const next = await Promise.all(ads.map((ad) => attachAuraColorFromPublicPrimary(db, ad)));
      if (!cancelled && next.some((ad, i) => ad !== ads[i])) setAds(next);
    };
    void backfill(berkeleyWantedAds, setBerkeleyWantedAds);
    void backfill(sfWantedAds, setSfWantedAds);
    void backfill(sfNorthBeachWantedAds, setSfNorthBeachWantedAds);
    void backfill(sfSomaWantedAds, setSfSomaWantedAds);
    void backfill(sfDowntownWantedAds, setSfDowntownWantedAds);
    return () => { cancelled = true; };
  }, [currentUser?.uid, berkeleyWantedAds, sfWantedAds, sfNorthBeachWantedAds, sfSomaWantedAds, sfDowntownWantedAds]);

  // FOX-PAID DATES: wait until SF FEATURED PACKS feed has settled so those queries/images go first
  useEffect(() => {
    if (!weeklyFeaturedFeedReady) return undefined;
    let cancelled = false;
    const loadPostedDateIdeas = async () => {
      try {
        const ideas = await fetchPostedSponsoredDateIdeas(db);
        if (cancelled) return;
        setPostedSponsoredDateIdeas(ideas);
        setPostedSponsoredDateIdeasReady(true);
      } catch (err) {
        if (!cancelled) {
          console.error('Error loading posted sponsored date ideas:', err);
          setPostedSponsoredDateIdeasReady(true);
        }
      }
    };
    void loadPostedDateIdeas();
    return () => {
      cancelled = true;
    };
  }, [weeklyFeaturedFeedReady]);

  /* Once every homepage resource has loaded, pre-pick the first 9 FoxChat brand tiles and warm
     their images in the browser cache so the survey grid is already decoded when the chat opens. */
  useEffect(() => {
    let idleId = null;
    const warm = () => {
      idleId = typeof requestIdleCallback !== 'undefined'
        ? requestIdleCallback(() => warmInitialBrandSample(9))
        : setTimeout(() => warmInitialBrandSample(9), 500);
    };
    if (document.readyState === 'complete') {
      warm();
      return () => {
        if (idleId === null) return;
        if (typeof cancelIdleCallback !== 'undefined') cancelIdleCallback(idleId);
        else clearTimeout(idleId);
      };
    }
    window.addEventListener('load', warm, { once: true });
    return () => {
      window.removeEventListener('load', warm);
      if (idleId === null) return;
      if (typeof cancelIdleCallback !== 'undefined') cancelIdleCallback(idleId);
      else clearTimeout(idleId);
    };
  }, []);

  // Real-time sync of user balance and cart from Firestore
  useEffect(() => {
    if (!currentUser?.uid) {
      setUserCart([]);
      setCartCount(0);
      setRewardsToRedeem([]);
      setYourRewardsConciergeKeys([]);
      setYourRewardsShare50SentKeys([]);
      setUserVibeAccuracy(null);
      setUserAuraRgb(null);
      setBerkeleyEmailVerifyLastSentMs(0);
      setBerkeleyEmailVerifySendFailedMs(0);
      return;
    }
    const unsubscribe = onSnapshot(doc(db, 'users', currentUser.uid), (snap) => {
      const data = snap.data();
      const cart = data?.cart ?? [];
      setUserCart(Array.isArray(cart) ? cart : []);
      setCartCount(Array.isArray(cart) ? cart.length : 0);
      const rewards = data?.rewardsToRedeem;
      setRewardsToRedeem(Array.isArray(rewards) ? rewards : []);
      const ck = data?.yourRewardsConciergeKeys;
      setYourRewardsConciergeKeys(Array.isArray(ck) ? ck : []);
      const s50 = data?.yourRewardsShare50SentKeys;
      setYourRewardsShare50SentKeys(Array.isArray(s50) ? s50 : []);
      const accuracyRaw = data?.accuracy;
      setUserVibeAccuracy(
        typeof accuracyRaw === 'number' && Number.isFinite(accuracyRaw) ? accuracyRaw : null,
      );
      const auraRgb = resolveAuraRgb(data?.auraColor);
      setUserAuraRgb(auraRgb);
      // No stored color yet (new account or legacy): ask the server to assign one.
      // The methodology lives only in the Cloud Function; we just read the result
      // once the snapshot updates. Guarded so we request at most once per uid.
      if (!auraRgb && auraEnsureRequestedForUidRef.current !== currentUser.uid) {
        auraEnsureRequestedForUidRef.current = currentUser.uid;
        ensureMyAuraColor().catch((e) => {
          auraEnsureRequestedForUidRef.current = null;
          console.warn('ensureMyAuraColor failed (continuing without aura):', e?.message || e);
        });
      }
      const streakRaw = data?.vibeCheckStreak;
      setUserVibeCheckStreak(
        typeof streakRaw === 'number' && Number.isFinite(streakRaw) ? streakRaw : 0,
      );
      setUserVibeCheckStreakLastPeriodKey(
        typeof data?.vibeCheckStreakLastPeriodKey === 'string'
          ? data.vibeCheckStreakLastPeriodKey
          : null,
      );
      setUserProfilePhotoUrl(data?.userPhotoUrl ?? null);
      setProfileUserPhotoOriginalUrl(data?.userPhotoOriginalUrl ?? null);
      setUserBerkeleyEmail(data?.berkeleyEmail ?? null);
      setUserBerkeleyEmailVerifiedAddress(data?.berkeleyEmailVerifiedAddress ?? null);
      setBerkeleyEmailVerified(data?.berkeleyEmailVerified ?? false);
      setBerkeleyEmailVerifyLastSentMs(
        firestoreTimestampToMs(data?.berkeleyEmailVerifyLastSentAt),
      );
      setBerkeleyEmailVerifySendFailedMs(
        firestoreTimestampToMs(data?.berkeleyEmailVerifySendFailedAt),
      );
      const notificationEmailRaw = data?.notificationEmail;
      setUserNotificationEmail(
        typeof notificationEmailRaw === 'string' && notificationEmailRaw.trim()
          ? notificationEmailRaw.trim()
          : null,
      );
    });
    return () => unsubscribe();
  }, [currentUser?.uid]);

  // On login, persist the streak reset when the user missed yesterday (broke the chain).
  useEffect(() => {
    if (!currentUser?.uid) return undefined;
    let cancelled = false;
    (async () => {
      try {
        await syncVibeCheckStreakOnLogin(db, currentUser.uid);
      } catch (err) {
        if (!cancelled) console.warn('Vibe check streak login sync failed:', err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentUser?.uid]);

  // Subscribe to unread messages count + fox daily-check badge (only if not responded today).
  useEffect(() => {
    if (!currentUser?.uid) {
      setUnreadMessagesCount(0);
      setFoxInboxUnread(false);
      return undefined;
    }

    let cancelled = false;
    const applyFoxUnread = (respondedToday) => {
      if (!cancelled) setFoxInboxUnread(!respondedToday);
    };

    applyFoxUnread(hasDailyVibeCheckForPeriod(currentUser.uid));

    (async () => {
      try {
        const check = await loadDailyVibeCheckForPeriod(db, currentUser.uid);
        if (!cancelled) applyFoxUnread(Boolean(check?.gifUrl));
        if (!cancelled && (check?.gifUrl || hasDailyVibeCheckForPeriod(currentUser.uid))) {
          const repaired = await reconcileVibeCheckStreakFromDailyChecks(db, currentUser.uid);
          if (!cancelled && typeof repaired === 'number' && repaired > 0) {
            setUserVibeCheckStreak(repaired);
            setUserVibeCheckStreakLastPeriodKey(getDailyVibePeriodKey());
          }
        }
      } catch {
        /* keep cache-based state */
      }
    })();

    const unsubscribeUnread = getTotalUnreadCount(currentUser.uid, setUnreadMessagesCount);
    return () => {
      cancelled = true;
      unsubscribeUnread();
    };
  }, [currentUser?.uid]);

  // Open inbox from email deep link
  useEffect(() => {
    if (deepLinkChatId && currentUser?.uid) {
      setInboxInitialConversationId(deepLinkChatId);
      setShowMessagesPopup(true);
      if (onDeepLinkChatHandled) onDeepLinkChatHandled();
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [deepLinkChatId, currentUser?.uid, onDeepLinkChatHandled]);

  // Open Messages inbox (list) from email / deeplink `/?openMessages=1` — no specific thread (see App.js).
  useEffect(() => {
    if (!deepLinkOpenMessagesTab || !currentUser?.uid) return;
    if (deepLinkChatId) return;
    setInboxInitialConversationId(null);
    setShowMessagesPopup(true);
    if (onDeepLinkOpenMessagesTabHandled) onDeepLinkOpenMessagesTabHandled();
    if (typeof window !== 'undefined' && window.location.pathname === '/') {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [
    deepLinkOpenMessagesTab,
    deepLinkChatId,
    currentUser?.uid,
    onDeepLinkOpenMessagesTabHandled,
  ]);

  const primeFeedTileDetailPopup = useCallback(() => {
    setShowReachOutGifPicker(false);
    setReachOutGifSearch('');
    setReachOutSelectedGif(null);
    setReachOutSubmitted(false);
    setFeedShareLinkCopied(false);
    setShowReferOptions(false);
    setShowReferEmailInput(false);
    setReferFriendEmail('');
    setReferFriendEmailError('');
    setReferFriendSubmitted(false);
    setFeedReferLinkCopied(false);
    setShowReferIgInput(false);
    setReferFriendIg('');
    setReferFriendIgError('');
    setReferFriendIgSubmitted(false);
  }, []);

  /** Friend collage Refer popup: ‹ Back from main menu → editor with SEND TO FRIEND still available. */
  const backFriendCollageReferPopupToEditor = useCallback(() => {
    setShowFriendCollageReferPopup(false);
    setFriendCollageReferPhase('menu');
    setReferFriendEmail('');
    setReferFriendEmailError('');
    setReferFriendSubmitted(false);
    setReferFriendIg('');
    setReferFriendIgError('');
    setReferFriendIgSubmitted(false);
    setFriendCollageReferLinkCopied(false);
  }, []);

  /** Friend collage Refer popup: × or overlay → exit friend session and open Your collages scrolled to Your rewards. */
  const closeFriendCollageReferPopupToRewards = useCallback(() => {
    setShowFriendCollageReferPopup(false);
    setFriendCollageReferPhase('menu');
    setFriendCollageReferPosterId(null);
    setReferFriendEmail('');
    setReferFriendEmailError('');
    setReferFriendSubmitted(false);
    setReferFriendIg('');
    setReferFriendIgError('');
    setReferFriendIgSubmitted(false);
    setFriendCollageReferLinkCopied(false);
    setCollageFriendFlowActive(false);
    setCollageFriendInviteEmail(null);
    setShowMyCollagesInline(true);
    setPosterDeleteConfirmId(null);
    setPosterDetailFromList(null);
    setPosterDetailFromListTitleOverride(null);
    setShowUnpostConfirm(false);
    const scrollToRewards = () => {
      document.getElementById('user-menu-your-rewards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    window.setTimeout(scrollToRewards, 180);
  }, []);

  const openFriendCollageReferPopup = useCallback(() => {
    const invite = collageFriendInviteEmail && String(collageFriendInviteEmail).trim();
    setReferFriendEmail(invite || '');
    setReferFriendEmailError('');
    setReferFriendSubmitted(false);
    setReferFriendIg('');
    setReferFriendIgError('');
    setReferFriendIgSubmitted(false);
    setFriendCollageReferPhase('menu');
    setFriendCollageReferLinkCopied(false);
    setShowFriendCollageReferPopup(true);
  }, [collageFriendInviteEmail]);

  const openFeedTileDetailFromGrid = useCallback((ad, cutoutSrc) => {
    setFeedTileDetailTitleOverride(null);
    const src = (typeof cutoutSrc === 'string' && cutoutSrc) || ad?.partnerCutout || null;
    feedTileDetailCutoutSrcRef.current = ad?.id && src ? { id: ad.id, src } : null;
    setFeedTileDetailAd(ad);
  }, []);

  const handleOpenChatPartnerCollage = useCallback(async (otherUserId, partnerDisplayName) => {
    if (!otherUserId) return;
    try {
      const pubSnap = await getDoc(doc(db, 'userPublicPrimary', otherUserId));
      if (!pubSnap.exists()) {
        window.alert(
          "We can't show their collage. They haven't made one yet or removed it.",
        );
        return;
      }
      const raw = pubSnap.data()?.ad;
      if (!raw || typeof raw !== 'object') {
        window.alert("We can't show their collage. They haven't made one yet or removed it. Try again later.");
        return;
      }
      const ad = {
        ...raw,
        createdAt: raw.createdAt?.toDate?.() ?? (raw.createdAt instanceof Date ? raw.createdAt : new Date(0)),
      };
      let mergedAd = ad;
      if (ad.id) {
        try {
          const sharedSnap = await getDoc(doc(db, 'sharedPosters', ad.id));
          if (sharedSnap.exists()) {
            mergedAd = mergeFeedDetailAdWithSharedPosterDemographics(ad, sharedSnap.data());
          }
        } catch (mergeErr) {
          console.warn('chat partner collage: sharedPosters demographic merge failed:', mergeErr);
        }
      }
      primeFeedTileDetailPopup();
      const trimmed = partnerDisplayName != null ? String(partnerDisplayName).trim() : '';
      const nameForTitle = trimmed || 'Someone';
      setFeedTileDetailTitleOverride(`${nameForTitle}'s LATEST COLLAGE`);
      setFeedTileDetailAd(mergedAd);
    } catch (err) {
      console.error('Error loading chat partner primary collage:', err);
      window.alert("Couldn't load their collage. Please try again.");
    }
  }, [primeFeedTileDetailPopup]);

  // Fetch pending orders when cart popup opens
  useEffect(() => {
    if (!showCartPopup || !currentUser?.uid) {
      setPendingOrders([]);
      return;
    }
    const fetchOrders = async () => {
      try {
        const snap = await getDocs(collection(db, 'users', currentUser.uid, 'orders'));
        const orders = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        orders.sort((a, b) => {
          const at = a.createdAt?.toMillis?.() ?? 0;
          const bt = b.createdAt?.toMillis?.() ?? 0;
          return bt - at;
        });
        setPendingOrders(orders);
      } catch (err) {
        console.error('Error fetching pending orders:', err);
      }
    };
    fetchOrders();
  }, [showCartPopup, currentUser?.uid]);

  // Fetch saved wanted posters on sign-in + refresh when popup opens
  useEffect(() => {
    if (!currentUser?.uid) {
      ensuredUserPublicPrimaryUidRef.current = null;
      foxMaskBackfillAttemptedRef.current = new Set();
      setSavedPosters([]);
      setPrimaryCollageId(null);
      setPostersHydratedUid(null);
      return;
    }
    let cancelled = false;
    const load = () => {
      setLoadingPosters(true);
      getDoc(doc(db, 'users', currentUser.uid))
        .then((snap) => {
          if (cancelled) return;
          const data = snap.data();
          const posters = normalizeSavedPostersList(Array.isArray(data?.savedWantedPosters) ? data.savedWantedPosters : []);
          const nextPrimaryId = data?.primaryCollageId ?? null;
          setSavedPosters(posters);
          setPrimaryCollageId(nextPrimaryId);
          if (
            getPrimarySavedPoster(posters, nextPrimaryId)
            && ensuredUserPublicPrimaryUidRef.current !== currentUser.uid
          ) {
            ensuredUserPublicPrimaryUidRef.current = currentUser.uid;
            void pushUserPublicPrimaryPreview();
          }
        })
        .catch((err) => {
          if (!cancelled) {
            console.error('Error fetching saved posters:', err);
          }
        })
        .finally(() => {
          if (!cancelled) {
            setLoadingPosters(false);
            setPostersHydratedUid(currentUser.uid);
          }
        });
    };
    load();
    return () => { cancelled = true; };
  }, [currentUser?.uid, showMyCollagesInline, openMyCollagesNonce, pushUserPublicPrimaryPreview]);

  /* Vibe Fox defers the fox-mask until after SAVE. New-user OAuth (Google/Apple) and email-attach
     paths can persist the collage and never finish that job. Backfill any poster still showing
     the unmasked original — also repairs existing missed masks on next login. */
  useEffect(() => {
    if (!currentUser?.uid || loadingPosters) return undefined;
    const uid = currentUser.uid;
    const displayName = currentUser.displayName;
    const pending = savedPosters.filter((p) => p?.id && posterNeedsFoxMask(p));
    if (pending.length === 0) return undefined;

    let cancelled = false;
    pending.forEach((poster) => {
      if (foxMaskBackfillAttemptedRef.current.has(poster.id)) return;
      foxMaskBackfillAttemptedRef.current.add(poster.id);
      const unmaskedUrl = unmaskedUrlFromPoster(poster);
      const commitIfPatched = (result) => {
        if (cancelled) return;
        if (result?.poster) {
          setSavedPosters((prev) => prev.map((p) => (p.id === poster.id ? result.poster : p)));
        }
      };
      void applyFoxMaskToSavedPoster({
        db,
        posterId: poster.id,
        unmaskedUrl,
        uid,
        displayName,
      }).then((result) => {
        if (cancelled) return;
        if (result?.skipped && result.reason === 'in_flight') {
          foxMaskBackfillAttemptedRef.current.delete(poster.id);
          window.setTimeout(() => {
            if (cancelled || foxMaskBackfillAttemptedRef.current.has(poster.id)) return;
            foxMaskBackfillAttemptedRef.current.add(poster.id);
            void applyFoxMaskToSavedPoster({
              db,
              posterId: poster.id,
              unmaskedUrl,
              uid,
              displayName,
            }).then(commitIfPatched);
          }, 15000);
          return;
        }
        commitIfPatched(result);
      });
    });
    return () => { cancelled = true; };
  }, [currentUser?.uid, currentUser?.displayName, loadingPosters, savedPosters]);

  useEffect(() => {
    if (!openMyCollagesNonce) return;
    setShowMyCollagesInline(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [openMyCollagesNonce]);

  /* Logged-in users land on Your collages as their homepage (under Fox Chat). Runs once per uid
     (covers persisted sessions on page load; Fox Chat itself is opened via postLoginCollagesNonce).
     Editor flows (e.g. EDIT under a collage) set showMyCollagesInline(false) afterwards and are
     not overridden. */
  const myCollagesHomeHandledUidRef = useRef(null);
  useEffect(() => {
    const uid = currentUser?.uid || null;
    if (!uid) {
      myCollagesHomeHandledUidRef.current = null;
      return;
    }
    if (myCollagesHomeHandledUidRef.current === uid) return;
    myCollagesHomeHandledUidRef.current = uid;
    setShowMyCollagesInline(true);
  }, [currentUser?.uid]);

  useEffect(() => {
    if (!showSavedPosterPopup) {
      setSavedPosterFlowStep(1);
      setSavedPosterLookingFor([]);
    }
  }, [showSavedPosterPopup]);

  useEffect(() => {
    if (!showSavedPosterPopup || !savedPosterForPopup?.id) return;
    setPromoteOnLuvwtfSocialsChecked(savedPosterForPopup.promoteOnLuvwtfSocials !== false);
    const lf = savedPosterForPopup.lookingForGenders;
    setSavedPosterLookingFor(Array.isArray(lf) && lf.length ? [...lf] : []);
  }, [showSavedPosterPopup, savedPosterForPopup?.id]);

  // Watch for image to become available and fade out animation if it's showing
  useEffect(() => {
    if (currentGeneratedImage && isShowingAnimation && animationStartTimeRef.current) {
      const elapsed = Date.now() - animationStartTimeRef.current;
      const minAnimationDuration = 3000;
      
      if (elapsed >= minAnimationDuration) {
        // Image is ready and minimum duration has passed, start fade out
        setIsFadingOut(true);
        // Hide animation after fade out completes
        setTimeout(() => {
          setIsShowingAnimation(false);
          setIsFadingOut(false);
        }, 800); // Match fade out animation duration
      } else {
        // Wait for minimum duration, then fade out
        const remainingTime = minAnimationDuration - elapsed;
        setTimeout(() => {
          setIsFadingOut(true);
          setTimeout(() => {
            setIsShowingAnimation(false);
            setIsFadingOut(false);
          }, 800);
        }, remainingTime);
      }
    }
  }, [currentGeneratedImage, isShowingAnimation]);

  // Normalize nickname for uniqueness check (trim, lowercase)
  const normalizeNickname = (s) => (s || '').trim().toLowerCase();

  // Given current nickname and list of existing nicknames, suggest next available: "The Cryptid" -> "The Cryptid 2", etc.
  const getSuggestedNickname = (currentNickname, existingNicknamesList) => {
    const base = (currentNickname || '').trim().replace(/\s+\d+$/, '');
    if (!base) return 'The One 2';
    const baseNorm = base.toLowerCase();
    const escapeRe = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const numbers = [];
    for (const n of existingNicknamesList) {
      const norm = (n || '').trim().toLowerCase();
      if (norm === baseNorm) numbers.push(1);
      else {
        const m = norm.match(new RegExp('^' + escapeRe(baseNorm) + '\\s+(\\d+)$'));
        if (m) numbers.push(parseInt(m[1], 10));
      }
    }
    const maxN = numbers.length ? Math.max(...numbers) : 0;
    return base + ' ' + (maxN + 1);
  };

  // Stable fingerprint for dedupe: when user edits poster, show Save again
  const getPosterFingerprint = (p) => {
    if (!p) return '';
    const swags = (p.swags || []).map((s) => s?.id ?? s?.imageUrl ?? '').filter(Boolean).sort();
    const activities = (p.activityX != null || p.activityY != null || p.activityZ != null)
      ? [p.activityX, p.activityY, p.activityZ].filter(Boolean).sort()
      : (p.activities || []).map((a) => (typeof a === 'string' ? a : a?.emoji ?? a?.id ?? '')).filter(Boolean).sort();
    const words = [...(p.words || [])].sort();
    const partnerKey = typeof p.partnerCutout === 'string' ? p.partnerCutout : (p.partnerCutout?.id ?? null);
    return JSON.stringify({
      posterNickname: p.posterNickname ?? null,
      partnerCutout: partnerKey,
      swags,
      activities,
      words,
      surveyAnswers: p.surveyAnswers ?? null
    });
  };

  // Build current poster shape from state for fingerprint comparison
  const getCurrentPosterFromState = () => {
    const act0 = selectedActivities?.[0];
    const act1 = selectedActivities?.[1];
    const act2 = selectedActivities?.[2];
    const activityX = act0 === undefined ? 'Seeking' : typeof act0 === 'string' ? act0 : (act0.name || act0.emoji || 'Seeking');
    const activityY = act1 === undefined ? 'Match' : typeof act1 === 'string' ? act1 : (act1.name || act1.emoji || 'Match');
    const activityZ = act2 === undefined ? null : typeof act2 === 'string' ? act2 : (act2.name || act2.emoji || null);
    return {
      posterNickname: (editedPosterNickname && String(editedPosterNickname).trim()) ? editedPosterNickname : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One'),
      partnerCutout: selectedPartnerCutout || null,
      swags: selectedSwags || [],
      activityX,
      activityY,
      activityZ: activityZ || null,
      words: selectedWords || [],
      surveyAnswers: surveyAnswers || null
    };
  };

  // When poster was saved/loaded (Share shown) but user edits anything, show Save again
  useEffect(() => {
    if (!currentPosterAlreadySaved || !savedPosterForPopup) return;
    if (skipNextPosterChangeCheckRef.current) {
      skipNextPosterChangeCheckRef.current = false;
      return;
    }
    const current = getCurrentPosterFromState();
    if (getPosterFingerprint(current) !== getPosterFingerprint(savedPosterForPopup)) {
      setCurrentPosterAlreadySaved(false);
    }
  }, [
    currentPosterAlreadySaved,
    savedPosterForPopup,
    selectedPartnerCutout,
    selectedSwags,
    selectedWords,
    selectedActivities,
    userPhotoUrl,
    editedPosterNickname,
    jungianAnalysisText,
    surveyAnswers
  ]);

  // WANTED Poster Builder Functions
  const randomizeActivityX = () => {
    let newActivity = getRandomActivity();
    while (newActivity === activityY) {
      newActivity = getRandomActivity();
    }
    setActivityX(newActivity);
  };

  const randomizeActivityY = () => {
    let newActivity = getRandomActivity();
    while (newActivity === activityX) {
      newActivity = getRandomActivity();
    }
    setActivityY(newActivity);
  };

  // Emoji selection functions
  const handleEmojiSelect = (emoji, index) => {
    if (selectedEmojis.length >= 25) {
      alert('You can select up to 25 emojis!');
      return;
    }
    
    // Get container dimensions dynamically from the actual rendered element
    // Container uses relative width (80%) with max-width constraints
    const emojiAreaElement = document.querySelector('.emoji-selection-area');
    let containerWidth, containerHeight, marginX, marginY;
    
    if (emojiAreaElement) {
      // Get actual rendered dimensions
      const rect = emojiAreaElement.getBoundingClientRect();
      containerWidth = rect.width;
      containerHeight = rect.height;
    } else {
      // Fallback: use screen size-based estimates (80% of parent, with max-width)
      const isMobile = window.innerWidth <= 480;
      const isTablet = window.innerWidth <= 768;
      const parentWidth = Math.min(450, window.innerWidth * 0.9); // person-outline-container max-width
      
      if (isMobile) {
        containerWidth = Math.min(parentWidth * 0.8, 200);
        containerHeight = 144;
      } else if (isTablet) {
        containerWidth = Math.min(parentWidth * 0.8, 256);
        containerHeight = 180;
      } else {
        containerWidth = Math.min(parentWidth * 0.8, 336);
        containerHeight = 240;
      }
    }
    
    // Set margins proportionally
    marginX = containerWidth * 0.05; // 5% margin
    marginY = containerHeight * 0.067; // ~6.7% margin
    
    // Calculate position within heart shape bounds
    // Heart shape: wider at top, narrows to point at bottom
    // Use a triangular constraint that mimics heart shape
    const y = Math.random() * (containerHeight - 40) + marginY;
    const centerX = containerWidth / 2;
    const relativeY = (y - marginY) / (containerHeight - marginY * 2); // 0 (top) to 1 (bottom)
    
    // Heart shape: wider at top (about 90% of width), narrows to point at bottom
    // Use a curve that's wider at top and narrows more gradually, then sharply at bottom
    const topWidth = containerWidth * 0.9; // 90% of width at top
    const bottomWidth = containerWidth * 0.1; // 10% of width at bottom (point)
    
    // Use a curve function for more natural heart shape
    // At top (relativeY=0): full width, at bottom (relativeY=1): narrow point
    const currentWidth = topWidth * (1 - relativeY) + bottomWidth * relativeY;
    // Apply a curve to make it more heart-like (wider in middle, then narrows)
    const heartCurve = Math.sin(relativeY * Math.PI); // Creates a curve
    const adjustedWidth = currentWidth * (0.7 + 0.3 * heartCurve);
    
    // Calculate maximum x distance from center at this y position
    // Ensure it's always positive and accounts for margins
    const availableWidth = adjustedWidth - (marginX * 2);
    const maxDistanceFromCenter = Math.max(0, availableWidth / 2);
    
    // Generate random distance from center (symmetric: -maxDistance to +maxDistance)
    const distanceFromCenter = (Math.random() * 2 - 1) * maxDistanceFromCenter;
    
    // Calculate final x position, ensuring it's within bounds
    const x = Math.max(marginX, Math.min(containerWidth - marginX, centerX + distanceFromCenter));
    
    const newEmoji = {
      id: Date.now() + Math.random(),
      emoji: emoji,
      x: x,
      y: y,
      rotation: Math.random() * 360,
      scale: 0.8 + Math.random() * 0.4, // Random scale between 0.8 and 1.2
      isNew: true // Flag for animation
    };
    
    setSelectedEmojis(prev => [...prev, newEmoji]);
    
    // Remove the isNew flag after animation completes
    setTimeout(() => {
      setSelectedEmojis(prev => 
        prev.map(emojiObj => 
          emojiObj.id === newEmoji.id 
            ? { ...emojiObj, isNew: false }
            : emojiObj
        )
      );
    }, 1300); // 0.8s fall + 0.5s pulse
  };

  const handleEmojiRemove = (emojiId) => {
    setSelectedEmojis(prev => prev.filter(emoji => emoji.id !== emojiId));
  };

  const handleEmojiTap = (emojiId) => {
    // Show expansion modal for edit/remove options
    const shouldRemove = window.confirm('Remove this emoji?');
    if (shouldRemove) {
      handleEmojiRemove(emojiId);
    }
  };

  const handleGenerateImage = async () => {
    if (selectedEmojis.length < 10) {
      alert('Please select at least 10 emojis to generate your partner!');
      return;
    }

    // Hide emoji selection
    setShowEmojiSelection(false);
    
    // Start image generation in the background (don't await)
    generateSingleImageInBackground();
    
    // Open chatbot immediately
    setShowPartnerGenerationChat(true);
  };

  const generateSingleImageInBackground = async () => {
    setIsGeneratingImage(true);
    
    try {
      const activities = [activityX, activityY].filter(a => a);
      const emojis = selectedEmojis.map(e => e.emoji);
      
      const result = await generatePartnerImagesReplicate(activities, emojis, 'free', 1);
      
      console.log('Image generation result:', result);
      
      if (result && result.images && result.images.length > 0) {
        // Replicate returns array of images, take the first one
        const firstImage = result.images[0];
        console.log('First image data:', firstImage);
        
        if (firstImage && firstImage.success && firstImage.url) {
          const imageData = {
            url: firstImage.url,
            prompt: firstImage.prompt,
            success: true
          };
          console.log('Setting image URL:', imageData.url);
          
          // Preload the image to make it load faster
          const img = new Image();
          img.src = imageData.url;
          img.onload = () => {
            console.log('Image preloaded successfully');
          };
          img.onerror = (error) => {
            console.error('Image preload failed:', error);
          };
          
          setPartnerGenerationImage(imageData.url);
          setCurrentGeneratedImage(imageData.url);
          setGeneratedImagesList(prev => [...prev, imageData.url]);
          setIsImageGenerated(true);
          // Image is ready - animation will end when minimum duration is met
        } else {
          console.error('Invalid image data:', firstImage);
        }
      } else {
        console.error('No images in result:', result);
      }
    } catch (error) {
      console.error('Error generating image:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        result: error
      });
      // Don't show alert, just log - user is in chatbot
    } finally {
      setIsGeneratingImage(false);
    }
  };

  const generateSingleImage = async () => {
    setIsGeneratingImage(true);
    setShowEmojiSelection(false);
    
    try {
      const activities = [activityX, activityY].filter(a => a);
      const emojis = selectedEmojis.map(e => e.emoji);
      
      const result = await generatePartnerImagesReplicate(activities, emojis, 'free', 1);
      
      if (result && result.images && result.images.length > 0) {
        // Replicate returns array of images, take the first one
        const firstImage = result.images[0];
        if (firstImage && firstImage.success && firstImage.url) {
          // Preload the image
          const img = new Image();
          img.src = firstImage.url;
          
          setCurrentGeneratedImage(firstImage.url);
          setGeneratedImagesList(prev => [...prev, firstImage.url]);
        }
      }
    } catch (error) {
      console.error('Error generating image:', error);
      alert('Failed to generate image. Please try again.');
    } finally {
      setIsGeneratingImage(false);
    }
  };

  const handlePartnerGenerationComplete = (answers) => {
    // Image should already be generated by this point
    // Start the heart animation when chat closes
    console.log('Partner generation answers:', answers);
    
    // Start animation sequence when chat closes
    setIsShowingAnimation(true);
    animationStartTimeRef.current = Date.now();
    
    // If image is already ready, useEffect will handle ending animation
    // If not, the animation will continue until image is ready (handled by useEffect)
  };

  const handleRandomizeImage = async () => {
    // If we already have 3 images, open the chat instead of generating a new one
    if (generatedImagesList.length >= 3) {
      setShowPartnerSelection(true);
      return;
    }
    
    await generateSingleImage();
  };

  const handlePostWantedAd = () => {
    // Save all data to localStorage for now (will be moved to Firebase later)
    const wantedAdData = {
      activityX,
      activityY,
      selectedEmojis: selectedEmojis.map(emoji => emoji.emoji),
      createdAt: new Date(),
      userId: currentUser?.uid || 'anonymous'
    };

    try {
      localStorage.setItem('wantedAdData', JSON.stringify(wantedAdData));
      console.log('Wanted ad data saved to localStorage');
    } catch (error) {
      console.error('Failed to save wanted ad data:', error);
    }

    // Open signup popup
    if (onShowSignUp) {
      onShowSignUp();
    }
  };

  const handleHelpMeDecide = () => {
    setShowDatingQuestions(true);
  };

  const handlePartnerSelected = (selectedImage) => {
    setSelectedPartnerImage(selectedImage);
    setGeneratedPartnerImage(selectedImage.url);
    setIsImageGenerated(true);
    setShowPartnerSelection(false);
  };

  const handleClosePartnerSelection = () => {
    setShowPartnerSelection(false);
    // If no image was selected, go back to emoji selection
    if (!selectedPartnerImage) {
      setShowEmojiSelection(true);
    }
  };

  const handleSaveConversation = async (conversationData) => {
    if (currentUser) {
      try {
        const userDocRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userDocRef, {
          'luvProfile.datingConversations': conversationData,
          updatedAt: new Date()
        });
        console.log('✅ Dating conversation saved to Firebase');
      } catch (error) {
        console.error('❌ Error saving dating conversation:', error);
      }
    }
  };

  const openSelfFoxChat = useCallback((e) => {
    if (e?.preventDefault) e.preventDefault();
    setFoxChatVariant('self');
    setShowFoxChatPopup(true);
  }, []);

  // Inline Survey Handlers (hero START / fox launcher use `openSelfFoxChat` instead)
  const handleCreateClick = (e) => {
    if (e?.preventDefault) e.preventDefault();
    console.log('Create button clicked (inline survey)');
    setCollageFriendFlowActive(false);
    setCollageFriendInviteEmail(null);
    if (showMyCollagesInline) {
      setShowMyCollagesInline(false);
      setPosterDeleteConfirmId(null);
      setPosterDetailFromList(null);
      setPosterDetailFromListTitleOverride(null);
      setShowUnpostConfirm(false);
    }
    // Reset partner image if user wants to create a new poster
    setSelectedPartnerCutout(null);
    setIsImageGenerated(false);
    setGeneratedPartnerImage(null);
    setCurrentGeneratedImage(null);
    setSelectedSwags([]);
    setSurveyCompleted(false);
    setUserPhotoUrl(null);
    setCollageUserPhotoOriginalUrl(null);
    setShowFoxButton(true);
    setSurveyOnIntro(true);
    setShowInlineSurvey(true);
    setCurrentPosterAlreadySaved(false);
    reopenPosterDetailAfterSaveIdRef.current = null;
    setEditingSavedPosterId(null);
    setEditingFeedAdId(null);
    setSuppressPrimaryLuvIconsOnEditorCanvas(false);
    setCollageFinderSelfGender(null);
    setCollageFinderFriendLuv(false);
    setCollageFinderRomanticLuv(false);
    setCollageFinderLookingForGenders([]);
    setCollageFinderSelfAge(AGE_WHEEL_DEFAULT);
    setFriendCutoutReplacedSinceSurvey(false);
    setTimeout(() => {
      const anchor =
        document.querySelector('.homepage-hero-title') ||
        document.querySelector('.wanted-poster-section');
      anchor?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  const handleDailyVibeCheckCompleted = useCallback(async ({ newStreak, periodKey } = {}) => {
    setFoxInboxUnread(false);
    if (typeof newStreak === 'number' && Number.isFinite(newStreak)) {
      setUserVibeCheckStreak(newStreak);
      if (typeof periodKey === 'string' && periodKey) {
        setUserVibeCheckStreakLastPeriodKey(periodKey);
      }
      return;
    }
    if (!currentUser?.uid) return;
    try {
      const repaired = await reconcileVibeCheckStreakFromDailyChecks(db, currentUser.uid);
      if (typeof repaired === 'number' && Number.isFinite(repaired)) {
        setUserVibeCheckStreak(repaired);
        setUserVibeCheckStreakLastPeriodKey(periodKey || getDailyVibePeriodKey());
      }
    } catch (err) {
      console.warn('Vibe check streak reconcile failed:', err);
    }
  }, [currentUser?.uid]);

  // Email / share link: https://luv.wtf/?makeCollage=1 — open FoxChat collage flow once, then strip param.
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('makeCollage') !== '1') return;
    params.delete('makeCollage');
    const clean = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (clean ? `?${clean}` : ''));
    openSelfFoxChat(null);
    // Intentionally run once on load; openSelfFoxChat from first render is sufficient for opening FoxChat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Email deep link: https://luv.wtf/?yourRewards=1 — open Your collages + scroll to Your Rewards, then strip param.
  // URLs that also include chatToken (`/?yourRewards=1&chatToken=…`) are handled in App.js after sign-in (postLoginRewardsNonce).
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('yourRewards') !== '1') return;
    if (params.get('chatToken')) return;
    params.delete('yourRewards');
    const clean = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (clean ? `?${clean}` : ''));
    setShowMyCollagesInline(true);
    const scrollToRewards = () => {
      document.getElementById('user-menu-your-rewards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    window.setTimeout(scrollToRewards, 180);
  }, []);

  /** Same field clears as `handleSaveClick` when Saved! popup is skipped (edit-from-list save). */
  const resetCollageEditorCore = useCallback(() => {
    setSurveyCompleted(false);
    setShowInlineSurvey(false);
    setSelectedPartnerCutout(null);
    setSelectedSwags([]);
    setSelectedWords([]);
    setSelectedActivities([]);
    setSurveyAnswers(null);
    setEditedPosterNickname(null);
    setPersonalityConfirmed(false);
    setJungianAnalysisText(null);
    setJungianPersonality(null);
    setEditingSavedPosterId(null);
    setEditingFeedAdId(null);
    setSuppressPrimaryLuvIconsOnEditorCanvas(false);
    setCollageFinderSelfGender(null);
    setCollageFinderFriendLuv(false);
    setCollageFinderRomanticLuv(false);
    setCollageFinderLookingForGenders([]);
    setCollageFinderSelfAge(AGE_WHEEL_DEFAULT);
    setCollageUserPhotoOriginalUrl(null);
  }, []);

  /** After first-time save: opening Your collages should leave a clean editor when user returns to the hero. */
  const resetCollageEditorForMyCollagesRedirect = useCallback(() => {
    resetCollageEditorCore();
    setCurrentPosterAlreadySaved(false);
    setIsImageGenerated(false);
    setGeneratedPartnerImage(null);
    setCurrentGeneratedImage(null);
    setUserPhotoUrl(null);
    setShowFoxButton(true);
    setSurveyOnIntro(true);
    setSelectedPlaces([]);
    setCurrentPosterPostedIrl(false);
    setCurrentPosterPostedTiktok(false);
    reopenPosterDetailAfterSaveIdRef.current = null;
    setFriendCutoutReplacedSinceSurvey(false);
    skipNextPosterChangeCheckRef.current = false;
  }, [resetCollageEditorCore]);

  const handleCloseSavedPosterPopup = useCallback(() => {
    setShowSavedPosterPopup(false);
    if (openCollagesAfterSavedPosterPopupRef.current) {
      openCollagesAfterSavedPosterPopupRef.current = false;
      resetCollageEditorForMyCollagesRedirect();
      setShowMyCollagesInline(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [resetCollageEditorForMyCollagesRedirect]);

  const handleSaveClick = async (saveOptions = {}) => {
    const forFriendShareReferral = !!saveOptions?.forFriendShareReferral;
    if (!currentUser) {
      if (onShowSignUp) onShowSignUp();
      return;
    }
    if (editedPosterNickname !== null && editedPosterNickname !== undefined && String(editedPosterNickname).trim() === '') {
      setShowPersonalityChart(true);
      return;
    }
    if (
      !editingSavedPosterId &&
      !editingFeedAdId &&
      (!collageFinderSelfGender || (!collageFinderFriendLuv && !collageFinderRomanticLuv))
    ) {
      setShowPersonalityChart(true);
      setChartHideRing(true);
      return;
    }
    const savingFriendCollage = collageFriendFlowActive && !forFriendShareReferral;
    const skipPostSaveConfirmationPopup = !!(editingSavedPosterId || editingFeedAdId);
    let mergedSavedPosterForDetailReopen = null;
    try {
      setIsSavingPoster(true);
      openCollagesAfterSavedPosterPopupRef.current = false;
      const posterId = nanoid();
      const nicknameForPoster = (editedPosterNickname && String(editedPosterNickname).trim()) ? editedPosterNickname : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One');

      // Persist images to Firebase Storage — partner, user photo, swags, and places run in parallel.
      const { partnerCutoutUrl, userPhotoUrlForStore, userPhotoOriginalUrlForStore, swagsForStore, placesForStore } =
        await persistCollageImageBundle({ useProfilePhotoFallback: true });
      const userDocRef = doc(db, 'users', currentUser.uid);
      const existingSnap = await getDoc(userDocRef);
      const existingPosters = normalizeSavedPostersList(Array.isArray(existingSnap.data()?.savedWantedPosters) ? existingSnap.data().savedWantedPosters : []);
      const rowForFriendFlags = editingFeedAdId
        ? existingPosters.find((p) => p.feedAdId === editingFeedAdId)
        : editingSavedPosterId
          ? existingPosters.find((p) => p.id === editingSavedPosterId)
          : null;
      const lookingForFromFinder =
        collageFinderRomanticLuv &&
        Array.isArray(collageFinderLookingForGenders) &&
        collageFinderLookingForGenders.length > 0
          ? [...collageFinderLookingForGenders]
          : null;
      const lookingForFromRow =
        Array.isArray(rowForFriendFlags?.lookingForGenders) && rowForFriendFlags.lookingForGenders.length > 0
          ? [...rowForFriendFlags.lookingForGenders]
          : null;
      const mergedSelfAge =
        Number.isFinite(collageFinderSelfAge) && collageFinderSelfAge >= 18 && collageFinderSelfAge <= 120
          ? collageFinderSelfAge
          : typeof rowForFriendFlags?.selfAge === 'number' && Number.isFinite(rowForFriendFlags.selfAge)
            ? rowForFriendFlags.selfAge
            : null;
      if (collageFinderRomanticLuv && !lookingForFromFinder && !lookingForFromRow) {
        setIsSavingPoster(false);
        setShowPersonalityChart(true);
        setChartHideRing(true);
        return;
      }
      /** Saved friend collage stays friend after collageFriendFlowActive is cleared (e.g. Refer popup closed). */
      const effectiveFriendCollageShare = !!collageFriendFlowActive || !!rowForFriendFlags?.friendCollageShare;
      // buildPosterDoc reads activities only from surveyAnswers.activities; the editor keeps picks in
      // selectedActivities (and load-from-saved sets that from activityX/Y/Z without syncing survey).
      const activitiesForPosterDoc =
        Array.isArray(selectedActivities) && selectedActivities.length > 0
          ? selectedActivities
              .map((a) => (typeof a === 'string' ? a : (a?.emoji || a?.name || '')))
              .filter((s) => s !== '')
          : Array.isArray(surveyAnswers?.activities)
            ? surveyAnswers.activities
            : [];
      const surveyAnswersForPosterDoc =
        surveyAnswers || activitiesForPosterDoc.length
          ? {
              ...(surveyAnswers && typeof surveyAnswers === 'object' ? surveyAnswers : {}),
              ...(activitiesForPosterDoc.length ? { activities: activitiesForPosterDoc } : {}),
            }
          : null;
      const posterData = buildPosterDoc({
        id: posterId,
        userId: currentUser?.uid,
        surveyAnswers: surveyAnswersForPosterDoc,
        imageBundle: { partnerCutoutUrl, userPhotoUrlForStore, userPhotoOriginalUrlForStore, swagsForStore, placesForStore },
        posterNickname: nicknameForPoster,
        selfGender: collageFinderSelfGender,
        friendLuv: !!collageFinderFriendLuv,
        romanticLuv: !!collageFinderRomanticLuv,
        words: selectedWords || [],
        postedIrl: !!currentPosterPostedIrl,
        postedTiktok: !!currentPosterPostedTiktok,
        friendCollageShare: effectiveFriendCollageShare,
        friendFoxMaskPlaceholder:
          effectiveFriendCollageShare && !surveyAnswers?.user_photo && !friendCutoutReplacedSinceSurvey,
        cutoutCustomizedSinceSurveyDefault:
          !!surveyAnswers?.user_photo || friendCutoutReplacedSinceSurvey,
        selfAge: mergedSelfAge,
        ...(lookingForFromFinder
          ? { lookingForGenders: lookingForFromFinder }
          : lookingForFromRow
            ? { lookingForGenders: lookingForFromRow }
            : {}),
      });
      /* When editing an existing poster and no fresh unmasked photo was uploaded, carry the prior
         row's unmasked URL forward so it isn't dropped on save. */
      if (
        !posterData.userPhotoOriginalUrl
        && typeof rowForFriendFlags?.userPhotoOriginalUrl === 'string'
        && rowForFriendFlags.userPhotoOriginalUrl.trim()
      ) {
        posterData.userPhotoOriginalUrl = rowForFriendFlags.userPhotoOriginalUrl.trim();
      }

      /* Editing tiles nudges the owner's vibe aura. `rowForFriendFlags` is the pre-edit row for
         both edit paths and null for a brand-new collage, which doesn't drift. The drift itself
         is applied server-side below, once the new poster is committed. */
      const auraTileChanges = rowForFriendFlags
        ? countCollageTileChanges(rowForFriendFlags, posterData)
        : null;
      const shouldDriftAura = !!auraTileChanges && hasCollageTileChanges(auraTileChanges);

      if (editingFeedAdId) {
        // Editing a posted feed collage — update the feed doc directly, skip uniqueness check.
        const mergedForFeed = existingPosters.find((p) => p.feedAdId === editingFeedAdId);
        const alsoPrivateFeed = !!(mergedForFeed?.isPrivateCollage);
        const feedFindPatch = {
          friendLuv: !!posterData.friendLuv,
          romanticLuv: !!posterData.romanticLuv,
        };
        try {
          await updateDoc(doc(db, 'wantedFeed', editingFeedAdId), {
            partnerCutout: posterData.partnerCutout || null,
            heartPhotoUrl: posterData.heartPhotoUrl || null,
            userPhotoUrl: posterData.userPhotoUrl || null,
            swags: posterData.swags || [],
            places: posterData.places || [],
            activityX: posterData.activityX,
            activityY: posterData.activityY,
            activityZ: posterData.activityZ,
            posterNickname: posterData.posterNickname,
            alsoPrivateMatch: alsoPrivateFeed,
            friendCollageShare: !!posterData.friendCollageShare,
            friendFoxMaskPlaceholder: !!posterData.friendFoxMaskPlaceholder,
            ...feedFindPatch,
            ...(posterData.selfGender && ['male', 'female', 'nb'].includes(posterData.selfGender)
              ? { selfGender: posterData.selfGender }
              : {}),
            ...(typeof posterData.selfAge === 'number' && Number.isFinite(posterData.selfAge)
              ? { selfAge: posterData.selfAge }
              : {}),
          });
        } catch (err) {
          console.error('Failed to update feed entry:', err);
          alert('Failed to update posted collage. Please try again.');
          return;
        }
        const matchedSavedId = existingPosters.find((p) => p.feedAdId === editingFeedAdId)?.id;
        if (matchedSavedId) {
          posterData.id = matchedSavedId;
          posterData.postedToFeed = true;
          posterData.feedAdId = editingFeedAdId;
          posterData.isPrivateCollage = !!mergedForFeed?.isPrivateCollage;
          posterData.friendCollageShare = !!(mergedForFeed?.friendCollageShare || collageFriendFlowActive);
          const updatedPosters = existingPosters.map((p) =>
            p.id === matchedSavedId ? { ...p, ...posterData } : p
          );
          await updateDoc(userDocRef, {
            savedWantedPosters: updatedPosters,
            updatedAt: new Date(),
          });
          void pushUserPublicPrimaryPreview();
        }
      } else if (editingSavedPosterId) {
        const oldPoster = existingPosters.find((p) => p.id === editingSavedPosterId);

        posterData.id = editingSavedPosterId;
        posterData.createdAt = oldPoster?.createdAt ?? posterData.createdAt;
        posterData.postedToFeed = oldPoster?.postedToFeed || false;
        posterData.feedAdId = oldPoster?.feedAdId || null;
        posterData.postedIrl = oldPoster?.postedIrl || currentPosterPostedIrl || false;
        posterData.postedTiktok = oldPoster?.postedTiktok || currentPosterPostedTiktok || false;
        posterData.isPrivateCollage = !!oldPoster?.isPrivateCollage;
        posterData.friendCollageShare = !!(oldPoster?.friendCollageShare || collageFriendFlowActive);
        const updatedPosters = existingPosters.map((p) =>
          p.id === editingSavedPosterId ? { ...p, ...posterData } : p
        );
        await updateDoc(userDocRef, {
          savedWantedPosters: updatedPosters,
          updatedAt: new Date(),
        });
        void pushUserPublicPrimaryPreview();
        mergedSavedPosterForDetailReopen = oldPoster
          ? { ...oldPoster, ...posterData }
          : { ...posterData };
        const alsoPrivateSavedFeed = !!oldPoster?.isPrivateCollage;
        const savedFeedFindPatch = {
          friendLuv: !!posterData.friendLuv,
          romanticLuv: !!posterData.romanticLuv,
        };
        if (oldPoster?.postedToFeed && oldPoster?.feedAdId) {
          try {
            await updateDoc(doc(db, 'wantedFeed', oldPoster.feedAdId), {
              partnerCutout: posterData.partnerCutout || null,
              heartPhotoUrl: posterData.heartPhotoUrl || null,
              userPhotoUrl: posterData.userPhotoUrl || null,
              swags: posterData.swags || [],
              places: posterData.places || [],
              activityX: posterData.activityX,
              activityY: posterData.activityY,
              activityZ: posterData.activityZ,
              posterNickname: posterData.posterNickname,
              alsoPrivateMatch: alsoPrivateSavedFeed,
              friendCollageShare: !!posterData.friendCollageShare,
              friendFoxMaskPlaceholder: !!posterData.friendFoxMaskPlaceholder,
              ...savedFeedFindPatch,
              ...(posterData.selfGender && ['male', 'female', 'nb'].includes(posterData.selfGender)
                ? { selfGender: posterData.selfGender }
                : {}),
              ...(typeof posterData.selfAge === 'number' && Number.isFinite(posterData.selfAge)
                ? { selfAge: posterData.selfAge }
                : {}),
            });
          } catch (feedErr) {
            console.error('Failed to sync feed entry for edited posted collage:', feedErr);
          }
        }
      } else {
        // New collage — check nickname uniqueness against saved posters + feed.
        const savedNicknames = (existingPosters || []).map((p) => (p.posterNickname ?? 'The One').trim()).filter(Boolean);
        const feedRef = collection(db, 'wantedFeed');
        const feedQuery = query(feedRef, orderBy('createdAt', 'desc'), limit(500));
        const feedSnap = await getDocs(feedQuery);
        const feedNicknames = feedSnap.docs
          .map((d) => (d.data().posterNickname ?? 'The One').trim())
          .filter(Boolean);
        const allExistingNicknamesList = [...savedNicknames, ...feedNicknames];
        const existingNicknamesSet = new Set(allExistingNicknamesList.map(normalizeNickname));
        const nicknameNorm = normalizeNickname(nicknameForPoster);

        if (existingNicknamesSet.has(nicknameNorm)) {
          const suggested = getSuggestedNickname(nicknameForPoster, allExistingNicknamesList);
          setSuggestedNicknameInPopup(suggested);
          setShowNicknameConflictPopup(true);
          return;
        }

        await updateDoc(userDocRef, {
          savedWantedPosters: arrayUnion(posterData),
          updatedAt: new Date(),
        });
        void pushUserPublicPrimaryPreview();
      }
      /* Start the recalculating window before navigating back to the user page, so the aura hint
         is already showing it rather than flashing the old "your vibe" first. Started on any tile
         change, not on the drift response, so the indicator doesn't depend on the request timing. */
      if (shouldDriftAura) {
        setAuraRecalc({ prevRgb: userAuraRgb });
      }

      if (savingFriendCollage) {
        setCollageFriendFlowActive(false);
        setCollageFriendSuccessPoster(posterData);
        setCollageFriendLinkCopied(false);
        setCollageFriendEmailSent(false);
        setShowCollageFriendSuccessPopup(true);
      } else if (forFriendShareReferral) {
        // Save only; refer popup + collageForFriend doc open / written after sharedPosters
      } else if (skipPostSaveConfirmationPopup) {
        setShowSavedPosterPopup(false);
        setSavedPosterForPopup(null);
        setSavedPosterLinkCopied(false);
        setShowMyCollagesInline(true);
        if (
          mergedSavedPosterForDetailReopen?.id
          && reopenPosterDetailAfterSaveIdRef.current
          && mergedSavedPosterForDetailReopen.id === reopenPosterDetailAfterSaveIdRef.current
        ) {
          reopenPosterDetailAfterSaveIdRef.current = null;
          setPosterDetailFromList(mergedSavedPosterForDetailReopen);
          setPosterDetailFromListTitleOverride('SAVED!');
        }
      } else {
        openCollagesAfterSavedPosterPopupRef.current = true;
        setSavedPosterForPopup(posterData);
        setSavedPosterLinkCopied(false);
        setShowSavedPosterPopup(true);
      }
      skipNextPosterChangeCheckRef.current = true;
      setCurrentPosterAlreadySaved(true);
      if (!openCollagesAfterSavedPosterPopupRef.current && !forFriendShareReferral) {
        /* Saving a collage edit lands back on Your collages; stop at the nickname tile so the user
           sees the collage they just edited rather than the top of the page. */
        if (skipPostSaveConfirmationPopup && !savingFriendCollage) {
          scrollToPrimaryNicknameTile();
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }

      if (forFriendShareReferral) {
        openCollagesAfterSavedPosterPopupRef.current = false;
        if (editingSavedPosterId || editingFeedAdId) {
          setSavedPosters((prev) => {
            const list = Array.isArray(prev) ? prev : [];
            return normalizeSavedPostersList(
              list.map((p) => (p.id === posterData.id ? { ...p, ...posterData } : p)),
            );
          });
        } else {
          setSavedPosters((prev) =>
            normalizeSavedPostersList([...(Array.isArray(prev) ? prev : []), posterData]),
          );
        }
        setEditingSavedPosterId(posterData.id);
        // Keep collageFriendFlowActive true until Refer popup closes so fox-mask / copy stay “friend”
      } else if (openCollagesAfterSavedPosterPopupRef.current) {
        setSavedPosters((prev) =>
          normalizeSavedPostersList([...(Array.isArray(prev) ? prev : []), posterData]),
        );
        setEditingSavedPosterId(posterData.id);
      } else {
        resetCollageEditorCore();
      }

      const posterForShare = posterData;
      const rawShare = { ...posterForShare };
      if (rawShare.createdAt && typeof rawShare.createdAt.toDate === 'function') {
        rawShare.createdAt = rawShare.createdAt;
      } else if (!(rawShare.createdAt instanceof Date)) {
        rawShare.createdAt = new Date();
      }
      const priorShareRow =
        (editingSavedPosterId && existingPosters.find((p) => p.id === editingSavedPosterId))
        || (editingFeedAdId && existingPosters.find((p) => p.feedAdId === editingFeedAdId));
      const lfPrior = priorShareRow?.lookingForGenders;
      if (Array.isArray(lfPrior) && lfPrior.length) {
        rawShare.lookingForGenders = [...lfPrior];
      }
      /* Drift the aura before mirroring so the public share carries the post-edit color. A
         failure here must never fail the save — the collage is already committed. */
      let auraForShare = userAuraRgb;
      if (shouldDriftAura) {
        try {
          const drifted = resolveAuraRgb(await driftMyAuraColor(auraTileChanges));
          if (drifted) {
            auraForShare = drifted;
            setUserAuraRgb(drifted);
          }
        } catch (auraErr) {
          console.warn('driftMyAuraColor failed (keeping current aura):', auraErr?.message || auraErr);
        }
      }
      if (auraForShare) {
        rawShare.auraColor = {
          r: auraForShare.r,
          g: auraForShare.g,
          b: auraForShare.b,
        };
      }
      await setDoc(
        doc(db, 'sharedPosters', posterForShare.id),
        sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(rawShare)),
      );

      if (forFriendShareReferral && currentUser?.uid) {
        try {
          await registerCollageForFriendPoster(db, currentUser.uid, posterData.id);
        } catch (cfErr) {
          console.error('collageForFriend register:', cfErr);
        }
        try {
          await runTransaction(db, async (transaction) => {
            const ref = doc(db, 'users', currentUser.uid);
            const snap = await transaction.get(ref);
            if (!snap.exists()) return;
            const raw = snap.data()?.spinBalance;
            const bal = typeof raw === 'number' && raw >= 0 ? raw : DEFAULT_USER_SPIN_BALANCE;
            transaction.set(ref, { spinBalance: bal + 1, updatedAt: new Date() }, { merge: true });
          });
        } catch (spinErr) {
          console.error('SEND TO FRIEND spin grant:', spinErr);
        }
        setFriendCollageReferPosterId(posterData.id);
        // Defer open so the same click doesn’t hit the overlay and close immediately (clears friend session).
        window.setTimeout(() => openFriendCollageReferPopup(), 120);
      }
    } catch (error) {
      console.error('Error saving poster:', error);
      alert('Failed to save poster. Please try again.');
    } finally {
      setIsSavingPoster(false);
    }
  };

  const handleShareClick = async () => {
    if (!currentUser) {
      if (onShowSignUp) onShowSignUp();
      return;
    }
    await handlePostOnLuvWtf(null, false);
  };

  const handleMatchFlowClose = (options) => {
    const scrollToEarnFoxes = options?.scrollToEarnFoxes === true;
    const currentStep = matchFlowStep;
    const poster = matchFlowPoster;
    setGiveawayOptOutConfirmOpen(false);
    setGiveawayOptOutSaving(false);
    setGiveawayOptInSaving(false);
    setMatchFlowConfirmRemoval(false);
    if (currentStep === 'confirm') {
      flushSync(() => {
        setMatchFlowStep(null);
        setMatchFlowPoster(null);
        setMatchFlowType(null);
        setMatchFlowExistingPrivate(null);
        setMatchFlowExistingPosted(null);
        setMatchFlowReductionPrompt(null);
        setMatchFlowLoading(false);
        openCollagesAfterSavedPosterPopupRef.current = false;
        resetCollageEditorForMyCollagesRedirect();
        setShowMyCollagesInline(true);
      });
      if (scrollToEarnFoxes) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToMatchAFriendSection();
          });
        });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    /* FoxChat-quiet path: closing the privateUpdate popup without UPDATE means the user declined
       to swap their primary. Clean up state but DO NOT re-open the SAVED! popup — FoxChat doesn't
       use it and the user is already on "Your collages." */
    const wasQuietSwap = matchFlowQuietPrivateSwapRef.current;
    matchFlowQuietPrivateSwapRef.current = false;
    setMatchFlowStep(null);
    setMatchFlowPoster(null);
    setMatchFlowType(null);
    setMatchFlowExistingPrivate(null);
    setMatchFlowExistingPosted(null);
    setMatchFlowReductionPrompt(null);
    setMatchFlowLoading(false);
    if (poster && !wasQuietSwap) {
      setSavedPosterForPopup(poster);
      setShowSavedPosterPopup(true);
    }
    if (wasQuietSwap) {
      triggerFoxChatBountyPrompt();
    }
  };

  const handleGiveawayOptOutConfirm = async () => {
    const poster = matchFlowPoster;
    if (!poster?.id || !currentUser?.uid) return;
    setGiveawayOptOutSaving(true);
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const updated = list.map((p) => (p.id === poster.id ? { ...p, promoteOnLuvwtfSocials: false } : p));
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      void pushUserPublicPrimaryPreview();
      setSavedPosters(updated);
      setMatchFlowPoster((prev) => (prev?.id === poster.id ? { ...prev, promoteOnLuvwtfSocials: false } : prev));
      setSavedPosterForPopup((prev) => (prev?.id === poster.id ? { ...prev, promoteOnLuvwtfSocials: false } : prev));
      setGiveawayOptOutConfirmOpen(false);
      try {
        await deleteDinnerGiveawayOptInsForPoster(db, currentUser.uid, poster.id);
      } catch (delErr) {
        console.error('Failed to remove dinner giveaway opt-in docs:', delErr);
      }
    } catch (err) {
      console.error('Failed to opt out of dinner giveaway:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setGiveawayOptOutSaving(false);
    }
  };

  const handleGiveawayOptInFromUploadedConfirm = async () => {
    const poster = matchFlowPoster;
    if (!poster?.id || !currentUser?.uid) return false;
    if (poster.promoteOnLuvwtfSocials === true) return true;
    setGiveawayOptInSaving(true);
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const primaryId = snap.data()?.primaryCollageId;
      let updated = list.map((p) => {
        if (p.id !== poster.id) return p;
        const merged = overlayPosterProfileFromClient(p, poster);
        return { ...merged, promoteOnLuvwtfSocials: true };
      });
      let clearedIds = [];
      if (primaryId) {
        const norm = normalizeGiveawayToPrimaryOnly(updated, primaryId);
        updated = norm.posters;
        clearedIds = norm.clearedPosterIds;
      }
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      const promotedRow = updated.find((p) => p.id === poster.id);
      await syncPosterProfileFieldMirrors(db, promotedRow);
      void pushUserPublicPrimaryPreview();
      setSavedPosters(updated);
      const promoted = promotedRow?.promoteOnLuvwtfSocials === true;
      setMatchFlowPoster((prev) => (prev?.id === poster.id ? { ...prev, ...promotedRow } : prev));
      setSavedPosterForPopup((prev) => (prev?.id === poster.id ? { ...prev, ...promotedRow } : prev));
      try {
        await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, clearedIds);
      } catch (err) {
        console.error('Failed to remove dinner giveaway opt-in docs:', err);
      }
      if (promoted) {
        try {
          await recordDinnerGiveawayOptIn(db, currentUser, promotedRow, 'uploaded_confirm_opt_in');
        } catch (err) {
          console.error('Failed to record dinner giveaway opt-in:', err);
        }
      }
      return true;
    } catch (err) {
      console.error('Failed to opt in to dinner giveaway:', err);
      alert('Something went wrong. Please try again.');
      return false;
    } finally {
      setGiveawayOptInSaving(false);
    }
  };

  const showPrimaryBountyOptInPopupIfEligible = useCallback((posterCandidate, analyticsSource = 'foxchat_bounty_optin') => {
    if (!posterCandidate?.id) return;
    if (posterCandidate.promoteOnLuvwtfSocials === true) return;
    if (foxChatBountyPromptOpenRef.current) return;
    bountyPopupAnalyticsSourceRef.current = analyticsSource;
    setFoxChatDeferredBountyPoster(posterCandidate);
    window.setTimeout(() => setFoxChatBountyPromptOpen(true), 400);
  }, []);

  const triggerFoxChatBountyPrompt = useCallback(() => {
    const raw = pendingFoxChatBountyPosterRef.current;
    if (!raw?.id) return;
    pendingFoxChatBountyPosterRef.current = null;
    showPrimaryBountyOptInPopupIfEligible(raw, 'foxchat_bounty_optin');
  }, [showPrimaryBountyOptInPopupIfEligible]);

  const handleFoxChatDeferredBountyChoice = async (optedIn) => {
    setFoxChatBountyPromptOpen(false);
    const stalePoster = foxChatDeferredBountyPoster;
    const giveawaySource = bountyPopupAnalyticsSourceRef.current || 'foxchat_bounty_optin';
    setFoxChatDeferredBountyPoster(null);
    pendingFoxChatBountyPosterRef.current = null;

    const scrollToFiveBountiesAfterClose = () => {
      window.setTimeout(() => {
        const el = document.getElementById('earn-foxes');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    };

    try {
      if (!optedIn || !stalePoster?.id || !currentUser?.uid) {
        return;
      }
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const posterFromDb = list.find((p) => p.id === stalePoster.id);
      if (!posterFromDb || posterFromDb.promoteOnLuvwtfSocials === true) return;
      const primaryId = snap.data()?.primaryCollageId;
      let updated = list.map((p) => {
        if (p.id !== stalePoster.id) return p;
        const merged = overlayPosterProfileFromClient(p, stalePoster);
        return { ...merged, promoteOnLuvwtfSocials: true };
      });
      let clearedIds = [];
      if (primaryId) {
        const norm = normalizeGiveawayToPrimaryOnly(updated, primaryId);
        updated = norm.posters;
        clearedIds = norm.clearedPosterIds;
      }
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      const promotedRow = updated.find((p) => p.id === stalePoster.id);
      await syncPosterProfileFieldMirrors(db, promotedRow);
      void pushUserPublicPrimaryPreview();
      setSavedPosters(updated);
      try {
        await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, clearedIds);
      } catch (err) {
        console.error('Failed to remove dinner giveaway opt-in docs:', err);
      }
      if (promotedRow?.promoteOnLuvwtfSocials === true) {
        try {
          await recordDinnerGiveawayOptIn(db, currentUser, promotedRow, giveawaySource);
        } catch (err) {
          console.error('Failed to record dinner giveaway opt-in:', err);
        }
      }
    } catch (err) {
      console.error('FoxChat deferred prize opt-in failed:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      scrollToFiveBountiesAfterClose();
    }
  };

  /* After successful sign-in (Login / magic link / OAuth), open Fox Chat. Wait until this uid's
     posters have loaded so FoxChat can pick vibe check (has a primary collage) vs profile creation.
     Inbox / rewards deeplinks keep their own landing. */
  useEffect(() => {
    if (!postLoginCollagesNonce || postLoginCollagesNonce <= handledPostLoginCollagesNonceRef.current) {
      return;
    }
    if (!currentUser?.uid || loadingPosters) return;
    if (postersHydratedUid !== currentUser.uid) return;

    handledPostLoginCollagesNonceRef.current = postLoginCollagesNonce;

    const pendingRewards = postLoginRewardsNonce > handledPostLoginRewardsNonceRef.current;
    if (pendingRewards || deepLinkChatId || deepLinkOpenMessagesTab) {
      return;
    }

    openSelfFoxChat(null);
  }, [
    postLoginCollagesNonce,
    postLoginRewardsNonce,
    loadingPosters,
    postersHydratedUid,
    currentUser?.uid,
    deepLinkChatId,
    deepLinkOpenMessagesTab,
    openSelfFoxChat,
  ]);

  /** After inbox-style `chatToken` sign-in via email rewards URL (yourRewards + chatToken), open Your collages and scroll YOUR REWARDS. */
  useEffect(() => {
    if (!postLoginRewardsNonce || postLoginRewardsNonce <= handledPostLoginRewardsNonceRef.current) {
      return;
    }
    if (!currentUser?.uid || loadingPosters) return;

    handledPostLoginRewardsNonceRef.current = postLoginRewardsNonce;

    setShowMyCollagesInline(true);
    window.setTimeout(() => {
      document.getElementById('user-menu-your-rewards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 220);
  }, [postLoginRewardsNonce, loadingPosters, currentUser?.uid]);

  /* Fragment links (e.g. from email: luv.wtf/#earn-foxes) run before React paints; the browser
     never scrolls again. Re-run after mount + on hashchange so FIVE PRIZES is in view. */
  useEffect(() => {
    const scrollFivePrizesHash = () => {
      const id = window.location.hash.replace(/^#/, '');
      if (id !== 'earn-foxes' && id !== 'five-bounties-seeking-match') return;
      const el = document.getElementById('earn-foxes');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    scrollFivePrizesHash();
    const t1 = window.setTimeout(scrollFivePrizesHash, 50);
    const t2 = window.setTimeout(scrollFivePrizesHash, 350);
    window.addEventListener('hashchange', scrollFivePrizesHash);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.removeEventListener('hashchange', scrollFivePrizesHash);
    };
  }, []);

  /** Core match + feed writes; throws on failure (caller may catch separately). */
  const runExecuteMatchActions = async (poster, setAsMain, postToFeed) => {
    const userDocRef = doc(db, 'users', currentUser.uid);
    const userSnap = await getDoc(userDocRef);
    let existing = normalizeSavedPostersList(Array.isArray(userSnap.data()?.savedWantedPosters) ? userSnap.data().savedWantedPosters : []);
      existing = existing.map((p) =>
        p.id === poster.id
          ? {
          ...p,
          friendLuv: typeof poster.friendLuv === 'boolean' ? poster.friendLuv : p.friendLuv,
          romanticLuv: typeof poster.romanticLuv === 'boolean' ? poster.romanticLuv : p.romanticLuv,
          ...(typeof poster.promoteOnLuvwtfSocials === 'boolean'
            ? { promoteOnLuvwtfSocials: poster.promoteOnLuvwtfSocials }
            : {}),
          ...(Array.isArray(poster.lookingForGenders) ? { lookingForGenders: poster.lookingForGenders } : {}),
          ...(poster.selfGender && ['male', 'female', 'nb'].includes(poster.selfGender) ? { selfGender: poster.selfGender } : {}),
        }
          : p,
      );

    if (setAsMain) {
      existing = existing.map(p => ({
        ...p,
        isPrivateCollage: p.id === poster.id,
      }));
    }

    if (postToFeed) {
      const previousPosted = existing.find(p => p.postedToFeed && p.feedAdId && p.id !== poster.id);
      if (previousPosted?.feedAdId) {
        try {
          await deleteDoc(doc(db, 'wantedFeed', previousPosted.feedAdId));
        } catch (err) {
          console.error('Error removing old feed entry:', err);
        }
        existing = existing.map(p =>
          p.id === previousPosted.id ? { ...p, postedToFeed: false, feedAdId: null } : p
        );
      }

      const posterEntry = existing.find(p => p.id === poster.id);
      if (!posterEntry?.postedToFeed) {
        const adForFirestore = {
          partnerCutout: poster.partnerCutout || null,
          heartPhotoUrl: poster.heartPhotoUrl || null,
          userPhotoUrl: poster.userPhotoUrl || null,
          swags: poster.swags || [],
          places: poster.places || [],
          activityX: poster.activityX,
          activityY: poster.activityY,
          activityZ: poster.activityZ || null,
          userId: currentUser.uid,
          userName: (currentUser?.displayName && String(currentUser.displayName).trim()) || 'You',
          posterNickname: poster.posterNickname || 'The One',
          dominantPersonality: poster.dominantPersonality || null,
          alsoPrivateMatch: !!setAsMain,
          friendLuv: typeof poster.friendLuv === 'boolean' ? poster.friendLuv : !!postToFeed,
          romanticLuv: typeof poster.romanticLuv === 'boolean' ? poster.romanticLuv : !!setAsMain,
          createdAt: serverTimestamp(),
          friendCollageShare: typeof poster.friendCollageShare === 'boolean' ? poster.friendCollageShare : false,
          friendFoxMaskPlaceholder:
            typeof poster.friendFoxMaskPlaceholder === 'boolean' ? poster.friendFoxMaskPlaceholder : false,
          ...(poster.selfGender && ['male', 'female', 'nb'].includes(poster.selfGender) ? { selfGender: poster.selfGender } : {}),
        };
        const docRef = await addDoc(collection(db, 'wantedFeed'), adForFirestore);
        existing = existing.map(p =>
          p.id === poster.id ? { ...p, postedToFeed: true, feedAdId: docRef.id } : p
        );

        const posterForShared = existing.find(p => p.id === poster.id);
        if (posterForShared) {
          try {
            await setDoc(
              doc(db, 'sharedPosters', docRef.id),
              sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(posterForShared)),
            );
          } catch (_) {}
        }
      }
    }

    const posterForFeedSync = existing.find((p) => p.id === poster.id);
    if (posterForFeedSync?.feedAdId) {
      const alsoPrivate = !!posterForFeedSync.isPrivateCollage;
      const syncFeed = {
        alsoPrivateMatch: alsoPrivate,
        friendLuv:
          typeof posterForFeedSync.friendLuv === 'boolean'
            ? posterForFeedSync.friendLuv
            : !!(posterForFeedSync.postedToFeed && posterForFeedSync.feedAdId),
        romanticLuv:
          typeof posterForFeedSync.romanticLuv === 'boolean'
            ? posterForFeedSync.romanticLuv
            : !!posterForFeedSync.isPrivateCollage,
      };
      if (posterForFeedSync.selfGender && ['male', 'female', 'nb'].includes(posterForFeedSync.selfGender)) {
        syncFeed.selfGender = posterForFeedSync.selfGender;
      }
      try {
        await updateDoc(doc(db, 'wantedFeed', posterForFeedSync.feedAdId), syncFeed);
      } catch (syncErr) {
        console.error('Failed to sync feed match / FIND prefs:', syncErr);
      }
    }

    const effectivePrimaryId =
      setAsMain || postToFeed
        ? poster.id
        : (typeof userSnap.data()?.primaryCollageId === 'string' && userSnap.data().primaryCollageId
          ? userSnap.data().primaryCollageId
          : null);
    let clearedGiveawayPosterIds = [];
    if (effectivePrimaryId) {
      const norm = normalizeGiveawayToPrimaryOnly(existing, effectivePrimaryId);
      existing = norm.posters;
      clearedGiveawayPosterIds = norm.clearedPosterIds;
    }

    const userPayload = { savedWantedPosters: existing, updatedAt: new Date() };
    if (setAsMain || postToFeed) {
      userPayload.primaryCollageId = poster.id;
    }
    await updateDoc(userDocRef, userPayload);
    if (clearedGiveawayPosterIds.length > 0) {
      try {
        await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, clearedGiveawayPosterIds);
      } catch (err) {
        console.error('Failed to remove dinner giveaway opt-in docs:', err);
      }
    }
    setSavedPosters(existing);
    if (setAsMain || postToFeed) {
      setPrimaryCollageId(poster.id);
    }
    void pushUserPublicPrimaryPreview();

    const mergedPoster = existing.find((p) => p.id === poster.id);
    if (mergedPoster?.promoteOnLuvwtfSocials === true) {
      try {
        await recordDinnerGiveawayOptIn(db, currentUser, mergedPoster, 'match_flow_execute');
      } catch (err) {
        console.error('Failed to record dinner giveaway opt-in:', err);
      }
    }
  };

  const executeMatchActions = async (poster, setAsMain, postToFeed) => {
    try {
      await runExecuteMatchActions(poster, setAsMain, postToFeed);
    } catch (err) {
      console.error('Error executing match actions:', err);
      alert('Something went wrong. Please try again.');
    }
  };

  const matchOptionsSummaryLabel = (priv, comm) => {
    if (priv && comm) return 'both COMPUTER AND COMMUNITY MATCH';
    if (priv) return 'COMPUTER MATCH';
    return 'COMMUNITY MATCH';
  };

  const completeMatchReplace = async (finalPrivate, finalCommunity) => {
    const poster = matchFlowPoster;
    if (!poster || !currentUser?.uid) return;
    setMatchFlowLoading(true);
    try {
      await executeMatchActions(poster, finalPrivate, finalCommunity);
      setMatchFlowReductionPrompt(null);
      setMatchFlowConfirmRemoval(false);
      setMatchFlowType(finalPrivate && finalCommunity ? 'both' : finalPrivate ? 'private' : 'community');
      setMatchFlowStep('confirm');
    } catch (err) {
      console.error('Error completing match replace:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setMatchFlowLoading(false);
    }
  };

  /**
   * Compare new POST checkboxes to what the user already had on *other* saved collages (excluding the new one).
   * If any match channel was active before but is unchecked now, offer to add it back on the new collage.
   */
  const evaluateMatchReductionAndApply = async (oldPosterFallback) => {
    const poster = matchFlowPoster;
    if (!poster || !currentUser?.uid) return;
    const newP = matchFlowSelectionPrivate;
    const newC = matchFlowSelectionCommunity;
    let prevPrivate = false;
    let prevCommunity = false;
    setMatchFlowLoading(true);
    try {
      try {
        const snap = await getDoc(doc(db, 'users', currentUser.uid));
        const existing = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
        const others = existing.filter((p) => p.id !== poster.id);
        prevPrivate = others.some((p) => p.isPrivateCollage);
        prevCommunity = others.some((p) => p.postedToFeed && p.feedAdId);
      } catch (err) {
        console.error('Error reading match state for reduction check:', err);
        prevPrivate = !!(oldPosterFallback?.isPrivateCollage);
        prevCommunity = !!(oldPosterFallback?.postedToFeed && oldPosterFallback?.feedAdId);
      }
      const missingPrivate = prevPrivate && !newP;
      const missingCommunity = prevCommunity && !newC;
      if (!missingPrivate && !missingCommunity) {
        await completeMatchReplace(newP, newC);
        return;
      }
      setMatchFlowReductionPrompt({
        oldLabel: matchOptionsSummaryLabel(prevPrivate, prevCommunity),
        missingPrivate,
        missingCommunity,
        newPrivate: newP,
        newCommunity: newC,
      });
    } finally {
      setMatchFlowLoading(false);
    }
  };

  /** @returns {Promise<boolean>} */
  const unpostSavedPosterFromFeed = async (poster) => {
    if (!poster?.id || !currentUser?.uid) return false;
    if (!poster.postedToFeed || !poster.feedAdId) return false;
    try {
      await deleteDoc(doc(db, 'wantedFeed', poster.feedAdId));
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const existing = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const updated = existing.map((p) =>
        p.id === poster.id ? { ...p, postedToFeed: false, feedAdId: null } : p
      );
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      void pushUserPublicPrimaryPreview();
      setSavedPosters((prev) =>
        prev.map((p) => (p.id === poster.id ? { ...p, postedToFeed: false, feedAdId: null } : p))
      );
      return true;
    } catch (err) {
      console.error('Error unposting from feed:', err);
      alert('Could not unpost. Please try again.');
      return false;
    }
  };

  const runMatchFlowForPoster = async (poster, needsPrivate, needsCommunity) => {
    if (!poster || !currentUser?.uid) return;
    if (!needsPrivate && !needsCommunity) return;
    setMatchFlowConfirmRemoval(false);
    const flowType = needsPrivate && needsCommunity ? 'both' : needsPrivate ? 'private' : 'community';

    if (needsCommunity && !(await ensureBerkeleyEmailAccess())) return;

    setMatchFlowLoading(true);
    try {
      if (needsCommunity) {
        const feedRef = collection(db, 'wantedFeed');
        const feedSnap = await getDocs(query(feedRef, orderBy('createdAt', 'desc'), limit(500)));
        const feedNicknames = feedSnap.docs
          .filter(d => d.data().userId !== currentUser.uid)
          .map(d => (d.data().posterNickname ?? 'The One').trim())
          .filter(Boolean);
        if (new Set(feedNicknames.map(normalizeNickname)).has(normalizeNickname(poster.posterNickname))) {
          const suggested = getSuggestedNickname(poster.posterNickname, feedNicknames);
          setSuggestedNicknameInPopup(suggested);
          setShowNicknameConflictPopup(true);
          setMatchFlowLoading(false);
          return;
        }
      }

      const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
      const existing = normalizeSavedPostersList(Array.isArray(userSnap.data()?.savedWantedPosters) ? userSnap.data().savedWantedPosters : []);

      // Primary collage: if another saved poster already has computer match, prompt to replace; else set this poster when needsPrivate (see executeMatchActions).
      const existingPrimaryOther = needsPrivate ? existing.find((p) => p.isPrivateCollage && p.id !== poster.id) : null;
      const currentPosted = needsCommunity ? existing.find(p => p.postedToFeed && p.feedAdId && p.id !== poster.id) : null;

      setMatchFlowPoster(poster);
      setMatchFlowType(flowType);
      setMatchFlowExistingPrivate(existingPrimaryOther || null);
      setMatchFlowExistingPosted(currentPosted || null);
      setMatchFlowSelectionPrivate(needsPrivate);
      setMatchFlowSelectionCommunity(needsCommunity);
      setMatchFlowReductionPrompt(null);
      setShowSavedPosterPopup(false);

      if (existingPrimaryOther) {
        setMatchFlowStep('privateUpdate');
      } else if (currentPosted) {
        setMatchFlowStep('communityUpdate');
      } else {
        await executeMatchActions(poster, needsPrivate, needsCommunity);
        setMatchFlowStep('confirm');
      }
    } catch (err) {
      console.error('Error in match flow:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setMatchFlowLoading(false);
    }
  };

  /**
   * Quiet variant of `runMatchFlowForPoster(poster, true, false)` used by the FoxChat post-save
   * flow. Behaves the same way Firestore-side, but suppresses the post-save "UPLOADED" confirm
   * popup (FoxChat already showed inline SAVED! feedback) and the SAVED!-popup re-open on
   * conflict-popup dismiss (FoxChat doesn't use the SAVED! popup at all).
   *
   *   - No existing primary → silently calls `runExecuteMatchActions(poster, true, false)` to
   *     write `isPrivateCollage: true` + `primaryCollageId`.
   *   - Existing primary (other than this poster) → opens the same `privateUpdate` popup
   *     ("UPDATE YOUR PRIMARY COLLAGE?"). The UPDATE button branches on
   *     `matchFlowQuietPrivateSwapRef` to do a silent swap (skips the `confirm` step).
   */
  const setSavedPosterAsPrimaryQuiet = async (poster) => {
    if (!poster?.id || !currentUser?.uid) return;
    try {
      const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
      const existing = normalizeSavedPostersList(
        Array.isArray(userSnap.data()?.savedWantedPosters) ? userSnap.data().savedWantedPosters : [],
      );
      const existingPrimaryOther = existing.find((p) => p.isPrivateCollage && p.id !== poster.id);
      if (!existingPrimaryOther) {
        await runExecuteMatchActions(poster, true, false);
        triggerFoxChatBountyPrompt();
        return;
      }
      matchFlowQuietPrivateSwapRef.current = true;
      setMatchFlowPoster(poster);
      setMatchFlowType('private');
      setMatchFlowExistingPrivate(existingPrimaryOther);
      setMatchFlowExistingPosted(null);
      setMatchFlowSelectionPrivate(true);
      setMatchFlowSelectionCommunity(false);
      setMatchFlowReductionPrompt(null);
      setMatchFlowStep('privateUpdate');
    } catch (err) {
      console.error('FoxChat-quiet setSavedPosterAsPrimary failed:', err);
    }
  };

  const toggleSavedPosterLookingFor = (gender) => {
    setSavedPosterLookingFor((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      if (list.includes(gender)) {
        return list.filter((g) => g !== gender);
      }
      if (list.length >= 3) return list;
      return [...list, gender];
    });
  };

  const handleSavedPosterLookingForConfirm = async () => {
    if (!savedPosterLookingFor.length) return;
    const poster = savedPosterForPopup;
    const nextLookingFor = [...savedPosterLookingFor];
    if (poster?.id && currentUser?.uid) {
      try {
        const userDocRef = doc(db, 'users', currentUser.uid);
        const snap = await getDoc(userDocRef);
        const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
        const updated = list.map((p) =>
          p.id === poster.id ? { ...p, lookingForGenders: nextLookingFor } : p,
        );
        await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
        void pushUserPublicPrimaryPreview();
        setSavedPosters(updated);
        setSavedPosterForPopup((prev) =>
          prev?.id === poster.id ? { ...prev, lookingForGenders: nextLookingFor } : prev,
        );
        try {
          await setDoc(
            doc(db, 'sharedPosters', poster.id),
            sanitizeForFirestore({ lookingForGenders: nextLookingFor }),
            { merge: true },
          );
        } catch (syncErr) {
          console.error('Failed to sync lookingForGenders to shared poster:', syncErr);
        }
      } catch (err) {
        console.error('Failed to save MATCH WITH preferences:', err);
      }
    } else {
      setSavedPosterForPopup((prev) => (prev ? { ...prev, lookingForGenders: nextLookingFor } : null));
    }
    setSavedPosterFlowStep(2);
  };

  const handleSavedPosterMatchClick = async () => {
    const poster = savedPosterForPopup;
    if (!poster || !currentUser?.uid) return;
    setMatchFlowLoading(true);
    const promoteOnLuvwtfSocials = promoteOnLuvwtfSocialsChecked;
    try {
      try {
        const userDocRef = doc(db, 'users', currentUser.uid);
        const snap = await getDoc(userDocRef);
        const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
        const primaryId = snap.data()?.primaryCollageId;
        let updated = list.map((p) => (p.id === poster.id ? { ...p, promoteOnLuvwtfSocials } : p));
        let clearedIds = [];
        if (primaryId) {
          const norm = normalizeGiveawayToPrimaryOnly(updated, primaryId);
          updated = norm.posters;
          clearedIds = norm.clearedPosterIds;
        }
        await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
        void pushUserPublicPrimaryPreview();
        setSavedPosters(updated);
        const persistedPromote = updated.find((p) => p.id === poster.id)?.promoteOnLuvwtfSocials === true;
        setSavedPosterForPopup((prev) => (prev?.id === poster.id ? { ...prev, promoteOnLuvwtfSocials: persistedPromote } : prev));
        try {
          await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, clearedIds);
        } catch (delErr) {
          console.error('Failed to remove dinner giveaway opt-in docs:', delErr);
        }
        if (!promoteOnLuvwtfSocials) {
          try {
            await deleteDinnerGiveawayOptInsForPoster(db, currentUser.uid, poster.id);
          } catch (delErr) {
            console.error('Failed to remove dinner giveaway opt-in docs:', delErr);
          }
        } else if (persistedPromote) {
          try {
            await recordDinnerGiveawayOptIn(db, currentUser, poster, 'saved_poster_meet_people');
          } catch (err) {
            console.error('Failed to record dinner giveaway opt-in:', err);
          }
        }
      } catch (err) {
        console.error('Failed to save promote-on-socials preference:', err);
      }
      const posterWithPromote = { ...poster, promoteOnLuvwtfSocials };
      await runMatchFlowForPoster(posterWithPromote, true, false);
    } finally {
      setMatchFlowLoading(false);
    }
  };

  const clearAllPrivateCollageFlags = async () => {
    if (!currentUser?.uid) return;
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const existing = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const updated = existing.map((p) => ({ ...p, isPrivateCollage: false }));
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      void pushUserPublicPrimaryPreview();
      setSavedPosters(updated);
      for (const p of updated) {
        if (!p.feedAdId) continue;
        try {
          await updateDoc(doc(db, 'wantedFeed', p.feedAdId), { alsoPrivateMatch: false });
        } catch (e) {
          console.error('Feed alsoPrivateMatch clear failed', e);
        }
      }
    } catch (err) {
      console.error('Error clearing computer match flags:', err);
      alert('Could not update. Please try again.');
    }
  };

  const handleUserMenuPrimaryPromoteSet = async (
    posterId,
    promoteOnLuvwtfSocials,
    profileSourcePoster = null,
    optInSource = 'user_menu_primary',
  ) => {
    if (!currentUser?.uid || !posterId) return false;
    if (matchFlowLoading) return false;
    setMatchFlowLoading(true);
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const poster = list.find((x) => x.id === posterId);
      if (!poster) return false;
      const mergedBase = overlayPosterProfileFromClient(poster, profileSourcePoster);
      const primaryId = snap.data()?.primaryCollageId ?? posterId;
      let updated = list.map((p) => (p.id === posterId ? { ...mergedBase, promoteOnLuvwtfSocials } : p));
      const norm = normalizeGiveawayToPrimaryOnly(updated, primaryId);
      updated = norm.posters;
      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      const row = updated.find((p) => p.id === posterId);
      await syncPosterProfileFieldMirrors(db, row);
      void pushUserPublicPrimaryPreview();
      setSavedPosters(updated);
      try {
        await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, norm.clearedPosterIds);
      } catch (err) {
        console.error('Failed to remove dinner giveaway opt-in docs:', err);
      }
      if (promoteOnLuvwtfSocials) {
        if (row?.promoteOnLuvwtfSocials === true) {
          try {
            await recordDinnerGiveawayOptIn(db, currentUser, row, optInSource);
          } catch (err) {
            console.error('Failed to record dinner giveaway opt-in:', err);
          }
        }
      } else {
        try {
          await deleteDinnerGiveawayOptInsForPoster(db, currentUser.uid, posterId);
        } catch (err) {
          console.error('Failed to remove dinner giveaway opt-in docs:', err);
        }
      }
      return true;
    } catch (err) {
      console.error('Failed to update dinner giveaway preference:', err);
      alert('Something went wrong. Please try again.');
      return false;
    } finally {
      setMatchFlowLoading(false);
    }
  };

  const handlePromoteOnSocialsExplainerOptInClick = async () => {
    if (promoteOnSocialsExplainerOptInBusy) return;
    setPromoteOnSocialsExplainerOptInBusy(true);
    try {
      const inMatchConfirmOptIn =
        matchFlowStep === 'confirm' &&
        matchFlowPoster?.id &&
        matchFlowPoster.promoteOnLuvwtfSocials !== true &&
        (matchFlowType === 'private' || matchFlowType === 'both');

      if (inMatchConfirmOptIn) {
        const ok = await handleGiveawayOptInFromUploadedConfirm();
        if (ok) closePromoteOnSocialsExplainer();
        return;
      }

      if (showSavedPosterPopup && savedPosterForPopup?.id && savedPosterFlowStep === 2) {
        if (savedPosterForPopup.promoteOnLuvwtfSocials === true) {
          setPromoteOnLuvwtfSocialsChecked(true);
          closePromoteOnSocialsExplainer();
          return;
        }
        const profileOverlay =
          savedPosterLookingFor.length > 0
            ? { ...savedPosterForPopup, lookingForGenders: [...savedPosterLookingFor] }
            : savedPosterForPopup;
        const ok = await handleUserMenuPrimaryPromoteSet(savedPosterForPopup.id, true, profileOverlay);
        if (ok) {
          setPromoteOnLuvwtfSocialsChecked(true);
          const posterId = savedPosterForPopup.id;
          setSavedPosterForPopup((prev) => {
            if (prev?.id !== posterId) return prev;
            const next = { ...prev, promoteOnLuvwtfSocials: true };
            if (Array.isArray(profileOverlay?.lookingForGenders) && profileOverlay.lookingForGenders.length > 0) {
              next.lookingForGenders = [...profileOverlay.lookingForGenders];
            }
            if (
              typeof profileOverlay?.selfAge === 'number'
              && Number.isFinite(profileOverlay.selfAge)
              && profileOverlay.selfAge >= 18
              && profileOverlay.selfAge <= 120
            ) {
              next.selfAge = profileOverlay.selfAge;
            }
            if (profileOverlay?.selfGender && ['male', 'female', 'nb'].includes(profileOverlay.selfGender)) {
              next.selfGender = profileOverlay.selfGender;
            }
            return next;
          });
          closePromoteOnSocialsExplainer();
        }
        return;
      }

      const primary = getPrimarySavedPoster(savedPosters, primaryCollageId);
      if (!primary?.id) {
        closePromoteOnSocialsExplainer();
        return;
      }
      if (primary.promoteOnLuvwtfSocials === true) {
        closePromoteOnSocialsExplainer();
        return;
      }
      const ok = await handleUserMenuPrimaryPromoteSet(primary.id, true, primary);
      if (ok) closePromoteOnSocialsExplainer();
    } finally {
      setPromoteOnSocialsExplainerOptInBusy(false);
    }
  };

  const closeUserMenuPrimaryReferPopup = useCallback(() => {
    setUserMenuPrimaryReferPosterId(null);
    setShowReferEmailInput(false);
    setShowReferIgInput(false);
    setReferFriendEmail('');
    setReferFriendEmailError('');
    setReferFriendSubmitted(false);
    setReferFriendIg('');
    setReferFriendIgError('');
    setReferFriendIgSubmitted(false);
    setFeedReferLinkCopied(false);
  }, []);

  const handlePrivateUpdateConfirm = async () => {
    if (!matchFlowExistingPrivate) return;
    /* FoxChat-quiet path: skip evaluateMatchReductionAndApply (which routes through
       completeMatchReplace → setMatchFlowStep('confirm') → "UPLOADED" popup) and instead run the
       primary swap silently, then close the popup directly. */
    if (matchFlowQuietPrivateSwapRef.current) {
      const poster = matchFlowPoster;
      if (!poster) return;
      setMatchFlowLoading(true);
      try {
        await runExecuteMatchActions(poster, true, false);
      } catch (err) {
        console.error('FoxChat-quiet primary swap failed:', err);
      } finally {
        matchFlowQuietPrivateSwapRef.current = false;
        setMatchFlowLoading(false);
        setMatchFlowStep(null);
        setMatchFlowPoster(null);
        setMatchFlowType(null);
        setMatchFlowExistingPrivate(null);
        setMatchFlowExistingPosted(null);
        setMatchFlowReductionPrompt(null);
        triggerFoxChatBountyPrompt();
      }
      return;
    }
    await evaluateMatchReductionAndApply(matchFlowExistingPrivate);
  };

  const handleCommunityUpdateConfirm = async () => {
    if (!matchFlowExistingPosted) return;
    await evaluateMatchReductionAndApply(matchFlowExistingPosted);
  };

  const handleMatchReductionAddMissing = () => {
    const r = matchFlowReductionPrompt;
    if (!r) return;
    const finalPrivate = r.newPrivate || r.missingPrivate;
    const finalCommunity = r.newCommunity || r.missingCommunity;
    void completeMatchReplace(finalPrivate, finalCommunity);
  };

  const handleMatchReductionKeepSelection = async () => {
    const r = matchFlowReductionPrompt;
    const poster = matchFlowPoster;
    if (!r || !poster || !currentUser?.uid) return;
    setMatchFlowLoading(true);
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      let existing = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);

      if (r.missingPrivate) {
        existing = existing.map((p) => ({ ...p, isPrivateCollage: false }));
      }
      if (r.missingCommunity) {
        const otherPosted = existing.find((p) => p.id !== poster.id && p.postedToFeed && p.feedAdId);
        if (otherPosted?.feedAdId) {
          try {
            await deleteDoc(doc(db, 'wantedFeed', otherPosted.feedAdId));
          } catch (err) {
            console.error('Error removing old feed entry:', err);
          }
          existing = existing.map((p) =>
            p.id === otherPosted.id ? { ...p, postedToFeed: false, feedAdId: null } : p
          );
        }
      }

      await updateDoc(userDocRef, { savedWantedPosters: existing, updatedAt: new Date() });
      setSavedPosters(existing);

      await executeMatchActions(poster, r.newPrivate, r.newCommunity);
      setMatchFlowReductionPrompt(null);
      setMatchFlowConfirmRemoval(false);
      setMatchFlowType(r.newPrivate && r.newCommunity ? 'both' : r.newPrivate ? 'private' : 'community');
      setMatchFlowStep('confirm');
    } catch (err) {
      console.error('Error applying match reduction keep:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setMatchFlowLoading(false);
    }
  };

  const reductionAddMissingButtonLabel = (r) => {
    if (!r) return 'ADD OPTIONS';
    if (r.missingPrivate && r.missingCommunity) return 'ADD COMPUTER & COMMUNITY MATCH';
    if (r.missingPrivate) return 'ADD COMPUTER MATCH';
    if (r.missingCommunity) return 'ADD COMMUNITY MATCH';
    return 'ADD OPTIONS';
  };

  const renderMatchCollagePreview = (poster, keyPrefix = 'match') => (
    <div className="wanted-poster wanted-poster-feed match-flow-poster-preview">
      <div className="poster-content">
        <div className="the-one-label the-one-label-feed">"{poster.posterNickname ?? 'The One'}"</div>
        <div className="collage-poster-area collage-poster-area-feed">
          <div className="partner-swag-container partner-swag-container-feed">
            <div className="partner-swag-left">
              {(poster.swags || []).length > 0 && (
                <div className="swag-images-left swag-images-left-feed">
                  {(poster.swags || []).map((swag, swagIndex) => {
                    const swagUrl = swag.imageUrl || swag;
                    if (!swagUrl) return null;
                    const seed = seedFromString(`${poster.id}-swag-${swagIndex}`);
                    const seedX = seedFromString(`${poster.id}-swag-x-${swagIndex}`);
                    const rotation = (seed * 30 - 15).toFixed(1);
                    const horizontalOffset = (seedX * 16 - 8).toFixed(1);
                    return (
                      <img
                        key={`${keyPrefix}-swag-${swag.id || swagIndex}`}
                        src={swagUrl}
                        alt={swag.name || 'Brand'}
                        className="swag-image swag-image-feed"
                        style={{ transform: `rotate(${rotation}deg)`, marginLeft: `${horizontalOffset}px` }}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className="partner-swag-center">
              {(() => {
                const cutJagged = (() => {
                  const v = 1 + Math.floor(seedFromString(`feed-cutout-${poster.id}`) * 3);
                  return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                })();
                if (showFriendFoxMaskPlaceholder(poster) && poster.partnerCutout) {
                  return (
                    <FriendFoxMaskPlaceholderCutout
                      variant="feed"
                      jaggedClassName={cutJagged}
                      heartSrc={poster.heartPhotoUrl || poster.surveyAnswers?.vibe_photo || orheartImage}
                      heartClassName="partner-cutout-gif-overlay partner-cutout-gif-overlay-feed"
                    />
                  );
                }
                if (poster.partnerCutout) {
                  return (
                    <div className="final-partner-image-wrapper">
                      <img
                        src={poster.partnerCutout}
                        alt=""
                        className={`final-partner-image final-partner-image-feed${cutJagged}`}
                      />
                      <img
                        src={poster.heartPhotoUrl || poster.surveyAnswers?.vibe_photo || orheartImage}
                        alt=""
                        className="partner-cutout-gif-overlay partner-cutout-gif-overlay-feed"
                      />
                    </div>
                  );
                }
                return (
                  <div
                    className={`final-partner-image final-partner-image-placeholder final-partner-image-feed${cutJagged}`}
                  >
                    {'\uD83D\uDC64'}
                  </div>
                );
              })()}
            </div>
            <div className="partner-swag-right">
              <div className="activities-emojis-right feed-tile-activities">
                {[poster.activityX, poster.activityY, poster.activityZ].filter(Boolean).map((label, i) => {
                  const seed = seedFromString(`${poster.id}-act-${i}`);
                  const seedX = seedFromString(`${poster.id}-act-x-${i}`);
                  const rotation = (seed * 24 - 12).toFixed(1);
                  const horizontalOffset = (seedX * 12 - 6).toFixed(1);
                  const hue = 32 + seed * 20;
                  const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                  return (
                    <div
                      key={`${keyPrefix}-act-${i}`}
                      className="activity-tile-outer activity-tile-outer-feed"
                      style={{ transform: `rotate(${rotation}deg)`, marginLeft: `${horizontalOffset}px` }}
                    >
                      <div className="activity-emoji-wrapper collage-activity-tile" style={{ background: bgColor }}>
                        <div className="activity-emoji activity-emoji-feed">
                          {typeof label === 'string' ? label : (label?.emoji ?? label?.name ?? '')}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {poster.places && poster.places.length > 0 && (
            <div className="collage-aspirations-row collage-aspirations-row-feed">
              {[poster.places.slice(0, Math.floor(seedFromString(`${poster.id}-places-split`) * 2) + 1), poster.places.slice(Math.floor(seedFromString(`${poster.id}-places-split`) * 2) + 1)].map((rowPlaces, rowIdx) => (
                rowPlaces.length > 0 && (
                  <div key={`${keyPrefix}-places-${rowIdx}`} className="collage-places-row-inner">
                    {rowPlaces.map((place, i) => (
                      <div key={place.id || `${keyPrefix}-${rowIdx}-${i}`} className="aspiration-tile-outer">
                        <div className="collage-place-tile">
                          <img src={place.imageUrl} alt={place.name} className="collage-place-img collage-place-img-feed" />
                        </div>
                      </div>
                    ))}
                  </div>
                )
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const handleConfirmPostIrl = async () => {
    if (!currentUser?.uid) return;

    const userDocRef = doc(db, 'users', currentUser.uid);

    const nicknameForPoster = (editedPosterNickname != null && String(editedPosterNickname).trim()) ? editedPosterNickname : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One');
    const unposted = (p) => !(p.postedToFeed || p.postedIrl || p.postedTiktok);
    const inScopeIrl = (p) => unposted(p) || p.postedIrl;

    if (savedPosterForPopup?.id) {
      if (savedPosterForPopup.postedIrl) {
        setShowPostFlyersIrlConfirmPopup(false);
        alert('This collage was already posted IRL.');
        return;
      }
      try {
        const snap = await getDoc(userDocRef);
        const posters = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
        const irlScopeNicknames = posters
          .filter((p) => p.id !== savedPosterForPopup.id && inScopeIrl(p))
          .map((p) => (p.posterNickname ?? 'The One').trim())
          .filter(Boolean);
        const existingSetIrl = new Set(irlScopeNicknames.map(normalizeNickname));
        if (existingSetIrl.has(normalizeNickname(nicknameForPoster))) {
          const suggested = getSuggestedNickname(nicknameForPoster, irlScopeNicknames);
          setSuggestedNicknameInPopup(suggested);
          setShowPostFlyersIrlConfirmPopup(false);
          setShowNicknameConflictPopup(true);
          return;
        }
        await updateDoc(userDocRef, { updatedAt: new Date() });
        const updated = posters.map((p) => (p.id === savedPosterForPopup.id ? { ...p, postedIrl: true, posterNickname: nicknameForPoster } : p));
        await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
        void pushUserPublicPrimaryPreview();
        const updatedPoster = { ...savedPosterForPopup, postedIrl: true, posterNickname: nicknameForPoster };
        if (!updatedPoster.userId) updatedPoster.userId = currentUser?.uid || null;
        setSavedPosters((prev) => prev.map((p) => (p.id === savedPosterForPopup.id ? updatedPoster : p)));
        setSavedPosterForPopup(updatedPoster);
        setCurrentPosterAlreadySaved(true);
        await setDoc(
          doc(db, 'sharedPosters', savedPosterForPopup.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(updatedPoster)),
        );
      } catch (err) {
        console.error('Error updating posted IRL:', err);
        alert('Could not complete. Please try again.');
        return;
      }
    } else {
      try {
        const posterId = nanoid();
        const { partnerCutoutUrl, userPhotoUrlForStore, userPhotoOriginalUrlForStore, swagsForStore, placesForStore } =
          await persistCollageImageBundle({ useProfilePhotoFallback: true });
        const act0 = selectedActivities?.[0];
        const act1 = selectedActivities?.[1];
        const act2 = selectedActivities?.[2];
        const activityX = act0 === undefined ? 'Seeking' : typeof act0 === 'string' ? act0 : (act0?.name || act0?.emoji || 'Seeking');
        const activityY = act1 === undefined ? 'Match' : typeof act1 === 'string' ? act1 : (act1?.name || act1?.emoji || 'Match');
        const activityZ = act2 === undefined ? null : typeof act2 === 'string' ? act2 : (act2?.name || act2?.emoji || null);
        const posterData = {
          id: posterId,
          createdAt: new Date(),
          userId: currentUser?.uid || null,
          surveyAnswers: surveyAnswers || null,
          partnerCutout: partnerCutoutUrl || null,
          heartPhotoUrl: surveyAnswers?.vibe_photo || null,
          swags: swagsForStore,
          places: placesForStore,
          activityX,
          activityY,
          activityZ: activityZ || null,
          words: selectedWords || [],
          userPhotoUrl: userPhotoUrlForStore || null,
          userPhotoOriginalUrl: userPhotoOriginalUrlForStore || null,
          posterNickname: nicknameForPoster,
          isPrivateCollage: false,
          postedIrl: true,
        };
        const existingSnap = await getDoc(userDocRef);
        const existingPosters = normalizeSavedPostersList(Array.isArray(existingSnap.data()?.savedWantedPosters) ? existingSnap.data().savedWantedPosters : []);
        const irlScopeNicknamesNew = existingPosters.filter(inScopeIrl).map((p) => (p.posterNickname ?? 'The One').trim()).filter(Boolean);
        const existingSetIrlNew = new Set(irlScopeNicknamesNew.map(normalizeNickname));
        if (existingSetIrlNew.has(normalizeNickname(nicknameForPoster))) {
          const suggested = getSuggestedNickname(nicknameForPoster, irlScopeNicknamesNew);
          setSuggestedNicknameInPopup(suggested);
          setShowPostFlyersIrlConfirmPopup(false);
          setShowNicknameConflictPopup(true);
          return;
        }
        await updateDoc(userDocRef, {
          savedWantedPosters: arrayUnion(posterData),
          updatedAt: new Date(),
        });
        void pushUserPublicPrimaryPreview();
        await setDoc(
          doc(db, 'sharedPosters', posterData.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(posterData)),
        );
        setSavedPosterForPopup(posterData);
        setCurrentPosterAlreadySaved(true);
        setSavedPosters((prev) => [...prev, posterData]);
        skipNextPosterChangeCheckRef.current = true;
      } catch (err) {
        console.error('Error saving and posting IRL:', err);
        alert('Could not save collage. Please try again.');
        return;
      }
    }

    setShowPostFlyersIrlConfirmPopup(false);
    setCurrentPosterPostedIrl(true);
    setSuccessPopupMessage('Confirmed! Your collage will be printed out and posted around campus.');
  };

  const handleConfirmPostTiktok = async () => {
    if (!currentUser?.uid) return;

    const userDocRef = doc(db, 'users', currentUser.uid);
    const nicknameForPosterTiktok = (editedPosterNickname != null && String(editedPosterNickname).trim()) ? editedPosterNickname : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One');
    const unpostedTiktok = (p) => !(p.postedToFeed || p.postedIrl || p.postedTiktok);
    const inScopeTiktok = (p) => unpostedTiktok(p) || p.postedTiktok;

    if (savedPosterForPopup?.id) {
      if (savedPosterForPopup.postedTiktok) {
        setShowPostTiktokConfirmPopup(false);
        alert('This collage was already posted on TikTok.');
        return;
      }
      try {
        const snap = await getDoc(userDocRef);
        const posters = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
        const tiktokScopeNicknames = posters
          .filter((p) => p.id !== savedPosterForPopup.id && inScopeTiktok(p))
          .map((p) => (p.posterNickname ?? 'The One').trim())
          .filter(Boolean);
        const existingSetTiktok = new Set(tiktokScopeNicknames.map(normalizeNickname));
        if (existingSetTiktok.has(normalizeNickname(nicknameForPosterTiktok))) {
          const suggested = getSuggestedNickname(nicknameForPosterTiktok, tiktokScopeNicknames);
          setSuggestedNicknameInPopup(suggested);
          setShowPostTiktokConfirmPopup(false);
          setShowNicknameConflictPopup(true);
          return;
        }
        await updateDoc(userDocRef, { updatedAt: new Date() });
        const updated = posters.map((p) => (p.id === savedPosterForPopup.id ? { ...p, postedTiktok: true, posterNickname: nicknameForPosterTiktok } : p));
        await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
        void pushUserPublicPrimaryPreview();
        const updatedPoster = { ...savedPosterForPopup, postedTiktok: true, posterNickname: nicknameForPosterTiktok };
        if (!updatedPoster.userId) updatedPoster.userId = currentUser?.uid || null;
        setSavedPosters((prev) => prev.map((p) => (p.id === savedPosterForPopup.id ? updatedPoster : p)));
        setSavedPosterForPopup(updatedPoster);
        setCurrentPosterAlreadySaved(true);
        await setDoc(
          doc(db, 'sharedPosters', savedPosterForPopup.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(updatedPoster)),
        );
      } catch (err) {
        console.error('Error updating posted TikTok:', err);
        alert('Could not complete. Please try again.');
        return;
      }
    } else {
      try {
        const posterId = nanoid();
        const { partnerCutoutUrl, userPhotoUrlForStore, userPhotoOriginalUrlForStore, swagsForStore, placesForStore: placesForStoreTiktok } =
          await persistCollageImageBundle({ useProfilePhotoFallback: true });
        const act0 = selectedActivities?.[0];
        const act1 = selectedActivities?.[1];
        const act2 = selectedActivities?.[2];
        const activityX = act0 === undefined ? 'Seeking' : typeof act0 === 'string' ? act0 : (act0?.name || act0?.emoji || 'Seeking');
        const activityY = act1 === undefined ? 'Match' : typeof act1 === 'string' ? act1 : (act1?.name || act1?.emoji || 'Match');
        const activityZ = act2 === undefined ? null : typeof act2 === 'string' ? act2 : (act2?.name || act2?.emoji || null);
        const posterData = {
          id: posterId,
          createdAt: new Date(),
          userId: currentUser?.uid || null,
          surveyAnswers: surveyAnswers || null,
          partnerCutout: partnerCutoutUrl || null,
          heartPhotoUrl: surveyAnswers?.vibe_photo || null,
          swags: swagsForStore,
          places: placesForStoreTiktok,
          activityX,
          activityY,
          activityZ: activityZ || null,
          words: selectedWords || [],
          userPhotoUrl: userPhotoUrlForStore || null,
          userPhotoOriginalUrl: userPhotoOriginalUrlForStore || null,
          posterNickname: nicknameForPosterTiktok,
          isPrivateCollage: false,
          postedTiktok: true,
        };
        const existingSnap = await getDoc(userDocRef);
        const existingPosters = normalizeSavedPostersList(Array.isArray(existingSnap.data()?.savedWantedPosters) ? existingSnap.data().savedWantedPosters : []);
        const tiktokScopeNicknamesNew = existingPosters.filter(inScopeTiktok).map((p) => (p.posterNickname ?? 'The One').trim()).filter(Boolean);
        const existingSetTiktokNew = new Set(tiktokScopeNicknamesNew.map(normalizeNickname));
        if (existingSetTiktokNew.has(normalizeNickname(nicknameForPosterTiktok))) {
          const suggested = getSuggestedNickname(nicknameForPosterTiktok, tiktokScopeNicknamesNew);
          setSuggestedNicknameInPopup(suggested);
          setShowPostTiktokConfirmPopup(false);
          setShowNicknameConflictPopup(true);
          return;
        }
        await updateDoc(userDocRef, {
          savedWantedPosters: arrayUnion(posterData),
          updatedAt: new Date(),
        });
        void pushUserPublicPrimaryPreview();
        await setDoc(
          doc(db, 'sharedPosters', posterData.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(posterData)),
        );
        setSavedPosterForPopup(posterData);
        setCurrentPosterAlreadySaved(true);
        setSavedPosters((prev) => [...prev, posterData]);
        skipNextPosterChangeCheckRef.current = true;
      } catch (err) {
        console.error('Error saving and posting TikTok:', err);
        alert('Could not save collage. Please try again.');
        return;
      }
    }

    setShowPostTiktokConfirmPopup(false);
    setCurrentPosterPostedTiktok(true);
    setSuccessPopupMessage('Confirmed! Your collage will be promoted with TikTok ads.');
  };

  // Persist image URL to Firebase Storage (data URLs, Replicate temp URLs, relative paths) and return stable URL.
  // Plain https URLs (e.g. firebasestorage.googleapis.com) are returned as-is — no fetch/upload.
  /* Thin wrappers around the shared utils so the original closure-based call signatures
     (no explicit inputs at the call sites) stay intact. The util implementations now live
     in `src/utils/collagePersistence.js` and are reused by FoxChat's SAVE flow. */
  const persistImageUrlToStorage = persistImageUrlToStorageUtil;

  const persistCollageImageBundle = async (opts = {}) => {
    const { useProfilePhotoFallback = false } = opts;
    return persistCollageImageBundleUtil({
      partnerCutout: selectedPartnerCutout,
      userPhotoMasked: userPhotoUrl,
      userPhotoOriginal: collageUserPhotoOriginalUrl || surveyAnswers?.user_photo_original || null,
      swags: selectedSwags || [],
      places: selectedPlaces || [],
      profilePhotoMaskedFallback: useProfilePhotoFallback ? userProfilePhotoUrl : null,
      profilePhotoOriginalFallback: useProfilePhotoFallback ? profileUserPhotoOriginalUrl : null,
    });
  };

  // Firestore rejects undefined; strip it from nested payloads
  const sanitizeForFirestore = (val) => {
    if (val === undefined) return null;
    if (val === null || typeof val !== 'object') return val;
    if (val instanceof Date || (typeof val.toDate === 'function')) return val;
    if (Array.isArray(val)) return val.map(sanitizeForFirestore).filter((v) => v !== undefined);
    const out = {};
    for (const [k, v] of Object.entries(val)) {
      if (v === undefined) continue;
      const s = sanitizeForFirestore(v);
      if (s !== undefined) out[k] = s;
    }
    return out;
  };

  /** sharedPosters is world-readable — never persist unmasked URLs there. */
  const stripUnmaskedPhotoForPublicShare = (poster) => {
    if (!poster || typeof poster !== 'object') return poster;
    const { userPhotoOriginalUrl: _omit, ...rest } = poster;
    return rest;
  };

  // Copy text to clipboard. Tries Clipboard API first, then execCommand fallback for Safari/iOS.
  // Call early in the Share handler (before Firestore awaits) so the copy runs close to the user gesture.
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      try {
        const el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'fixed';
        el.style.top = '0';
        el.style.left = '0';
        el.style.width = '2em';
        el.style.height = '2em';
        el.style.padding = '0';
        el.style.border = 'none';
        el.style.outline = 'none';
        el.style.boxShadow = 'none';
        el.style.background = 'transparent';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.focus();
        el.select();
        el.setSelectionRange(0, text.length);
        const ok = document.execCommand('copy');
        document.body.removeChild(el);
        return ok;
      } catch (fallbackErr) {
        console.warn('Clipboard fallback failed:', fallbackErr);
        return false;
      }
    }
  };

  const handleSavedPosterShare = async () => {
    if (!savedPosterForPopup?.id) return;
    if (!currentUser) {
      alert('Please sign in to create a shareable link.');
      return;
    }
    const link = `${window.location.origin}/poster/${savedPosterForPopup.id}`;
    try {
      const copied = await copyToClipboard(link);
      const snap = await getDoc(doc(db, 'sharedPosters', savedPosterForPopup.id));
      if (!snap.exists()) {
        const raw = { ...savedPosterForPopup };
        if (!raw.userId) raw.userId = currentUser?.uid || null;
        if (raw.createdAt && typeof raw.createdAt.toDate === 'function') {
          raw.createdAt = raw.createdAt;
        } else if (!(raw.createdAt instanceof Date)) {
          raw.createdAt = new Date();
        }
        await setDoc(
          doc(db, 'sharedPosters', savedPosterForPopup.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(raw)),
        );
      }
      if (!copied) alert(`Link created! Copy it manually: ${link}`);
      setSavedPosterLinkCopied(true);
      setTimeout(() => setSavedPosterLinkCopied(false), 1000);
    } catch (err) {
      console.error('Error sharing poster:', err?.code, err?.message, err);
      if (err?.code === 'permission-denied' || err?.message?.includes('Missing or insufficient permissions')) {
        alert('Share link failed (permission denied). Deploy Firestore rules: firebase deploy --only firestore:rules');
      } else {
        alert('Could not generate link. Please try again.');
      }
    }
  };

  const handleShareMainCollage = async (poster) => {
    if (!poster?.id) return;
    if (!currentUser) {
      alert('Please sign in to create a shareable link.');
      return;
    }
    try {
      const snap = await getDoc(doc(db, 'sharedPosters', poster.id));
      if (!snap.exists()) {
        const raw = { ...poster };
        if (!raw.userId) raw.userId = currentUser.uid;
        if (raw.createdAt && typeof raw.createdAt.toDate === 'function') {
          raw.createdAt = raw.createdAt;
        } else if (!(raw.createdAt instanceof Date)) {
          raw.createdAt = new Date();
        }
        await setDoc(
          doc(db, 'sharedPosters', poster.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(raw)),
        );
      }
      setShowReferEmailInput(false);
      setShowReferIgInput(false);
      setReferFriendEmail('');
      setReferFriendEmailError('');
      setReferFriendSubmitted(false);
      setReferFriendIg('');
      setReferFriendIgError('');
      setReferFriendIgSubmitted(false);
      setFeedReferLinkCopied(false);
      setUserMenuPrimaryReferPosterId(poster.id);
    } catch (err) {
      console.error('Error sharing collage:', err?.code, err?.message, err);
      if (err?.code === 'permission-denied' || err?.message?.includes('Missing or insufficient permissions')) {
        alert('Share link failed (permission denied). Deploy Firestore rules: firebase deploy --only firestore:rules');
      } else {
        alert('Could not generate link. Please try again.');
      }
    }
  };

  const handlePosterDetailFromListShare = async () => {
    if (!posterDetailFromList?.id) return;
    if (!currentUser) {
      alert('Please sign in to create a shareable link.');
      return;
    }
    const link = `${window.location.origin}/poster/${posterDetailFromList.id}`;
    try {
      const copied = await copyToClipboard(link);
      const snap = await getDoc(doc(db, 'sharedPosters', posterDetailFromList.id));
      if (!snap.exists()) {
        const raw = { ...posterDetailFromList };
        if (!raw.userId) raw.userId = currentUser?.uid || null;
        if (raw.createdAt && typeof raw.createdAt?.toDate === 'function') {
          raw.createdAt = raw.createdAt;
        } else if (!(raw.createdAt instanceof Date)) {
          raw.createdAt = new Date();
        }
        await setDoc(
          doc(db, 'sharedPosters', posterDetailFromList.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(raw)),
        );
      }
      if (!copied) alert(`Link created! Copy it manually: ${link}`);
      setPosterDetailLinkCopied(true);
      setTimeout(() => setPosterDetailLinkCopied(false), 2000);
    } catch (err) {
      console.error('Error sharing poster:', err?.code, err?.message, err);
      if (err?.code === 'permission-denied' || err?.message?.includes('Missing or insufficient permissions')) {
        alert('Share link failed (permission denied). Deploy Firestore rules: firebase deploy --only firestore:rules');
      } else {
        alert('Could not generate link. Please try again.');
      }
    }
  };

  const handleCollageFriendSuccessCopyLink = async () => {
    const poster = collageFriendSuccessPoster;
    if (!poster?.id || !currentUser?.uid) return;
    const link = `${window.location.origin}/poster/${poster.id}`;
    try {
      const copied = await copyToClipboard(link);
      const snap = await getDoc(doc(db, 'sharedPosters', poster.id));
      if (!snap.exists()) {
        const raw = { ...poster };
        if (!raw.userId) raw.userId = currentUser.uid;
        if (raw.createdAt && typeof raw.createdAt.toDate === 'function') {
          raw.createdAt = raw.createdAt;
        } else if (!(raw.createdAt instanceof Date)) {
          raw.createdAt = new Date();
        }
        await setDoc(
          doc(db, 'sharedPosters', poster.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(raw)),
        );
      }
      if (!copied) window.alert(`Copy this link: ${link}`);
      setCollageFriendLinkCopied(true);
      setTimeout(() => setCollageFriendLinkCopied(false), 2000);
    } catch (err) {
      console.error('Friend collage copy link:', err);
      window.alert('Could not copy link. Try again.');
    }
  };

  const handleCollageFriendSuccessSendEmail = () => {
    if (!collageFriendInviteEmail || collageFriendEmailSent) return;
    setCollageFriendEmailSent(true);
  };

  /**
   * Set primary collage. If oldPrimary had computer and/or community match, apply the same on newPrimary
   * (FIND prefs copied from old). If old had neither, updates primaryCollageId and saved posters.
   * Dinner giveaway on the new primary matches the previous primary’s participation unless the user
   * later changes it (inherit on switch; previous primary cleared).
   */
  const executeMakePrimary = async (newPrimary, oldPrimary = null) => {
    if (!newPrimary?.id || !currentUser?.uid) return;
    const userDocRef = doc(db, 'users', currentUser.uid);
    const snap = await getDoc(userDocRef);
    const list = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
    const prevPrimaryId =
      typeof snap.data()?.primaryCollageId === 'string' && snap.data().primaryCollageId
        ? snap.data().primaryCollageId
        : null;
    const oldRowForGiveaway = oldPrimary?.id
      ? (list.find((p) => p.id === oldPrimary.id) ?? oldPrimary)
      : (prevPrimaryId ? list.find((p) => p.id === prevPrimaryId) : null);
    const oldWasInGiveaway = oldRowForGiveaway?.promoteOnLuvwtfSocials === true;

    const hadPrivate = !!oldPrimary?.isPrivateCollage;
    const hadCommunity = !!(oldPrimary?.postedToFeed && oldPrimary?.feedAdId);
    if (!hadPrivate && !hadCommunity) {
      const { posters: updated, clearedPosterIds } = applyPrimarySwitchGiveaway(list, newPrimary.id, oldWasInGiveaway);
      if (clearedPosterIds.length > 0) {
        try {
          await deleteDinnerGiveawayOptInsForPosters(db, currentUser.uid, clearedPosterIds);
        } catch (err) {
          console.error('Failed to remove dinner giveaway opt-in docs:', err);
        }
      }
      if (oldWasInGiveaway) {
        const row = updated.find((p) => p.id === newPrimary.id);
        if (row) {
          try {
            await recordDinnerGiveawayOptIn(db, currentUser, row, 'make_primary_inherit');
          } catch (err) {
            console.error('Failed to record dinner giveaway opt-in:', err);
          }
        }
      }
      await updateDoc(userDocRef, {
        savedWantedPosters: updated,
        primaryCollageId: newPrimary.id,
        updatedAt: new Date(),
      });
      setPrimaryCollageId(newPrimary.id);
      setSavedPosters(updated);
      void pushUserPublicPrimaryPreview();
      return;
    }
    const merged = {
      ...newPrimary,
      friendLuv: typeof oldPrimary?.friendLuv === 'boolean' ? oldPrimary.friendLuv : newPrimary.friendLuv,
      romanticLuv: typeof oldPrimary?.romanticLuv === 'boolean' ? oldPrimary.romanticLuv : newPrimary.romanticLuv,
      lookingForGenders: Array.isArray(oldPrimary?.lookingForGenders)
        ? [...oldPrimary.lookingForGenders]
        : newPrimary.lookingForGenders,
      selfGender:
        oldPrimary?.selfGender && ['male', 'female', 'nb'].includes(oldPrimary.selfGender)
          ? oldPrimary.selfGender
          : newPrimary.selfGender,
      promoteOnLuvwtfSocials: oldWasInGiveaway,
    };
    try {
      await runExecuteMatchActions(merged, hadPrivate, hadCommunity);
    } catch (err) {
      console.error('Error setting primary collage with match settings:', err);
      alert('Something went wrong. Please try again.');
      throw err;
    }
  };

  const handlePosterDetailMakePrimaryClick = () => {
    const poster = posterDetailFromList;
    if (!poster?.id || !currentUser?.uid) return;
    const current = getPrimarySavedPoster(savedPosters, primaryCollageId);
    if (current && current.id !== poster.id) {
      setMakePrimaryReplaceConfirm({ currentPrimary: current, newPrimary: poster });
      setPosterDetailFromList(null);
      setPosterDetailFromListTitleOverride(null);
      return;
    }
    void (async () => {
      try {
        await executeMakePrimary(poster);
        setPosterDetailFromList(null);
        setPosterDetailFromListTitleOverride(null);
      } catch (err) {
        console.error('Error setting primary collage:', err);
        alert('Could not set primary collage. Please try again.');
      }
    })();
  };

  const handleMakePrimaryReplaceConfirm = async () => {
    const next = makePrimaryReplaceConfirm?.newPrimary;
    if (!next?.id || !currentUser?.uid) return;
    setMakePrimaryReplaceLoading(true);
    try {
      await executeMakePrimary(next, makePrimaryReplaceConfirm.currentPrimary);
      setMakePrimaryReplaceConfirm(null);
    } catch (err) {
      console.error('Error setting primary collage:', err);
      alert('Could not set primary collage. Please try again.');
    } finally {
      setMakePrimaryReplaceLoading(false);
    }
  };

  const handleUnpostFromFeed = async () => {
    const poster = posterDetailFromList;
    if (!poster?.id || !currentUser?.uid) return;
    if (!poster.postedToFeed || !poster.feedAdId) return;
    const ok = await unpostSavedPosterFromFeed(poster);
    if (ok) {
      setPosterDetailFromList(null);
      setPosterDetailFromListTitleOverride(null);
    }
  };

  const handleFeedTileShare = async () => {
    if (!feedTileDetailAd?.id) return;
    if (!currentUser) {
      alert('Please sign in to create a shareable link.');
      return;
    }
    const ad = feedTileDetailAd;
    const link = `${window.location.origin}/poster/${ad.id}`;
    try {
      const copied = await copyToClipboard(link);
      const raw = {
        id: ad.id,
        createdAt: (ad.createdAt && typeof ad.createdAt.toDate === 'function') ? ad.createdAt : (ad.createdAt instanceof Date ? ad.createdAt : new Date()),
        userId: ad.userId ?? currentUser?.uid ?? null,
        partnerCutout: ad.partnerCutout ?? null,
        heartPhotoUrl: ad.heartPhotoUrl ?? null,
        swags: Array.isArray(ad.swags) ? ad.swags : [],
        places: Array.isArray(ad.places) ? ad.places : [],
        activityX: ad.activityX ?? null,
        activityY: ad.activityY ?? null,
        activityZ: ad.activityZ ?? null,
        words: [],
        userPhotoUrl: ad.userPhotoUrl ?? null,
        posterNickname: ad.posterNickname ?? null,
        surveyAnswers: null,
        friendLuv: typeof ad.friendLuv === 'boolean' ? ad.friendLuv : null,
        romanticLuv: typeof ad.romanticLuv === 'boolean' ? ad.romanticLuv : null,
        selfGender: ad.selfGender ?? null,
        alsoPrivateMatch: typeof ad.alsoPrivateMatch === 'boolean' ? ad.alsoPrivateMatch : null,
      };
      await setDoc(
        doc(db, 'sharedPosters', ad.id),
        sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(raw)),
      );
      if (!copied) alert(`Link created! Copy it manually: ${link}`);
      setFeedShareLinkCopied(true);
      setTimeout(() => setFeedShareLinkCopied(false), 1000);
    } catch (err) {
      console.error('Error sharing feed poster:', err?.code, err?.message, err);
      if (err?.code === 'permission-denied' || err?.message?.includes('Missing or insufficient permissions')) {
        alert('Share link failed (permission denied). Deploy Firestore rules: firebase deploy --only firestore:rules');
      } else {
        alert('Could not generate link. Please try again.');
      }
    }
  };

  const handleLoadSavedPoster = (poster, options) => {
    setSuppressPrimaryLuvIconsOnEditorCanvas(!!options?.hidePrimaryLuvIcons);
    setShowMyCollagesInline(false);
    setSavedPosterForPopup(poster);
    setEditingSavedPosterId(poster.id);
    setSavedPosterLinkCopied(false);
    const restoredHeartPhoto = poster.heartPhotoUrl || poster.surveyAnswers?.vibe_photo || null;
    setSurveyAnswers(
      restoredHeartPhoto
        ? { ...(poster.surveyAnswers || {}), vibe_photo: restoredHeartPhoto }
        : poster.surveyAnswers || null
    );
    setSelectedPartnerCutout(poster.partnerCutout || null);
    const selfPersistedCutout =
      !!poster.partnerCutout
      && typeof poster.partnerCutout === 'string'
      && !poster.friendCollageShare
      && poster.partnerCutout !== foxMaskFallback;
    setFriendCutoutReplacedSinceSurvey(
      !!poster.surveyAnswers?.user_photo
      || (!!poster.friendCollageShare && poster.friendFoxMaskPlaceholder === false)
      || !!poster.cutoutCustomizedSinceSurveyDefault
      || selfPersistedCutout,
    );
    setUserPhotoUrl(poster.userPhotoUrl ?? null);
    setCollageUserPhotoOriginalUrl(
      poster.userPhotoOriginalUrl && typeof poster.userPhotoOriginalUrl === 'string'
        ? poster.userPhotoOriginalUrl
        : null,
    );
    setEditedPosterNickname(poster.posterNickname ?? null);
    setSelectedSwags(Array.isArray(poster.swags) ? poster.swags : []);
    setSelectedPlaces(Array.isArray(poster.places) ? poster.places : []);
    setSelectedWords(Array.isArray(poster.words) ? poster.words : []);
    {
      const g = poster.selfGender;
      setCollageFinderSelfGender(g && ['male', 'female', 'nb'].includes(g) ? g : null);
      const fl = posterFindLuvIconFlags(poster);
      setCollageFinderFriendLuv(typeof poster.friendLuv === 'boolean' ? poster.friendLuv : fl.friend);
      setCollageFinderRomanticLuv(typeof poster.romanticLuv === 'boolean' ? poster.romanticLuv : fl.romantic);
      setCollageFinderLookingForGenders(
        Array.isArray(poster.lookingForGenders) && poster.lookingForGenders.length
          ? [...poster.lookingForGenders]
          : [],
      );
      {
        const n = typeof poster.selfAge === 'number' ? poster.selfAge : NaN;
        setCollageFinderSelfAge(
          Number.isFinite(n) && n >= 18 && n <= 120 ? n : AGE_WHEEL_DEFAULT,
        );
      }
    }
    setSelectedActivities(
      (poster.activityX != null || poster.activityY != null || poster.activityZ != null)
        ? [poster.activityX, poster.activityY, poster.activityZ].filter(Boolean)
        : Array.isArray(poster.activities)
          ? poster.activities.map((a) => (typeof a === 'string' ? a : (a.emoji || a.name || '')))
          : []
    );
    setSurveyCompleted(true);
    setShowFoxButton(true);
    setShowInlineSurvey(false);
    skipNextPosterChangeCheckRef.current = true;
    setCurrentPosterAlreadySaved(true);
    setCurrentPosterPostedIrl(!!poster.postedIrl);
    setCurrentPosterPostedTiktok(!!poster.postedTiktok);
    // Saved poster was already confirmed in a past session – show cutout and word immediately
    setHasClosedPersonalityChartOnce(true);
    setPersonalityConfirmed(true);
    setGeneratedWordReadyForPopup(false);
    setTimeout(() => {
      const el = document.querySelector('.wanted-poster-section');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  };

  const handleLoadFeedPoster = (ad) => {
    const activities = [ad.activityX, ad.activityY, ad.activityZ].filter(Boolean).map((a) => (typeof a === 'string' ? a : a?.emoji ?? a));
    const restoredHeartPhoto = ad.heartPhotoUrl || null;
    setSurveyAnswers(restoredHeartPhoto ? { vibe_photo: restoredHeartPhoto } : null);
    setSelectedPartnerCutout(ad.partnerCutout || null);
    setUserPhotoUrl(ad.userPhotoUrl ?? null);
    setEditedPosterNickname(ad.posterNickname ?? null);
    setSelectedSwags(Array.isArray(ad.swags) ? ad.swags : []);
    setSelectedPlaces(Array.isArray(ad.places) ? ad.places : []);
    setSelectedWords([]);
    setSelectedActivities(activities);
    setSurveyCompleted(true);
    setShowFoxButton(true);
    setShowInlineSurvey(false);
    const matchedSaved = savedPosters.find((p) => p.feedAdId === ad.id || p.id === ad.id);
    const isDinnerFeatured = ad.feedSource === 'dinnerGiveaway';
    setEditingFeedAdId(isDinnerFeatured ? null : ad.id);
    setEditingSavedPosterId(isDinnerFeatured ? (matchedSaved?.id ?? ad.id) : null);
    setSuppressPrimaryLuvIconsOnEditorCanvas(false);
    setCollageUserPhotoOriginalUrl(
      matchedSaved?.userPhotoOriginalUrl && typeof matchedSaved.userPhotoOriginalUrl === 'string'
        ? matchedSaved.userPhotoOriginalUrl
        : null,
    );
    setSavedPosterForPopup(matchedSaved || null);
    if (matchedSaved) {
      const g = matchedSaved.selfGender;
      setCollageFinderSelfGender(g && ['male', 'female', 'nb'].includes(g) ? g : null);
      const fl = posterFindLuvIconFlags(matchedSaved);
      setCollageFinderFriendLuv(typeof matchedSaved.friendLuv === 'boolean' ? matchedSaved.friendLuv : fl.friend);
      setCollageFinderRomanticLuv(typeof matchedSaved.romanticLuv === 'boolean' ? matchedSaved.romanticLuv : fl.romantic);
      setCollageFinderLookingForGenders(
        Array.isArray(matchedSaved.lookingForGenders) && matchedSaved.lookingForGenders.length
          ? [...matchedSaved.lookingForGenders]
          : [],
      );
      {
        const n = typeof matchedSaved.selfAge === 'number' ? matchedSaved.selfAge : NaN;
        setCollageFinderSelfAge(
          Number.isFinite(n) && n >= 18 && n <= 120 ? n : AGE_WHEEL_DEFAULT,
        );
      }
    } else {
      const g = ad.selfGender;
      setCollageFinderSelfGender(g && ['male', 'female', 'nb'].includes(g) ? g : null);
      const fl = posterFindLuvIconFlags({
        friendLuv: ad.friendLuv,
        romanticLuv: ad.romanticLuv,
        postedToFeed: !isDinnerFeatured,
        feedAdId: isDinnerFeatured ? null : ad.id,
        isPrivateCollage: ad.alsoPrivateMatch,
      });
      setCollageFinderFriendLuv(typeof ad.friendLuv === 'boolean' ? ad.friendLuv : fl.friend);
      setCollageFinderRomanticLuv(typeof ad.romanticLuv === 'boolean' ? ad.romanticLuv : fl.romantic);
      setCollageFinderLookingForGenders(
        Array.isArray(ad.lookingForGenders) && ad.lookingForGenders.length ? [...ad.lookingForGenders] : [],
      );
      {
        const n = typeof ad.selfAge === 'number' ? ad.selfAge : NaN;
        setCollageFinderSelfAge(
          Number.isFinite(n) && n >= 18 && n <= 120 ? n : AGE_WHEEL_DEFAULT,
        );
      }
    }
    setFriendCutoutReplacedSinceSurvey(
      matchedSaved
        ? !!matchedSaved.surveyAnswers?.user_photo
        || (!!matchedSaved.friendCollageShare && matchedSaved.friendFoxMaskPlaceholder === false)
        || !!matchedSaved.cutoutCustomizedSinceSurveyDefault
        || (!!matchedSaved.partnerCutout
          && typeof matchedSaved.partnerCutout === 'string'
          && !matchedSaved.friendCollageShare
          && matchedSaved.partnerCutout !== foxMaskFallback)
        : true,
    );
    skipNextPosterChangeCheckRef.current = true;
    setCurrentPosterAlreadySaved(true);
    setHasClosedPersonalityChartOnce(true);
    setPersonalityConfirmed(true);
    setGeneratedWordReadyForPopup(false);
    setTimeout(() => {
      const el = document.querySelector('.wanted-poster-section');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 150);
  };

  const openBountyMatchFriendFromStrip = useCallback((ad) => {
    if (!ad) return;
    primeFeedTileDetailPopup();
    setFeedTileDetailTitleOverride(null);
    setFeedTileDetailAd(ad);
    setShowReferOptions(true);
  }, [primeFeedTileDetailPopup]);

  const openBountyShareFromStrip = useCallback((ad) => {
    if (!ad) return;
    primeFeedTileDetailPopup();
    openFeedTileDetailFromGrid(ad);
  }, [primeFeedTileDetailPopup, openFeedTileDetailFromGrid]);

  const openBountyEditFromStrip = useCallback((ad) => {
    if (!ad) return;
    setFeedTileDetailAd(null);
    setFeedTileDetailTitleOverride(null);
    setFeedShareLinkCopied(false);
    handleLoadFeedPoster(ad);
  }, [handleLoadFeedPoster]);

  const handleDeleteSavedPoster = async (e, poster) => {
    e.preventDefault();
    e.stopPropagation();
    if (!currentUser?.uid || !poster?.id) return;
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const existing = normalizeSavedPostersList(Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : []);
      const next = existing.filter((p) => p.id !== poster.id);
      const prevPrimary = snap.data()?.primaryCollageId ?? null;
      const deletePayload = { savedWantedPosters: next, updatedAt: new Date() };
      if (prevPrimary === poster.id) {
        deletePayload.primaryCollageId = null;
      }
      await updateDoc(userDocRef, deletePayload);
      void pushUserPublicPrimaryPreview();
      setSavedPosters((prev) => prev.filter((p) => p.id !== poster.id));
      if (prevPrimary === poster.id) {
        setPrimaryCollageId(null);
      }
      if (savedPosterForPopup?.id === poster.id) {
        openCollagesAfterSavedPosterPopupRef.current = false;
        setSavedPosterForPopup(null);
        setShowSavedPosterPopup(false);
        setCurrentPosterAlreadySaved(false);
        setCurrentPosterPostedIrl(false);
        setCurrentPosterPostedTiktok(false);
      }
      if (poster.feedAdId) {
        try {
          await deleteDoc(doc(db, 'wantedFeed', poster.feedAdId));
        } catch (feedErr) {
          console.error('Error removing poster from feed:', feedErr);
        }
      }
    } catch (err) {
      console.error('Error deleting saved poster:', err);
      alert('Failed to delete poster. Please try again.');
    }
  };

  useEffect(() => {
    if (!currentUser?.uid) {
      setProfileVerified(null);
      return undefined;
    }
    setProfileVerified(berkeleyEmailVerified ? true : false);
    return undefined;
  }, [berkeleyEmailVerified, currentUser?.uid]);

  const ensureBerkeleyEmailAccess = useCallback(async () => {
    if (berkeleyEmailVerified) return true;

    const authEmail = (currentUser?.email || '').trim().toLowerCase();
    const hasSubmittedEdu = Boolean(userBerkeleyEmail) || isEduEmail(authEmail);

    if (hasSubmittedEdu) {
      setBerkeleyEmailPending(true);
      setBerkeleyEmailSubmitted(false);
      setBerkeleyEmailError('');
      setShowBerkeleyEmailPopup(true);
      return false;
    }

    setBerkeleyEmailInput('');
    setBerkeleyEmailError('');
    setBerkeleyEmailSubmitted(false);
    setBerkeleyEmailPending(false);
    setShowBerkeleyEmailPopup(true);
    return false;
  }, [berkeleyEmailVerified, currentUser?.email, userBerkeleyEmail]);

  const handleVerifyProfileClick = useCallback(() => {
    void ensureBerkeleyEmailAccess();
  }, [ensureBerkeleyEmailAccess]);

  /** Closes the nickname popup after the age re-verify confirm resolves (CANCEL or UPDATE). */
  const closeChartAfterAgeReverifyConfirm = useCallback(() => {
    setAgeReverifyConfirmOpen(false);
    setShowPersonalityChart(false);
    setChartHideRing(false);
    setFeedPersonalityView(null);
    setGeneratedWordReadyForPopup(false);
  }, []);

  const handleAgeReverifyCancel = useCallback(() => {
    const baseline = chartOpenSelfAgeRef.current;
    if (typeof baseline === 'number') setCollageFinderSelfAge(baseline);
    closeChartAfterAgeReverifyConfirm();
  }, [closeChartAfterAgeReverifyConfirm]);

  const handleAgeReverifyUpdate = useCallback(async () => {
    if (!currentUser?.uid) {
      closeChartAfterAgeReverifyConfirm();
      return;
    }
    setAgeReverifySaving(true);
    try {
      const reverifyEmail = (userBerkeleyEmail || currentUser.email || '').trim().toLowerCase();
      // Stamp inbox-ownership before creating the doc so the verification trigger
      // sees it and skips re-emailing an already-verified user (just admin re-review).
      await updateDoc(doc(db, 'users', currentUser.uid), {
        berkeleyEmailVerified: false,
        ...(berkeleyEmailVerified && isEduEmail(reverifyEmail)
          ? {
              berkeleyEmailVerifiedAddress: reverifyEmail,
              berkeleyEmailOwnershipVerifiedAt: serverTimestamp(),
            }
          : {}),
      });
      await addDoc(collection(db, 'berkeleyVerifications'), {
        userId: currentUser.uid,
        accountEmail: currentUser.email || null,
        berkeleyEmail: userBerkeleyEmail || currentUser.email || null,
        status: 'pending',
        submittedAt: serverTimestamp(),
        source: 'age_change',
      });
      chartOpenSelfAgeRef.current = collageFinderSelfAge;
      closeChartAfterAgeReverifyConfirm();
    } catch (err) {
      console.error('Error moving profile to pending re-verification after age change:', err);
      alert('Failed to update your age. Please try again.');
    } finally {
      setAgeReverifySaving(false);
    }
  }, [berkeleyEmailVerified, closeChartAfterAgeReverifyConfirm, collageFinderSelfAge, currentUser, userBerkeleyEmail]);

  const handleInviteMatchToDailyVibeChecks = useCallback(async ({
    conversationId,
    otherUid,
    displayName,
  }) => {
    if (!currentUser?.uid || !conversationId || !otherUid) return false;
    try {
      await createDailyVibeShareInvite(db, currentUser.uid, otherUid);
      await sendMessage(
        conversationId,
        currentUser.uid,
        DAILY_VIBE_SHARE_INVITE_TEXT,
        { isSystemMessage: true, dailyVibeShareInvite: true },
      );
      return true;
    } catch (err) {
      console.error('Failed to invite match to daily vibe checks:', err);
      return false;
    }
  }, [currentUser?.uid]);

  const handleInviteFriendByEmailToDailyVibeChecks = useCallback(async (friendEmail) => {
    if (!currentUser?.uid) {
      return { ok: false, error: 'Sign in to invite a friend.' };
    }
    try {
      return await sendDailyVibeEmailInviteApi(friendEmail);
    } catch (err) {
      console.error('Failed to send daily vibe email invite:', err);
      return { ok: false, error: 'Could not send invite. Try again.' };
    }
  }, [currentUser?.uid]);

  /* FoxChat daily-check verify gate: open the same .edu confirmation popup as Your collages.
     Chat stays open underneath (FoxChat drops its overlay while this popup is showing). */
  const handleFoxChatVerifyProfile = useCallback(() => {
    void ensureBerkeleyEmailAccess();
  }, [ensureBerkeleyEmailAccess]);

  const openBountyReachOutFromStrip = useCallback(async (ad) => {
    if (!ad) return;
    if (currentUser && !(await ensureBerkeleyEmailAccess())) return;
    primeFeedTileDetailPopup();
    setFeedTileDetailTitleOverride(null);
    setFeedTileDetailAd(ad);
    reachOutLocalBaseRef.current = getShuffledHelloGifsAll();
    setReachOutGifs(mergeReachOutLocalThenKlipy(reachOutLocalBaseRef.current, []));
    setReachOutGifSearch('');
    setShowReachOutGifPicker(true);
  }, [primeFeedTileDetailPopup, currentUser, ensureBerkeleyEmailAccess]);

  const notificationEmailOnFile = useMemo(() => {
    if (userNotificationEmail) return userNotificationEmail;
    const authEmail = currentUser?.email;
    return typeof authEmail === 'string' && authEmail.trim() ? authEmail.trim() : '';
  }, [currentUser?.email, userNotificationEmail]);

  const handleSaveNotificationEmail = useCallback(async (rawEmail) => {
    if (!currentUser?.uid) return false;
    const trimmed = String(rawEmail || '').trim().toLowerCase();
    if (!trimmed) return false;
    const at = trimmed.lastIndexOf('@');
    if (at <= 0 || at === trimmed.length - 1) return false;
    try {
      await updateDoc(doc(db, 'users', currentUser.uid), {
        notificationEmail: trimmed,
        updatedAt: new Date(),
      });
      setUserNotificationEmail(trimmed);
      return true;
    } catch (err) {
      console.error('Error saving notification email:', err);
      return false;
    }
  }, [currentUser?.uid]);

  const {
    remainingSeconds: eduResendCooldownSeconds,
    markSent: markEduVerifySent,
    clearLocalCooldown: clearEduVerifyLocalCooldown,
  } = useEduVerifyResendCooldown(berkeleyEmailVerifyLastSentMs);

  // Server stamps `berkeleyEmailVerifySendFailedAt` when Postmark refused the message
  // (after its own retry). Newer than the last successful send = the inbox got nothing;
  // lift the optimistic cooldown so RESEND is available right away. Mirrors
  // useEduProfileVerification.
  const eduVerifySendFailed =
    berkeleyEmailVerifySendFailedMs > 0 &&
    berkeleyEmailVerifySendFailedMs > berkeleyEmailVerifyLastSentMs;
  useEffect(() => {
    if (eduVerifySendFailed) clearEduVerifyLocalCooldown();
  }, [eduVerifySendFailed, clearEduVerifyLocalCooldown]);

  const handleBerkeleyEmailSubmit = async (overrideEmail) => {
    const fromArg = typeof overrideEmail === 'string' ? overrideEmail : undefined;
    const email = String(fromArg ?? berkeleyEmailInput).trim().toLowerCase();
    if (!email) {
      setBerkeleyEmailError('Please enter your .edu email.');
      return false;
    }
    if (!isEduEmail(email)) {
      setBerkeleyEmailError('Email must be a .edu address.');
      return false;
    }
    if (!currentUser?.uid) {
      setBerkeleyEmailError('Please sign in first.');
      return false;
    }
    setBerkeleyEmailSubmitting(true);
    setBerkeleyEmailError('');
    try {
      const saved = await submitEduEmailForVerification({
        uid: currentUser.uid,
        accountEmail: currentUser.email || null,
        berkeleyEmail: email,
        source: 'profile',
      });
      setUserBerkeleyEmail(saved);
      setBerkeleyEmailSubmitted(true);
      setBerkeleyEmailPending(false);
      markEduVerifySent();
      return true;
    } catch (err) {
      console.error('Error saving Berkeley email:', err);
      setBerkeleyEmailError(err?.message || 'Something went wrong. Please try again.');
      return false;
    } finally {
      setBerkeleyEmailSubmitting(false);
    }
  };

  const handleBerkeleyEmailResend = useCallback(async () => {
    if (eduResendCooldownSeconds > 0) return false;
    const email = (
      userBerkeleyEmail ||
      (isEduEmail(currentUser?.email || '') ? currentUser.email : '') ||
      ''
    )
      .trim()
      .toLowerCase();
    if (!email || !isEduEmail(email) || !currentUser?.uid) return false;
    setBerkeleyEmailSubmitting(true);
    setBerkeleyEmailError('');
    try {
      await submitEduEmailForVerification({
        uid: currentUser.uid,
        accountEmail: currentUser.email || null,
        berkeleyEmail: email,
        source: 'resend',
      });
      setBerkeleyEmailSubmitted(true);
      markEduVerifySent();
      return true;
    } catch (err) {
      console.error('Error resending school email verification:', err);
      setBerkeleyEmailError(err?.message || 'Something went wrong. Please try again.');
      return false;
    } finally {
      setBerkeleyEmailSubmitting(false);
    }
  }, [
    currentUser,
    eduResendCooldownSeconds,
    markEduVerifySent,
    userBerkeleyEmail,
  ]);

  // Email ownership proven when the confirmed address matches the submitted .edu,
  // or when the .edu is the account email and Firebase Auth has it verified
  // (OAuth / email-link / set-password). Mirrors onBerkeleyVerificationCreated.
  const eduEmailConfirmed = (() => {
    const berkeleyEmailLc = (userBerkeleyEmail || '').trim().toLowerCase();
    if (!berkeleyEmailLc) return false;
    const authEmailLc = (currentUser?.email || '').trim().toLowerCase();
    const authEmailVerified = currentUser?.emailVerified === true;
    const verifiedAddressLc = (userBerkeleyEmailVerifiedAddress || '').trim().toLowerCase();
    return (
      (verifiedAddressLc && verifiedAddressLc === berkeleyEmailLc) ||
      (authEmailVerified && authEmailLc && authEmailLc === berkeleyEmailLc)
    );
  })();

  const handlePostOnLuvWtf = async (overrideUserPhotoUrl = null, skipConfirmation = false, existingPosterId = null, savedPoster = null) => {
    const effNickname = savedPoster?.posterNickname ?? editedPosterNickname;
    const effActivities = savedPoster
      ? [savedPoster.activityX, savedPoster.activityY, savedPoster.activityZ].filter(Boolean)
      : selectedActivities;
    const effPartnerCutout = savedPoster ? (savedPoster.partnerCutout || null) : selectedPartnerCutout;
    const effSwags = savedPoster ? (savedPoster.swags || []) : (selectedSwags || []);
    const effPlaces = savedPoster ? (savedPoster.places || []) : (selectedPlaces || []);
    const effVibePhoto = savedPoster
      ? (savedPoster.heartPhotoUrl || savedPoster.surveyAnswers?.vibe_photo || null)
      : (surveyAnswers?.vibe_photo || null);
    const effPersonality = savedPoster?.dominantPersonality ?? jungianPersonality ?? null;

    const effectiveUserPhoto =
      typeof overrideUserPhotoUrl === 'string' && overrideUserPhotoUrl
        ? overrideUserPhotoUrl
        : userPhotoUrl || userProfilePhotoUrl;
    if (!effectiveUserPhoto) {
      setShowMyCollagesInline(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      window.alert('Add a photo to your primary collage before posting to the feed.');
      return;
    }
    if (!(await ensureBerkeleyEmailAccess())) return;
    if (!effNickname || !String(effNickname).trim()) {
      setChartHideRing(true);
      setChartOpenedFromSurvey(false);
      setShowPersonalityChart(true);
      return;
    }

    if (!skipConfirmation) {
      if (currentUser?.uid) {
        try {
          const titleForCheck = (effNickname && String(effNickname).trim())
            ? effNickname
            : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One');
          const feedRef = collection(db, 'wantedFeed');
          const feedSnap = await getDocs(query(feedRef, orderBy('createdAt', 'desc'), limit(500)));
          const feedNicknames = feedSnap.docs.map((d) => (d.data().posterNickname ?? 'The One').trim()).filter(Boolean);
          const existingNicknamesSet = new Set(feedNicknames.map(normalizeNickname));
          if (existingNicknamesSet.has(normalizeNickname(titleForCheck))) {
            const suggested = getSuggestedNickname(titleForCheck, feedNicknames);
            setSuggestedNicknameInPopup(suggested);
            setShowNicknameConflictPopup(true);
            return;
          }
        } catch (err) {
          console.error('Pre-confirm nickname check failed:', err);
        }
      }
      setShowPostConfirmPopup(true);
      return;
    }

    const act0 = effActivities?.[0];
    const act1 = effActivities?.[1];
    const act2 = effActivities?.[2];
    const activityX =
      act0 === undefined ? 'Seeking' : typeof act0 === 'string' ? act0 : (act0.name || act0.emoji || 'Seeking');
    const activityY =
      act1 === undefined ? 'Match' : typeof act1 === 'string' ? act1 : (act1.name || act1.emoji || 'Match');
    const activityZ =
      act2 === undefined ? null : typeof act2 === 'string' ? act2 : (act2.name || act2.emoji || null);

    const titleForAd = (effNickname && String(effNickname).trim()) ? effNickname : ((jungianAnalysisText ? parseNicknameFromAnalysis(jungianAnalysisText) : null) ?? 'The One');
    const dominantPersonalityForAd = effPersonality;

    const vibePhotoUrl = effVibePhoto;
    const userPhotoUrlForAd = effectiveUserPhoto || null;

    const newAd = {
      id: nanoid(),
      partnerCutout: effPartnerCutout,
      heartPhotoUrl: vibePhotoUrl,
      userPhotoUrl: userPhotoUrlForAd,
      swags: effSwags.map((swag) => ({
        imageUrl: swag.imageUrl || swag,
        name: swag.name || null,
        id: swag.id || null,
      })),
      places: effPlaces.map((place) => ({
        imageUrl: place.imageUrl || null,
        name: place.name || null,
        id: place.id || null,
      })),
      activityX,
      activityY,
      activityZ,
      userId: currentUser?.uid || null,
      createdAt: new Date(),
      userName: (currentUser?.displayName && String(currentUser.displayName).trim()) || 'You',
      posterNickname: titleForAd,
      dominantPersonality: dominantPersonalityForAd,
    };

    if (currentUser?.uid) {
      try {
        if (savedPoster) {
          // Fast path: poster already saved with stable image URLs — skip re-persistence and duplicate checks.
          const feedSnap = await getDocs(query(collection(db, 'wantedFeed'), orderBy('createdAt', 'desc'), limit(500)));
          const feedNicknames = feedSnap.docs.map((d) => (d.data().posterNickname ?? 'The One').trim()).filter(Boolean);
          if (new Set(feedNicknames.map(normalizeNickname)).has(normalizeNickname(newAd.posterNickname))) {
            const suggested = getSuggestedNickname(newAd.posterNickname, feedNicknames);
            setSuggestedNicknameInPopup(suggested);
            setShowNicknameConflictPopup(true);
            return;
          }

          const adForFirestore = {
            partnerCutout: newAd.partnerCutout || null,
            heartPhotoUrl: newAd.heartPhotoUrl || null,
            userPhotoUrl: newAd.userPhotoUrl || null,
            swags: newAd.swags || [],
            places: newAd.places || [],
            activityX: newAd.activityX,
            activityY: newAd.activityY,
            activityZ: newAd.activityZ,
            userId: newAd.userId,
            userName: newAd.userName,
            posterNickname: newAd.posterNickname,
            dominantPersonality: newAd.dominantPersonality,
            alsoPrivateMatch: !!(savedPoster?.isPrivateCollage),
            friendLuv: typeof savedPoster?.friendLuv === 'boolean' ? savedPoster.friendLuv : false,
            romanticLuv: typeof savedPoster?.romanticLuv === 'boolean' ? savedPoster.romanticLuv : false,
            createdAt: serverTimestamp(),
            friendCollageShare: typeof savedPoster?.friendCollageShare === 'boolean' ? savedPoster.friendCollageShare : false,
            friendFoxMaskPlaceholder:
              typeof savedPoster?.friendFoxMaskPlaceholder === 'boolean' ? savedPoster.friendFoxMaskPlaceholder : false,
            ...(savedPoster?.selfGender && ['male', 'female', 'nb'].includes(savedPoster.selfGender)
              ? { selfGender: savedPoster.selfGender }
              : {}),
          };
          const docRef = await addDoc(collection(db, 'wantedFeed'), adForFirestore);
          newAd.id = docRef.id;
          newAd.createdAt = new Date();
          newAd.alsoPrivateMatch = !!(savedPoster?.isPrivateCollage);
          newAd.friendLuv = adForFirestore.friendLuv;
          newAd.romanticLuv = adForFirestore.romanticLuv;
          if (adForFirestore.selfGender) newAd.selfGender = adForFirestore.selfGender;

          const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
          const existing = normalizeSavedPostersList(Array.isArray(userSnap.data()?.savedWantedPosters) ? userSnap.data().savedWantedPosters : []);
          const updated = existing.map((p) =>
            p.id === existingPosterId
              ? { ...p, postedToFeed: true, feedAdId: docRef.id }
              : p
          );
          await updateDoc(doc(db, 'users', currentUser.uid), {
            savedWantedPosters: updated,
            updatedAt: new Date(),
          });
          void pushUserPublicPrimaryPreview();
        } else {
          // Full path: new collage — validate nickname, check duplicates, persist images.
          const feedRef = collection(db, 'wantedFeed');
          const feedQuery = query(feedRef, orderBy('createdAt', 'desc'), limit(500));
          const feedSnap = await getDocs(feedQuery);
          const feedNicknames = feedSnap.docs
            .map((d) => (d.data().posterNickname ?? 'The One').trim())
            .filter(Boolean);
          const existingNicknamesSet = new Set(feedNicknames.map(normalizeNickname));
          const nicknameNorm = normalizeNickname(newAd.posterNickname);
          if (existingNicknamesSet.has(nicknameNorm)) {
            const suggested = getSuggestedNickname(newAd.posterNickname, feedNicknames);
            setSuggestedNicknameInPopup(suggested);
            setShowPostConfirmPopup(false);
            setShowNicknameConflictPopup(true);
            return;
          }

          const swagUrls = (newAd.swags || []).map((s) => (s && (s.imageUrl || s)) || '').filter(Boolean).sort();
          const contentFingerprint = JSON.stringify({
            partnerCutout: newAd.partnerCutout || null,
            heartPhotoUrl: newAd.heartPhotoUrl || null,
            userPhotoUrl: newAd.userPhotoUrl || null,
            swagUrls,
            activityX: newAd.activityX,
            activityY: newAd.activityY,
            activityZ: newAd.activityZ || null,
            posterNickname: newAd.posterNickname || null,
          });
          const existingSnap = await getDocs(
            query(
              collection(db, 'wantedFeed'),
              where('userId', '==', currentUser.uid),
              limit(100)
            )
          );
          const isDuplicate = existingSnap.docs.some(
            (d) => d.data().contentFingerprint === contentFingerprint
          );
          if (isDuplicate) {
            setShowPostConfirmPopup(false);
            setShowDuplicatePostPopup(true);
            return;
          }

          const stripDataUrl = (v) =>
            v && typeof v === 'string' && v.startsWith('data:') ? null : v;
          const clipUnmasked = (u) => (u && typeof u === 'string' && u.trim() ? u.trim() : null);
          const unmaskedForPost =
            clipUnmasked(collageUserPhotoOriginalUrl)
            || clipUnmasked(surveyAnswers?.user_photo_original)
            || (profileUserPhotoOriginalUrl && typeof profileUserPhotoOriginalUrl === 'string' ? profileUserPhotoOriginalUrl.trim() : null);
          const [partnerCutoutForStore, heartPhotoUrlForStore, userPhotoUrlForStore, userPhotoOriginalUrlForStorePost, swagsForStore] = await Promise.all([
            (async () => {
              if (!newAd.partnerCutout || typeof newAd.partnerCutout !== 'string') return null;
              const u = await persistImageUrlToStorage(newAd.partnerCutout, 'partner_cutouts/generated', 'png');
              return u || (newAd.partnerCutout.startsWith('data:') || newAd.partnerCutout.includes('replicate.delivery') ? null : newAd.partnerCutout);
            })(),
            (async () => {
              const h = await persistImageUrlToStorage(
                newAd.heartPhotoUrl && typeof newAd.heartPhotoUrl === 'string' ? newAd.heartPhotoUrl : null,
                'vibe_photos',
                'jpg',
              );
              return h || stripDataUrl(newAd.heartPhotoUrl) || null;
            })(),
            (async () => {
              const u = await persistImageUrlToStorage(
                newAd.userPhotoUrl && typeof newAd.userPhotoUrl === 'string' ? newAd.userPhotoUrl : null,
                'user_photos',
                'jpg',
              );
              return u || (newAd.userPhotoUrl && typeof newAd.userPhotoUrl === 'string' && !newAd.userPhotoUrl.startsWith('data:') ? newAd.userPhotoUrl : null);
            })(),
            (async () => {
              if (!unmaskedForPost || typeof unmaskedForPost !== 'string') return null;
              const u = await persistImageUrlToStorage(unmaskedForPost, 'user_photos', 'jpg');
              return u || (unmaskedForPost.startsWith('data:') ? null : unmaskedForPost);
            })(),
            Promise.all(
              (newAd.swags || []).map(async (s) => {
                const rawUrl = s.imageUrl || s;
                const stableUrl = rawUrl && typeof rawUrl === 'string'
                  ? await persistImageUrlToStorage(rawUrl, 'swags', 'png')
                  : null;
                return {
                  imageUrl: stableUrl || (rawUrl && typeof rawUrl === 'string' && !rawUrl.startsWith('data:') ? rawUrl : null),
                  name: s.name || null,
                  id: s.id || null,
                };
              }),
            ),
          ]);

          const adForFirestore = {
            partnerCutout: partnerCutoutForStore,
            heartPhotoUrl: heartPhotoUrlForStore,
            userPhotoUrl: userPhotoUrlForStore,
            swags: swagsForStore,
            places: newAd.places || [],
            activityX: newAd.activityX,
            activityY: newAd.activityY,
            activityZ: newAd.activityZ,
            userId: newAd.userId,
            userName: newAd.userName,
            posterNickname: newAd.posterNickname,
            dominantPersonality: newAd.dominantPersonality,
            alsoPrivateMatch: false,
            friendLuv: false,
            romanticLuv: false,
            friendCollageShare: false,
            friendFoxMaskPlaceholder: false,
            contentFingerprint,
            createdAt: serverTimestamp(),
            ...(newAd.selfGender && ['male', 'female', 'nb'].includes(newAd.selfGender)
              ? { selfGender: newAd.selfGender }
              : {}),
          };
          const docRef = await addDoc(collection(db, 'wantedFeed'), adForFirestore);
          newAd.id = docRef.id;
          newAd.createdAt = new Date();
          newAd.alsoPrivateMatch = false;
          newAd.friendLuv = false;
          newAd.romanticLuv = false;
          if (adForFirestore.selfGender) newAd.selfGender = adForFirestore.selfGender;
          newAd.partnerCutout = partnerCutoutForStore;
          newAd.heartPhotoUrl = heartPhotoUrlForStore;
          newAd.userPhotoUrl = userPhotoUrlForStore;
          newAd.swags = swagsForStore;

          const posterForSaved = {
            id: docRef.id,
            createdAt: new Date(),
            userId: currentUser?.uid || null,
            surveyAnswers: null,
            partnerCutout: partnerCutoutForStore,
            heartPhotoUrl: heartPhotoUrlForStore,
            swags: swagsForStore,
            places: newAd.places || [],
            activityX: newAd.activityX,
            activityY: newAd.activityY,
            activityZ: newAd.activityZ || null,
            words: [],
            userPhotoUrl: userPhotoUrlForStore,
            userPhotoOriginalUrl: userPhotoOriginalUrlForStorePost || null,
            posterNickname: newAd.posterNickname,
            isPrivateCollage: false,
            postedToFeed: true,
            feedAdId: docRef.id,
          };
          await updateDoc(doc(db, 'users', currentUser.uid), {
            savedWantedPosters: arrayUnion(posterForSaved),
            updatedAt: new Date(),
          });
          void pushUserPublicPrimaryPreview();
          await setDoc(
            doc(db, 'sharedPosters', docRef.id),
            sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(posterForSaved)),
          );
        }
      } catch (err) {
        const code = err?.code;
        const message = err?.message || String(err);
        console.error('Error saving post to feed:', code, message, err);
        const hint = code === 'permission-denied'
          ? ' Make sure you\'re signed in and Firestore rules are deployed (firebase deploy --only firestore:rules).'
          : code === 'unavailable' || message.includes('CORS') || message.includes('network')
            ? ' Check your network and that the Firebase project allows localhost.'
            : ` Error: ${message}`;
        alert('Post added to feed, but failed to save permanently. Please try again later.' + hint);
      }
    }

    setSurveyCompleted(false);
    setShowInlineSurvey(false);
    setSelectedPartnerCutout(null);
    setSelectedSwags([]);
    setSelectedWords([]);
    setSelectedActivities([]);
    setSurveyAnswers(null);
    setEditedPosterNickname(null);
    setPersonalityConfirmed(false);
    setJungianAnalysisText(null);
    setJungianPersonality(null);
    setCurrentPosterAlreadySaved(false);
    setEditingSavedPosterId(null);
    setEditingFeedAdId(null);
    setSuppressPrimaryLuvIconsOnEditorCanvas(false);
    setCollageUserPhotoOriginalUrl(null);

    setSuccessPopupMessage('Posted successfully!');
    setShowPostConfirmPopup(false);
  };


  // Image Upload Handlers
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!isLikelyPhotoFile(file)) {
      alert('Please upload an image file');
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      alert('Image size must be less than 10MB');
      return;
    }
    void (async () => {
      try {
        const displayFile = await ensureBrowserDisplayablePhotoFile(file);
        setUploadedImage(displayFile);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(displayFile);
      } catch (err) {
        console.error('HEIF conversion failed:', err);
        alert('Couldn’t read this HEIF photo. Try exporting it as JPEG.');
      }
    })();
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
  };

  const handleAnalyzeImage = async () => {
    if (!uploadedImage) {
      alert('Please upload an image first');
      return;
    }
    
    setIsAnalyzing(true);
    try {
      console.log('Analyzing image:', uploadedImage.name);
      
      // Call the analysis function (will be implemented with Replicate API later)
      const result = await analyzeImageReplicate(uploadedImage, 'free');
      
      console.log('Analysis result:', result);
      
      // TODO: Handle the analysis result (e.g., show insights, update UI, etc.)
      alert('Image analysis complete! Results will be displayed here once the API is fully implemented.');
    } catch (error) {
      console.error('Error analyzing image:', error);
      
      // Check if it's a 404 (endpoint not implemented yet) or other error
      if (error.message.includes('404') || error.message.includes('not found')) {
        alert('Image analysis feature is being set up. Please check back soon!');
      } else {
        alert('Failed to analyze image. Please try again.');
      }
    } finally {
      setIsAnalyzing(false);
    }
  };

  const handleUploadClose = () => {
    setShowImageUpload(false);
    setUploadedImage(null);
    setImagePreview(null);
    setUploadMode(null);
  };

  // Ex Image Upload Handlers
  const handleExImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please upload an image file');
        return;
      }
      
      // Validate file size (max 10MB)
      if (file.size > 10 * 1024 * 1024) {
        alert('Image size must be less than 10MB');
        return;
      }
      
      setUploadedExImage(file);
      
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setExImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveExImage = () => {
    setUploadedExImage(null);
    setExImagePreview(null);
  };

  const handleAnalyzeExImage = async () => {
    if (!uploadedExImage) {
      alert('Please upload an image first');
      return;
    }
    
    setIsAnalyzingEx(true);
    try {
      console.log('Analyzing ex image:', uploadedExImage.name);
      
      // Call the ex analysis function (will be implemented with Replicate API later)
      const result = await analyzeExImageReplicate(uploadedExImage, 'free');
      
      console.log('Ex analysis result:', result);
      
      // TODO: Handle the analysis result (e.g., show insights, update UI, etc.)
      alert('Ex image analysis complete! Results will be displayed here once the API is fully implemented.');
    } catch (error) {
      console.error('Error analyzing ex image:', error);
      
      // Check if it's a 404 (endpoint not implemented yet) or other error
      if (error.message.includes('404') || error.message.includes('not found')) {
        alert('Ex image analysis feature is being set up. Please check back soon!');
      } else {
        alert('Failed to analyze ex image. Please try again.');
      }
    } finally {
      setIsAnalyzingEx(false);
    }
  };

  const handleExUploadClose = () => {
    setShowExImageUpload(false);
    setUploadedExImage(null);
    setExImagePreview(null);
    setUploadMode(null);
  };

  const handleRedeemClick = async (item) => {
    setRedeemHintMessage('');
    if (!currentUser) {
      onShowSignUp?.();
      return;
    }
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        cart: arrayUnion({ id: item.id, title: item.alt, price: item.price, alt: item.alt }),
      });
    } catch (err) {
      console.error('Error adding to cart:', err);
      setRedeemHintMessage('Something went wrong. Please try again.');
    }
  };

  const handleRemoveFromCart = async (item) => {
    if (!currentUser?.uid) return;
    try {
      const userRef = doc(db, 'users', currentUser.uid);
      const userSnap = await getDoc(userRef);
      const cart = userSnap.data()?.cart ?? [];
      const idx = cart.findIndex((c) => c.id === item.id && c.title === item.title && c.price === item.price);
      if (idx === -1) return;
      const newCart = [...cart];
      newCart.splice(idx, 1);
      await updateDoc(userRef, {
        cart: newCart,
      });
    } catch (err) {
      console.error('Error removing from cart:', err);
    }
  };

  const handleConfirmOrder = async () => {
    if (!currentUser?.uid || !userCart.length) {
      setShowCartPopup(false);
      return;
    }
    try {
      await addDoc(collection(db, 'users', currentUser.uid, 'orders'), {
        items: userCart,
        createdAt: serverTimestamp(),
      });
      setShowCartPopup(false);
      setShowOrderConfirmPopup(true);
    } catch (err) {
      console.error('Error confirming order:', err);
    }
  };

  const handleCartSignOut = async () => {
    try {
      await signOut(auth);
      setShowCartPopup(false);
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  const handleNavbarSignOut = async () => {
    try {
      setShowMyCollagesInline(false);
      await signOut(auth);
    } catch (err) {
      console.error('Error signing out:', err);
    }
  };

  const handleNavbarYourRewardsClick = () => {
    setShowMyCollagesInline(true);
    const scrollToRewards = () => {
      document.getElementById('user-menu-your-rewards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    setTimeout(scrollToRewards, 180);
  };

  const redeemCouponCode = useCallback(
    async (rawCode) => {
      if (!currentUser?.uid) {
        return { ok: false, error: 'Sign in to redeem a coupon.' };
      }
      const normalized = normalizeCouponCode(rawCode);
      if (!normalized) {
        return { ok: false, error: 'Enter a coupon code.' };
      }
      const spec = lookupCouponReward(rawCode);
      if (!spec) {
        return { ok: false, error: 'That code is not valid.' };
      }
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const snap = await getDoc(userRef);
        const data = snap.data() || {};
        const rewards = Array.isArray(data.rewardsToRedeem) ? data.rewardsToRedeem : [];
        const already = rewards.some(
          (r) => r && String(r.couponCode || '').toUpperCase() === normalized,
        );
        if (already) {
          return { ok: false, error: 'You already redeemed this code.' };
        }
        if (rewardTileCountAtOrOverLimit(rewards)) {
          return { ok: false, error: REWARD_TILE_LIMIT_MESSAGE };
        }
        await updateDoc(userRef, {
          rewardsToRedeem: arrayUnion({
            id: `coupon-${normalized}-${Date.now()}`,
            couponCode: normalized,
            title: spec.title,
            description: spec.description,
          }),
        });
        return { ok: true };
      } catch (err) {
        console.error('Error redeeming coupon:', err);
        return { ok: false, error: 'Something went wrong. Try again.' };
      }
    },
    [currentUser?.uid],
  );

  /** Persist Fox Concierge GET (YOUR REWARDS tile) for ops / fulfillment. */
  const logRewardConciergeGet = useCallback(
    async (reward) => {
      if (!currentUser?.uid || !reward || typeof reward !== 'object') return;
      try {
        await addDoc(collection(db, 'rewardConciergeGetClicks'), {
          userId: currentUser.uid,
          userEmail: currentUser.email || null,
          rewardId: reward.id ?? null,
          couponCode: reward.couponCode ?? null,
          rewardTitle: reward.title ?? null,
          rewardDescription: reward.description ?? null,
          createdAt: serverTimestamp(),
        });
        const persistKey = rewardTilePersistenceKey(reward);
        if (persistKey && reward.source !== 'freeMatcha') {
          await updateDoc(doc(db, 'users', currentUser.uid), {
            yourRewardsConciergeKeys: arrayUnion(persistKey),
          });
        }
      } catch (err) {
        console.error('Failed to log reward concierge GET:', err);
      }
    },
    [currentUser?.uid, currentUser?.email],
  );

  const persistShare50FriendSent = useCallback(
    async (reward) => {
      if (!currentUser?.uid || !reward || typeof reward !== 'object') return;
      const k = rewardTilePersistenceKey(reward);
      if (!k) return;
      try {
        await updateDoc(doc(db, 'users', currentUser.uid), {
          yourRewardsShare50SentKeys: arrayUnion(k),
        });
      } catch (err) {
        console.error('Failed to persist share50 friend sent:', err);
      }
    },
    [currentUser?.uid],
  );

  const handleOrderConfirmClose = async () => {
    if (currentUser?.uid) {
      try {
        await updateDoc(doc(db, 'users', currentUser.uid), { cart: [] });
      } catch (err) {
        console.error('Error clearing cart:', err);
      }
    }
    setShowOrderConfirmPopup(false);
  };

  /** Pass `{ completed: true }` from InlineSurvey when the flow finishes so collage-a-friend stays active for the editor. */
  const handleSurveyClose = (closeDetail) => {
    setShowInlineSurvey(false);
    setSurveyOnIntro(true);
    const finishedNormally =
      closeDetail &&
      typeof closeDetail === 'object' &&
      closeDetail.completed === true;
    if (collageFriendFlowActive && !finishedNormally) {
      setCollageFriendFlowActive(false);
      setCollageFriendInviteEmail(null);
    }
  };

  const handleFriendFlowSurveyBackToRewards = useCallback(() => {
    setShowInlineSurvey(false);
    setSurveyOnIntro(true);
    setCollageFriendFlowActive(false);
    setCollageFriendInviteEmail(null);
    setShowMyCollagesInline(true);
      setPosterDeleteConfirmId(null);
    setPosterDetailFromList(null);
    setPosterDetailFromListTitleOverride(null);
    setShowUnpostConfirm(false);
    setTimeout(() => {
      document.getElementById('user-menu-your-rewards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
  }, []);

  const handleCollageFriendFlowStart = useCallback(
    async (email) => {
      if (!currentUser?.uid) {
        window.alert('Sign in to collage a friend.');
        return false;
      }
      const trimmed = String(email || '').trim().toLowerCase();
      if (!trimmed) return false;
      try {
        await addDoc(collection(db, 'referSubmissions'), {
          posterId: null,
          friendEmail: trimmed,
          createdAt: serverTimestamp(),
          userId: currentUser.uid,
          source: 'friend_collage_preflow',
        });
      } catch (err) {
        console.error('friend collage preflow email:', err);
        window.alert('Could not save that email. Check your connection and try again.');
        return false;
      }
      setCollageFriendInviteEmail(trimmed);
      setCollageFriendFlowActive(true);
      setShowMyCollagesInline(false);
      setPosterDeleteConfirmId(null);
      setPosterDetailFromList(null);
      setPosterDetailFromListTitleOverride(null);
      setShowUnpostConfirm(false);
      setSelectedPartnerCutout(null);
      setIsImageGenerated(false);
      setGeneratedPartnerImage(null);
      setCurrentGeneratedImage(null);
      setSelectedSwags([]);
      setSurveyCompleted(false);
      setUserPhotoUrl(null);
      setCollageUserPhotoOriginalUrl(null);
      setShowFoxButton(true);
      setSurveyOnIntro(false);
      setCurrentPosterAlreadySaved(false);
      setEditingSavedPosterId(null);
      setEditingFeedAdId(null);
      setSuppressPrimaryLuvIconsOnEditorCanvas(false);
      setShowInlineSurvey(true);
      setFriendCutoutReplacedSinceSurvey(false);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 80);
      return true;
    },
    [currentUser?.uid],
  );

  const closeCollageFriendSuccessPopup = useCallback(() => {
    setShowCollageFriendSuccessPopup(false);
    setCollageFriendSuccessPoster(null);
    setCollageFriendInviteEmail(null);
    setCollageFriendLinkCopied(false);
    setCollageFriendEmailSent(false);
  }, []);

  const handleSurveyComplete = async (surveyData) => {
    console.log('handleSurveyComplete called with:', surveyData);
    setSurveyCompleted(true);
    setShowInlineSurvey(false);
    setPartnerCutoutError(null);

    // Personality is chosen at random; user confirms or switches in the personality chart popup
    setJungianPersonality(getRandomDominantPersonality());

    if (surveyData.answers) {
      setSurveyAnswers(surveyData.answers);
      setFriendCutoutReplacedSinceSurvey(!!surveyData.answers.user_photo);
      if (surveyData.answers.user_photo) {
        const photoUrl = surveyData.answers.user_photo;
        setUserPhotoUrl(photoUrl);
        const orig = surveyData.answers.user_photo_original;
        if (orig && typeof orig === 'string' && orig.trim()) {
          setCollageUserPhotoOriginalUrl(orig.trim());
        } else {
          setCollageUserPhotoOriginalUrl(null);
        }
        // Navbar uses users.userPhotoUrl from Firestore — only update after save via syncUserPublicPrimaryFromUserDocument
      }
    }
    if (surveyData.jungianAnalysis) {
      setJungianAnalysisText(surveyData.jungianAnalysis);
    }
    setSelectedSwags(
      surveyData.answers?.brands?.length > 0
        ? surveyData.answers.brands
        : getRandomBrandSamples(3)
    );
    if (surveyData.words && Array.isArray(surveyData.words)) {
      setSelectedWords(surveyData.words);
    }
    if (surveyData.activities && Array.isArray(surveyData.activities)) {
      setSelectedActivities(surveyData.activities);
    }
    if (surveyData.places && Array.isArray(surveyData.places)) {
      setSelectedPlaces(surveyData.places);
    } else if (surveyData.answers?.places && Array.isArray(surveyData.answers.places)) {
      setSelectedPlaces(surveyData.answers.places);
    }

    // Resolve the nickname descriptor before opening the chart so it shows immediately
    surveyAnalysisPromiseRef.current = surveyData.analysisPromise ?? null;
    surveyDescriptorPromiseRef.current = surveyData.descriptorPromise ?? null;
    const descriptorPromise = surveyData.descriptorPromise || Promise.resolve(getRandomWord());
    try {
      const descriptor = await descriptorPromise;
      setEditedPosterNickname(descriptor && String(descriptor).trim() ? descriptor : getRandomWord());
    } catch {
      setEditedPosterNickname(getRandomWord());
    }
    setGeneratedWordReadyForPopup(true);
    setChartOpenedFromSurvey(true);
    setCollageFinderSelfGender(null);
    setCollageFinderFriendLuv(false);
    setCollageFinderRomanticLuv(false);
    setCollageFinderLookingForGenders([]);
    setCollageFinderSelfAge(AGE_WHEEL_DEFAULT);
    setShowPersonalityChart(true);

    // If user uploaded their own photo during the survey, use it as the partner cutout
    if (surveyData.answers?.user_photo) {
      setSelectedPartnerCutout(surveyData.answers.user_photo);
      return;
    }

    // No user photo — use fox mask as default cutout
    setSelectedPartnerCutout(foxMaskFallback);
  };

  const handleHeartPhotoUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!isLikelyPhotoFile(file)) {
      alert('Please upload an image file');
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      alert('Image size must be less than 15MB');
      return;
    }
    void (async () => {
      try {
        const displayFile = await ensureBrowserDisplayablePhotoFile(file);
        setHeartPhotoFile(displayFile);
        const reader = new FileReader();
        reader.onloadend = () => setHeartPhotoPreview(reader.result);
        reader.readAsDataURL(displayFile);
      } catch (err) {
        console.error('HEIF conversion failed:', err);
        alert('Couldn’t read this HEIF photo. Try exporting it as JPEG.');
      }
    })();
  };

  const removeHeartPhoto = () => {
    setHeartPhotoFile(null);
    setHeartPhotoPreview(null);
    if (heartPhotoInputRef.current) heartPhotoInputRef.current.value = '';
  };

  const fetchHeartGifs = async (query = 'vibe') => {
    setLoadingHeartGifs(true);
    try {
      const customerId = currentUser?.uid || `anon_${Date.now()}`;
      const gifs = await searchSpiritGifs(query, customerId);
      setHeartGifs(gifs.slice(0, 9));
    } catch (error) {
      console.error('Error fetching heart GIFs:', error);
    } finally {
      setLoadingHeartGifs(false);
    }
  };

  const handleHeartPhotoSubmit = async () => {
    if (!heartPhotoFile) return;
    setHeartPhotoUploading(true);
    try {
      const storagePath = `vibe_photos/${Date.now()}_${nanoid(8)}/${heartPhotoFile.name}`;
      const storageRef = ref(storage, storagePath);
      await uploadBytes(storageRef, heartPhotoFile, {
        contentType: heartPhotoFile.type || 'image/jpeg',
      });
      const downloadUrl = await getDownloadURL(storageRef);
      setSurveyAnswers((prev) => (prev ? { ...prev, vibe_photo: downloadUrl } : { vibe_photo: downloadUrl }));
      removeHeartPhoto();
      setShowHeartPhotoUpload(false);
    } catch (err) {
      console.error('Heart photo upload failed:', err);
      alert('Failed to upload photo. Please try again.');
    } finally {
      setHeartPhotoUploading(false);
    }
  };

  const confirmCutoutReuploadPhoto = async () => {
    if (!cutoutReuploadEditedUrl) return;
    let urlToSave = cutoutReuploadEditedUrl;
    if (typeof urlToSave === 'string' && urlToSave.includes('replicate.delivery')) {
      setCutoutReuploadConfirming(true);
      try {
        const res = await fetch(urlToSave);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        const ext = (blob.type && blob.type.split('/')[1]) || 'png';
        const storagePath = `user_photos/${Date.now()}_${nanoid(8)}.${ext}`;
        const storageRefPersist = ref(storage, storagePath);
        await uploadBytes(storageRefPersist, blob, { contentType: blob.type || 'image/png' });
        urlToSave = await getDownloadURL(storageRefPersist);
      } catch (e) {
        console.warn('Could not persist user photo to Storage:', e);
      } finally {
        setCutoutReuploadConfirming(false);
      }
    }
    const originalUrl = cutoutReuploadOriginalUrlRef.current || null;
    setSelectedPartnerCutout(urlToSave);
    setFriendCutoutReplacedSinceSurvey(true);
    setSurveyAnswers((prev) => ({
      ...(prev && typeof prev === 'object' ? prev : {}),
      user_photo: urlToSave,
      user_photo_original: originalUrl,
    }));
    setUserPhotoUrl(urlToSave);
    if (originalUrl && typeof originalUrl === 'string' && originalUrl.trim()) {
      setCollageUserPhotoOriginalUrl(originalUrl.trim());
    } else {
      setCollageUserPhotoOriginalUrl(null);
    }
    // Do not write users.userPhotoUrl here — navbar stays on saved primary until collage save + primary sync
    setCutoutReuploadEditedUrl(null);
    cutoutReuploadOriginalUrlRef.current = null;
    setCutoutReuploadFile(null);
    setCutoutReuploadPreview(null);
    setShowCutoutReupload(false);
    if (cutoutReuploadInputRef.current) cutoutReuploadInputRef.current.value = '';
  };

  const retryCutoutReuploadPhoto = () => {
    setCutoutReuploadEditedUrl(null);
    cutoutReuploadOriginalUrlRef.current = null;
    setCutoutReuploadFile(null);
    setCutoutReuploadPreview(null);
    if (cutoutReuploadInputRef.current) cutoutReuploadInputRef.current.value = '';
  };

  const handleCutoutReuploadSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) {
      alert('Image size must be less than 15MB');
      return;
    }
    void (async () => {
      try {
        const displayFile = await ensureBrowserDisplayablePhotoFile(file);
        setCutoutReuploadFile(displayFile);
        const reader = new FileReader();
        reader.onloadend = () => setCutoutReuploadPreview(reader.result);
        reader.readAsDataURL(displayFile);
      } catch (err) {
        console.error('HEIF conversion failed:', err);
        alert('Couldn’t read this HEIF photo. Try exporting it as JPEG.');
      }
    })();
  };

  const handleCutoutReuploadSubmit = async () => {
    if (!cutoutReuploadFile) return;
    setCutoutReuploadHintIndex(0);
    setCutoutReuploadUploading(true);
    try {
      const storagePath = `user_photos/${Date.now()}_${nanoid(8)}/${cutoutReuploadFile.name}`;
      const storageRef = ref(storage, storagePath);
      await uploadBytes(storageRef, cutoutReuploadFile, {
        contentType: cutoutReuploadFile.type || 'image/jpeg',
      });
      const downloadUrl = await getDownloadURL(storageRef);
      cutoutReuploadOriginalUrlRef.current = downloadUrl;
      setCutoutReuploadUploading(false);
      setCutoutReuploadProcessing(true);
      try {
        const editedUrl = await applyUserPhotoFoxMask(downloadUrl);
        setCutoutReuploadEditedUrl(editedUrl);
        setCutoutReuploadFile(null);
        setCutoutReuploadPreview(null);
        if (cutoutReuploadInputRef.current) cutoutReuploadInputRef.current.value = '';
      } catch (err) {
        console.error('Cutout re-upload fox mask failed:', err);
        alert('Failed to process photo. Please try again.');
      } finally {
        setCutoutReuploadProcessing(false);
      }
    } catch (err) {
      console.error('Cutout re-upload failed:', err);
      alert('Failed to upload photo. Please try again.');
      setCutoutReuploadUploading(false);
    }
  };

  const closeCutoutReupload = () => {
    setCutoutReuploadFile(null);
    setCutoutReuploadPreview(null);
    setCutoutReuploadEditedUrl(null);
    cutoutReuploadOriginalUrlRef.current = null;
    setCutoutReuploadConfirming(false);
    setShowCutoutReupload(false);
    if (cutoutReuploadInputRef.current) cutoutReuploadInputRef.current.value = '';
  };

  /**
   * "TRY A NEW MASK" step 1 (Your collages primary preview): re-run the user's stored *unmasked*
   * photo through the fox-mask edit and return the freshly masked image URL (persisted to Storage)
   * WITHOUT touching the saved poster yet — the caller shows an OLD vs NEW comparison popup and
   * only commits on UPDATE (see `handleCommitNewMask`). Returns null on failure / no original.
   */
  const handleGenerateNewMask = async (poster) => {
    if (!currentUser?.uid || !poster?.id) return null;
    const unmaskedUrl =
      (poster.userPhotoOriginalUrl && String(poster.userPhotoOriginalUrl).trim())
      || (poster.surveyAnswers?.user_photo_original && String(poster.surveyAnswers.user_photo_original).trim())
      || null;
    if (!unmaskedUrl) {
      alert("We don't have your original photo on file to re-mask. Use EDIT to upload a new photo.");
      return null;
    }
    try {
      const maskedRaw = await applyUserPhotoFoxMask(unmaskedUrl);
      const maskedUrl = (await persistImageUrlToStorageUtil(maskedRaw, 'user_photos', 'jpg')) || maskedRaw;
      if (!maskedUrl) throw new Error('No masked image produced');
      return maskedUrl;
    } catch (err) {
      console.error('TRY A NEW MASK generate failed:', err);
      alert('Could not generate a new mask. Please try again.');
      return null;
    }
  };

  /**
   * "TRY A NEW MASK" step 2: commit the chosen new mask into the saved poster's `partnerCutout` /
   * `userPhotoUrl` (keeping `userPhotoOriginalUrl` intact), mirror to the public `sharedPosters/{id}`
   * doc (unmasked stripped), and refresh the `userPublicPrimary` preview. Returns true on success.
   */
  const handleCommitNewMask = async (poster, newMaskUrl) => {
    if (!currentUser?.uid || !poster?.id || !newMaskUrl) return false;
    try {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const snap = await getDoc(userDocRef);
      const list = normalizeSavedPostersList(
        Array.isArray(snap.data()?.savedWantedPosters) ? snap.data().savedWantedPosters : [],
      );
      let patched = null;
      const updated = list.map((p) => {
        if (p.id !== poster.id) return p;
        patched = { ...p, partnerCutout: newMaskUrl, userPhotoUrl: newMaskUrl };
        return patched;
      });
      if (!patched) return false;

      await updateDoc(userDocRef, { savedWantedPosters: updated, updatedAt: new Date() });
      setSavedPosters(updated);

      /* Keep the public share mirror in sync (helper strips the unmasked original). */
      try {
        await setDoc(
          doc(db, 'sharedPosters', patched.id),
          sanitizeForFirestore(stripUnmaskedPhotoForPublicShare(patched)),
          { merge: true },
        );
      } catch (mirrorErr) {
        console.warn('TRY A NEW MASK sharedPosters mirror failed:', mirrorErr);
      }
      void pushUserPublicPrimaryPreview();
      return true;
    } catch (err) {
      console.error('TRY A NEW MASK commit failed:', err);
      alert('Could not update your mask. Please try again.');
      return false;
    }
  };

  const handleEditCutoutSubmit = async (e) => {
    e.preventDefault();
    const text = (editCutoutInput || '').trim();
    if (!text || !selectedPartnerCutout) return;
    if (!currentUser && editCountForGuest >= EDIT_CUTOUT_LIMIT_GUEST) {
      setEditCutoutError(`You've used all ${EDIT_CUTOUT_LIMIT_GUEST} edits. Sign up to edit more.`);
      return;
    }
    setEditCutoutError(null);
    setIsEditingCutout(true);
    try {
      const newImageUrl = await editPartnerCutoutNanoBanana(selectedPartnerCutout, text);
      setSelectedPartnerCutout(newImageUrl);
      setFriendCutoutReplacedSinceSurvey(true);
      setEditCutoutInput('');
      setShowEditCutoutModal(false);
      if (!currentUser) {
        setEditCountForGuest((prev) => {
          const next = prev + 1;
          try {
            sessionStorage.setItem('partnerCutoutEditCount', String(next));
          } catch {}
          return next;
        });
      }
    } catch (err) {
      console.error('Edit partner cutout failed:', err);
      setEditCutoutError(err.message || 'Edit failed');
    } finally {
      setIsEditingCutout(false);
    }
  };

  const handleGenerateCustomBrand = async () => {
    const prompt = (customBrandPrompt || '').trim();
    if (!prompt) {
      setCustomBrandError('Please enter a description');
      return;
    }
    if (!currentUser && editCountForGuest >= EDIT_CUTOUT_LIMIT_GUEST) {
      setCustomBrandError(`You've used all ${EDIT_CUTOUT_LIMIT_GUEST} edits. Sign up to create more.`);
      if (onShowSignUp) onShowSignUp('You have used up all your edits for this session. Sign up for more edits!');
      return;
    }
    setCustomBrandError(null);
    setIsGeneratingBrandImage(true);
    try {
      const imageUrl = await generateBrandImageNanoBanana(prompt);
      setSelectedSwags(prev => {
        const next = [...prev];
        next[editingSwagIndex] = { imageUrl, name: prompt, id: imageUrl };
        return next;
      });
      setEditingSwagIndex(null);
      setShowBrandAddOwnInput(false);
      setCustomBrandPrompt('');
      if (!currentUser) {
        setEditCountForGuest((prev) => {
          const next = prev + 1;
          try {
            sessionStorage.setItem('partnerCutoutEditCount', String(next));
          } catch {}
          return next;
        });
      }
    } catch (err) {
      console.error('Generate brand image failed:', err);
      setCustomBrandError(err.message || 'Failed to generate image');
    } finally {
      setIsGeneratingBrandImage(false);
    }
  };

  const closeBrandPicker = () => {
    setEditingSwagIndex(null);
    setShowBrandAddOwnInput(false);
    setCustomBrandPrompt('');
    setCustomBrandError(null);
    setShowBrandSearch(false);
    setBrandSearchQuery('');
    setBrandSearchResults([]);
    setBrandSearchLoading(false);
    setBrandPickerSearchEmpty(false);
    setBrandPickerMoreClickCount(0);
  };

  useEffect(() => {
    if (editingSwagIndex === null) return;
    /* Same as InlineSurvey when PICK THREE stuff is shown: warm brand image search. */
    searchBrandImages('warmup', 1).catch(() => {});
    /* Random 9 like survey’s first view — current collage items are only in the preview above “change to:”. */
    setBrandPickerOptions(getVariedBrandSample(9));
    setBrandPickerMoreClickCount(0);
    setShowBrandSearch(false);
    setBrandSearchQuery('');
    setBrandSearchResults([]);
    setBrandSearchLoading(false);
    setBrandPickerSearchEmpty(false);
  }, [editingSwagIndex]);

  const handleBrandPickerMoreOptions = () => {
    setBrandSearchResults([]);
    setBrandPickerSearchEmpty(false);
    setBrandPickerOptions((prev) => {
      const pool = allBrands.filter((b) => !prev.some((r) => r.id === b.id));
      const shuffled = [...pool].sort(() => Math.random() - 0.5);
      const next = shuffled.slice(0, 9);
      const bag = [...allBrands].sort(() => Math.random() - 0.5);
      for (const b of bag) {
        if (next.length >= 9) break;
        if (!next.some((x) => x.id === b.id)) next.push(b);
      }
      return next;
    });
    setBrandPickerMoreClickCount((c) => c + 1);
  };

  const closeActivityPicker = () => {
    setEditingActivityIndex(null);
    setShowActivityPickerSearch(false);
    setActivityPickerSearchQuery('');
    setActivityPickerSearchResults([]);
    setActivityPickerSearchEmpty(false);
    setActivityPickerMoreClickCount(0);
  };

  useEffect(() => {
    if (editingActivityIndex === null) return;
    const filtered = activityEmojis.filter((e) => !RELIGION_EMOJIS.includes(e));
    const shuffled = [...filtered].sort(() => Math.random() - 0.5);
    setActivityPickerGrid(shuffled.slice(0, 9));
    setActivityPickerMoreClickCount(0);
    setShowActivityPickerSearch(false);
    setActivityPickerSearchQuery('');
    setActivityPickerSearchResults([]);
    setActivityPickerSearchEmpty(false);
  }, [editingActivityIndex]);

  const handleActivityPickerMoreOptions = () => {
    setActivityPickerSearchResults([]);
    setActivityPickerSearchEmpty(false);
    setActivityPickerGrid((prev) => {
      const pool = activityEmojis.filter((e) => !RELIGION_EMOJIS.includes(e) && !prev.includes(e));
      const shuffled = [...pool].sort(() => Math.random() - 0.5);
      const next = shuffled.slice(0, 9);
      const bag = [...activityEmojis].filter((e) => !RELIGION_EMOJIS.includes(e)).sort(() => Math.random() - 0.5);
      for (const e of bag) {
        if (next.length >= 9) break;
        if (!next.includes(e)) next.push(e);
      }
      return next;
    });
    setActivityPickerMoreClickCount((c) => c + 1);
  };

  const closePlacePicker = () => {
    setEditingPlaceIndex(null);
    setShowPlacePickerSearch(false);
    setPlacePickerSearchQuery('');
    setPlacePickerSearchResults([]);
    setPlacePickerSearchLoading(false);
    setPlacePickerSearchDone(false);
    setPlacePickerMoreClickCount(0);
  };

  useEffect(() => {
    if (editingPlaceIndex === null) return;
    /* Same as InlineSurvey when PICK THREE places is shown: warm Firebase + Google Places search. */
    searchPlaces('warmup').catch(() => {});
    setPlacePickerGrid(getVariedPlacesSample(9));
    setPlacePickerMoreClickCount(0);
    setShowPlacePickerSearch(false);
    setPlacePickerSearchQuery('');
    setPlacePickerSearchResults([]);
    setPlacePickerSearchLoading(false);
    setPlacePickerSearchDone(false);
  }, [editingPlaceIndex]);

  const handlePlacePickerMoreOptions = () => {
    setPlacePickerSearchResults([]);
    setPlacePickerSearchDone(false);
    setPlacePickerGrid((prev) => {
      const pool = allPlaces.filter((p) => !prev.some((r) => r.id === p.id));
      const shuffled = [...pool].sort(() => Math.random() - 0.5);
      const next = shuffled.slice(0, 9);
      const bag = [...allPlaces].sort(() => Math.random() - 0.5);
      for (const p of bag) {
        if (next.length >= 9) break;
        if (!next.some((x) => x.id === p.id)) next.push(p);
      }
      return next;
    });
    setPlacePickerMoreClickCount((c) => c + 1);
  };

  // Per-index activity styles so replacing one activity doesn't reset others
  const prevActivitiesRef = useRef([]);
  const [activityImageStylesByIndex, setActivityImageStylesByIndex] = useState(() => new Map());

  useEffect(() => {
    if (!selectedActivities || selectedActivities.length === 0) {
      setActivityImageStylesByIndex(new Map());
      prevActivitiesRef.current = [];
      return;
    }
    const prev = prevActivitiesRef.current;
    const isEmojiFormat = typeof selectedActivities[0] === 'string';

    setActivityImageStylesByIndex(oldMap => {
      const nextMap = new Map(oldMap);
      selectedActivities.forEach((item, index) => {
        const prevItem = prev[index];
        const itemChanged = prevItem !== item;
        const newIndex = index >= prev.length;
        if (itemChanged || newIndex) {
          if (isEmojiFormat) {
            nextMap.set(index, {
              rotation: (Math.random() * 30 - 15).toFixed(1),
              horizontalOffset: (Math.random() * 40 - 20).toFixed(1),
              bgColor: `hsl(${(35 + Math.random() * 15).toFixed(0)}, ${(85 + Math.random() * 15).toFixed(0)}%, ${(65 + Math.random() * 15).toFixed(0)}%)`,
              fontSize: `${(2.5 + Math.random() * 1.5).toFixed(1)}rem`,
            });
          } else {
            nextMap.set(index, {
              rotation: (Math.random() * 20 - 10).toFixed(1),
              horizontalOffset: (Math.random() * 30 - 15).toFixed(1),
            });
          }
        }
      });
      // Trim map if array shortened
      for (const key of nextMap.keys()) {
        if (Number(key) >= selectedActivities.length) nextMap.delete(key);
      }
      return nextMap;
    });
    prevActivitiesRef.current = [...selectedActivities];
  }, [selectedActivities]);

  // Memoize swag image styles to prevent regeneration on every render
  const swagImageStyles = useMemo(() => {
    const styles = new Map();
    if (selectedSwags && selectedSwags.length > 0) {
      const swagUrls = selectedSwags.map(swag => swag.imageUrl).filter(Boolean);
      swagUrls.forEach((url) => {
        styles.set(url, {
          rotation: (Math.random() * 40 - 20).toFixed(1),
          horizontalOffset: (Math.random() * 50 - 25).toFixed(1)
        });
      });
    }
    return styles;
  }, [selectedSwags]);

  // Per-index place styles so replacing one place doesn't reset others
  const prevPlacesRef = useRef([]);
  const [placeStylesByIndex, setPlaceStylesByIndex] = useState(() => new Map());
  const [placesTopCount, setPlacesTopCount] = useState(() => Math.random() < 0.5 ? 1 : 2);

  useEffect(() => {
    if (!selectedPlaces || selectedPlaces.length === 0) {
      setPlaceStylesByIndex(new Map());
      prevPlacesRef.current = [];
      return;
    }
    const prev = prevPlacesRef.current;
    if (prev.length !== selectedPlaces.length) {
      setPlacesTopCount(Math.random() < 0.5 ? 1 : 2);
    }
    setPlaceStylesByIndex(oldMap => {
      const nextMap = new Map(oldMap);
      selectedPlaces.forEach((place, index) => {
        const prevPlace = prev[index];
        if (!prevPlace || prevPlace.id !== place.id || index >= prev.length) {
          nextMap.set(index, {});
        }
      });
      for (const key of nextMap.keys()) {
        if (Number(key) >= selectedPlaces.length) nextMap.delete(key);
      }
      return nextMap;
    });
    prevPlacesRef.current = [...selectedPlaces];
  }, [selectedPlaces]);

  // Memoize fallback activities to prevent reshuffling on every render
  const fallbackActivities = useMemo(() => {
    const allActivities = [runningImage, coffeeImage, eatingImage, hikingImage];
    const shuffled = [...allActivities].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 3);
  }, [selectedActivities]); // Only regenerate when selectedActivities changes

  const posterNickname = parseNicknameFromAnalysis(jungianAnalysisText);

  const [magazinePair, setMagazinePair] = useState(() => {
    const shuffled = [...MAGAZINE_IMAGES].sort(() => Math.random() - 0.5);
    return {
      left: { src: shuffled[0], rot: (Math.random() * 20 - 10).toFixed(1), dx: (Math.random() * 16 - 8).toFixed(1) },
      right: { src: shuffled[1], rot: (Math.random() * 20 - 10).toFixed(1), dx: (Math.random() * 16 - 8).toFixed(1) },
    };
  });
  const [scissorsOffset, setScissorsOffset] = useState({
    left: { rot: (Math.random() * 60 - 30).toFixed(1), dx: (Math.random() * 30 - 15).toFixed(1), dy: (Math.random() * 20 - 10).toFixed(1) },
    right: { rot: (Math.random() * 60 - 30).toFixed(1), dx: (Math.random() * 30 - 15).toFixed(1), dy: (Math.random() * 20 - 10).toFixed(1) },
  });
  return (
    <div className="home-page">
      <div className="background" ref={backgroundRef}>
        <Navbar
          onShowSurvey={onShowSurvey}
          onShowLoginPopup={onShowLoginPopup}
          onShowSignUp={onShowSignUp}
          currentUser={currentUser}
          cartCount={cartCount}
          onCartClick={() => setShowCartPopup(true)}
          onPostersClick={() => {
            setShowMyCollagesInline(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          onYourRewardsClick={handleNavbarYourRewardsClick}
          onRedeemCouponClick={currentUser?.uid ? () => setCouponRedeemModalOpen(true) : undefined}
          onCollageFriendClick={currentUser?.uid ? () => setCollageFriendModalOpen(true) : undefined}
          onFindsClick={() => setShowFindsPopup(true)}
          onMessagesClick={() => setShowMessagesPopup(true)}
          unreadMessagesCount={unreadMessagesCount + (foxInboxUnread ? 1 : 0)}
          onSignOut={handleNavbarSignOut}
          forceSignedOutView={signUpPopupOpen}
          userPhotoUrl={userProfilePhotoUrl}
          onLogoClick={() => {
            onLogoClick?.();
            // Logged-in homepage is Your collages; signed-out logo click returns to the hero editor.
            setShowMyCollagesInline(!!currentUser?.uid);
            setPosterDeleteConfirmId(null);
            setPosterDetailFromList(null);
            setPosterDetailFromListTitleOverride(null);
            setShowUnpostConfirm(false);
          }}
        />
        <CouponRedeemModal
          open={couponRedeemModalOpen}
          onClose={() => setCouponRedeemModalOpen(false)}
          onRedeemCoupon={redeemCouponCode}
        />
        <CollageFriendModal
          open={collageFriendModalOpen}
          onClose={() => setCollageFriendModalOpen(false)}
          onCollageFriendStart={handleCollageFriendFlowStart}
        />
        {/* Section 1: WANTED Poster Builder — or inline "Your collages" list */}
        <div className="wanted-poster-section">
          {showMyCollagesInline ? (
            <UserMenuCollagesSection
              spinBalanceUserId={currentUser?.uid || null}
              onMatchaExplainerOpen={handleDinnerOptInExplainerOpen}
              greetingName={
                mainPrivateMatchPosterNickname
                || (currentUser?.displayName && String(currentUser.displayName).trim())
                || ''
              }
              primaryCollageId={primaryCollageId}
              savedPosters={savedPosters}
              loadingPosters={loadingPosters}
              posterDeleteConfirmId={posterDeleteConfirmId}
              onSelectPoster={(poster) => {
                reopenPosterDetailAfterSaveIdRef.current = null;
                setPosterDetailFromListTitleOverride(null);
                setPosterDetailFromList(poster);
                setPosterDetailLinkCopied(false);
              }}
              onSetDeleteConfirmId={setPosterDeleteConfirmId}
              onDeletePoster={handleDeleteSavedPoster}
              onEditMainCollage={(poster) => {
                if (!poster?.id) return;
                reopenPosterDetailAfterSaveIdRef.current = null;
                setPosterDetailFromList(null);
                setPosterDetailFromListTitleOverride(null);
                setPosterDetailLinkCopied(false);
                setShowUnpostConfirm(false);
                handleLoadSavedPoster(poster, { hidePrimaryLuvIcons: true });
              }}
              onShareMainCollage={handleShareMainCollage}
              onGenerateNewMask={handleGenerateNewMask}
              onCommitNewMask={handleCommitNewMask}
              matchFlowLoading={matchFlowLoading}
              onUserMenuPrimaryPromoteSet={handleUserMenuPrimaryPromoteSet}
              onShowDinnerGiveawayExplainer={() => openPromoteOnSocialsExplainer('default')}
              rewardsToRedeem={rewardsToRedeem}
              persistedRewardConciergeKeys={yourRewardsConciergeKeys}
              persistedRewardShare50SentKeys={yourRewardsShare50SentKeys}
              onInviteMatchToDailyVibeChecks={handleInviteMatchToDailyVibeChecks}
              onInviteFriendByEmailToDailyVibeChecks={handleInviteFriendByEmailToDailyVibeChecks}
              onRewardConciergeGet={logRewardConciergeGet}
              onPersistShare50FriendSent={persistShare50FriendSent}
              onScrollToMatchAFriend={scrollToMatchAFriendSection}
              onStartCollage={openSelfFoxChat}
              vibeAccuracy={userVibeAccuracy}
              auraRgb={displayedAuraRgb}
              auraRecalculating={!!auraRecalc}
              vibeCheckStreak={userVibeCheckStreak}
              vibeCheckStreakLastPeriodKey={userVibeCheckStreakLastPeriodKey}
              onVibeCheck={openSelfFoxChat}
              onOpenMessages={() => setShowMessagesPopup(true)}
              profileVerified={profileVerified}
              profileVerificationPending={Boolean(
                !berkeleyEmailVerified &&
                profileVerified !== true &&
                (userBerkeleyEmail || isEduEmail(currentUser?.email || '')),
              )}
              profileEmailConfirmed={eduEmailConfirmed}
              eduVerifySendFailed={eduVerifySendFailed}
              onVerifyProfile={handleVerifyProfileClick}
              eduEmailOnFile={
                userBerkeleyEmail ||
                (isEduEmail(currentUser?.email || '') ? currentUser.email : '') ||
                ''
              }
              onSaveEduEmail={handleBerkeleyEmailSubmit}
              onResendEduEmail={handleBerkeleyEmailResend}
              eduResendCooldownSeconds={eduResendCooldownSeconds}
              eduVerifyBusy={berkeleyEmailSubmitting}
              eduVerifyError={berkeleyEmailError}
              notificationEmailOnFile={notificationEmailOnFile}
              onSaveNotificationEmail={handleSaveNotificationEmail}
            />
          ) : (
          <>
              {(!showInlineSurvey || surveyOnIntro) && (
              <h1 className="homepage-hero-title">
                <span className="homepage-hero-title__line">LUVWHATTHEFOX</span>
              </h1>
              )}
              {!showInlineSurvey && !surveyCompleted && !showImageUpload && !showExImageUpload && samplePartnerCutout && (
                <p className="hero-sample-hint hero-sample-hint--divider">
                  find your match
                </p>
              )}
              {/* WANTED Poster */}
              <div className="wanted-poster">
            
                <div className="poster-content">
                  {/* Sample Poster - Show before survey */}
                  {!showInlineSurvey && !surveyCompleted && !showImageUpload && !showExImageUpload && samplePartnerCutout && (
                    <>
                      {SHOW_HERO_SAMPLE_NICKNAME_STRIP ? (
                        <div className="homepage-hero-feed-nickname-slot">
                          <FeedNicknameTile
                            ad={{
                              id: 'homepage-sample',
                              posterNickname: SAMPLE_NICKNAMES[sampleNicknameIndex],
                              selfGender: getSelfGenderForSampleCutoutUrl(samplePartnerCutout),
                            }}
                            savedPosters={[]}
                            currentUserId={null}
                            findLuvFlags={{
                              friend: sampleFeedFindLuv.friend,
                              romantic: sampleFeedFindLuv.romantic,
                            }}
                          />
                        </div>
                      ) : null}
                      <div className="collage-poster-area collage-poster-area--hero-sample">
                      <div className="partner-swag-container">
                        {(() => {
                          const swagImages = [];
                          if (sampleSwags && sampleSwags.length > 0) {
                            const swagUrls = sampleSwags.map(swag => swag.imageUrl).filter(Boolean);
                            swagImages.push(...swagUrls);
                          }
                          return (
                            <>
                              <div className="partner-swag-left">
                                {swagImages.length > 0 && (
                                  <div className="swag-images-left">
                                    {swagImages.map((swagUrl, index) => {
                                      const layout = sampleSwagLayouts[index];
                                      return (
                                        <img
                                          key={index}
                                          src={swagUrl}
                                          alt="Swag"
                                          className="swag-image"
                                          style={{
                                            transform: `rotate(${layout?.rotation ?? 0}deg)`,
                                            marginLeft: `${layout?.horizontalOffset ?? 0}px`
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                              <div className="partner-swag-center">
                                <div
                                  className="final-partner-image-wrapper"
                                  style={{ cursor: 'pointer' }}
                                  onClick={openSelfFoxChat}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => e.key === 'Enter' && openSelfFoxChat(e)}
                                  aria-label="Create your poster"
                                >
                                  <img
                                    src={samplePartnerCutout}
                                    alt="Sample partner"
                                    className={`final-partner-image${partnerCutoutJaggedClass}`}
                                    fetchpriority="high"
                                    decoding="async"
                                  />
                                  <img
                                    src={HEART_GIFS[heartGifIndex]}
                                    alt=""
                                    className="partner-cutout-gif-overlay"
                                    style={{ pointerEvents: 'none' }}
                                  />
                                </div>
                              </div>
                              <div className="partner-swag-right">
                                {sampleActivityEmojis && sampleActivityEmojis.length > 0 && (
                                  <div className="activities-emojis-right">
                                    {sampleActivityEmojis.map((emoji, index) => {
                                      const layout = sampleEmojiLayouts[index];
                                      return (
                                        <div
                                          key={index}
                                          className="activity-emoji-wrapper collage-activity-tile"
                                          style={{
                                            transform: `rotate(${layout?.rotation ?? 0}deg)`,
                                            marginLeft: `${layout?.horizontalOffset ?? 0}px`,
                                            background: layout?.background,
                                          }}
                                        >
                                          <div
                                            className="activity-emoji"
                                            style={{ fontSize: layout?.fontSize }}
                                          >
                                            {emoji}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                      {samplePlaces && samplePlaces.length > 0 && (
                        <div className="collage-aspirations-row">
                          <div className="collage-places-row-inner">
                            <div className="aspiration-tile-outer">
                              <div className="collage-place-tile">
                                <img src={samplePlaces[0].imageUrl} alt={samplePlaces[0].name} className="collage-place-img" />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      </div>{/* end collage-poster-area */}
                    </>
                  )}


                  {/* Image Upload Interface (Analyze IG) */}
                  {showImageUpload && !showInlineSurvey && !surveyCompleted && (
                    <div className="inline-survey-content image-upload-interface">
                      <div className="survey-question">Upload an image to analyze</div>
                      
                      {!imagePreview ? (
                        <div className="image-upload-area">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            id="image-upload-input"
                            style={{ display: 'none' }}
                          />
                          <label htmlFor="image-upload-input" className="image-upload-button">
                            <span>Choose Image</span>
                          </label>
                          <p className="image-upload-hint">Select an image from your device</p>
                        </div>
                      ) : (
                        <div className="image-preview-container">
                          <div className="image-preview-wrapper">
                            <img 
                              src={imagePreview} 
                              alt="Preview" 
                              className="image-preview"
                            />
                            <button 
                              className="remove-image-button"
                              onClick={handleRemoveImage}
                              aria-label="Remove image"
                            >
                              ×
                            </button>
                          </div>
                          <button 
                            className="analyze-button"
                            onClick={handleAnalyzeImage}
                            disabled={isAnalyzing}
                          >
                            {isAnalyzing ? 'Analyzing...' : 'Analyze Image'}
                          </button>
                        </div>
                      )}
                      
                      <button 
                        className="fox-menu-close"
                        onClick={handleUploadClose}
                      >
                        ‹
                      </button>
                    </div>
                  )}

                  {/* Ex Image Upload Interface (Recycle your ex) */}
                  {showExImageUpload && !showInlineSurvey && !surveyCompleted && (
                    <div className="inline-survey-content image-upload-interface">
                      <div className="survey-question">Upload an image of your ex</div>
                      
                      {!exImagePreview ? (
                        <div className="image-upload-area">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleExImageUpload}
                            id="ex-image-upload-input"
                            style={{ display: 'none' }}
                          />
                          <label htmlFor="ex-image-upload-input" className="image-upload-button">
                            <span>Choose Image</span>
                          </label>
                          <p className="image-upload-hint">Select an image from your device</p>
                        </div>
                      ) : (
                        <div className="image-preview-container">
                          <div className="image-preview-wrapper">
                            <img 
                              src={exImagePreview} 
                              alt="Preview" 
                              className="image-preview"
                            />
                            <button 
                              className="remove-image-button"
                              onClick={handleRemoveExImage}
                              aria-label="Remove image"
                            >
                              ×
                            </button>
                          </div>
                          <button 
                            className="analyze-button"
                            onClick={handleAnalyzeExImage}
                            disabled={isAnalyzingEx}
                          >
                            {isAnalyzingEx ? 'Analyzing...' : 'Recycle Ex'}
                          </button>
                        </div>
                      )}
                      
                      <button 
                        className="fox-menu-close"
                        onClick={handleExUploadClose}
                      >
                        ‹
                      </button>
                    </div>
                  )}

                  {/* Inline Survey Content */}
                  {showInlineSurvey && (
                    <InlineSurvey
                      key={collageFriendFlowActive ? 'inline-survey-friend' : 'inline-survey-self'}
                      onClose={handleSurveyClose}
                      onComplete={handleSurveyComplete}
                      currentUser={currentUser}
                      onIntroChange={setSurveyOnIntro}
                      skipSurveyIntro={collageFriendFlowActive}
                      onFriendFlowExitToRewards={
                        collageFriendFlowActive ? handleFriendFlowSurveyBackToRewards : undefined
                      }
                      collageFriendFlow={collageFriendFlowActive}
                      visualsHintText={
                        collageFriendFlowActive
                          ? "What visuals give your friend's vibe?"
                          : undefined
                      }
                    />
                  )}

                  {/* Final Partner Image Container */}
                  {surveyCompleted && (
                    <>
                      <div className="collage-poster-area">
                      <div className="final-partner-image-container">
                        <div className="the-one-label-wrapper the-one-label-wrapper--collage-editor-nickname">
                          <FeedNicknameTile
                            ad={{
                              posterNickname:
                                (editedPosterNickname && String(editedPosterNickname).trim())
                                  ? editedPosterNickname
                                  : posterNickname ?? 'The One',
                            }}
                            savedPosters={savedPosters}
                            currentUserId={currentUser?.uid ?? null}
                            editorSavedPoster={collageNicknameStripPoster}
                            quoteChildren={
                              !personalityConfirmed
                                ? '"—"'
                                : pickingWord
                                  ? (friendCollageCopyActive
                                    ? "Picking your friend's nickname..."
                                    : 'Picking your nickname...')
                                  : undefined
                            }
                            asButton
                            disabled={!surveyCompleted}
                            onClick={() => {
                              setChartOpenedFromSurvey(false);
                              setChartHideRing(true);
                              setShowPersonalityChart(true);
                            }}
                            ariaLabel="Edit nickname"
                          />
                        </div>
                        <p className="collage-tap-to-edit-hint">(tap any tile to edit)</p>
                        {/* GIF overlay is now on the partner cutout instead */}
                      </div>
                      <div className="partner-swag-container">
                        {/* Three-column grid: left | center (partner) | right — keeps partner centered on all screen sizes */}
                        {(() => {
                          const swagImages = [];
                          if (selectedSwags && selectedSwags.length > 0) {
                            const swagUrls = selectedSwags.map(swag => swag.imageUrl).filter(Boolean);
                            swagImages.push(...swagUrls);
                          }
                          const activityImages = [];
                          if (selectedActivities && selectedActivities.length > 0) {
                            const activityUrls = selectedActivities.map(activity => activity.imageUrl).filter(Boolean);
                            activityImages.push(...activityUrls);
                          }
                          if (activityImages.length === 0) {
                            activityImages.push(...fallbackActivities);
                          }
                          const hasEmojiActivities = selectedActivities && selectedActivities.length > 0 &&
                            typeof selectedActivities[0] === 'string';
                          return (
                            <>
                              <div className="partner-swag-left">
                                {swagImages.length > 0 && (
                                  <div className="swag-images-left">
                                    {swagImages.map((swagUrl, index) => {
                                      const style = swagImageStyles.get(swagUrl) || { rotation: '0', horizontalOffset: '0' };
                                      return (
                                        <div
                                          key={`${swagUrl}-${index}`}
                                          className="swag-image-wrapper swag-image-wrapper-clickable"
                                          onClick={() => setEditingSwagIndex(index)}
                                          role="button"
                                          tabIndex={0}
                                          onKeyDown={(e) => e.key === 'Enter' && setEditingSwagIndex(index)}
                                          aria-label="Replace brand"
                                          title="Replace brand"
                                        >
                                          <img
                                            src={swagUrl}
                                            alt="Swag"
                                            className="swag-image"
                                            style={{
                                              transform: `rotate(${style.rotation}deg)`,
                                              marginLeft: `${style.horizontalOffset}px`
                                            }}
                                          />
                                          <span className="swag-edit-icon" aria-hidden="true">✂</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                              <div className="partner-swag-center">
                                <div className="partner-swag-center-stack">
                                  {selectedPartnerCutout && !hasClosedPersonalityChartOnce ? (
                                    <div className={`final-partner-image final-partner-image-placeholder${partnerCutoutJaggedClass}`}>
                                      <div className="partner-cutout-spinner" aria-hidden="true" />
                                      <p className="partner-cutout-generating-text">{PARTNER_CUTOUT_HINT_MESSAGES[partnerCutoutHintIndex]}…</p>
                                    </div>
                                  ) : showSessionFoxMaskPlaceholder ? (
                                    <div
                                      className="final-partner-image-wrapper final-partner-image-wrapper-clickable"
                                      onClick={() => setShowCutoutReupload(true)}
                                      role="button"
                                      tabIndex={0}
                                      onKeyDown={(e) => { if (e.key === 'Enter') setShowCutoutReupload(true); }}
                                      aria-label="Change photo"
                                      title="Upload a new photo"
                                    >
                                      <FriendFoxMaskPlaceholderCutout
                                        variant="main"
                                        jaggedClassName={partnerCutoutJaggedClass}
                                        includeOuterImageWrapper={false}
                                        heartSrc={surveyAnswers?.vibe_photo || orheartImage}
                                        heartClassName="partner-cutout-gif-overlay"
                                        heartOverlayInteractive
                                        onHeartOverlayClick={(e) => {
                                          e.stopPropagation();
                                          setShowHeartPhotoUpload(true);
                                        }}
                                        onHeartOverlayKeyDown={(e) => {
                                          if (e.key === 'Enter') {
                                            e.stopPropagation();
                                            setShowHeartPhotoUpload(true);
                                          }
                                        }}
                                      />
                                      <span className="partner-cutout-edit-icon" aria-hidden="true">📷</span>
                                    </div>
                                  ) : selectedPartnerCutout ? (
                                    <div
                                      className="final-partner-image-wrapper final-partner-image-wrapper-clickable"
                                      onClick={() => setShowCutoutReupload(true)}
                                      role="button"
                                      tabIndex={0}
                                      onKeyDown={(e) => { if (e.key === 'Enter') setShowCutoutReupload(true); }}
                                      aria-label="Change photo"
                                      title="Upload a new photo"
                                    >
                                      <img
                                        src={selectedPartnerCutout}
                                        alt="Your partner"
                                        className={`final-partner-image${partnerCutoutJaggedClass}`}
                                        onError={(e) => {
                                          const fallback = getRandomSampleCutout(surveyAnswers?.looking_for);
                                          if (e.target.src !== fallback) {
                                            e.target.src = fallback;
                                          }
                                        }}
                                      />
                                      <span className="partner-cutout-edit-icon" aria-hidden="true">📷</span>
                                      <img
                                        src={surveyAnswers?.vibe_photo || orheartImage}
                                        alt="Spirit GIF"
                                        className="partner-cutout-gif-overlay"
                                        onClick={(e) => { e.stopPropagation(); setShowHeartPhotoUpload(true); }}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => { if (e.key === 'Enter') { e.stopPropagation(); setShowHeartPhotoUpload(true); } }}
                                        aria-label="Change spirit GIF"
                                      />
                                    </div>
                                  ) : partnerCutoutError ? (
                                    <div className={`final-partner-image final-partner-image-placeholder${partnerCutoutJaggedClass}`}>
                                      <p className="partner-cutout-error-text">{partnerCutoutError}</p>
                                    </div>
                                  ) : null}
                                  {primaryCollageLuvPrefsOnCanvas.show &&
                                  selectedPartnerCutout &&
                                  hasClosedPersonalityChartOnce &&
                                  !suppressPrimaryLuvIconsOnEditorCanvas &&
                                  !collageEditorSavedPosterForNickname
                                    ? renderPrimaryCollageLuvIcons(
                                      primaryCollageLuvPrefsOnCanvas.friend,
                                      primaryCollageLuvPrefsOnCanvas.romantic,
                                    )
                                    : null}
                                </div>
                              </div>
                              <div className="partner-swag-right">
                                {hasEmojiActivities && (
                                  <div className="activities-emojis-right">
                                    {selectedActivities.map((emoji, index) => {
                                      const style = activityImageStylesByIndex.get(index) || {
                                        rotation: (Math.random() * 30 - 15).toFixed(1),
                                        horizontalOffset: (Math.random() * 40 - 20).toFixed(1)
                                      };
                                      return (
                                        <div
                                          key={`emoji-${index}`}
                                          className="activity-tile-outer activity-emoji-wrapper-clickable"
                                          style={{
                                            transform: `rotate(${style.rotation}deg)`,
                                            marginLeft: `${style.horizontalOffset}px`,
                                          }}
                                          onClick={() => setEditingActivityIndex(index)}
                                          role="button"
                                          tabIndex={0}
                                          onKeyDown={(e) => e.key === 'Enter' && setEditingActivityIndex(index)}
                                          aria-label="Replace activity"
                                          title="Replace activity"
                                        >
                                          <div
                                            className="activity-emoji-wrapper collage-activity-tile"
                                            style={{ background: style.bgColor || `hsl(42, 90%, 72%)` }}
                                          >
                                            <div
                                              className="activity-emoji"
                                              style={{ fontSize: style.fontSize || '3.2rem' }}
                                            >
                                              {emoji}
                                            </div>
                                          </div>
                                          <span className="activity-edit-icon" aria-hidden="true">✂</span>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                                {!hasEmojiActivities && activityImages.length > 0 && (
                                  <div className="activities-images-right">
                                    {activityImages.map((activityUrl, index) => {
                                      const style = activityImageStylesByIndex.get(index) || { rotation: '0', horizontalOffset: '0' };
                                      return (
                                        <img
                                          key={`${activityUrl}-${index}`}
                                          src={activityUrl}
                                          alt="Activity"
                                          className="swag-image"
                                          style={{
                                            transform: `rotate(${style.rotation}deg)`,
                                            marginLeft: `${style.horizontalOffset}px`
                                          }}
                                        />
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                      {/* Places row – bottom-left, level with GIF */}
                      {selectedPlaces && selectedPlaces.length > 0 && (
                        <div className="collage-aspirations-row">
                          {[selectedPlaces.slice(0, placesTopCount), selectedPlaces.slice(placesTopCount, 3)].map((rowPlaces, rowIdx) => (
                            rowPlaces.length > 0 && (
                              <div key={rowIdx} className="collage-places-row-inner">
                                {rowPlaces.map((place, i) => {
                                  const globalIdx = rowIdx === 0 ? i : placesTopCount + i;
                                  return (
                                    <div
                                      key={place.id || globalIdx}
                                      className="aspiration-tile-outer activity-emoji-wrapper-clickable"
                                      style={{ pointerEvents: 'auto' }}
                                      onClick={() => setEditingPlaceIndex(globalIdx)}
                                      role="button"
                                      tabIndex={0}
                                      onKeyDown={(e) => e.key === 'Enter' && setEditingPlaceIndex(globalIdx)}
                                      aria-label="Replace place"
                                      title="Replace place"
                                    >
                                      <div className="collage-place-tile">
                                        <img src={place.imageUrl} alt={place.name} className="collage-place-img" />
                                      </div>
                                      <span className="activity-edit-icon" aria-hidden="true">✂</span>
                                    </div>
                                  );
                                })}
                              </div>
                            )
                          ))}
                        </div>
                      )}
                      </div>{/* end collage-poster-area */}
                      {/* Activity (emoji) replace picker – same shell as YOUR STUFF editor */}
                      {editingActivityIndex !== null && createPortal(
                        <div className="brand-picker-overlay" onClick={closeActivityPicker}>
                          <div
                            className="brand-picker-popover brand-picker-popover--stuff-editor"
                            onClick={e => e.stopPropagation()}
                          >
                            <button type="button" className="cart-popup-close" onClick={closeActivityPicker} aria-label="Close">×</button>
                            <div className="inline-survey-content brand-picker-survey-body">
                              <h2 className="survey-question brand-picker-stuff-title">YOUR EMOJI</h2>
                              {typeof selectedActivities[editingActivityIndex] === 'string' && (
                                <div className="brand-picker-current-brand-wrap">
                                  <div
                                    className={`activity-emoji-wrapper collage-activity-tile brand-picker-current-activity-preview brand-picker-current-activity-preview--tile-${(editingActivityIndex % 3) + 1}`}
                                    role="img"
                                    aria-label={selectedActivities[editingActivityIndex]}
                                  >
                                    <div
                                      className="activity-emoji"
                                      style={{
                                        fontSize:
                                          activityImageStylesByIndex.get(editingActivityIndex)?.fontSize ||
                                          '3.2rem',
                                      }}
                                    >
                                      {selectedActivities[editingActivityIndex]}
                                    </div>
                                  </div>
                                </div>
                              )}
                              <p className="survey-subtitle brand-picker-stuff-change-line">change to:</p>
                              <div className="survey-checkbox-group brand-picker-stuff-grid">
                                {(activityPickerSearchResults.length > 0 ? activityPickerSearchResults : activityPickerGrid).map((emoji, gridIdx) => (
                                  <button
                                    key={`${emoji}-${gridIdx}`}
                                    type="button"
                                    className="survey-checkbox-option activities-option"
                                    onClick={() => {
                                      setSelectedActivities((prev) => {
                                        const next = [...prev];
                                        next[editingActivityIndex] = emoji;
                                        return next;
                                      });
                                      closeActivityPicker();
                                    }}
                                    aria-label={`Select ${emoji}`}
                                  >
                                    {emoji}
                                  </button>
                                ))}
                                <button
                                  type="button"
                                  className="survey-checkbox-option survey-add-custom"
                                  onClick={handleActivityPickerMoreOptions}
                                  aria-label="More emoji options"
                                >
                                  MORE OPTIONS
                                </button>
                                <div
                                  className={`brand-picker-search-prompt-slot${showActivityPickerSearch ? ' brand-picker-search-prompt-slot--search' : ''}`}
                                  aria-hidden={activityPickerMoreClickCount < 2}
                                >
                                  {activityPickerMoreClickCount >= 2 && !showActivityPickerSearch && (
                                    <button
                                      type="button"
                                      className="brand-search-prompt"
                                      onClick={() => {
                                        setShowActivityPickerSearch(true);
                                        setActivityPickerSearchQuery('');
                                        setActivityPickerSearchResults([]);
                                        setActivityPickerSearchEmpty(false);
                                      }}
                                    >
                                      Nothing you like? Tap here to search!
                                    </button>
                                  )}
                                  {showActivityPickerSearch && (
                                    <div className="brand-search-container brand-picker-stuff-inline-search">
                                      <form
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          const q = activityPickerSearchQuery.trim();
                                          if (!q) return;
                                          const results = searchActivityPlusEmojisByQuery(q, 9);
                                          setActivityPickerSearchResults(results);
                                          setActivityPickerSearchEmpty(results.length === 0);
                                        }}
                                      >
                                        <input
                                          type="text"
                                          className="brand-search-input"
                                          placeholder="Search emojis..."
                                          value={activityPickerSearchQuery}
                                          onChange={(e) => {
                                            setActivityPickerSearchQuery(e.target.value);
                                            setActivityPickerSearchResults([]);
                                            setActivityPickerSearchEmpty(false);
                                          }}
                                          ref={focusPopupInputOnMount}
                                          aria-label="Search emojis by keyword"
                                        />
                                      </form>
                                      {activityPickerSearchEmpty && activityPickerSearchResults.length === 0 && (
                                        <p className="brand-picker-stuff-search-empty" role="status">
                                          No emojis matched. Try different words.
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>,
                        document.body
                      )}
                      {/* Place replace picker — same shell as YOUR STUFF / YOUR EMOJI; MORE OPTIONS + search like InlineSurvey places step */}
                      {editingPlaceIndex !== null && createPortal(
                        <div className="brand-picker-overlay" onClick={() => { if (!placePickerSearchLoading) closePlacePicker(); }}>
                          <div
                            className="brand-picker-popover brand-picker-popover--stuff-editor"
                            onClick={e => e.stopPropagation()}
                          >
                            <button type="button" className="cart-popup-close" onClick={() => { if (!placePickerSearchLoading) closePlacePicker(); }} aria-label="Close">×</button>
                            <div className="inline-survey-content brand-picker-survey-body">
                              <h2 className="survey-question brand-picker-stuff-title">YOUR PLACE</h2>
                              {selectedPlaces[editingPlaceIndex] && (
                                <div className="brand-picker-current-brand-wrap">
                                  <div
                                    className={`survey-checkbox-option brand-option place-option brand-picker-current-place brand-picker-current-place--tile-${(editingPlaceIndex % 3) + 1}`}
                                    role="img"
                                    aria-label={selectedPlaces[editingPlaceIndex].name || 'Current place'}
                                  >
                                    <img
                                      src={selectedPlaces[editingPlaceIndex].imageUrl}
                                      alt={selectedPlaces[editingPlaceIndex].name || ''}
                                      className="place-option-img"
                                    />
                                  </div>
                                </div>
                              )}
                              <p className="survey-subtitle brand-picker-stuff-change-line">change to:</p>
                              <div className="survey-checkbox-group brand-picker-stuff-grid">
                                {(placePickerSearchResults.length > 0 ? placePickerSearchResults : placePickerGrid).map((place, gridIdx) => (
                                  <button
                                    key={place.id || `place-grid-${gridIdx}`}
                                    type="button"
                                    className="survey-checkbox-option brand-option place-option"
                                    onClick={() => {
                                      setSelectedPlaces((prev) => {
                                        const next = [...prev];
                                        next[editingPlaceIndex] = place;
                                        return next;
                                      });
                                      closePlacePicker();
                                    }}
                                    aria-label={place.name || 'Select place'}
                                  >
                                    <img src={place.imageUrl} alt={place.name || ''} className="place-option-img" />
                                  </button>
                                ))}
                                <button
                                  type="button"
                                  className={`survey-checkbox-option survey-add-custom${placePickerSearchLoading ? ' brand-picker-more-options--loading' : ''}`}
                                  onClick={handlePlacePickerMoreOptions}
                                  disabled={placePickerSearchLoading}
                                  aria-busy={placePickerSearchLoading}
                                  aria-label={placePickerSearchLoading ? 'Searching the web' : 'More place options'}
                                >
                                  {placePickerSearchLoading ? 'Searching the web...' : 'MORE OPTIONS'}
                                </button>
                                <div
                                  className={`brand-picker-search-prompt-slot${showPlacePickerSearch ? ' brand-picker-search-prompt-slot--search' : ''}`}
                                  aria-hidden={placePickerMoreClickCount < 2}
                                >
                                  {placePickerMoreClickCount >= 2 && !showPlacePickerSearch && (
                                    <button
                                      type="button"
                                      className="brand-search-prompt"
                                      onClick={() => {
                                        setShowPlacePickerSearch(true);
                                        setPlacePickerSearchQuery('');
                                        setPlacePickerSearchResults([]);
                                        setPlacePickerSearchDone(false);
                                      }}
                                    >
                                      Nothing you like? Tap here to search!
                                    </button>
                                  )}
                                  {showPlacePickerSearch && (
                                    <div className="brand-search-container brand-picker-stuff-inline-search">
                                      <form
                                        onSubmit={async (e) => {
                                          e.preventDefault();
                                          if (!placePickerSearchQuery.trim() || placePickerSearchLoading) return;
                                          setPlacePickerSearchLoading(true);
                                          setPlacePickerSearchDone(false);
                                          try {
                                            const results = await searchPlaces(placePickerSearchQuery.trim());
                                            const list = Array.isArray(results) ? results : [];
                                            setPlacePickerSearchResults(list);
                                          } catch (err) {
                                            console.error('Place search error:', err);
                                            setPlacePickerSearchResults([]);
                                          } finally {
                                            setPlacePickerSearchLoading(false);
                                            setPlacePickerSearchDone(true);
                                          }
                                        }}
                                      >
                                        <input
                                          type="text"
                                          className="brand-search-input"
                                          placeholder="Search for a place..."
                                          value={placePickerSearchQuery}
                                          onChange={(e) => {
                                            setPlacePickerSearchQuery(e.target.value);
                                            setPlacePickerSearchResults([]);
                                            setPlacePickerSearchDone(false);
                                          }}
                                          ref={focusPopupInputOnMount}
                                          aria-label="Search for a place"
                                        />
                                      </form>
                                      {placePickerSearchDone && !placePickerSearchLoading && placePickerSearchResults.length === 0 && (
                                        <p className="brand-picker-stuff-search-empty" role="status">
                                          No places found
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>,
                        document.body
                      )}
                      {/* Brand replace picker – render via portal so it appears above Save/Find buttons */}
                      {editingSwagIndex !== null && createPortal(
                        <div className="brand-picker-overlay" onClick={() => { if (!brandSearchLoading) closeBrandPicker(); }}>
                          <div
                            className="brand-picker-popover brand-picker-popover--stuff-editor"
                            onClick={e => e.stopPropagation()}
                          >
                            <button type="button" className="cart-popup-close" onClick={() => { if (!brandSearchLoading) closeBrandPicker(); }} aria-label="Close">×</button>
                            <div className="inline-survey-content brand-picker-survey-body">
                              <h2 className="survey-question brand-picker-stuff-title">YOUR STUFF</h2>
                              {selectedSwags[editingSwagIndex] && (
                                <div className="brand-picker-current-brand-wrap">
                                  <div
                                    className={`survey-checkbox-option brand-option brand-picker-current-brand brand-picker-current-brand--swag-${(editingSwagIndex % 3) + 1}`}
                                    style={{ backgroundImage: `url('${selectedSwags[editingSwagIndex].imageUrl}')` }}
                                    role="img"
                                    aria-label={selectedSwags[editingSwagIndex].name || 'Current item'}
                                  />
                                </div>
                              )}
                              <p className="survey-subtitle brand-picker-stuff-change-line">change to:</p>
                              <div className="survey-checkbox-group brand-picker-stuff-grid">
                                {(brandSearchResults.length > 0 ? brandSearchResults : brandPickerOptions).map((brand, gridIdx) => (
                                  <button
                                    key={brand.id || `grid-${gridIdx}`}
                                    type="button"
                                    className="survey-checkbox-option brand-option"
                                    style={{ backgroundImage: `url('${brand.imageUrl}')` }}
                                    onClick={() => {
                                      setSelectedSwags((prev) => {
                                        const next = [...prev];
                                        next[editingSwagIndex] = { imageUrl: brand.imageUrl, name: brand.name, id: brand.id };
                                        return next;
                                      });
                                      closeBrandPicker();
                                    }}
                                    aria-label={brand.name}
                                  />
                                ))}
                                <button
                                  type="button"
                                  className={`survey-checkbox-option survey-add-custom${brandSearchLoading ? ' brand-picker-more-options--loading' : ''}`}
                                  onClick={handleBrandPickerMoreOptions}
                                  disabled={brandSearchLoading}
                                  aria-busy={brandSearchLoading}
                                  aria-label={brandSearchLoading ? 'Searching the web' : 'More brand options'}
                                >
                                  {brandSearchLoading ? 'Searching the web...' : 'MORE OPTIONS'}
                                </button>
                                <div
                                  className={`brand-picker-search-prompt-slot${showBrandSearch ? ' brand-picker-search-prompt-slot--search' : ''}`}
                                  aria-hidden={brandPickerMoreClickCount < 2}
                                >
                                  {brandPickerMoreClickCount >= 2 && !showBrandSearch && (
                                    <button
                                      type="button"
                                      className="brand-search-prompt"
                                      onClick={() => {
                                        setShowBrandSearch(true);
                                        setBrandSearchQuery('');
                                        setBrandSearchResults([]);
                                        setBrandPickerSearchEmpty(false);
                                      }}
                                    >
                                      Nothing you like? Tap here to search!
                                    </button>
                                  )}
                                  {showBrandSearch && (
                                    <div className="brand-search-container brand-picker-stuff-inline-search">
                                      <form
                                        onSubmit={async (e) => {
                                          e.preventDefault();
                                          if (!brandSearchQuery.trim() || brandSearchLoading) return;
                                          setBrandSearchLoading(true);
                                          setBrandPickerSearchEmpty(false);
                                          try {
                                            const results = await searchBrandImages(brandSearchQuery.trim());
                                            setBrandSearchResults(results);
                                            setBrandPickerSearchEmpty(results.length === 0);
                                          } catch (err) {
                                            console.error('Brand search error:', err);
                                            setBrandSearchResults([]);
                                            setBrandPickerSearchEmpty(true);
                                          } finally {
                                            setBrandSearchLoading(false);
                                          }
                                        }}
                                      >
                                        <input
                                          type="text"
                                          className="brand-search-input"
                                          placeholder="Search for any item..."
                                          value={brandSearchQuery}
                                          onChange={(e) => setBrandSearchQuery(e.target.value)}
                                          ref={focusPopupInputOnMount}
                                        />
                                      </form>
                                      {brandPickerSearchEmpty && !brandSearchLoading && brandSearchResults.length === 0 && (
                                        <p className="brand-picker-stuff-search-empty" role="status">
                                          No images found. Try different words.
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>,
                        document.body
                      )}
                    </>
                  )}

                </div>

                {/* Heart photo upload modal - change photo inside the heart */}
                {showHeartPhotoUpload && (
                  <div className="heart-photo-upload-overlay" onClick={() => {
                    if (!heartPhotoUploading) {
                      removeHeartPhoto();
                      setShowHeartGifGrid(false);
                      setShowHeartPhotoUpload(false);
                    }
                  }} role="dialog" aria-modal="true" aria-labelledby="heart-photo-upload-title">
                    <div className="heart-photo-upload-modal" onClick={(e) => e.stopPropagation()}>
                      <h2 id="heart-photo-upload-title" className="heart-photo-upload-title">AURA GIF</h2>
                      {surveyAnswers?.vibe_photo && !heartPhotoPreview && (
                        <div className="heart-photo-upload-current">
                          <img src={surveyAnswers.vibe_photo} alt="Current vibe" className="heart-photo-upload-current-img" />
                          <img src={klipyLogo} alt="KLIPY" className="spirit-gif-klipy-watermark" />
                        </div>
                      )}
                      {!showHeartGifGrid ? (
                        <div className="heart-photo-upload-area">
                          <button
                            type="button"
                            className="heart-photo-upload-button"
                            onClick={() => {
                              const customerId = currentUser?.uid || 'anonymous';
                              searchSpiritGifs('warmup', customerId).catch(() => {});
                              setHeartGifs(getRandomMoodLocalGifs(9));
                              setHeartGifSearch('');
                              setShowHeartGifGrid(true);
                            }}
                          >
                            <span>{surveyAnswers?.vibe_photo ? 'CHANGE GIF' : 'CHOOSE GIF'}</span>
                          </button>
                        </div>
                      ) : (
                        <div className="heart-gif-picker">
                          <div className="heart-gif-grid">
                            {(loadingHeartGifs
                              ? (heartGifs.length > 0
                                  ? heartGifs.map(g => ({ ...g, placeholder: true }))
                                  : Array.from({ length: 9 }, (_, i) => ({ id: `ph-${i}`, placeholder: true })))
                              : heartGifs
                            ).map((gif) => {
                              if (gif.placeholder) {
                                return <div key={gif.id} className="heart-gif-tile heart-gif-placeholder" />;
                              }
                              return (
                                <button
                                  key={gif.id}
                                  className="heart-gif-tile"
                                  onClick={() => {
                                    setSurveyAnswers((prev) => (prev ? { ...prev, vibe_photo: gif.fullUrl || gif.gifUrl } : { vibe_photo: gif.fullUrl || gif.gifUrl }));
                                    setShowHeartGifGrid(false);
                                    setShowHeartPhotoUpload(false);
                                  }}
                                >
                                  <span className="heart-gif-spinner" />
                                  <img
                                    src={gif.stillUrl || gif.gifUrl}
                                    alt={gif.title}
                                    className="heart-gif-tile-img"
                                    loading="lazy"
                                    onLoad={(e) => {
                                      e.target.parentElement.querySelector('.heart-gif-spinner')?.classList.add('hidden');
                                      if (gif.stillUrl && e.target.src !== gif.gifUrl) {
                                        e.target.src = gif.gifUrl;
                                      }
                                    }}
                                  />
                                </button>
                              );
                            })}
                          </div>
                          <div className="heart-gif-search-wrap">
                            <input
                              type="text"
                              className="heart-gif-search-input"
                              placeholder="Search KLIPY GIFs..."
                              value={heartGifSearch}
                              onChange={(e) => setHeartGifSearch(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter' && heartGifSearch.trim()) fetchHeartGifs(heartGifSearch.trim());
                              }}
                            />
                            <button
                              className="heart-gif-search-btn"
                              onClick={() => { if (heartGifSearch.trim()) fetchHeartGifs(heartGifSearch.trim()); }}
                              disabled={!heartGifSearch.trim() || loadingHeartGifs}
                            >
                              SEARCH
                            </button>
                          </div>
                        </div>
                      )}
                      <button
                        type="button"
                        className="heart-photo-upload-close"
                        onClick={() => {
                        if (!heartPhotoUploading) {
                          removeHeartPhoto();
                          setShowHeartGifGrid(false);
                          setShowHeartPhotoUpload(false);
                        }
                      }}
                        aria-label="Close"
                      >
                        ‹
                      </button>
                    </div>
                  </div>
                )}

                {/* Edit partner cutout modal */}
                {showEditCutoutModal && (
                  <div className="edit-cutout-modal-overlay" onClick={() => !isEditingCutout && setShowEditCutoutModal(false)} role="dialog" aria-modal="true" aria-labelledby="edit-cutout-title">
                    <div className="edit-cutout-modal" onClick={(e) => e.stopPropagation()}>
                      <button type="button" className="cart-popup-close" onClick={() => !isEditingCutout && setShowEditCutoutModal(false)} disabled={isEditingCutout} aria-label="Close">×</button>
                      <h2 id="edit-cutout-title" className="edit-cutout-modal-title">Edit cutout</h2>
                      <p className="edit-cutout-modal-description">How would you like to change your love&apos;s cutout?</p>
                      {!currentUser && (
                        <p className="edit-cutout-modal-limit" aria-live="polite">
                          {editCountForGuest} of {EDIT_CUTOUT_LIMIT_GUEST} edits used this session. Sign up for more.
                        </p>
                      )}
                      <form onSubmit={handleEditCutoutSubmit}>
                        <textarea
                          className="edit-cutout-textarea"
                          value={editCutoutInput}
                          onChange={(e) => setEditCutoutInput(e.target.value)}
                          placeholder="e.g. more adventurous vibe, wear a leather jacket, more casual style"
                          rows={3}
                          disabled={isEditingCutout || (!currentUser && editCountForGuest >= EDIT_CUTOUT_LIMIT_GUEST)}
                          ref={focusPopupInputOnMount}
                        />
                        {editCutoutError && <p className="edit-cutout-error">{editCutoutError}</p>}
                        <div className="edit-cutout-modal-actions">
                          <button type="submit" className="edit-cutout-submit" disabled={isEditingCutout || !editCutoutInput.trim() || (!currentUser && editCountForGuest >= EDIT_CUTOUT_LIMIT_GUEST)}>
                            {isEditingCutout ? `${PARTNER_CUTOUT_HINT_MESSAGES[editCutoutHintIndex]}…` : 'Apply'}
                          </button>
                          <button type="button" className="edit-cutout-cancel" onClick={() => setShowEditCutoutModal(false)} disabled={isEditingCutout}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {/* Cutout photo re-upload popup */}
                {showCutoutReupload && (
                  <div
                    className="edit-cutout-modal-overlay"
                    onClick={() => {
                      if (!cutoutReuploadUploading && !cutoutReuploadProcessing && !cutoutReuploadConfirming) closeCutoutReupload();
                    }}
                    role="dialog"
                    aria-modal="true"
                  >
                    <div className="edit-cutout-modal" onClick={(e) => e.stopPropagation()}>
                      <button
                        type="button"
                        className="cart-popup-close"
                        onClick={() => {
                          if (!cutoutReuploadUploading && !cutoutReuploadProcessing && !cutoutReuploadConfirming) closeCutoutReupload();
                        }}
                        disabled={cutoutReuploadUploading || cutoutReuploadProcessing || cutoutReuploadConfirming}
                        aria-label="Close"
                      >
                        ×
                      </button>
                      <h2 className="edit-cutout-modal-title">Upload your photo</h2>
                      <p className="edit-cutout-modal-description">We&apos;ll add a fox mask for privacy</p>
                      {cutoutReuploadEditedUrl ? (
                        <div className="user-photo-popup-confirm-wrap">
                          <img
                            src={cutoutReuploadEditedUrl}
                            alt="Your photo with fox mask"
                            className="user-photo-popup-edited"
                          />
                          <div className="user-photo-popup-confirm-actions">
                            <button
                              type="button"
                              className="user-photo-popup-confirm-btn"
                              onClick={() => { void confirmCutoutReuploadPhoto(); }}
                              disabled={cutoutReuploadConfirming}
                            >
                              {cutoutReuploadConfirming ? 'Saving…' : 'USE THIS'}
                            </button>
                            <button
                              type="button"
                              className="user-photo-popup-try-again-btn"
                              onClick={retryCutoutReuploadPhoto}
                              disabled={cutoutReuploadConfirming}
                            >
                              Try different photo
                            </button>
                          </div>
                        </div>
                      ) : !cutoutReuploadPreview ? (
                        <div className="user-photo-popup-upload-area">
                          <input
                            ref={cutoutReuploadInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleCutoutReuploadSelect}
                            id="cutout-reupload-input"
                            className="user-photo-popup-input"
                          />
                          <label htmlFor="cutout-reupload-input" className="user-photo-popup-upload-button">
                            <span>Choose Photo</span>
                          </label>
                          <p className="user-photo-popup-hint">Max 15MB</p>
                        </div>
                      ) : (
                        <div className="user-photo-popup-preview-wrap">
                          <div className="user-photo-popup-preview-container">
                            <img src={cutoutReuploadPreview} alt="Preview" className="user-photo-popup-preview" />
                            {!cutoutReuploadUploading && !cutoutReuploadProcessing && (
                              <button
                                type="button"
                                className="user-photo-popup-remove"
                                onClick={() => { setCutoutReuploadFile(null); setCutoutReuploadPreview(null); if (cutoutReuploadInputRef.current) cutoutReuploadInputRef.current.value = ''; }}
                                aria-label="Remove image"
                              >
                                ×
                              </button>
                            )}
                          </div>
                          <div className="edit-cutout-modal-actions edit-cutout-modal-actions--single">
                            <button
                              type="button"
                              className="edit-cutout-submit"
                              onClick={handleCutoutReuploadSubmit}
                              disabled={cutoutReuploadUploading || cutoutReuploadProcessing}
                            >
                              {cutoutReuploadUploading || cutoutReuploadProcessing
                                ? CUTOUT_REUPLOAD_HINTS[cutoutReuploadHintIndex]
                                : 'Upload'}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {(isShowingAnimation || isImageGenerated || currentGeneratedImage || selectedPartnerCutout) && (
                  <>
                    {surveyCompleted && (
                      <div className="action-buttons-container">
                        {friendCollageCopyActive ? (
                          <>
                            <div className="action-buttons-row">
                              <button
                                className="action-button share-button"
                                style={{ flex: 'none', minWidth: 0, paddingLeft: '4.5rem', paddingRight: '4.5rem', paddingTop: '1rem', paddingBottom: '1rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', whiteSpace: 'nowrap' }}
                                type="button"
                                disabled={isSavingPoster}
                                onClick={async () => {
                                  if (isSavingPoster) return;
                                  await handleSaveClick({ forFriendShareReferral: true });
                                }}
                              >
                                {isSavingPoster ? 'SAVING…' : 'SEND TO FRIEND'}
                              </button>
                            </div>
                            <p className="poster-collage-hint">send to friend and get a free spin</p>
                          </>
                        ) : showSessionFoxMaskPlaceholder ? (
                          <div className="action-buttons-row">
                            <button
                              className="action-button share-button"
                              style={{ flex: 'none', minWidth: 0, paddingLeft: '4.5rem', paddingRight: '4.5rem', paddingTop: '1rem', paddingBottom: '1rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', whiteSpace: 'nowrap' }}
                              type="button"
                              onClick={() => {
                                setShowCutoutReupload(true);
                              }}
                            >
                              UPLOAD PHOTO
                            </button>
                          </div>
                        ) : savedPosters.length > 0 ? (
                          <>
                            <div className="action-buttons-row">
                              <button
                                className="action-button share-button"
                                style={{ flex: 'none', minWidth: 0, paddingLeft: '5.5rem', paddingRight: '5.5rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap' }}
                                onClick={() => {
                                  setEditingFeedAdId(null);
                                  setEditingSavedPosterId(null);
                                  setSuppressPrimaryLuvIconsOnEditorCanvas(false);
                                  setCurrentPosterAlreadySaved(false);
                                  setSavedPosterForPopup(null);
                                  handleSaveClick();
                                }}
                                disabled={isSavingPoster}
                              >
                                {isSavingPoster ? 'SAVING...' : 'SAVE'}
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="action-buttons-row">
                              <button
                                className="action-button share-button"
                                style={{ flex: 'none', minWidth: 0, paddingLeft: '4.5rem', paddingRight: '4.5rem', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={handleSaveClick}
                                disabled={isSavingPoster}
                              >
                                {isSavingPoster ? 'SAVING...' : 'Save'}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
              </div>
              {!showInlineSurvey && !surveyCompleted && (
                <>
                  <div ref={heroAuraZoneRef} className="homepage-hero-aura-zone">
                    <HeroMatrixAura
                      auraZoneRef={heroAuraZoneRef}
                      showIcon={false}
                      showLabel={false}
                      showCloud={false}
                    />
                    <button
                      ref={heroStartBtnRef}
                      className="poster-collage-btn poster-collage-btn--hero-start"
                      onClick={openSelfFoxChat}
                    >
                      START
                    </button>
                    <p className="hero-start-hint">
                      unmask if you vibe
                    </p>
                  </div>
                  <div className="poster-collage-row">
                    <img
                      src={magazinePair.left.src}
                      alt=""
                      className="poster-collage-magazine"
                      style={{ transform: `rotate(${magazinePair.left.rot}deg) translateX(${magazinePair.left.dx}px)` }}
                    />
                    <img src={scissorsImage} alt="" className="poster-collage-scissors poster-collage-scissors-left" style={{ transform: `scaleX(-1) scaleY(-1) rotate(${scissorsOffset.left.rot}deg) translate(${scissorsOffset.left.dx}px, ${scissorsOffset.left.dy}px)` }} />
                    <button
                      type="button"
                      className="poster-collage-fox-btn"
                      onClick={openSelfFoxChat}
                      aria-label="Start collage"
                    >
                      <img src={theFoxMini} alt="" className="poster-collage-fox-icon" aria-hidden />
                    </button>
                    <img src={scissorsImage} alt="" className="poster-collage-scissors poster-collage-scissors-right" style={{ transform: `scaleY(-1) rotate(${scissorsOffset.right.rot}deg) translate(${scissorsOffset.right.dx}px, ${scissorsOffset.right.dy}px)` }} />
                    <img
                      src={magazinePair.right.src}
                      alt=""
                      className="poster-collage-magazine"
                      style={{ transform: `rotate(${magazinePair.right.rot}deg) translateX(${magazinePair.right.dx}px)` }}
                    />
                  </div>
                </>
              )}
          </>
          )}
        </div>

        {/* Section Divider */}
        <div className="wanted-section-divider"></div>

        {/* FRIEND & ROMANTIC MATCHING + SAFETY — hidden while viewing Your collages on the main page */}
        {!showMyCollagesInline && (
        <>
        <section className="trade-foxes-section trade-foxes-section--fox-love">
          <h3 className="trade-foxes-title">IT STARTS BEFORE WORDS</h3>
          <div className="earn-foxes-subtitle-row">
            <div className="earn-foxes-subtitle-text">
              <button
                type="button"
                className="earn-foxes-subtitle earn-foxes-dinner-intro earn-foxes-dinner-intro--plain earn-foxes-dinner-intro-btn"
                onClick={openSelfFoxChat}
              >
                we analyze your visual aesthetics to predict a vibe match
              </button>
            </div>
          </div>
          <div className="earn-foxes-subtitle-row">
            <div className="earn-foxes-subtitle-text">
              <VibeAuraVadSpace onClick={openSelfFoxChat} />
              <button
                type="button"
                className="trade-foxes-give-btn vibe-fox-get-btn"
                onClick={openSelfFoxChat}
              >
                GET A FOX
              </button>
              <div className="vibe-fox-get-hint">
                <p className="earn-foxes-subtitle vibe-fox-get-hint-line">
                  run your vibe fox on friends to see their vibe{' '}
                  <span className="vibe-fox-get-hint-line-break">or get matched with new people</span>
                </p>
                <div className="vibe-fox-get-hint-line vibe-fox-get-hint-line--verified">
                  <p className="earn-foxes-subtitle vibe-fox-get-hint-verified-title">
                    <button
                      type="button"
                      className="vibe-fox-get-hint-verified-title-btn"
                      onClick={() => setShowVerifiedUniversitiesPopup(true)}
                    >
                      <span className="vibe-fox-get-hint-verified-title-inner">
                        <span className="vibe-fox-get-hint-check" aria-hidden="true">✓</span>
                        All matches are .edu-verified{' '}
                        <span className="vibe-fox-get-hint-verified-title-end">(student or alumni email)</span>
                      </span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {redeemHintMessage && (
          <p className="trade-foxes-hint-message">{redeemHintMessage}</p>
        )}
        </>
        )}

        <div className="wanted-section-divider-bottom"></div>

        {/* Section 2: Wanted Ads Feed – memoized so sample poster 1s rotation doesn't re-render tiles */}
        <WantedAdsFeed
          berkeleyWantedAds={berkeleyWantedAds}
          sfWantedAds={sfWantedAds}
          sfNorthBeachWantedAds={sfNorthBeachWantedAds}
          sfSomaWantedAds={sfSomaWantedAds}
          sfDowntownWantedAds={sfDowntownWantedAds}
          feedCutoutUrls={feedCutoutUrls}
          onTileClick={openFeedTileDetailFromGrid}
          currentUserId={currentUser?.uid ?? null}
          savedPosters={savedPosters}
          onBountyReachOutFromStrip={openBountyReachOutFromStrip}
          onBountyMatchFriendFromStrip={openBountyMatchFriendFromStrip}
          onBountyShareFromStrip={openBountyShareFromStrip}
          onBountyEditFromStrip={openBountyEditFromStrip}
          onWeeklyFeaturedOptInClick={
            currentUser ? openWeeklyFeaturedOptInOrOptOutPopup : undefined
          }
          onShowSignUp={onShowSignUp}
          feedReady={weeklyFeaturedFeedReady}
        />

        <div className="weekly-featured-divider-bottom" aria-hidden="true" />
        <div className="fox-paid-dates-divider-top" aria-hidden="true" />
        <section className="fox-paid-dates-section" id="fox-paid-dates">
          <h3>
            <span className="wanted-ads-feed-title-line">FOX-PAID DATES IN SF</span>
          </h3>
          <PostedSponsoredDateIdeasCarousel
            dateIdeas={postedSponsoredDateIdeas}
            onCardClick={handlePaidForDateExplainerOpen}
            feedReady={postedSponsoredDateIdeasReady}
          />
          <div className="earn-foxes-subtitle-row earn-foxes-bounty-science-row fox-paid-dates-sponsor-row">
            <div className="earn-foxes-subtitle-text">
              <button
                type="button"
                className="earn-foxes-subtitle earn-foxes-dinner-intro earn-foxes-dinner-intro-btn"
                onClick={openSponsoredDateIdeaPopup}
              >
                {'submit your date idea and get it '}
                <span className="earn-foxes-dinner-intro-btn-inline-end">
                  sponsored
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="earn-foxes-matcha-arrow earn-foxes-dinner-intro-btn-arrow" aria-hidden><path d="M7 17 17 7M7 7h10v10" /></svg>
                </span>
              </button>
            </div>
          </div>
        </section>
        <div className="fox-paid-dates-divider-bottom" aria-hidden="true" />

        {/* FAQ — collapsible accordion under FIVE PRIZES on #FAF8F5 fill. Uses native <details>/<summary> for accessibility (keyboard + screen reader) by default. */}
        <section className="homepage-faq-section" id="homepage-faq">
          <h3 className="homepage-faq-title">FAQ</h3>
          <div className="homepage-faq-list">
            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">How do I start?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Pick brands, places, emojis, GIFs &mdash; all the little things that feel
                  {' '}
                  &ldquo;so you.&rdquo;
                </p>
                <p className="homepage-faq-answer">
                  Decide if you&apos;re looking for friends or romance, and Vibe Fox will find you a match based on the visual-vibe transformer analysis.
                </p>
                <p className="homepage-faq-answer">
                  We use your .edu email as a reliable way to confirm you are a real person before you get matched.
                </p>
                <button
                  type="button"
                  className="homepage-faq-create-collage-btn homepage-faq-answer-flourish"
                  onClick={openSelfFoxChat}
                >
                  Create your profile
                  <span className="earn-foxes-dinner-intro-btn-inline-end">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="earn-foxes-matcha-arrow earn-foxes-dinner-intro-btn-arrow"
                      aria-hidden
                    >
                      <path d="M7 17 17 7M7 7h10v10" />
                    </svg>
                  </span>
                </button>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  What&apos;s the visual-vibe transformer (VVTF)?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Rather than using an LLM, we developed our own Visual-Vibe Transformer that translates visuals into emotional coordinates to predict a match.
                </p>
                <p className="homepage-faq-answer">
                  Because up to 90% of human communication is non-verbal.
                </p>
                <p className="homepage-faq-answer">
                  The visuals you pick predict the unique color of your vibe cloud.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">VVTF vs LLMs</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  LLMs predict words. VVTF predicts vibes.
                </p>
                <div className="homepage-faq-table-wrap">
                  <table className="homepage-faq-table">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col">
                          Large Language Models
                          <br />
                          (LLMs)
                        </th>
                        <th scope="col">
                          Visual Vibe Transformer
                          <br />
                          (VVTF)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row"><span className="homepage-faq-table-rowlabel">Matching</span></th>
                        <td>e.g., &ldquo;What would people on Reddit and Quora say about these two profiles based on the text descriptions?&rdquo;</td>
                        <td>e.g., &ldquo;How would the emotional vibe evolve between these two people based on their visual choices?&rdquo;</td>
                      </tr>
                      <tr>
                        <th scope="row"><span className="homepage-faq-table-rowlabel">Output</span></th>
                        <td>text descriptions / judgments</td>
                        <td>emotional trajectories in Valence&ndash;Arousal&ndash;Dominance (VAD+) coordinates</td>
                      </tr>
                      <tr>
                        <th scope="row"><span className="homepage-faq-table-rowlabel">Methodology</span></th>
                        <td>translate user profiles and conversations into text and use an LLM to infer compatibility</td>
                        <td>map user visuals to emotional embeddings and use VVTF to infer compatibility</td>
                      </tr>
                      <tr>
                        <th scope="row"><span className="homepage-faq-table-rowlabel">Limitations</span></th>
                        <td>assumes words are enough to describe and understand emotions</td>
                        <td>assumes there is an underlying structure to how emotions relate to each other and evolve</td>
                      </tr>
                      <tr>
                        <th scope="row"><span className="homepage-faq-table-rowlabel">Persona</span></th>
                        <td>The Architect from The Matrix</td>
                        <td>The Oracle from The Matrix</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  My friend referred me to a Weekly Featured profile. What The Fox?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  They&rsquo;re hoping to collect a prize if you match.
                </p>
                <p className="homepage-faq-answer">
                  If you vibe with the profile you were sent, you can reach out by sending them a GIF &mdash;
                  {' '}
                  it&rsquo;s our low&#8209;pressure way of saying &ldquo;hey, i&rsquo;m interested.&rdquo;
                </p>
                <p className="homepage-faq-answer">
                  To celebrate our launch, all Weekly Featured Profiles can pick any Fox-Paid date experience to share with their match.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  I got a vibe match from the VVTF analysis. What do I do next?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  If their profile is giving &ldquo;yes,&rdquo; hit them with a GIF or go straight to unmasking. You can
                  start texting once you both unmask.
                </p>
                <p className="homepage-faq-answer">
                  Also check your rewards page. If you&rsquo;ve got a Fox-Paid date card, you can redeem it for a romantic or friend date experience with your match.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item" hidden>
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  I won $$ for dinner. How do I get it?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Meet someone you vibe with on luv.wtf, then unmask to start texting and plan a date. When you&rsquo;re
                  ready, email{' '}
                  <a href="mailto:contact@luv.wtf" className="homepage-faq-answer-link">
                    contact@luv.wtf
                  </a>{' '}
                  with &ldquo;$$ for dinner.&rdquo; We&rsquo;ll set you up at your fave campus spot.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  Who pays for the Fox-Paid Dates?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  LuvWTF does &mdash; straight out of our marketing budget.
                </p>
                <p className="homepage-faq-answer">
                  We looked at the price of social media ads, screamed internally, and decided we&rsquo;d rather give actual
                  humans actual money instead of donating it to the algorithm overlords.
                </p>
                <p className="homepage-faq-answer">
                  If we&rsquo;re choosing between &ldquo;fund a stranger&rsquo;s dinner&rdquo; and &ldquo;boost a post that
                  gets 11 likes,&rdquo; the choice is obvious.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  How does VVTF use profile visuals to predict vibe compatibility?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Each visual you pick &mdash; a brand, a place, a GIF &mdash; signals something deeper than just how it looks.
                </p>
                <p className="homepage-faq-answer">
                  A person choosing Adidas Sambas is not the same as someone choosing 550 Chelseas.
                </p>
                <p className="homepage-faq-answer">
                  We start with visuals because they&rsquo;re the most accurate digital medium for self&#8209;expression, and we infer deeper traits from your visual choices.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">Is this for romantic matching or friend matching?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">Both. You choose your preferences when you sign up.</p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">How do I get matches?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Verify your profile and complete your daily vibe check. You will get a new match every time you complete your vibe check.
                </p>
                <p className="homepage-faq-answer">
                  You&rsquo;ll also see other profiles when friends send you referrals.
                </p>
                <p className="homepage-faq-answer">
                  And you can reach out directly to the SF Featured Packs.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item" hidden>
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">What are the FIVE PRIZES about?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  We post 5 cash prizes at a time in our FIVE PRIZES section. Whenever a prized collage finds a match, we pay the cash prize and pull a new collage at random from the opt&#8209;in pool.
                </p>
                <p className="homepage-faq-answer">
                  All 5 prized collages also get $100 toward dinner with their match.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item" hidden>
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">How can I get the cash prize?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  Refer a friend to a prized collage. If they match and unmask, you get the cash prize.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item" hidden>
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">
                  Can I get a cash prize if I reach out to a prized collage directly instead of referring a friend?
                </span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer-subhead">When you get the cash prize:</p>
                <ul className="homepage-faq-list-bullets">
                  <li>If you refer a friend to a prized collage and they match &amp; unmask, you get the cash prize.</li>
                </ul>
                <p className="homepage-faq-answer-subhead">When you get $100 for dinner:</p>
                <ul className="homepage-faq-list-bullets">
                  <li>If you reach out directly and it&rsquo;s mutual, you get $100 toward a dinner with the person behind the collage.</li>
                  <li>You don&rsquo;t collect the referral cash prize.</li>
                </ul>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">Why the mask?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">To protect your privacy.</p>
                <p className="homepage-faq-answer">
                  VVTF matches your profile based on vibe compatibility, and you decide if/when to show your face to your match. Unmask if you vibe.
                </p>
              </div>
            </details>

            <details className="homepage-faq-item">
              <summary className="homepage-faq-question">
                <span className="homepage-faq-question-text">Why the fox?</span>
                <FaqChevron />
              </summary>
              <div className="homepage-faq-answer-body">
                <p className="homepage-faq-answer">
                  In <em>The Little Prince</em>, The Fox teaches The Little Prince how to make friends.
                </p>
                <p className="homepage-faq-answer">Also:</p>
                <ul className="homepage-faq-list-bullets">
                  <li>Foxes bond for life in the wild.</li>
                  <li>Foxes are social; vixens especially groom, guard, and play with their kin.</li>
                  <li>Foxes can make 40+ different sounds.</li>
                  <li>They use the earth&rsquo;s magnetic field to hunt.</li>
                  <li>Their vocal range spans 5 octaves (Mariah&#8209;level).</li>
                  <li>Their signature chatter is called &ldquo;gekkering.&rdquo;</li>
                  <li>The species name for red foxes is <em>Vulpes Vulpes</em>.</li>
                </ul>
                <p className="homepage-faq-answer">
                  Foxes are symbols of intuition. Across cultures, they represent reading between the lines &mdash; exactly what our VVTF analysis does with visuals.
                </p>
                <a
                  href="/f"
                  className="homepage-faq-create-collage-btn homepage-faq-answer-flourish"
                >
                  To learn more, check out our founder&rsquo;s statement
                  <span className="earn-foxes-dinner-intro-btn-inline-end">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="earn-foxes-matcha-arrow earn-foxes-dinner-intro-btn-arrow"
                      aria-hidden
                    >
                      <path d="M7 17 17 7M7 7h10v10" />
                    </svg>
                  </span>
                </a>
              </div>
            </details>
          </div>
          {/* Site logo (`/icons/logo3.webp`); sizing matched former footer strip. */}
          <div className="homepage-faq-logo-wrap">
            <img
              src={`${process.env.PUBLIC_URL || ''}/icons/logo3.webp`}
              alt="luv.wtf"
              className="homepage-faq-logo"
            />
          </div>
          {/* Same links + classes as footer (`Footer.js` `.footer-legal-row`). */}
          <div className="homepage-faq-legal-wrap" id="homepage-faq-legal">
            <div className="footer-legal-row">
              <a href="mailto:contact@luv.wtf" className="footer-legal-link">contact</a>
              <span className="footer-legal-sep" aria-hidden="true">|</span>
              <a
                href="https://www.instagram.com/luv.vvtf/"
                className="footer-legal-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                instagram
              </a>
              <span className="footer-legal-sep" aria-hidden="true">|</span>
              <a href="/legal" className="footer-legal-link">legal</a>
            </div>
          </div>
        </section>
      </div>
      <Footer onShowSignUp={onShowSignUp} onSignOut={handleNavbarSignOut} currentUser={currentUser} onStartCollage={handleCreateClick} />

      {/* SAVED poster popup – MATCH WITH → intro + MEET PEOPLE (FIND + self gender from nickname popup) */}
      {showSavedPosterPopup && savedPosterForPopup && (
        <div className="cart-popup-overlay saved-poster-popup-overlay" onClick={handleCloseSavedPosterPopup}>
          <div className="cart-popup saved-poster-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={handleCloseSavedPosterPopup} aria-label="Close">×</button>
            <h2 className="saved-poster-popup-title">Saved!</h2>
            <div className="saved-poster-popup-preview-wrap">
              <div className="wanted-poster wanted-poster-feed saved-poster-popup-poster">
                <div className="poster-content">
                  <FeedNicknameTile
                    ad={savedPosterForPopup}
                    savedPosters={savedPosters}
                    currentUserId={currentUser?.uid ?? null}
                    findLuvFlags={posterFindLuvIconFlags(savedPosterForPopup)}
                  />
                  <div className="collage-poster-area collage-poster-area-feed">
                    <div className="partner-swag-container partner-swag-container-feed">
                      <div className="partner-swag-left">
                        {(savedPosterForPopup.swags || []).length > 0 && (
                          <div className="swag-images-left swag-images-left-feed">
                            {(savedPosterForPopup.swags || []).map((swag, swagIndex) => {
                              const swagUrl = swag.imageUrl || swag;
                              if (!swagUrl) return null;
                              const seed = seedFromString(`${savedPosterForPopup.id}-swag-${swagIndex}`);
                              const seedX = seedFromString(`${savedPosterForPopup.id}-swag-x-${swagIndex}`);
                              const rotation = (seed * 30 - 15).toFixed(1);
                              const horizontalOffset = (seedX * 16 - 8).toFixed(1);
                              return (
                                <img
                                  key={swag.id || swagIndex}
                                  src={swagUrl}
                                  alt={swag.name || 'Brand'}
                                  className="swag-image swag-image-feed"
                                  style={{ transform: `rotate(${rotation}deg)`, marginLeft: `${horizontalOffset}px` }}
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div className="partner-swag-center">
                        <div className="partner-swag-center-stack">
                          {(() => {
                            const cutJagged = (() => {
                              const v = 1 + Math.floor(seedFromString(`feed-cutout-${savedPosterForPopup.id}`) * 3);
                              return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                            })();
                            if (showFriendFoxMaskPlaceholder(savedPosterForPopup) && savedPosterForPopup.partnerCutout) {
                              return (
                                <FriendFoxMaskPlaceholderCutout
                                  variant="feed"
                                  jaggedClassName={cutJagged}
                                  heartSrc={
                                    savedPosterForPopup.heartPhotoUrl
                                    || savedPosterForPopup.surveyAnswers?.vibe_photo
                                    || orheartImage
                                  }
                                  heartClassName="partner-cutout-gif-overlay partner-cutout-gif-overlay-feed"
                                />
                              );
                            }
                            if (savedPosterForPopup.partnerCutout) {
                              return (
                                <div className="final-partner-image-wrapper">
                                  <img
                                    src={savedPosterForPopup.partnerCutout}
                                    alt=""
                                    className={`final-partner-image final-partner-image-feed${cutJagged}`}
                                  />
                                  <img
                                    src={
                                      savedPosterForPopup.heartPhotoUrl
                                      || savedPosterForPopup.surveyAnswers?.vibe_photo
                                      || orheartImage
                                    }
                                    alt=""
                                    className="partner-cutout-gif-overlay partner-cutout-gif-overlay-feed"
                                  />
                                </div>
                              );
                            }
                            return (
                              <div
                                className={`final-partner-image final-partner-image-placeholder final-partner-image-feed${cutJagged}`}
                              >
                                {'\uD83D\uDC64'}
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                      <div className="partner-swag-right">
                        <div className="activities-emojis-right feed-tile-activities">
                          {[savedPosterForPopup.activityX, savedPosterForPopup.activityY, savedPosterForPopup.activityZ].filter(Boolean).map((label, i) => {
                            const seed = seedFromString(`${savedPosterForPopup.id}-act-${i}`);
                            const seedX = seedFromString(`${savedPosterForPopup.id}-act-x-${i}`);
                            const rotation = (seed * 24 - 12).toFixed(1);
                            const horizontalOffset = (seedX * 12 - 6).toFixed(1);
                            const hue = 32 + seed * 20;
                            const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                            return (
                              <div
                                key={i}
                                className="activity-tile-outer activity-tile-outer-feed"
                                style={{ transform: `rotate(${rotation}deg)`, marginLeft: `${horizontalOffset}px` }}
                              >
                                <div
                                  className="activity-emoji-wrapper collage-activity-tile"
                                  style={{ background: bgColor }}
                                >
                                  <div className="activity-emoji activity-emoji-feed">
                                    {typeof label === 'string' ? label : (label?.emoji ?? label?.name ?? '')}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    {savedPosterForPopup.places && savedPosterForPopup.places.length > 0 && (
                      <div className="collage-aspirations-row collage-aspirations-row-feed">
                        {[savedPosterForPopup.places.slice(0, Math.floor(seedFromString(`${savedPosterForPopup.id}-places-split`) * 2) + 1), savedPosterForPopup.places.slice(Math.floor(seedFromString(`${savedPosterForPopup.id}-places-split`) * 2) + 1)].map((rowPlaces, rowIdx) => (
                          rowPlaces.length > 0 && (
                            <div key={rowIdx} className="collage-places-row-inner">
                              {rowPlaces.map((place, i) => (
                                <div key={place.id || `${rowIdx}-${i}`} className="aspiration-tile-outer">
                                  <div className="collage-place-tile">
                                    <img src={place.imageUrl} alt={place.name} className="collage-place-img collage-place-img-feed" />
                                  </div>
                                </div>
                              ))}
                            </div>
                          )
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {savedPosterFlowStep === 1 && (
              <>
                {(() => {
                  const { romantic, friend } = posterFindLuvIconFlags(savedPosterForPopup);
                  if (!romantic && !friend) return null;
                  return (
                    <div className="saved-poster-popup-luv-badges saved-poster-popup-luv-badges--above-looking-for-heading" role="list">
                      {romantic ? (
                        <span className="saved-poster-popup-luv-badge saved-poster-popup-luv-badge--romantic" role="listitem">
                          <img src={orheartImage} alt="" className="saved-poster-popup-luv-badge-icon" />
                          <span className="saved-poster-popup-luv-badge-text">ROMANTIC LUV</span>
                        </span>
                      ) : null}
                      {friend ? (
                        <span className="saved-poster-popup-luv-badge saved-poster-popup-luv-badge--friend" role="listitem">
                          <img src={friendsImage} alt="" className="saved-poster-popup-luv-badge-icon saved-poster-popup-luv-badge-icon--friend" />
                          <span className="saved-poster-popup-luv-badge-text">FRIEND LUV</span>
                        </span>
                      ) : null}
                    </div>
                  );
                })()}
                <div className="saved-poster-popup-match-step-heading">
                  <p className="saved-poster-popup-description saved-poster-popup-description--match-step-heading">MEET PEOPLE</p>
                </div>
                <div className="saved-poster-gender-options">
                  <button
                    type="button"
                    className={`saved-poster-gender-btn${savedPosterLookingFor.includes('male') ? ' selected' : ''}`}
                    disabled={savedPosterLookingFor.length >= 3 && !savedPosterLookingFor.includes('male')}
                    onClick={() => toggleSavedPosterLookingFor('male')}
                  >
                    MALE
                  </button>
                  <button
                    type="button"
                    className={`saved-poster-gender-btn${savedPosterLookingFor.includes('female') ? ' selected' : ''}`}
                    disabled={savedPosterLookingFor.length >= 3 && !savedPosterLookingFor.includes('female')}
                    onClick={() => toggleSavedPosterLookingFor('female')}
                  >
                    FEMALE
                  </button>
                  <button
                    type="button"
                    className={`saved-poster-gender-btn${savedPosterLookingFor.includes('nb') ? ' selected' : ''}`}
                    disabled={savedPosterLookingFor.length >= 3 && !savedPosterLookingFor.includes('nb')}
                    onClick={() => toggleSavedPosterLookingFor('nb')}
                  >
                    NB
                  </button>
                </div>
              </>
            )}
            {savedPosterFlowStep === 2 && (
              <>
                <div className="saved-poster-popup-match-step-heading saved-poster-popup-match-step-heading--back-only">
                  <button
                    type="button"
                    className="saved-poster-popup-step-back"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!matchFlowLoading) setSavedPosterFlowStep(1);
                    }}
                    disabled={matchFlowLoading}
                    aria-label="Go back to match with selection"
                  >
                    ‹
                  </button>
                </div>
                <p className="saved-poster-popup-description saved-poster-popup-vibe-intro">
                  Every Tuesday LuvWTF will send you a few intros that match your collage vibe.
                </p>
                {(() => {
                  const { romantic, friend } = posterFindLuvIconFlags(savedPosterForPopup);
                  return (
                    <div className="saved-poster-popup-looking-for-luv">
                      <p className="saved-poster-popup-description saved-poster-popup-looking-for-label">You are looking for:</p>
                      <div className="saved-poster-popup-luv-badges" role="list">
                        {romantic ? (
                          <span className="saved-poster-popup-luv-badge saved-poster-popup-luv-badge--romantic" role="listitem">
                            <img src={orheartImage} alt="" className="saved-poster-popup-luv-badge-icon" />
                            <span className="saved-poster-popup-luv-badge-text">ROMANTIC LUV</span>
                          </span>
                        ) : null}
                        {friend ? (
                          <span className="saved-poster-popup-luv-badge saved-poster-popup-luv-badge--friend" role="listitem">
                            <img src={friendsImage} alt="" className="saved-poster-popup-luv-badge-icon saved-poster-popup-luv-badge-icon--friend" />
                            <span className="saved-poster-popup-luv-badge-text">FRIEND LUV</span>
                          </span>
                        ) : null}
                      </div>
                    </div>
                  );
                })()}
              </>
            )}

            <div className="saved-poster-popup-actions">
              {savedPosterFlowStep === 1 && (
                <button
                  type="button"
                  className="saved-poster-popup-share-btn"
                  disabled={savedPosterLookingFor.length === 0}
                  onClick={() => { void handleSavedPosterLookingForConfirm(); }}
                >
                  CONFIRM
                </button>
              )}
              {savedPosterFlowStep === 2 && (
                <div className="saved-poster-popup-post-wrap">
                  <button
                    type="button"
                    className="saved-poster-popup-share-btn"
                    disabled={matchFlowLoading}
                    onClick={handleSavedPosterMatchClick}
                  >
                    {matchFlowLoading ? 'LOADING...' : 'MEET PEOPLE'}
                  </button>
                  <div className="saved-poster-popup-promote-row">
                    <label
                      className={`saved-poster-popup-promote-inner${matchFlowLoading ? ' saved-poster-popup-promote-inner--disabled' : ''}`}
                      role="checkbox"
                      aria-checked={promoteOnLuvwtfSocialsChecked}
                      tabIndex={matchFlowLoading ? -1 : 0}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (matchFlowLoading) return;
                        setPromoteOnLuvwtfSocialsChecked((prev) => !prev);
                      }}
                      onKeyDown={(e) => {
                        if (matchFlowLoading) return;
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setPromoteOnLuvwtfSocialsChecked((prev) => !prev);
                        }
                      }}
                    >
                      <span
                        className={`saved-poster-popup-promote-check${promoteOnLuvwtfSocialsChecked ? ' checked' : ''}`}
                        aria-hidden="true"
                      >
                        {promoteOnLuvwtfSocialsChecked ? '✓' : ''}
                      </span>
                      <span className="saved-poster-popup-promote-hint">
                        opt into five prizes program and win $100 for dinner
                      </span>
                    </label>
                    <span
                      className="saved-poster-match-help"
                      role="button"
                      tabIndex={0}
                      aria-label="Prize opt-in: $100 dinner — more info"
                      onClick={(e) => {
                        e.stopPropagation();
                        openPromoteOnSocialsExplainer('default');
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          e.stopPropagation();
                          openPromoteOnSocialsExplainer('default');
                        }
                      }}
                    >
                      ?
                    </span>
                  </div>
                </div>
              )}
              {/* Copy link hidden for now; remove saved-poster-popup-copy-btn--hidden to show */}
              <button
                type="button"
                className="saved-poster-popup-copy-btn saved-poster-popup-copy-btn--hidden"
                onClick={handleSavedPosterShare}
              >
                {savedPosterLinkCopied ? 'Copied!' : 'Copy Link'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showVerifiedUniversitiesPopup && (
        <div
          className="cart-popup-overlay vibe-popup-overlay verified-universities-popup-overlay"
          onClick={() => setShowVerifiedUniversitiesPopup(false)}
        >
          <div className="cart-popup vibe-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => setShowVerifiedUniversitiesPopup(false)}
              aria-label="Close"
            >
              ×
            </button>
            <h3 className="match-explainer-title">WE MATCH REAL PEOPLE</h3>
            <p className="vibe-popup-text">
              Anyone is welcome to sign up and see their vibe color, but matching is for verified profiles only.
            </p>
            <p className="vibe-popup-text">
              We use your .edu email as a reliable way to verify you are a real person before you get matched.
            </p>
            <p className="vibe-popup-text">
              More ways to get verified are on the way.
            </p>
            <button
              type="button"
              className="vibe-popup-btn"
              onClick={() => {
                setShowVerifiedUniversitiesPopup(false);
                onShowSignUp?.();
              }}
            >
              SIGN UP
            </button>
          </div>
        </div>
      )}

      <VisualVibeTransformerExplainer
        open={showVisualVibeTransformerExplainer}
        onClose={() => setShowVisualVibeTransformerExplainer(false)}
        signedIn={Boolean(currentUser)}
        onSignUp={onShowSignUp}
      />

      {showPromoteOnSocialsExplainer && (
        <div
          className="cart-popup-overlay vibe-popup-overlay promote-on-socials-explainer-overlay"
          onClick={closePromoteOnSocialsExplainer}
        >
          <div className="cart-popup vibe-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={closePromoteOnSocialsExplainer} aria-label="Close">&times;</button>
            {promoteOnSocialsExplainerVariant === 'participating' ? (
              <>
                <h3 className="match-explainer-title win-100-for-dinner-title">ENROLLED!</h3>
                <p className="vibe-popup-text promote-on-socials-explainer-participating">
                  You opted into our five prizes program. We post five prizes at a time. When a prized
                  collage finds a match, we pay out the cash prize and give the matched pair $100 toward their
                  dinner together.
                  <span className="dinner-participating-followup">
                    Then we pull a new collage at random from the opt{'\u2011'}in pool. If your
                    collage gets picked, we&apos;ll hit you up.
                  </span>
                </p>
              </>
            ) : (
              <>
                <h3 className="match-explainer-title fox-chat-bounty-title">WEEKLY FEATURED OPT-IN</h3>
                <p className="vibe-popup-text">
                  Opt in your profile to be featured on our website for a week. If your profile is selected, get a Fox-Paid date when you match
                </p>
              </>
            )}
            {promoteOnSocialsExplainerVariant === 'participating' &&
            !getPrimarySavedPoster(savedPosters, primaryCollageId) ? (
              <button
                type="button"
                className="vibe-popup-btn"
                onClick={(e) => {
                  closePromoteOnSocialsExplainer();
                  handleCreateClick(e);
                }}
              >
                COLLAGE
              </button>
            ) : promoteOnSocialsExplainerVariant === 'participating' ? (
              <button type="button" className="vibe-popup-btn" onClick={closePromoteOnSocialsExplainer}>
                GOT IT
              </button>
            ) : (
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={
                  promoteOnSocialsExplainerOptInBusy ||
                  matchFlowLoading ||
                  giveawayOptInSaving
                }
                onClick={() => {
                  void handlePromoteOnSocialsExplainerOptInClick();
                }}
              >
                {promoteOnSocialsExplainerOptInBusy || matchFlowLoading || giveawayOptInSaving
                  ? 'SAVING…'
                  : 'OPT IN'}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Computer match update popup */}
      {matchFlowStep === 'privateUpdate' && matchFlowPoster && (
        <div className="cart-popup-overlay vibe-popup-overlay" onClick={handleMatchFlowClose}>
          <div className="cart-popup match-flow-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={handleMatchFlowClose} aria-label="Close">&times;</button>
            <h3 className="match-explainer-title match-flow-sticky-title">UPDATE YOUR PRIMARY COLLAGE?</h3>
            <div className="match-flow-scroll-content">
              <p className="match-flow-label">Current:</p>
              <div className="match-flow-collage-wrap">
                {matchFlowExistingPrivate && renderMatchCollagePreview(matchFlowExistingPrivate, 'old-main')}
              </div>
              <p className="match-flow-label">New:</p>
              <div className="match-flow-collage-wrap">
                {renderMatchCollagePreview(matchFlowPoster, 'new-main')}
              </div>
              <button type="button" className="vibe-popup-btn" disabled={matchFlowLoading} onClick={handlePrivateUpdateConfirm}>
                {matchFlowLoading ? 'Updating...' : 'UPDATE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Draft list: replace primary collage (same layout as computer match update) */}
      {makePrimaryReplaceConfirm && (
        <div
          className="cart-popup-overlay vibe-popup-overlay"
          onClick={() => {
            if (!makePrimaryReplaceLoading) setMakePrimaryReplaceConfirm(null);
          }}
        >
          <div className="cart-popup match-flow-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="cart-popup-close"
              disabled={makePrimaryReplaceLoading}
              onClick={() => {
                if (!makePrimaryReplaceLoading) setMakePrimaryReplaceConfirm(null);
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 className="match-explainer-title match-flow-sticky-title">UPDATE YOUR PRIMARY COLLAGE?</h3>
            <div className="match-flow-scroll-content">
              <p className="match-flow-label">Current:</p>
              <div className="match-flow-collage-wrap">
                {makePrimaryReplaceConfirm.currentPrimary &&
                  renderMatchCollagePreview(makePrimaryReplaceConfirm.currentPrimary, 'list-primary-old')}
              </div>
              <p className="match-flow-label">New:</p>
              <div className="match-flow-collage-wrap">
                {makePrimaryReplaceConfirm.newPrimary &&
                  renderMatchCollagePreview(makePrimaryReplaceConfirm.newPrimary, 'list-primary-new')}
              </div>
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={makePrimaryReplaceLoading}
                onClick={() => { void handleMakePrimaryReplaceConfirm(); }}
              >
                {makePrimaryReplaceLoading ? 'Updating...' : 'UPDATE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Community match update popup */}
      {matchFlowStep === 'communityUpdate' && matchFlowPoster && (
        <div className="cart-popup-overlay vibe-popup-overlay" onClick={handleMatchFlowClose}>
          <div className="cart-popup match-flow-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={handleMatchFlowClose} aria-label="Close">&times;</button>
            <h3 className="match-explainer-title match-flow-sticky-title">UPDATE POSTED COLLAGE</h3>
            <div className="match-flow-scroll-content">
              <p className="match-flow-label">Current:</p>
              <div className="match-flow-collage-wrap">
                {matchFlowExistingPosted && renderMatchCollagePreview(matchFlowExistingPosted, 'old-posted')}
              </div>
              <p className="match-flow-label">New:</p>
              <div className="match-flow-collage-wrap">
                {renderMatchCollagePreview(matchFlowPoster, 'new-posted')}
              </div>
              <button type="button" className="vibe-popup-btn" disabled={matchFlowLoading} onClick={handleCommunityUpdateConfirm}>
                {matchFlowLoading ? 'Updating...' : 'UPDATE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {matchFlowReductionPrompt && matchFlowPoster && (
        <div
          className="cart-popup-overlay vibe-popup-overlay match-flow-reduction-overlay"
          onClick={() => { if (!matchFlowLoading) setMatchFlowReductionPrompt(null); }}
        >
          <div className="cart-popup vibe-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => { if (!matchFlowLoading) setMatchFlowReductionPrompt(null); }}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 className="match-explainer-title">MATCH OPTIONS</h3>
            <p className="vibe-popup-text">
              Your current collage is set for{' '}
              <strong>{matchFlowReductionPrompt.oldLabel}</strong>
              . You chose fewer match options for your new collage.
            </p>
            <div className="match-flow-confirm-actions">
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={matchFlowLoading}
                onClick={handleMatchReductionAddMissing}
              >
                {matchFlowLoading ? 'Updating...' : reductionAddMissingButtonLabel(matchFlowReductionPrompt)}
              </button>
              <button
                type="button"
                className="vibe-popup-btn match-flow-close-btn"
                disabled={matchFlowLoading}
                onClick={handleMatchReductionKeepSelection}
              >
                {matchFlowLoading ? 'Updating...' : 'KEEP MY CHOICE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Match confirmation popup */}
      {matchFlowStep === 'confirm' && matchFlowPoster && (
        <div className="cart-popup-overlay vibe-popup-overlay" onClick={handleMatchFlowClose}>
          <div className="cart-popup vibe-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={handleMatchFlowClose} aria-label="Close">&times;</button>
            <h3
              className={`match-explainer-title${
                !matchFlowConfirmRemoval && matchFlowType !== 'community' && matchFlowType !== 'both'
                  ? ' match-explainer-title--saved-popup'
                  : ''
              }`}
            >
              {matchFlowConfirmRemoval
                ? matchFlowType === 'none'
                  ? 'MATCH SETTINGS UPDATED'
                  : matchFlowType === 'community'
                    ? 'REMOVED FROM COMPUTER MATCH'
                    : matchFlowType === 'private'
                      ? 'REMOVED FROM COMMUNITY MATCH'
                      : 'COMPUTER & COMMUNITY MATCH'
                : matchFlowType === 'community'
                  ? 'COMMUNITY POSTED!'
                  : matchFlowType === 'both'
                    ? 'COMPUTER & COMMUNITY MATCH'
                    : 'UPLOADED'}
            </h3>
            <div className="match-flow-collage-wrap match-flow-collage-wrap-confirm">
              {renderMatchCollagePreview(matchFlowPoster, 'confirm')}
            </div>
            {matchFlowConfirmRemoval ? (
              <>
                {matchFlowType === 'private' && (
                  <p className="vibe-popup-text match-flow-check-text">
                    <span className="match-flow-check-icon">✓</span>
                    Your collage is removed from the MATCH TO GET $100 DINNER feed. Computer matching stays on.
                  </p>
                )}
                {matchFlowType === 'community' && (
                  <p className="vibe-popup-text match-flow-check-text">
                    <span className="match-flow-check-icon">✓</span>
                    You&apos;re no longer in computer matching. Your collage is still posted for community match.
                  </p>
                )}
                {matchFlowType === 'none' && (
                  <p className="vibe-popup-text">
                    This collage is removed from computer matching and from the MATCH TO GET $100 DINNER feed.
                  </p>
                )}
                {matchFlowType === 'both' && (
                  <p className="vibe-popup-text match-flow-check-text">
                    <span className="match-flow-check-icon">✓</span>
                    Your match settings for this collage are updated.
                  </p>
                )}
              </>
            ) : (
              <>
                {(matchFlowType === 'private' || matchFlowType === 'both') && (
                  <>
                    <p
                      className={`vibe-popup-text${matchFlowType === 'private' ? ' match-flow-vibe-intro-uploaded' : ''}`}
                    >
                      Every Tuesday LuvWTF will send you a few intros that match your collage vibe.
                    </p>
                    {matchFlowPoster.promoteOnLuvwtfSocials === true ? (
                      <div className="match-flow-giveaway-confirm-wrap">
                        <p className="vibe-popup-text match-flow-check-text match-flow-giveaway-confirm dinner-giveaway-participating-hint">
                          <span className="match-flow-check-icon">✓</span>
                          <span className="match-flow-giveaway-confirm-inline">
                            You opted into our five prizes program. We post five prizes at a time. When a
                            prized collage finds a match, we pay out the cash prize and give the matched pair $100
                            toward their dinner together.
                            <span className="dinner-participating-followup">
                              Then we pull a new collage at random from the opt{'\u2011'}in pool. If your
                              collage gets picked, we&apos;ll hit you up.{' '}
                              <button
                                type="button"
                                className="match-flow-giveaway-opt-out-link match-flow-giveaway-opt-out-link--inline"
                                disabled={matchFlowLoading || giveawayOptOutSaving || giveawayOptInSaving}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setGiveawayOptOutConfirmOpen(true);
                                }}
                              >
                                (opt out)
                              </button>
                            </span>
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div className="saved-poster-popup-promote-row match-flow-uploaded-dinner-reminder">
                        <div
                          role="checkbox"
                          aria-checked={false}
                          aria-label="Opt into five prizes program and win $100 for dinner — not selected. Activate to opt in."
                          tabIndex={matchFlowLoading || giveawayOptInSaving ? -1 : 0}
                          className={`match-flow-uploaded-dinner-reminder-inner${matchFlowLoading || giveawayOptInSaving ? ' match-flow-uploaded-dinner-reminder-inner--disabled' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (matchFlowLoading || giveawayOptInSaving) return;
                            void handleGiveawayOptInFromUploadedConfirm();
                          }}
                          onKeyDown={(e) => {
                            if (matchFlowLoading || giveawayOptInSaving) return;
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              void handleGiveawayOptInFromUploadedConfirm();
                            }
                          }}
                        >
                          <span className="saved-poster-popup-promote-check" aria-hidden="true" />
                          <span className="saved-poster-popup-promote-hint match-flow-uploaded-dinner-reminder-hint">
                            {giveawayOptInSaving
                              ? 'Saving…'
                              : 'opt into five prizes program and win $100 for dinner'}
                          </span>
                        </div>
                        <span
                          className="saved-poster-match-help"
                          role="button"
                          tabIndex={0}
                          aria-label="Prize opt-in: $100 dinner — more info"
                          onClick={(e) => {
                            e.stopPropagation();
                            openPromoteOnSocialsExplainer('default');
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              e.stopPropagation();
                              openPromoteOnSocialsExplainer('default');
                            }
                          }}
                        >
                          ?
                        </span>
                      </div>
                    )}
                  </>
                )}
                {matchFlowType === 'both' && <div style={{ height: '0.75rem' }} />}
                {(matchFlowType === 'community' || matchFlowType === 'both') && (
                  <>
                    <div className="match-flow-cal-above-feed" aria-hidden="true">
                      <img src={calIcon} alt="" className="match-flow-cal-icon-above" />
                    </div>
                    <p className="vibe-popup-text match-flow-check-text">
                      <span className="match-flow-check-icon">✓</span>
                      Your collage is posted in our MATCH TO GET $100 DINNER feed. Wait for the Cal community to match you.
                    </p>
                  </>
                )}
              </>
            )}
            <div className="match-flow-confirm-actions">
              {!matchFlowConfirmRemoval && matchFlowType === 'private' && (
                <button
                  type="button"
                  className="vibe-popup-btn"
                  onClick={() => handleMatchFlowClose({ scrollToEarnFoxes: true })}
                >
                  BROWSE PRIZES
                </button>
              )}
              {!matchFlowConfirmRemoval && matchFlowType === 'community' && (
                <button
                  type="button"
                  className="vibe-popup-btn"
                  disabled={matchFlowLoading}
                  onClick={async () => {
                    const poster = matchFlowPoster;
                    if (!poster || !currentUser?.uid) return;
                    setMatchFlowLoading(true);
                    try {
                      const userSnap = await getDoc(doc(db, 'users', currentUser.uid));
                      const existing = normalizeSavedPostersList(Array.isArray(userSnap.data()?.savedWantedPosters) ? userSnap.data().savedWantedPosters : []);
                      const currentMain = existing.find(p => p.isPrivateCollage && p.id !== poster.id);
                      if (currentMain) {
                        setMatchFlowExistingPrivate(currentMain);
                        setMatchFlowSelectionPrivate(true);
                        setMatchFlowSelectionCommunity(true);
                        setMatchFlowType('both');
                        setMatchFlowStep('privateUpdate');
                      } else {
                        await executeMatchActions(poster, true, false);
                        setMatchFlowConfirmRemoval(false);
                        setMatchFlowType('both');
                        setMatchFlowStep('confirm');
                      }
                    } catch (err) {
                      console.error('Error starting computer match:', err);
                      alert('Something went wrong. Please try again.');
                    } finally {
                      setMatchFlowLoading(false);
                    }
                  }}
                >
                  {matchFlowLoading ? 'LOADING...' : 'COMPUTER MATCH'}
                </button>
              )}
              {!(matchFlowType === 'private' && !matchFlowConfirmRemoval) && (
                <button type="button" className="vibe-popup-btn match-flow-close-btn" onClick={() => handleMatchFlowClose()}>
                  CLOSE
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {giveawayOptOutConfirmOpen && matchFlowPoster && (
        <div
          className="cart-popup-overlay vibe-popup-overlay match-flow-giveaway-opt-out-overlay"
          onClick={() => {
            if (!giveawayOptOutSaving) setGiveawayOptOutConfirmOpen(false);
          }}
        >
          <div
            className="cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="match-flow-giveaway-opt-out-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => {
                if (!giveawayOptOutSaving) setGiveawayOptOutConfirmOpen(false);
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 id="match-flow-giveaway-opt-out-title" className="match-explainer-title">
              Leave the prize program?
            </h3>
            <p className="vibe-popup-text match-flow-giveaway-opt-out-question">
              Your collage will be removed from the opt{'\u2011'}in pool, so you won&apos;t be in
              the running for a cash prize. You can opt in again anytime from your collages page.
            </p>
            <div className="match-flow-confirm-actions">
              <button
                type="button"
                className="vibe-popup-btn match-flow-close-btn"
                disabled={giveawayOptOutSaving}
                onClick={() => setGiveawayOptOutConfirmOpen(false)}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={giveawayOptOutSaving}
                onClick={() => { void handleGiveawayOptOutConfirm(); }}
              >
                {giveawayOptOutSaving ? 'SAVING...' : 'OPT OUT'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Verified profile changed age in the nickname popup — confirm re-verification */}
      {ageReverifyConfirmOpen && (
        <div
          className="cart-popup-overlay vibe-popup-overlay age-reverify-confirm-overlay"
          onClick={() => {
            if (!ageReverifySaving) handleAgeReverifyCancel();
          }}
        >
          <div
            className="cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="age-reverify-confirm-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => {
                if (!ageReverifySaving) handleAgeReverifyCancel();
              }}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 id="age-reverify-confirm-title" className="match-explainer-title">
              Update your age?
            </h3>
            <p className="vibe-popup-text age-reverify-confirm-question">
              We will need to re&#8209;verify your profile if you update your age. Would you like
              to update your age?
            </p>
            <div className="match-flow-confirm-actions">
              <button
                type="button"
                className="vibe-popup-btn match-flow-close-btn"
                disabled={ageReverifySaving}
                onClick={handleAgeReverifyCancel}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={ageReverifySaving}
                onClick={() => { void handleAgeReverifyUpdate(); }}
              >
                {ageReverifySaving ? 'UPDATING...' : 'UPDATE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Your Finds Popup */}
      {showFindsPopup && (
        <div className="cart-popup-overlay" onClick={() => setShowFindsPopup(false)}>
          <div className="cart-popup posters-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowFindsPopup(false)} aria-label="Close">×</button>
            <h3 className="cart-popup-title">YOUR FINDS</h3>
            <p className="posters-popup-empty">When someone applies or refers a friend to your collage, you will see them here.</p>
          </div>
        </div>
      )}

      {/* Collage detail popup (from Your collages list) – Share + Edit when primary; Make primary + Edit when not */}
      {posterDetailFromList && (
        <div
          className="feed-tile-detail-overlay feed-tile-detail-overlay--your-collages"
          onClick={() => { setPosterDetailFromList(null); setPosterDetailFromListTitleOverride(null); setShowUnpostConfirm(false); }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="poster-detail-from-list-title"
        >
          <div className="feed-tile-detail-popup collage-details-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="feed-tile-detail-close"
              onClick={() => { setPosterDetailFromList(null); setPosterDetailFromListTitleOverride(null); setShowUnpostConfirm(false); }}
              aria-label="Close"
            >
              ×
            </button>
            <h2 id="poster-detail-from-list-title" className="feed-tile-detail-title">
              {posterDetailFromListTitleOverride || 'COLLAGE DETAILS'}
            </h2>
            <CollageDetailsLuvLegend
              {...posterFindLuvIconFlags(posterDetailFromList)}
              lookingForGenders={posterDetailFromList?.lookingForGenders}
              auraColor={posterDetailFromList?.auraColor ?? userAuraRgb}
            />
            <div className="collage-details-collage-wrapper" aria-hidden="true">
              <div className="wanted-poster wanted-poster-feed collage-details-poster">
                <div className="poster-content">
                  <FeedNicknameTile
                    ad={
                      posterDetailFromList?.auraColor
                        ? posterDetailFromList
                        : { ...posterDetailFromList, auraColor: userAuraRgb }
                    }
                    savedPosters={savedPosters}
                    currentUserId={currentUser?.uid ?? null}
                    findLuvFlags={posterFindLuvIconFlags(posterDetailFromList)}
                    showVibeAura
                  />
                  <div className="match-a-friend-collage">
                  <div className="collage-poster-area">
                    <div className="partner-swag-container">
                      <div className="partner-swag-left">
                        {(posterDetailFromList.swags || []).length > 0 && (
                          <div className="swag-images-left">
                            {(posterDetailFromList.swags || []).map((swag, swagIndex) => {
                              const swagUrl = swag.imageUrl || swag;
                              if (!swagUrl) return null;
                              const seed = seedFromString(`${posterDetailFromList.id}-swag-${swagIndex}`);
                              const seedX = seedFromString(`${posterDetailFromList.id}-swag-x-${swagIndex}`);
                              const rotation = (seed * 30 - 15).toFixed(1);
                              const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                              return (
                                <img
                                  key={swag.id || swagIndex}
                                  src={swagUrl}
                                  alt={swag.name || 'Brand'}
                                  className="swag-image"
                                  style={{
                                    transform: `rotate(${rotation}deg)`,
                                    marginLeft: `${horizontalOffset}px`
                                  }}
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div className="partner-swag-center">
                        <div className="partner-swag-center-stack">
                          {(() => {
                            const cutJagged = (() => {
                              const v = 1 + Math.floor(seedFromString(`feed-cutout-${posterDetailFromList.id}`) * 3);
                              return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                            })();
                            if (showFriendFoxMaskPlaceholder(posterDetailFromList) && posterDetailFromList.partnerCutout) {
                              return (
                                <FriendFoxMaskPlaceholderCutout
                                  variant="feed"
                                  jaggedClassName={cutJagged}
                                  heartSrc={
                                    posterDetailFromList.heartPhotoUrl
                                    || posterDetailFromList.surveyAnswers?.vibe_photo
                                    || orheartImage
                                  }
                                  heartClassName="partner-cutout-gif-overlay"
                                />
                              );
                            }
                            if (posterDetailFromList.partnerCutout) {
                              return (
                                <div className="final-partner-image-wrapper">
                                  <img
                                    src={posterDetailFromList.partnerCutout}
                                    alt=""
                                    className={`final-partner-image final-partner-image-feed${cutJagged}`}
                                  />
                                  <img
                                    src={
                                      posterDetailFromList.heartPhotoUrl
                                      || posterDetailFromList.surveyAnswers?.vibe_photo
                                      || orheartImage
                                    }
                                    alt=""
                                    className="partner-cutout-gif-overlay"
                                  />
                                </div>
                              );
                            }
                            return (
                              <div
                                className={`final-partner-image final-partner-image-placeholder final-partner-image-feed${cutJagged}`}
                              >
                                {'\uD83D\uDC64'}
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                      <div className="partner-swag-right">
                        <div className="activities-emojis-right">
                          {[posterDetailFromList.activityX, posterDetailFromList.activityY, posterDetailFromList.activityZ].filter(Boolean).map((label, i) => {
                            const seed = seedFromString(`${posterDetailFromList.id}-act-${i}`);
                            const seedX = seedFromString(`${posterDetailFromList.id}-act-x-${i}`);
                            const rotation = (seed * 30 - 15).toFixed(1);
                            const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                            const hue = 32 + seed * 20;
                            const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                            return (
                              <div
                                key={i}
                                className="activity-tile-outer"
                                style={{
                                  transform: `rotate(${rotation}deg)`,
                                  marginLeft: `${horizontalOffset}px`
                                }}
                              >
                                <div
                                  className="activity-emoji-wrapper collage-activity-tile"
                                  style={{ background: bgColor }}
                                >
                                  <div
                                    className="activity-emoji"
                                    style={{
                                      fontSize: `calc(${(2.5 + seed * 1.5).toFixed(4)} * var(--collage-details-activity-scale, 1) * 1rem)`,
                                    }}
                                  >
                                    {typeof label === 'string' ? label : (label?.emoji ?? label?.name ?? '')}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    {posterDetailFromList.places && posterDetailFromList.places.length > 0 && (
                      <div className="collage-aspirations-row">
                        {[posterDetailFromList.places.slice(0, Math.floor(seedFromString(`${posterDetailFromList.id}-places-split`) * 2) + 1), posterDetailFromList.places.slice(Math.floor(seedFromString(`${posterDetailFromList.id}-places-split`) * 2) + 1)].map((rowPlaces, rowIdx) => (
                          rowPlaces.length > 0 && (
                            <div key={rowIdx} className="collage-places-row-inner">
                              {rowPlaces.map((place, i) => (
                                <div key={place.id || `${rowIdx}-${i}`} className="aspiration-tile-outer">
                                  <div className="collage-place-tile">
                                    <img src={place.imageUrl} alt={place.name} className="collage-place-img" />
                                  </div>
                                </div>
                              ))}
                            </div>
                          )
                        ))}
                      </div>
                    )}
                  </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="feed-tile-detail-actions">
              {posterDetailFromListIsPrimary ? (
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                  onClick={handlePosterDetailFromListShare}
                >
                  {posterDetailLinkCopied ? 'Link copied!' : 'Share'}
                </button>
              ) : (
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                  onClick={handlePosterDetailMakePrimaryClick}
                >
                  Make primary
                </button>
              )}
              {posterDetailFromList.postedToFeed ? (
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                  onClick={() => setShowUnpostConfirm(true)}
                >
                  Unpost
                </button>
              ) : (
                <button
                  type="button"
                  className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                  onClick={() => {
                    const poster = posterDetailFromList;
                    if (poster?.id) reopenPosterDetailAfterSaveIdRef.current = poster.id;
                    setPosterDetailFromListTitleOverride(null);
                    setPosterDetailFromList(null);
                    handleLoadSavedPoster(poster);
                  }}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {showCollageFriendSuccessPopup && collageFriendSuccessPoster && (
        <div
          className="feed-tile-detail-overlay"
          onClick={closeCollageFriendSuccessPopup}
          role="dialog"
          aria-modal="true"
          aria-labelledby="collage-friend-success-title"
        >
          <div className="feed-tile-detail-popup collage-details-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="feed-tile-detail-close"
              onClick={closeCollageFriendSuccessPopup}
              aria-label="Close"
            >
              ×
            </button>
            <h2 id="collage-friend-success-title" className="feed-tile-detail-title">
              YOU COLLAGED A FRIEND!
            </h2>
            <div className="collage-details-collage-wrapper" aria-hidden="true">
              <div className="wanted-poster wanted-poster-feed collage-details-poster">
                <div className="poster-content">
                  <button type="button" className="the-one-label the-one-label-feed" tabIndex={-1} aria-hidden="true">
                    &quot;{collageFriendSuccessPoster.posterNickname ?? 'The One'}&quot;
                  </button>
                  <div className="match-a-friend-collage">
                    <div className="collage-poster-area">
                      <div className="partner-swag-container">
                        <div className="partner-swag-left">
                          {(collageFriendSuccessPoster.swags || []).length > 0 && (
                            <div className="swag-images-left">
                              {(collageFriendSuccessPoster.swags || []).map((swag, swagIndex) => {
                                const swagUrl = swag.imageUrl || swag;
                                if (!swagUrl) return null;
                                const seed = seedFromString(`${collageFriendSuccessPoster.id}-swag-${swagIndex}`);
                                const seedX = seedFromString(`${collageFriendSuccessPoster.id}-swag-x-${swagIndex}`);
                                const rotation = (seed * 30 - 15).toFixed(1);
                                const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                                return (
                                  <img
                                    key={swag.id || swagIndex}
                                    src={swagUrl}
                                    alt={swag.name || 'Brand'}
                                    className="swag-image"
                                    style={{
                                      transform: `rotate(${rotation}deg)`,
                                      marginLeft: `${horizontalOffset}px`,
                                    }}
                                  />
                                );
                              })}
                            </div>
                          )}
                        </div>
                        <div className="partner-swag-center">
                          <div className="partner-swag-center-stack">
                            {(() => {
                              const cutJagged = (() => {
                                const v = 1 + Math.floor(seedFromString(`feed-cutout-${collageFriendSuccessPoster.id}`) * 3);
                                return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                              })();
                              if (
                                showFriendFoxMaskPlaceholder(collageFriendSuccessPoster)
                                && collageFriendSuccessPoster.partnerCutout
                              ) {
                                return (
                                  <FriendFoxMaskPlaceholderCutout
                                    variant="feed"
                                    jaggedClassName={cutJagged}
                                    heartSrc={
                                      collageFriendSuccessPoster.heartPhotoUrl
                                      || collageFriendSuccessPoster.surveyAnswers?.vibe_photo
                                      || orheartImage
                                    }
                                    heartClassName="partner-cutout-gif-overlay"
                                  />
                                );
                              }
                              if (collageFriendSuccessPoster.partnerCutout) {
                                return (
                                  <div className="final-partner-image-wrapper">
                                    <img
                                      src={collageFriendSuccessPoster.partnerCutout}
                                      alt=""
                                      className={`final-partner-image final-partner-image-feed${cutJagged}`}
                                    />
                                    <img
                                      src={
                                        collageFriendSuccessPoster.heartPhotoUrl
                                        || collageFriendSuccessPoster.surveyAnswers?.vibe_photo
                                        || orheartImage
                                      }
                                      alt=""
                                      className="partner-cutout-gif-overlay"
                                    />
                                  </div>
                                );
                              }
                              return (
                                <div
                                  className={`final-partner-image final-partner-image-placeholder final-partner-image-feed${cutJagged}`}
                                >
                                  {'\uD83D\uDC64'}
                                </div>
                              );
                            })()}
                          </div>
                        </div>
                        <div className="partner-swag-right">
                          <div className="activities-emojis-right">
                            {[collageFriendSuccessPoster.activityX, collageFriendSuccessPoster.activityY, collageFriendSuccessPoster.activityZ]
                              .filter(Boolean)
                              .map((label, i) => {
                                const seed = seedFromString(`${collageFriendSuccessPoster.id}-act-${i}`);
                                const seedX = seedFromString(`${collageFriendSuccessPoster.id}-act-x-${i}`);
                                const rotation = (seed * 30 - 15).toFixed(1);
                                const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                                const hue = 32 + seed * 20;
                                const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                                return (
                                  <div
                                    key={i}
                                    className="activity-tile-outer"
                                    style={{
                                      transform: `rotate(${rotation}deg)`,
                                      marginLeft: `${horizontalOffset}px`,
                                    }}
                                  >
                                    <div
                                      className="activity-emoji-wrapper collage-activity-tile"
                                      style={{ background: bgColor }}
                                    >
                                      <div
                                        className="activity-emoji"
                                        style={{
                                          fontSize: `calc(${(2.5 + seed * 1.5).toFixed(4)} * var(--collage-details-activity-scale, 1) * 1rem)`,
                                        }}
                                      >
                                        {typeof label === 'string' ? label : (label?.emoji ?? label?.name ?? '')}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                      {collageFriendSuccessPoster.places && collageFriendSuccessPoster.places.length > 0 && (
                        <div className="collage-aspirations-row">
                          {[
                            collageFriendSuccessPoster.places.slice(
                              0,
                              Math.floor(seedFromString(`${collageFriendSuccessPoster.id}-places-split`) * 2) + 1,
                            ),
                            collageFriendSuccessPoster.places.slice(
                              Math.floor(seedFromString(`${collageFriendSuccessPoster.id}-places-split`) * 2) + 1,
                            ),
                          ].map((rowPlaces, rowIdx) =>
                            rowPlaces.length > 0 ? (
                              <div key={rowIdx} className="collage-places-row-inner">
                                {rowPlaces.map((place, i) => (
                                  <div key={place.id || `${rowIdx}-${i}`} className="aspiration-tile-outer">
                                    <div className="collage-place-tile">
                                      <img src={place.imageUrl} alt={place.name} className="collage-place-img" />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : null,
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p className="feed-tile-detail-apply-prompt collage-friend-success-prompt">
              Send this to a friend you collaged and win $$ for your dinner date or your friend&apos;s dinner date.
            </p>
            <div className="feed-tile-detail-actions">
              <button
                type="button"
                className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                onClick={handleCollageFriendSuccessCopyLink}
              >
                {collageFriendLinkCopied ? 'Link copied!' : 'COPY LINK'}
              </button>
              <button
                type="button"
                className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                onClick={handleCollageFriendSuccessSendEmail}
                disabled={collageFriendEmailSent}
              >
                {collageFriendEmailSent ? 'EMAIL SENT' : 'SEND EMAIL'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showUnpostConfirm && (
        <div className="cart-popup-overlay" onClick={() => setShowUnpostConfirm(false)}>
          <div className="cart-popup unpost-confirm-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowUnpostConfirm(false)} aria-label="Close">×</button>
            <p className="unpost-confirm-text">Are you sure you want to remove your posting?</p>
            <div className="feed-tile-detail-actions">
              <button
                type="button"
                className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                onClick={async () => {
                  setShowUnpostConfirm(false);
                  await handleUnpostFromFeed();
                }}
              >
                Confirm
              </button>
              <button
                type="button"
                className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                onClick={() => setShowUnpostConfirm(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Messages Inbox */}
      {showMessagesPopup && currentUser && (
        <Inbox
          currentUser={currentUser}
          initialConversationId={inboxInitialConversationId}
          onOpenPartnerCollage={handleOpenChatPartnerCollage}
          onClose={() => { setShowMessagesPopup(false); setInboxInitialConversationId(null); }}
          hasPrimaryCollage={Boolean(getPrimarySavedPoster(savedPosters, primaryCollageId))}
          foxDailyCheckUnread={foxInboxUnread}
          onDailyVibeCheckCompleted={handleDailyVibeCheckCompleted}
          vibeCheckStreak={userVibeCheckStreak}
          vibeCheckStreakLastPeriodKey={userVibeCheckStreakLastPeriodKey}
          onStartCollage={(e) => {
            setShowMessagesPopup(false);
            setInboxInitialConversationId(null);
            openSelfFoxChat(e);
          }}
          onVerifyProfile={handleFoxChatVerifyProfile}
          profileVerified={berkeleyEmailVerified}
        />
      )}

      {/* Floating Fox chat launcher + chat panel */}
      <FoxChat
        key={foxChatVariant}
        foxChatCopy={foxChatVariant === 'ops' ? FOX_OPS_CHAT_COPY : DEFAULT_FOX_CHAT_COPY}
        launcherVisible={foxChatLauncherVisible && !showFoxChatPopup}
        isOpen={showFoxChatPopup}
        onLauncherClick={openSelfFoxChat}
        onClose={() => {
          setShowFoxChatPopup(false);
          setFoxChatVariant('self');
        }}
        currentUser={currentUser}
        onShowSignUp={onShowSignUp}
        signUpPopupOpen={signUpPopupOpen}
        loginPopupOpen={loginPopupOpen}
        onCollageSaved={(posterData) => {
          /* After a FoxChat-saved collage:
             1. Close the chat panel + route the user to "Your collages" so they can edit it in
                the existing HomePage editor.
             2. Trigger the quiet primary-collage flow (C.7 in the SAVE write chain): if the user
                has no existing primary, silently set `isPrivateCollage: true` + `primaryCollageId`
                — no popup, FoxChat already showed inline SAVED! feedback. If they already have a
                primary, open the "UPDATE YOUR PRIMARY COLLAGE?" popup so they can swap; clicking
                UPDATE swaps silently, dismissing leaves the poster saved-but-not-primary.
             3. After primary flow settles, `triggerFoxChatBountyPrompt` shows PRIZE OPT-IN on
                Your collages (not inside FoxChat). */
          setShowFoxChatPopup(false);
          setFoxChatVariant('self');
          resetCollageEditorForMyCollagesRedirect();
          setShowMyCollagesInline(true);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          if (posterData) {
            pendingFoxChatBountyPosterRef.current = posterData;
            /* Defer to the next tick so React flushes the "Your collages" redirect before the
               match-flow popup might mount. Failures are logged inside the helper and never
               bubble into FoxChat (the poster is already persisted regardless). */
            window.setTimeout(() => { void setSavedPosterAsPrimaryQuiet(posterData); }, 0);
          }
        }}
        registerFoxChatResetEmailAttachHooks={
          foxChatResetEmailAttachHooksRef
            ? (hooks) => {
                foxChatResetEmailAttachHooksRef.current = hooks;
              }
            : undefined
        }
        onDailyVibeCheckCompleted={handleDailyVibeCheckCompleted}
        onOpenMessages={(conversationId) => {
          setShowFoxChatPopup(false);
          setFoxChatVariant('self');
          setInboxInitialConversationId(conversationId || null);
          setShowMessagesPopup(true);
        }}
        onVerifyProfile={handleFoxChatVerifyProfile}
        verifyPopupOpen={showBerkeleyEmailPopup}
        profileVerified={berkeleyEmailVerified}
        vibeCheckStreak={userVibeCheckStreak}
        vibeCheckStreakLastPeriodKey={userVibeCheckStreakLastPeriodKey}
        hasSavedCollage={Boolean(getPrimarySavedPoster(savedPosters, primaryCollageId))}
      />

      {/* FoxChat — PRIZE OPT-IN after save + redirect to Your collages (not shown inside FoxChat). */}
      {foxChatBountyPromptOpen && (
        <div
          className="cart-popup-overlay vibe-popup-overlay fox-chat-bounty-overlay"
          onClick={() => void handleFoxChatDeferredBountyChoice(false)}
          role="presentation"
        >
          <div
            className="cart-popup vibe-popup fox-chat-bounty-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => void handleFoxChatDeferredBountyChoice(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <h3 className="match-explainer-title fox-chat-bounty-title">WEEKLY FEATURED OPT-IN</h3>
            <p className="vibe-popup-text fox-chat-bounty-text">
              Opt in your profile to be featured on our website for a week. If your profile is selected, get a Fox-Paid date when you match
            </p>
            <button
              type="button"
              className="vibe-popup-btn fox-chat-bounty-opt-in-btn"
              onClick={() => void handleFoxChatDeferredBountyChoice(true)}
            >
              OPT IN
            </button>
            <button
              type="button"
              className="fox-chat-bounty-no-thanks"
              onClick={() => void handleFoxChatDeferredBountyChoice(false)}
            >
              No thanks!
            </button>
          </div>
        </div>
      )}

      {/* Cart Popup */}
      {showCartPopup && (
        <div className="login-popup-overlay signup-popup-overlay" onClick={() => setShowCartPopup(false)}>
          <div className="login-popup signup-popup cart-popup" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setShowCartPopup(false)} aria-label="Close">×</button>
            <div className="login-popup-header">
              <h2>YOUR CART</h2>
            </div>
            {currentUser?.email && (
              <>
                <p className="cart-popup-email">{currentUser.email}</p>
                <button type="button" className="cart-popup-sign-out" onClick={handleCartSignOut}>Sign out</button>
              </>
            )}
            {!userCart.length ? (
              <p className="cart-popup-empty-hint">Your cart is empty</p>
            ) : (
              <ul className="cart-popup-list">
                {userCart.map((item, i) => (
                  <li key={`${item.id}-${i}`} className="cart-popup-item">
                    <button type="button" className="cart-popup-remove" onClick={() => handleRemoveFromCart(item)} aria-label="Remove">×</button>
                    <span className="cart-popup-item-title">{item.title ?? item.alt}</span>
                    <span className="cart-popup-item-price">
                      <img src={theFoxMini} alt="" className="cart-popup-fox-icon" />
                      <span>{item.price.toLocaleString()}</span>
                    </span>
                  </li>
                ))}
              </ul>
            )}
            <button type="button" className="login-button cart-popup-confirm" onClick={handleConfirmOrder} disabled={!userCart.length}>
              Confirm
            </button>
            {pendingOrders.length > 0 && (
              <div className="cart-popup-pending">
                <h4 className="cart-popup-pending-title">PENDING ORDERS</h4>
                {pendingOrders.map((order) => (
                  <div key={order.id} className="cart-popup-pending-item">
                    <span className="cart-popup-pending-date">
                      {order.createdAt?.toDate?.()?.toLocaleDateString?.() ?? '—'}
                    </span>
                    <ul className="cart-popup-pending-items">
                      {(order.items ?? []).map((it, idx) => (
                        <li key={idx}>{it.title ?? it.alt}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Great choice! Popup */}
      {showOrderConfirmPopup && (
        <div className="heart-photo-upload-overlay" onClick={handleOrderConfirmClose}>
          <div className="heart-photo-upload-modal" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={handleOrderConfirmClose} aria-label="Close">×</button>
            <h2 className="heart-photo-upload-title">Great choice!</h2>
            <p style={{ fontFamily: "'Londrina Solid', sans-serif", fontSize: '1rem', color: '#444', margin: '0 0 1.5rem' }}>
              The Fox will reach out to confirm your order and delivery instructions.
            </p>
            <button className="heart-photo-upload-button" onClick={handleOrderConfirmClose}>
              Got it
            </button>
          </div>
        </div>
      )}

      {/* Duplicate wanted ad popup */}
      {showPostConfirmPopup && (
          <div className="cart-popup-overlay" onClick={() => setShowPostConfirmPopup(false)}>
            <div className="cart-popup" onClick={(e) => e.stopPropagation()}>
              <button className="cart-popup-close" onClick={() => setShowPostConfirmPopup(false)} aria-label="Close">×</button>
              <h3 className="cart-popup-title">CONFIRM POST ON LUV.WTF</h3>
              <p className="cart-popup-message post-confirm-message" style={{ margin: '1rem 0' }}>
                Your collage will be posted on luv.wtf. Anyone can refer a friend to your posted collage, but they will need to be verified to reach out.
              </p>
              <label className="post-confirm-checkbox-label" onClick={() => setPromoteSocials(prev => !prev)}>
                <span className={`post-confirm-checkbox${promoteSocials ? ' checked' : ''}`}>{promoteSocials ? '✓' : ''}</span>
                <span>Promote my collage on socials</span>
              </label>
              <div className="post-confirm-actions">
                <button type="button" className="post-confirm-cancel" onClick={() => setShowPostConfirmPopup(false)}>Cancel</button>
                <button type="button" className="post-confirm-confirm" onClick={() => handlePostOnLuvWtf(null, true)}>Confirm</button>
              </div>
            </div>
          </div>
      )}

      {/* Confirm posting IRL flyers popup */}
      {showPostFlyersIrlConfirmPopup && (
        <div className="cart-popup-overlay" onClick={() => setShowPostFlyersIrlConfirmPopup(false)}>
          <div className="cart-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowPostFlyersIrlConfirmPopup(false)} aria-label="Close">×</button>
            <h3 className="cart-popup-title">CONFIRM POSTING IRL FLYERS</h3>
            <p className="cart-popup-message post-confirm-message" style={{ margin: '1rem 0' }}>
              Your collage will be printed and posted as physical flyers around campus.
            </p>
            <div className="post-confirm-actions">
              <button type="button" className="post-confirm-cancel" onClick={() => setShowPostFlyersIrlConfirmPopup(false)}>Cancel</button>
              <button type="button" className="post-confirm-confirm" onClick={handleConfirmPostIrl}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm TikTok ads popup */}
      {showPostTiktokConfirmPopup && (
        <div className="cart-popup-overlay" onClick={() => setShowPostTiktokConfirmPopup(false)}>
          <div className="cart-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowPostTiktokConfirmPopup(false)} aria-label="Close">×</button>
            <h3 className="cart-popup-title">CONFIRM TIKTOK ADS</h3>
            <p className="cart-popup-message post-confirm-message" style={{ margin: '1rem 0' }}>
              Your collage will be promoted with TikTok ads.
            </p>
            <div className="post-confirm-actions">
              <button type="button" className="post-confirm-cancel" onClick={() => setShowPostTiktokConfirmPopup(false)}>Cancel</button>
              <button type="button" className="post-confirm-confirm" onClick={handleConfirmPostTiktok}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      {showBerkeleyEmailPopup && (
        <div className="cart-popup-overlay cart-popup-overlay--above-feed-detail" onClick={() => { setShowBerkeleyEmailPopup(false); setBerkeleyEmailSubmitted(false); setBerkeleyEmailPending(false); }}>
          <div className="cart-popup berkeley-email-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => { setShowBerkeleyEmailPopup(false); setBerkeleyEmailSubmitted(false); setBerkeleyEmailPending(false); }} aria-label="Close">×</button>
            {berkeleyEmailSubmitted || (berkeleyEmailPending && !eduEmailConfirmed) ? (
              <>
                <h3 className="cart-popup-title">CONFIRM YOUR EMAIL</h3>
                {eduVerifySendFailed ? (
                  <p className="cart-popup-message berkeley-email-error" style={{ margin: '0.75rem 0 0' }}>
                    We couldn&apos;t deliver the verification link to this address. Tap RESEND to try again.
                  </p>
                ) : (
                  <p className="cart-popup-message" style={{ margin: '0.75rem 0 0' }}>
                    We sent a link to verify your .edu email. Confirm your email.
                  </p>
                )}
                <p className="cart-popup-message" style={{ margin: '0.65rem 0 1.5rem' }}>
                  We use your .edu email as a reliable way to verify you are a real person before you get matched.
                </p>
                <PendingEduEmailField
                  email={
                    userBerkeleyEmail ||
                    (isEduEmail(currentUser?.email || '') ? currentUser.email : '') ||
                    berkeleyEmailInput
                  }
                  cooldownSeconds={eduResendCooldownSeconds}
                  busy={berkeleyEmailSubmitting}
                  error={berkeleyEmailError}
                  onSave={handleBerkeleyEmailSubmit}
                  onResend={handleBerkeleyEmailResend}
                  variant="popup"
                />
              </>
            ) : berkeleyEmailPending ? (
              <>
                <h3 className="cart-popup-title">VERIFICATION PENDING</h3>
                <p className="cart-popup-message" style={{ margin: '0.75rem 0 1.5rem' }}>
                  Your .edu email is confirmed and your profile is being verified. This can take up to 24 hours. We only match real people.
                </p>
                <button
                  type="button"
                  className="berkeley-email-got-it"
                  onClick={() => { setShowBerkeleyEmailPopup(false); setBerkeleyEmailPending(false); }}
                >
                  Got it
                </button>
              </>
            ) : (
              <>
                <h3 className="cart-popup-title">VERIFY YOUR PROFILE</h3>
                <p className="cart-popup-message" style={{ margin: '0.75rem 0 1.25rem' }}>
                  We use your .edu email as a reliable way to confirm you are a real person. You can use your student or alumni email:
                </p>
                <form onSubmit={(e) => { e.preventDefault(); handleBerkeleyEmailSubmit(); }}>
                  <input
                    type="email"
                    className="berkeley-email-input"
                    placeholder="you@school.edu"
                    value={berkeleyEmailInput}
                    onChange={(e) => { setBerkeleyEmailInput(e.target.value); setBerkeleyEmailError(''); }}
                    ref={focusPopupInputOnMount}
                    disabled={berkeleyEmailSubmitting}
                  />
                  {berkeleyEmailError && (
                    <p className="berkeley-email-error">{berkeleyEmailError}</p>
                  )}
                  <div className="post-confirm-actions">
                    <button type="button" className="post-confirm-cancel" onClick={() => setShowBerkeleyEmailPopup(false)}>Cancel</button>
                    <button type="submit" className="post-confirm-confirm" disabled={berkeleyEmailSubmitting}>
                      {berkeleyEmailSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {showDuplicatePostPopup && (
        <div className="cart-popup-overlay" onClick={() => setShowDuplicatePostPopup(false)}>
          <div className="cart-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowDuplicatePostPopup(false)} aria-label="Close">×</button>
            <h3 className="cart-popup-title">Already posted</h3>
            <p className="cart-popup-message" style={{ margin: '1rem 0' }}>
              You&apos;ve already posted this wanted ad. Create a new poster to post another ad or edit your existing ad.
            </p>
            <button type="button" className="cart-popup-confirm" onClick={() => setShowDuplicatePostPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}

      {dinnerOptInExplainerOpen && (
        <div
          className="cart-popup-overlay vibe-popup-overlay matcha-explainer-overlay--stack-top"
          onClick={closeDinnerOptInExplainer}
        >
          <div className="cart-popup vibe-popup" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="cart-popup-close" onClick={closeDinnerOptInExplainer} aria-label="Close">&times;</button>
            <h3 className="cart-popup-title vibe-popup-dinner-title">MATCH-A-FRIEND PRIZES</h3>
            <p className="vibe-popup-text">
              Refer a friend to a weekly featured profile and if they match with the person behind the mask, you get a free spin and they share a date experience on us
            </p>
            <button
              type="button"
              className="vibe-popup-btn"
              disabled={matchaSpinLoading}
              aria-busy={matchaSpinLoading}
              onClick={() => {
                if (matchaSpinLoading) return;
                if (!currentUser) {
                  closeDinnerOptInExplainer();
                  onShowSignUp?.(null, 'feed');
                  return;
                }
                if (weeklyFeaturedAds.length === 0) {
                  closeDinnerOptInExplainer();
                  return;
                }
                const randomAd = weeklyFeaturedAds[Math.floor(Math.random() * weeklyFeaturedAds.length)];
                /* Same resolution order the popup uses for the cutout, so the pinned bitmap matches. */
                const cutoutSrc = randomAd.partnerCutout || (feedCutoutUrls && feedCutoutUrls[0]) || null;
                /* Keep the explainer up while the collage's images decode so the card opens fully
                   painted (the carousel click path gets this for free from its own preload). */
                const gen = ++matchaSpinGenRef.current;
                setMatchaSpinLoading(true);
                void warmFeedAdDetailImages(randomAd, cutoutSrc).then(() => {
                  if (gen !== matchaSpinGenRef.current) return;
                  setMatchaSpinLoading(false);
                  setDinnerOptInExplainerOpen(false);
                  primeFeedTileDetailPopup();
                  openFeedTileDetailFromGrid(randomAd, cutoutSrc);
                });
              }}
            >
              {matchaSpinLoading ? 'LOADING...' : 'GET A SPIN'}
            </button>
          </div>
        </div>
      )}

      <PaidForDateExplainer
        open={paidForDateExplainerOpen}
        onClose={() => setPaidForDateExplainerOpen(false)}
        signedIn={Boolean(currentUser)}
        onSignUp={() => onShowSignUp?.(null, 'feed')}
        onGetPaidForDate={openSelfFoxChat}
      />

      {foxPaidDatesWeeklyOptInOpen && currentUser && (
        <div
          className="user-menu-match-removal-confirm-overlay"
          role="presentation"
          onClick={() => {
            if (!matchFlowLoading) setFoxPaidDatesWeeklyOptInOpen(false);
          }}
        >
          <div
            className="user-menu-match-removal-confirm cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="fox-paid-dates-weekly-opt-in-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => {
                if (!matchFlowLoading) setFoxPaidDatesWeeklyOptInOpen(false);
              }}
              aria-label="Close"
              disabled={matchFlowLoading}
            >
              ×
            </button>
            <h3 id="fox-paid-dates-weekly-opt-in-title" className="match-explainer-title user-menu-match-removal-confirm-title">
              WEEKLY FEATURED OPT-IN
            </h3>
            <p className="vibe-popup-text">
              Opt in your profile to be featured on our website for a week. If your profile is selected, get a Fox-Paid date when you match
            </p>
            <div className="user-menu-match-removal-confirm-actions">
              <button
                type="button"
                className="vibe-popup-btn match-flow-close-btn"
                disabled={matchFlowLoading}
                onClick={() => setFoxPaidDatesWeeklyOptInOpen(false)}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={matchFlowLoading}
                onClick={() => { void handleFoxPaidDatesWeeklyOptInConfirm(); }}
              >
                {matchFlowLoading ? 'SAVING…' : 'OPT IN'}
              </button>
            </div>
          </div>
        </div>
      )}

      {foxPaidDatesWeeklyOptInSuccessOpen && currentUser && (
        <div
          className="user-menu-match-removal-confirm-overlay"
          role="presentation"
          onClick={() => setFoxPaidDatesWeeklyOptInSuccessOpen(false)}
        >
          <div
            className="user-menu-match-removal-confirm cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="fox-paid-dates-weekly-opt-in-success-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => setFoxPaidDatesWeeklyOptInSuccessOpen(false)}
              aria-label="Close"
            >
              ×
            </button>
            <h3 id="fox-paid-dates-weekly-opt-in-success-title" className="match-explainer-title user-menu-match-removal-confirm-title">
              WEEKLY FEATURED
            </h3>
            <p className="vibe-popup-text">
              You&apos;re opted in! You can opt out anytime from this page.
            </p>
            <button
              type="button"
              className="vibe-popup-btn"
              onClick={() => setFoxPaidDatesWeeklyOptInSuccessOpen(false)}
            >
              GOT IT
            </button>
          </div>
        </div>
      )}

      {foxPaidDatesWeeklyOptOutOpen && currentUser && (
        <div
          className="user-menu-match-removal-confirm-overlay"
          role="presentation"
          onClick={() => {
            if (!matchFlowLoading) setFoxPaidDatesWeeklyOptOutOpen(false);
          }}
        >
          <div
            className="user-menu-match-removal-confirm cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="fox-paid-dates-weekly-opt-out-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => {
                if (!matchFlowLoading) setFoxPaidDatesWeeklyOptOutOpen(false);
              }}
              aria-label="Close"
              disabled={matchFlowLoading}
            >
              ×
            </button>
            <h3 id="fox-paid-dates-weekly-opt-out-title" className="match-explainer-title user-menu-match-removal-confirm-title">
              YOU&apos;RE ALREADY OPTED IN. WOULD YOU LIKE TO OPT OUT?
            </h3>
            <p className="vibe-popup-text match-flow-giveaway-opt-out-question">
              Your profile will be removed from the opt{'\u2011'}in pool, so you won&apos;t be in
              the running for paid-for dates. You can opt in again anytime from this page.
            </p>
            <div className="user-menu-match-removal-confirm-actions">
              <button
                type="button"
                className="vibe-popup-btn match-flow-close-btn"
                disabled={matchFlowLoading}
                onClick={() => setFoxPaidDatesWeeklyOptOutOpen(false)}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="vibe-popup-btn"
                disabled={matchFlowLoading}
                onClick={() => { void handleFoxPaidDatesWeeklyOptOutConfirm(); }}
              >
                {matchFlowLoading ? 'SAVING…' : 'OPT OUT'}
              </button>
            </div>
          </div>
        </div>
      )}

      {foxPaidDatesWeeklyOptOutSuccessOpen && currentUser && (
        <div
          className="user-menu-match-removal-confirm-overlay"
          role="presentation"
          onClick={() => setFoxPaidDatesWeeklyOptOutSuccessOpen(false)}
        >
          <div
            className="user-menu-match-removal-confirm cart-popup vibe-popup"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="fox-paid-dates-weekly-opt-out-success-title"
          >
            <button
              type="button"
              className="cart-popup-close"
              onClick={() => setFoxPaidDatesWeeklyOptOutSuccessOpen(false)}
              aria-label="Close"
            >
              ×
            </button>
            <h3 id="fox-paid-dates-weekly-opt-out-success-title" className="match-explainer-title user-menu-match-removal-confirm-title">
              WEEKLY FEATURED
            </h3>
            <p className="vibe-popup-text">
              You&apos;re opted out! You can opt in anytime from this page.
            </p>
            <button
              type="button"
              className="vibe-popup-btn"
              onClick={() => setFoxPaidDatesWeeklyOptOutSuccessOpen(false)}
            >
              GOT IT
            </button>
          </div>
        </div>
      )}

      {sponsoredDateIdeaPopupOpen && (
        <div className="cart-popup-overlay vibe-popup-overlay sponsored-date-idea-popup-overlay" onClick={closeSponsoredDateIdeaPopup}>
          <div className="cart-popup vibe-popup sponsored-date-idea-popup" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="cart-popup-close" onClick={closeSponsoredDateIdeaPopup} aria-label="Close">&times;</button>
            {sponsoredDateIdeaSubmitted ? (
              currentUser ? (
                <>
                  <h3 className="cart-popup-title vibe-popup-dinner-title">THANK YOU</h3>
                  <p className="vibe-popup-text" style={{ margin: '0.75rem 0 1.5rem' }}>
                    We got your date idea. We&apos;ll reach out if we sponsor it for Fox-Paid Dates.
                  </p>
                  <button type="button" className="vibe-popup-btn" onClick={closeSponsoredDateIdeaPopup}>
                    Got it
                  </button>
                </>
              ) : (
                <>
                  <h3 className="cart-popup-title vibe-popup-dinner-title">THANK YOU</h3>
                  <p className="vibe-popup-text" style={{ margin: '0.75rem 0 1.5rem' }}>
                    {SPONSORED_DATE_IDEA_SIGNUP_MESSAGE}
                  </p>
                  <button
                    type="button"
                    className="vibe-popup-btn"
                    onClick={() => {
                      closeSponsoredDateIdeaPopup();
                      onShowSignUp?.(SPONSORED_DATE_IDEA_SIGNUP_MESSAGE, 'feed');
                    }}
                  >
                    SIGN UP
                  </button>
                </>
              )
            ) : (
              <>
                <h3 className="cart-popup-title vibe-popup-dinner-title">SUBMIT A DATE IDEA</h3>
                <p className="vibe-popup-text sponsored-date-idea-popup-lead">
                  Tell us a spot you love. If we pick it, we&apos;ll sponsor it as a Fox-Paid Date experience.
                </p>
                <form
                  className="sponsored-date-idea-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSponsoredDateIdeaSubmit();
                  }}
                >
                  <label className="sponsored-date-idea-label" htmlFor="sponsored-date-idea-place">
                    Place
                  </label>
                  <input
                    id="sponsored-date-idea-place"
                    type="text"
                    className="sponsored-date-idea-input"
                    placeholder="e.g. Lake Merritt, Oakland"
                    value={sponsoredDateIdeaPlace}
                    onChange={(e) => {
                      setSponsoredDateIdeaPlace(e.target.value);
                      if (sponsoredDateIdeaError) setSponsoredDateIdeaError('');
                    }}
                    disabled={sponsoredDateIdeaSubmitting}
                  />
                  {sponsoredDateIdeaPlacePhotoTiles.length > 0 && (
                    <div className="sponsored-date-idea-place-photos" aria-live="polite">
                      <p className="sponsored-date-idea-place-photos-hint">Place photo (optional)</p>
                        <div className="sponsored-date-idea-place-photos-grid">
                          {sponsoredDateIdeaPlacePhotoTiles.map(({ place, key, isSelected }) => (
                            <button
                              key={key}
                              type="button"
                              className={`sponsored-date-idea-place-photo-btn${isSelected ? ' sponsored-date-idea-place-photo-btn--selected' : ''}`}
                              onClick={() => {
                                setSponsoredDateIdeaSelectedPlace(isSelected ? null : place);
                              }}
                              aria-label={place.name || 'Select place'}
                              aria-pressed={isSelected}
                            >
                              <img
                                src={place.imageUrl}
                                alt={place.name || ''}
                                className="sponsored-date-idea-place-photo-img"
                              />
                            </button>
                          ))}
                        </div>
                    </div>
                  )}
                  <label className="sponsored-date-idea-label" htmlFor="sponsored-date-idea-highlights">
                    Highlights
                  </label>
                  <textarea
                    id="sponsored-date-idea-highlights"
                    className="sponsored-date-idea-textarea"
                    placeholder="What makes this spot special?"
                    rows={3}
                    value={sponsoredDateIdeaHighlights}
                    onChange={(e) => {
                      setSponsoredDateIdeaHighlights(e.target.value);
                      if (sponsoredDateIdeaError) setSponsoredDateIdeaError('');
                    }}
                    disabled={sponsoredDateIdeaSubmitting}
                  />
                  <label className="sponsored-date-idea-label" htmlFor="sponsored-date-idea-what-to-do">
                    What to get / do
                  </label>
                  <textarea
                    id="sponsored-date-idea-what-to-do"
                    className="sponsored-date-idea-textarea"
                    placeholder="e.g. rent paddle boats, grab ice cream after"
                    rows={3}
                    value={sponsoredDateIdeaWhatToDo}
                    onChange={(e) => {
                      setSponsoredDateIdeaWhatToDo(e.target.value);
                      if (sponsoredDateIdeaError) setSponsoredDateIdeaError('');
                    }}
                    disabled={sponsoredDateIdeaSubmitting}
                  />
                  {sponsoredDateIdeaError && (
                    <p className="sponsored-date-idea-error">{sponsoredDateIdeaError}</p>
                  )}
                  <div className="post-confirm-actions">
                    <button
                      type="button"
                      className="post-confirm-cancel"
                      onClick={closeSponsoredDateIdeaPopup}
                      disabled={sponsoredDateIdeaSubmitting}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="post-confirm-confirm" disabled={sponsoredDateIdeaSubmitting}>
                      {sponsoredDateIdeaSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}

      {/* Success popup (luv.wtf post or IRL confirm) */}
      {successPopupMessage && (
        <div className="cart-popup-overlay" onClick={() => setSuccessPopupMessage(null)}>
          <div className="cart-popup success-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setSuccessPopupMessage(null)} aria-label="Close">×</button>
            <p className="cart-popup-message success-popup-message" style={{ margin: '1rem 0' }}>
              {successPopupMessage}
            </p>
            <button type="button" className="cart-popup-confirm" onClick={() => setSuccessPopupMessage(null)}>
              OK
            </button>
          </div>
        </div>
      )}

      {/* Nickname already exists popup */}
      {showNicknameConflictPopup && (
        <div className="cart-popup-overlay" onClick={() => setShowNicknameConflictPopup(false)}>
          <div className="cart-popup nickname-conflict-popup" onClick={(e) => e.stopPropagation()}>
            <button className="cart-popup-close" onClick={() => setShowNicknameConflictPopup(false)} aria-label="Close">×</button>
            <h3 className="cart-popup-title">Nickname already exists</h3>
            <p className="cart-popup-message">
              This nickname already exists, please select a new nickname.
            </p>
            <p className="cart-popup-message nickname-conflict-suggested">
              E.g.: <button type="button" className="nickname-conflict-suggested-value nickname-conflict-suggested-clickable" onClick={() => { setEditedPosterNickname(suggestedNicknameInPopup); setShowNicknameConflictPopup(false); }}>&quot;{suggestedNicknameInPopup}&quot;</button>
            </p>
            <button type="button" className="cart-popup-confirm" onClick={() => setShowNicknameConflictPopup(false)}>
              OK
            </button>
          </div>
        </div>
      )}
      
      {showDatingQuestions && (
        <DatingChatBot
          isOpen={showDatingQuestions}
          onClose={() => setShowDatingQuestions(false)}
          userDescription={selectedEmojis.map(emoji => emoji.emoji).join(' ')}
          onSaveConversation={handleSaveConversation}
          currentUser={currentUser}
          onOpenSignUp={(hint) => onShowSignUp(hint, 'feed')}
        />
      )}

      {showPartnerSelection && (
        <PartnerSelectionChat
          isOpen={showPartnerSelection}
          onClose={handleClosePartnerSelection}
          generatedImages={generatedImagesList}
          onPartnerSelected={handlePartnerSelected}
          currentUser={currentUser}
        />
      )}

      <PartnerGenerationChat
        isOpen={showPartnerGenerationChat}
        onClose={() => setShowPartnerGenerationChat(false)}
        onComplete={handlePartnerGenerationComplete}
        generatedImage={partnerGenerationImage}
      />

      {showPersonalityChart && (
        <PersonalityChart
          dominantPersonality={feedPersonalityView ? feedPersonalityView.dominantPersonality : jungianPersonality}
          onDominantChange={feedPersonalityView ? undefined : setJungianPersonality}
          answers={surveyAnswers || {}}
          words={selectedWords || []}
          titleDescriptor={feedPersonalityView ? feedPersonalityView.nickname : (editedPosterNickname !== null && editedPosterNickname !== undefined ? editedPosterNickname : (posterNickname ?? 'The One'))}
          onTitleDescriptorChange={feedPersonalityView ? undefined : (val) => setEditedPosterNickname(val == null ? null : val)}
          wordFromJungianAfterConfirm={chartOpenedFromSurvey && !feedPersonalityView}
          hidePersonalityRing={chartHideRing}
          generatedWordReady={generatedWordReadyForPopup}
          onPersonalityConfirmed={() => {
            if (personalityPickStartedRef.current || generatedWordReadyForPopup) {
              setPersonalityConfirmed(true);
              return;
            }
            personalityPickStartedRef.current = true;
            setPersonalityConfirmed(true);
            const minDelayMs = 1000;
            const descriptorPromise = surveyDescriptorPromiseRef.current
              || Promise.resolve(getRandomWord());
            Promise.all([
              new Promise((r) => setTimeout(r, minDelayMs)),
              descriptorPromise,
            ]).then(([, descriptor]) => {
              setEditedPosterNickname(descriptor && String(descriptor).trim() ? descriptor : getRandomWord());
              setGeneratedWordReadyForPopup(true);
              personalityPickStartedRef.current = false;
            });
          }}
          onClose={() => {
            if (chartOpenedFromSurvey && !feedPersonalityView) {
              if (personalityPickStartedRef.current) {
                return;
              }
              if (generatedWordReadyForPopup) {
                setShowPersonalityChart(false);
                setChartOpenedFromSurvey(false);
                setChartHideRing(false);
                setFeedPersonalityView(null);
                setGeneratedWordReadyForPopup(false);
                setHasClosedPersonalityChartOnce(true);
                return;
              }
              setPersonalityConfirmed(true);
              setChartOpenedFromSurvey(false);
              setChartHideRing(false);
              setShowPersonalityChart(false);
              setFeedPersonalityView(null);
              setGeneratedWordReadyForPopup(false);
              setHasClosedPersonalityChartOnce(true);
              setPickingWord(true);
              const minDelayMs = 1000;
              const descriptorPromise = surveyDescriptorPromiseRef.current
                || Promise.resolve(getRandomWord());
              Promise.all([
                new Promise((r) => setTimeout(r, minDelayMs)),
                descriptorPromise,
              ]).then(([, descriptor]) => {
                setEditedPosterNickname(descriptor && String(descriptor).trim() ? descriptor : 'The One');
                setPickingWord(false);
              });
            } else {
              // Verified profiles must confirm re-verification before an age change sticks.
              // Friend collages edit the friend's age, not the user's — no re-verify there.
              if (
                berkeleyEmailVerified &&
                !friendCollageCopyActive &&
                typeof chartOpenSelfAgeRef.current === 'number' &&
                Number.isFinite(collageFinderSelfAge) &&
                collageFinderSelfAge !== chartOpenSelfAgeRef.current
              ) {
                setAgeReverifyConfirmOpen(true);
                return;
              }
              setShowPersonalityChart(false);
              setChartHideRing(false);
              setFeedPersonalityView(null);
              setGeneratedWordReadyForPopup(false);
            }
          }}
          onUpdateWords={feedPersonalityView ? undefined : (updatedWords) => {
            setSelectedWords(updatedWords);
            setShowPersonalityChart(false);
          }}
          collageFinderEnabled={!feedPersonalityView}
          finderSelfGender={collageFinderSelfGender}
          onFinderSelfGenderChange={setCollageFinderSelfGender}
          finderFriendLuv={collageFinderFriendLuv}
          finderRomanticLuv={collageFinderRomanticLuv}
          onFinderFriendLuvChange={setCollageFinderFriendLuv}
          onFinderRomanticLuvChange={(next) => {
            setCollageFinderRomanticLuv(next);
            if (!next) setCollageFinderLookingForGenders([]);
          }}
          finderLookingForGenders={collageFinderLookingForGenders}
          onFinderLookingForGendersChange={setCollageFinderLookingForGenders}
          finderSelfAge={collageFinderSelfAge}
          onFinderSelfAgeChange={setCollageFinderSelfAge}
          collageFriendFlow={!!friendCollageCopyActive && !feedPersonalityView}
        />
      )}

      {/* Feed tile detail popup: Posted by + user photo + Looking for + personality chart */}
      {feedTileDetailAd && (
        <div
          className="feed-tile-detail-overlay feed-tile-detail-overlay--feed"
          onClick={() => {
            setFeedTileDetailAd(null);
            setFeedTileDetailTitleOverride(null);
            setShowReachOutGifPicker(false);
            setReachOutGifSearch('');
            setReachOutSelectedGif(null);
            setReachOutSubmitted(false);
            setFeedShareLinkCopied(false);
            setShowReferOptions(false);
            setShowReferEmailInput(false);
            setReferFriendEmail('');
            setReferFriendEmailError('');
            setReferFriendSubmitted(false);
            setShowReferIgInput(false);
            setReferFriendIg('');
            setReferFriendIgError('');
            setReferFriendIgSubmitted(false);
            setFeedReferLinkCopied(false);
          }}
          role="dialog"
          aria-modal="true"
          aria-labelledby="feed-tile-detail-title"
        >
          <div
            className={`feed-tile-detail-popup feed-tile-detail-popup--feed${
              feedTileDetailTitleOverride && feedTileDetailAd.userId !== currentUser?.uid
                ? ' feed-tile-detail-popup--partner-primary'
                : ''
            }`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="feed-tile-detail-close"
              onClick={() => {
                setFeedTileDetailAd(null);
                setFeedTileDetailTitleOverride(null);
                setShowReachOutGifPicker(false);
                setReachOutGifSearch('');
                setReachOutSelectedGif(null);
                setReachOutSubmitted(false);
                setFeedShareLinkCopied(false);
                setShowReferOptions(false);
                setShowReferEmailInput(false);
                setReferFriendEmail('');
                setReferFriendEmailError('');
                setReferFriendSubmitted(false);
                setShowReferIgInput(false);
                setReferFriendIg('');
                setReferFriendIgError('');
                setReferFriendIgSubmitted(false);
                setFeedReferLinkCopied(false);
              }}
              aria-label="Close"
            >
              ×
            </button>
            {showReferOptions ? (
              <div className="shared-poster-apply-content">
                {showReferEmailInput ? (
                  <>
                    <button type="button" className="feed-tile-detail-back" onClick={() => { setShowReferEmailInput(false); setReferFriendEmail(''); setReferFriendEmailError(''); setReferFriendSubmitted(false); }} aria-label="Back">‹ Back</button>
                    <h2 className="feed-tile-detail-title">Enter your friend&apos;s email</h2>
                    <form
                      className="feed-tile-detail-apply-form"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const email = (referFriendEmail || '').trim().toLowerCase();
                        const emailErr = referFriendEmailValidationError(email);
                        if (emailErr) {
                          setReferFriendEmailError(emailErr);
                          return;
                        }
                        setReferFriendEmailError('');
                        try {
                          await addDoc(collection(db, 'referSubmissions'), {
                            posterId: feedTileDetailAd.id,
                            friendEmail: email,
                            createdAt: serverTimestamp(),
                            userId: currentUser?.uid || null,
                          });
                          setReferFriendSubmitted(true);
                          promptFeedMatchReferSignupIfNeeded();
                        } catch (err) {
                          console.error('Error saving refer submission:', err);
                          setReferFriendEmailError('Something went wrong. Please try again.');
                        }
                      }}
                    >
                      <input
                        type="email"
                        className="feed-tile-detail-apply-input"
                        placeholder="friend@example.com"
                        value={referFriendEmail}
                        onChange={(e) => { setReferFriendEmail(e.target.value); setReferFriendEmailError(''); }}
                        aria-label="Friend's email"
                        autoComplete="email"
                        disabled={referFriendSubmitted}
                      />
                      {referFriendEmailError && <p className="feed-tile-detail-apply-error" role="alert">{referFriendEmailError}</p>}
                      <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendSubmitted}>
                        {referFriendSubmitted ? 'Received!' : 'Send'}
                      </button>
                    </form>
                    {referFriendSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll send them an invite!</p>}
                  </>
                ) : showReferIgInput ? (
                  <>
                    <button type="button" className="feed-tile-detail-back" onClick={() => { setShowReferIgInput(false); setReferFriendIg(''); setReferFriendIgError(''); setReferFriendIgSubmitted(false); }} aria-label="Back">‹ Back</button>
                    <h2 className="feed-tile-detail-title">Enter their IG handle</h2>
                    <form
                      className="feed-tile-detail-apply-form"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const handle = (referFriendIg || '').trim().replace(/^@/, '');
                        if (!handle) {
                          setReferFriendIgError('Please enter an IG handle.');
                          return;
                        }
                        setReferFriendIgError('');
                        try {
                          await addDoc(collection(db, 'referSubmissions'), {
                            posterId: feedTileDetailAd.id,
                            friendIgHandle: handle,
                            createdAt: serverTimestamp(),
                            userId: currentUser?.uid || null,
                          });
                          setReferFriendIgSubmitted(true);
                          promptFeedMatchReferSignupIfNeeded();
                        } catch (err) {
                          console.error('Error saving refer submission:', err);
                          setReferFriendIgError('Something went wrong. Please try again.');
                        }
                      }}
                    >
                      <input
                        type="text"
                        className="feed-tile-detail-apply-input"
                        placeholder="@username"
                        value={referFriendIg}
                        onChange={(e) => { setReferFriendIg(e.target.value); setReferFriendIgError(''); }}
                        aria-label="Friend's IG handle"
                        autoComplete="off"
                        disabled={referFriendIgSubmitted}
                      />
                      {referFriendIgError && <p className="feed-tile-detail-apply-error" role="alert">{referFriendIgError}</p>}
                      <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendIgSubmitted}>
                        {referFriendIgSubmitted ? 'Received!' : 'Send'}
                      </button>
                    </form>
                    {referFriendIgSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll reach out to them!</p>}
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="feed-tile-detail-back"
                      onClick={() => {
                        setShowReferOptions(false);
                        setShowReferEmailInput(false);
                        setShowReferIgInput(false);
                        setReferFriendEmail('');
                        setReferFriendEmailError('');
                        setReferFriendSubmitted(false);
                        setReferFriendIg('');
                        setReferFriendIgError('');
                        setReferFriendIgSubmitted(false);
                        setFeedReferLinkCopied(false);
                      }}
                      aria-label="Back"
                    >
                      ‹ Back
                    </button>
                    <h2 id="feed-tile-detail-title" className="feed-tile-detail-title">
                      {`MATCH A FRIEND WITH ${feedAdCollageNickname(feedTileDetailAd)}`}
                    </h2>
                    <p className="feed-tile-detail-apply-prompt">
                      {(() => {
                        const bountyLine = matchFriendPromptBountyDollars(feedTileDetailAd);
                        if (bountyLine) {
                          return (
                            <>
                              Match a friend - get {bountyLine}. We&apos;ll send them an invite to join.
                            </>
                          );
                        }
                        return <>We&apos;ll send them an invite to join.</>;
                      })()}
                    </p>
                    <div className="shared-poster-refer-options">
                      <button
                        type="button"
                        className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                        onClick={() => setShowReferEmailInput(true)}
                      >
                        Enter your friend&apos;s email
                      </button>
                      <button
                        type="button"
                        className="feed-tile-detail-btn feed-tile-detail-btn-ig"
                        onClick={() => setShowReferIgInput(true)}
                      >
                        Enter their IG handle
                      </button>
                      <button
                        type="button"
                        className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                        onClick={async () => {
                          try {
                            // Signed-out sharers of a weekly featured poster get the short slot link
                            // (luv.wtf/1 …); signed-in users keep unique /poster/:id?ref= links.
                            const weeklyFeaturedSlot = !currentUser
                              ? weeklyFeaturedSlotByAdId.get(feedTileDetailAd.id)
                              : undefined;
                            const link = weeklyFeaturedSlot
                              ? buildWeeklyFeaturedSlotUrl(window.location.origin, weeklyFeaturedSlot)
                              : buildPosterShareUrl(
                                  window.location.origin,
                                  feedTileDetailAd.id,
                                  currentUser?.uid,
                                );
                            await navigator.clipboard.writeText(link);
                            setFeedReferLinkCopied(true);
                            promptFeedMatchReferSignupIfNeeded();
                          } catch {
                            setFeedReferLinkCopied(true);
                            promptFeedMatchReferSignupIfNeeded();
                          }
                        }}
                      >
                        {feedReferLinkCopied ? 'Link copied!' : 'Share link'}
                      </button>
                    </div>
                  </>
                )}
              </div>
            ) : showReachOutGifPicker ? (
              <>
                {reachOutSubmitted ? (
                  <>
                    <button
                      type="button"
                      className="feed-tile-detail-back"
                      onClick={() => {
                        setShowReachOutGifPicker(false);
                        setReachOutSubmitted(false);
                        setReachOutSelectedGif(null);
                        setReachOutGifSearch('');
                      }}
                      aria-label="Back"
                    >
                      ‹ Back
                    </button>
                    <p className="feed-tile-detail-thank-you">GIF sent!</p>
                  </>
                ) : reachOutSelectedGif ? (
                  <>
                    <button
                      type="button"
                      className="feed-tile-detail-back"
                      onClick={() => setReachOutSelectedGif(null)}
                      aria-label="Back"
                    >
                      ‹ Back
                    </button>
                    <h2 id="feed-tile-detail-title" className="feed-tile-detail-title">
                      {`SAY HELLO TO ${feedAdCollageNickname(feedTileDetailAd)}!`}
                    </h2>
                    <div className="reach-out-gif-preview">
                      <img
                        src={reachOutSelectedGif.fullUrl || reachOutSelectedGif.gifUrl}
                        alt={reachOutSelectedGif.title}
                        className="reach-out-gif-preview-img"
                      />
                    </div>
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                      disabled={reachOutSubmitting}
                      onClick={async () => {
                        const targetUid = feedTileDetailAd.userId;
                        if (!targetUid) {
                          console.error('Cannot reach out: poster has no userId');
                          return;
                        }
                        if (!currentUser) {
                          if (onShowSignUp) onShowSignUp(null, 'feed');
                          return;
                        }
                        if (!(await ensureBerkeleyEmailAccess())) return;
                        setReachOutSubmitting(true);
                        try {
                          const gifUrl = reachOutSelectedGif.fullUrl || reachOutSelectedGif.gifUrl;
                          const senderNickname = mainPrivateMatchPosterNickname
                            || (currentUser?.displayName && String(currentUser.displayName).trim())
                            || 'Someone';
                          const targetNickname = feedTileDetailAd.posterNickname || 'Someone';
                          const conversationId = await getOrCreateConversation(
                            currentUser,
                            targetUid,
                            { senderDisplayName: senderNickname, targetDisplayName: targetNickname },
                          );
                          await sendMessage(conversationId, currentUser.uid, '', { gifUrl });

                          setFeedTileDetailAd(null);
                          setFeedTileDetailTitleOverride(null);
                          setShowReachOutGifPicker(false);
                          setReachOutSelectedGif(null);
                          setReachOutGifSearch('');
                          setReachOutSubmitted(false);

                          setInboxInitialConversationId(conversationId);
                          setShowMessagesPopup(true);
                        } catch (err) {
                          console.error('Error sending reach-out GIF:', err);
                        } finally {
                          setReachOutSubmitting(false);
                        }
                      }}
                    >
                      {reachOutSubmitting ? 'Sending…' : 'SEND'}
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      className="feed-tile-detail-back"
                      onClick={() => {
                        setShowReachOutGifPicker(false);
                        setReachOutGifSearch('');
                      }}
                      aria-label="Back"
                    >
                      ‹ Back
                    </button>
                    <h2 id="feed-tile-detail-title" className="feed-tile-detail-title">
                      {`SAY HELLO TO ${feedAdCollageNickname(feedTileDetailAd)}!`}
                    </h2>
                    <p className="feed-tile-detail-apply-prompt">Pick a GIF to introduce yourself</p>
                    <div className="heart-gif-picker">
                      <div className="reach-out-gif-grid-scroll" ref={reachOutGifGridScrollRef}>
                        <div className="heart-gif-grid">
                          {(loadingReachOutGifs && reachOutGifs.length === 0
                            ? Array.from({ length: 9 }, (_, i) => ({ id: `ph-${i}`, placeholder: true }))
                            : reachOutGifs
                          ).map((gif) => {
                            if (gif.placeholder) {
                              return <div key={gif.id} className="heart-gif-tile heart-gif-placeholder" />;
                            }
                            return (
                              <button
                                key={gif.id}
                                className="heart-gif-tile"
                                onClick={() => setReachOutSelectedGif(gif)}
                              >
                                <span className="heart-gif-spinner" />
                                <img
                                  src={gif.stillUrl || gif.gifUrl}
                                  alt={gif.title}
                                  className="heart-gif-tile-img"
                                  loading="lazy"
                                  onLoad={(e) => {
                                    e.target.parentElement.querySelector('.heart-gif-spinner')?.classList.add('hidden');
                                    if (gif.stillUrl && e.target.src !== gif.gifUrl) {
                                      e.target.src = gif.gifUrl;
                                    }
                                  }}
                                />
                              </button>
                            );
                          })}
                        </div>
                        {!currentUser ? (
                          <div className="reach-out-gif-signin-scroll-footer">
                            <p className="reach-out-gif-signin-hint">
                              sign in to load more GIFs
                            </p>
                            <button
                              type="button"
                              className="reach-out-gif-signin-btn"
                              onClick={() => onShowLoginPopup?.()}
                            >
                              SIGN IN
                            </button>
                          </div>
                        ) : null}
                      </div>
                      {currentUser ? (
                        <div className="heart-gif-search-wrap">
                        <input
                          type="text"
                          className="heart-gif-search-input"
                          placeholder="Search KLIPY GIFs..."
                          value={reachOutGifSearch}
                          onChange={(e) => setReachOutGifSearch(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && reachOutGifSearch.trim()) {
                              appendReachOutKlipyGifs(reachOutGifSearch.trim(), true);
                            }
                          }}
                        />
                        <button
                          type="button"
                          className="heart-gif-search-btn"
                          onClick={() => {
                            if (reachOutGifSearch.trim()) appendReachOutKlipyGifs(reachOutGifSearch.trim(), true);
                          }}
                          disabled={!reachOutGifSearch.trim() || loadingReachOutGifs}
                        >
                          SEARCH
                        </button>
                      </div>
                      ) : null}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <h2 id="feed-tile-detail-title" className="feed-tile-detail-title">
                  {feedTileDetailTitleOverride
                    || (feedTileDetailAd.feedSource === 'dinnerGiveaway'
                      ? `MEET ${(String(feedTileDetailAd.posterNickname ?? feedTileDetailAd.userName ?? 'Someone').trim() || 'Someone').toUpperCase()}`
                      : 'COLLAGE DETAILS')}
                </h2>
                <CollageDetailsLuvLegend
                  {...feedTileDetailFindLuvFlags(feedTileDetailAd, savedPosters, currentUser?.uid ?? null)}
                  lookingForGenders={lookingForGendersForFeedAd(
                    feedTileDetailAd,
                    savedPosters,
                    currentUser?.uid ?? null,
                  )}
                  auraColor={feedTileDetailAd?.auraColor}
                />
                <div className="collage-details-collage-wrapper feed-detail-collage-wrapper" aria-hidden="true">
                  <div className="wanted-poster wanted-poster-feed collage-details-poster">
                    <div className="poster-content">
                      <FeedNicknameTile
                        ad={feedTileDetailAd}
                        savedPosters={savedPosters}
                        currentUserId={currentUser?.uid ?? null}
                        findLuvFlags={feedTileDetailFindLuvFlags(feedTileDetailAd, savedPosters, currentUser?.uid ?? null)}
                        bountyAmount={feedTileDetailAd.bountyAmount}
                        showVibeAura
                      />
                      <div className="match-a-friend-collage">
                      <div className="collage-poster-area">
                        <div className="partner-swag-container">
                          <div className="partner-swag-left">
                            {(feedTileDetailAd.swags || []).length > 0 && (
                              <div className="swag-images-left">
                                {(feedTileDetailAd.swags || []).map((swag, swagIndex) => {
                                  const swagUrl = swag.imageUrl || swag;
                                  if (!swagUrl) return null;
                                  const seed = seedFromString(`${feedTileDetailAd.id}-swag-${swagIndex}`);
                                  const seedX = seedFromString(`${feedTileDetailAd.id}-swag-x-${swagIndex}`);
                                  const rotation = (seed * 30 - 15).toFixed(1);
                                  const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                                  return (
                                    <img
                                      key={swag.id || swagIndex}
                                      src={swagUrl}
                                      alt={swag.name || 'Brand'}
                                      className="swag-image"
                                      style={{
                                        transform: `rotate(${rotation}deg)`,
                                        marginLeft: `${horizontalOffset}px`
                                      }}
                                    />
                                  );
                                })}
                              </div>
                            )}
                          </div>
                          <div className="partner-swag-center">
                            <div className="partner-swag-center-stack">
                              {(() => {
                                const cutJagged = (() => {
                                  const v = 1 + Math.floor(seedFromString(`feed-cutout-${feedTileDetailAd.id}`) * 3);
                                  return v === 1 ? '' : ` partner-cutout-jagged-${v}`;
                                })();
                                const pinnedCutout = feedTileDetailCutoutSrcRef.current;
                                const cutoutSrc =
                                  (pinnedCutout?.id === feedTileDetailAd.id && pinnedCutout.src)
                                  || feedTileDetailAd.partnerCutout
                                  || (feedCutoutUrls && feedCutoutUrls[0])
                                  || null;
                                const savedMatch = savedPosters.find((p) => p.feedAdId === feedTileDetailAd.id || p.id === feedTileDetailAd.id);
                                const mergedForFriendPh = savedMatch
                                  ? {
                                    ...feedTileDetailAd,
                                    friendCollageShare:
                                      feedTileDetailAd.friendCollageShare ?? savedMatch.friendCollageShare,
                                    friendFoxMaskPlaceholder:
                                      feedTileDetailAd.friendFoxMaskPlaceholder
                                      ?? savedMatch.friendFoxMaskPlaceholder,
                                    surveyAnswers:
                                      feedTileDetailAd.surveyAnswers || savedMatch.surveyAnswers,
                                  }
                                  : feedTileDetailAd;
                                const {
                                  animatedSrc: spiritSrc,
                                  pauseOffCenter: spiritPauseOffCenter,
                                } = spiritOverlaySourcesFromAd(mergedForFriendPh, orheartImage);
                                if (showFriendFoxMaskPlaceholder(mergedForFriendPh) && feedTileDetailAd.partnerCutout) {
                                  return (
                                    <FriendFoxMaskPlaceholderCutout
                                      variant="feed"
                                      jaggedClassName={cutJagged}
                                      heartSrc={spiritSrc}
                                      animateHeart
                                      pauseHeartOffCenter={spiritPauseOffCenter}
                                      captureHeartStill
                                      heartClassName="partner-cutout-gif-overlay"
                                    />
                                  );
                                }
                                if (cutoutSrc) {
                                  return (
                                    <div className="final-partner-image-wrapper">
                                      <ReusedFeedImg
                                        src={cutoutSrc}
                                        alt=""
                                        className={`final-partner-image final-partner-image-feed${cutJagged}`}
                                      />
                                      <PartnerCutoutSpiritOverlay
                                        src={spiritSrc}
                                        animate
                                        pauseOffCenter={spiritPauseOffCenter}
                                        captureStill
                                        alt=""
                                        className="partner-cutout-gif-overlay"
                                      />
                                    </div>
                                  );
                                }
                                return (
                                  <div
                                    className={`final-partner-image final-partner-image-placeholder final-partner-image-feed${cutJagged}`}
                                  >
                                    {'\uD83D\uDC64'}
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                          <div className="partner-swag-right">
                            <div className="activities-emojis-right">
                              {[feedTileDetailAd.activityX, feedTileDetailAd.activityY, feedTileDetailAd.activityZ].filter(Boolean).map((label, i) => {
                                const seed = seedFromString(`${feedTileDetailAd.id}-act-${i}`);
                                const seedX = seedFromString(`${feedTileDetailAd.id}-act-x-${i}`);
                                const rotation = (seed * 30 - 15).toFixed(1);
                                const horizontalOffset = (seedX * 40 - 20).toFixed(1);
                                const hue = 32 + seed * 20;
                                const bgColor = `hsl(${hue.toFixed(0)}, 90%, 72%)`;
                                return (
                                  <div
                                    key={i}
                                    className="activity-tile-outer"
                                    style={{
                                      transform: `rotate(${rotation}deg)`,
                                      marginLeft: `${horizontalOffset}px`
                                    }}
                                  >
                                    <div
                                      className="activity-emoji-wrapper collage-activity-tile"
                                      style={{ background: bgColor }}
                                    >
                                      <div
                                        className="activity-emoji"
                                        style={{
                                          fontSize: `calc(${(2.5 + seed * 1.5).toFixed(4)} * var(--collage-details-activity-scale, 1) * 1rem)`,
                                        }}
                                      >
                                        {typeof label === 'string' ? label : (label?.emoji ?? label?.name ?? '')}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                        {feedTileDetailAd.places && feedTileDetailAd.places.length > 0 && (
                          <div className="collage-aspirations-row">
                            {[feedTileDetailAd.places.slice(0, Math.floor(seedFromString(`${feedTileDetailAd.id}-places-split`) * 2) + 1), feedTileDetailAd.places.slice(Math.floor(seedFromString(`${feedTileDetailAd.id}-places-split`) * 2) + 1)].map((rowPlaces, rowIdx) => (
                              rowPlaces.length > 0 && (
                                <div key={rowIdx} className="collage-places-row-inner">
                                  {rowPlaces.map((place, i) => (
                                    <div key={place.id || `${rowIdx}-${i}`} className="aspiration-tile-outer">
                                      <div className="collage-place-tile">
                                        <img src={place.imageUrl} alt={place.name} className="collage-place-img" />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )
                            ))}
                          </div>
                        )}
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                {(feedTileDetailAd.userId === currentUser?.uid || !feedTileDetailTitleOverride) && (
                  <div className="feed-tile-detail-actions">
                    {feedTileDetailAd.userId === currentUser?.uid ? (
                      <>
                        <button
                          type="button"
                          className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                          onClick={handleFeedTileShare}
                        >
                          {feedShareLinkCopied ? 'Link copied!' : 'Share'}
                        </button>
                        <button
                          type="button"
                          className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                          onClick={() => {
                            const ad = feedTileDetailAd;
                            setFeedTileDetailAd(null);
                            setFeedTileDetailTitleOverride(null);
                            setFeedShareLinkCopied(false);
                            handleLoadFeedPoster(ad);
                          }}
                        >
                          Edit
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                          onClick={async () => {
                            if (currentUser && !(await ensureBerkeleyEmailAccess())) return;
                            reachOutLocalBaseRef.current = getShuffledHelloGifsAll();
                            setReachOutGifs(mergeReachOutLocalThenKlipy(reachOutLocalBaseRef.current, []));
                            setReachOutGifSearch('');
                            setShowReachOutGifPicker(true);
                          }}
                        >
                          UNMASK
                        </button>
                        <button
                          type="button"
                          className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                          onClick={() => setShowReferOptions(true)}
                        >
                          MATCH A FRIEND
                        </button>
                      </>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {userMenuPrimaryReferPosterId && (
        <div
          className="feed-tile-detail-overlay"
          onClick={closeUserMenuPrimaryReferPopup}
          role="dialog"
          aria-modal="true"
          aria-labelledby="user-menu-primary-refer-title"
        >
          <div className="feed-tile-detail-popup feed-tile-detail-popup--feed" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="feed-tile-detail-close" onClick={closeUserMenuPrimaryReferPopup} aria-label="Close">
              ×
            </button>
            <div className="shared-poster-apply-content">
              {showReferEmailInput ? (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-back"
                    onClick={() => {
                      setShowReferEmailInput(false);
                      setReferFriendEmail('');
                      setReferFriendEmailError('');
                      setReferFriendSubmitted(false);
                    }}
                    aria-label="Back"
                  >
                    ‹ Back
                  </button>
                  <h2 id="user-menu-primary-refer-title" className="feed-tile-detail-title">
                    Enter your friend&apos;s email
                  </h2>
                  <form
                    className="feed-tile-detail-apply-form"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const email = (referFriendEmail || '').trim().toLowerCase();
                      const emailErr = referFriendEmailValidationError(email);
                      if (emailErr) {
                        setReferFriendEmailError(emailErr);
                        return;
                      }
                      setReferFriendEmailError('');
                      try {
                        await addDoc(collection(db, 'referSubmissions'), {
                          posterId: userMenuPrimaryReferPosterId,
                          friendEmail: email,
                          createdAt: serverTimestamp(),
                          userId: currentUser?.uid || null,
                        });
                        setReferFriendSubmitted(true);
                      } catch (err) {
                        console.error('Error saving refer submission:', err);
                        setReferFriendEmailError('Something went wrong. Please try again.');
                      }
                    }}
                  >
                    <input
                      type="email"
                      className="feed-tile-detail-apply-input"
                      placeholder="friend@example.com"
                      value={referFriendEmail}
                      onChange={(e) => {
                        setReferFriendEmail(e.target.value);
                        setReferFriendEmailError('');
                      }}
                      aria-label="Friend's email"
                      autoComplete="email"
                      disabled={referFriendSubmitted}
                    />
                    {referFriendEmailError && (
                      <p className="feed-tile-detail-apply-error" role="alert">
                        {referFriendEmailError}
                      </p>
                    )}
                    <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendSubmitted}>
                      {referFriendSubmitted ? 'Received!' : 'Send'}
                    </button>
                  </form>
                  {referFriendSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll send them an invite!</p>}
                </>
              ) : showReferIgInput ? (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-back"
                    onClick={() => {
                      setShowReferIgInput(false);
                      setReferFriendIg('');
                      setReferFriendIgError('');
                      setReferFriendIgSubmitted(false);
                    }}
                    aria-label="Back"
                  >
                    ‹ Back
                  </button>
                  <h2 id="user-menu-primary-refer-title" className="feed-tile-detail-title">
                    Enter their IG handle
                  </h2>
                  <form
                    className="feed-tile-detail-apply-form"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const handle = (referFriendIg || '').trim().replace(/^@/, '');
                      if (!handle) {
                        setReferFriendIgError('Please enter an IG handle.');
                        return;
                      }
                      setReferFriendIgError('');
                      try {
                        await addDoc(collection(db, 'referSubmissions'), {
                          posterId: userMenuPrimaryReferPosterId,
                          friendIgHandle: handle,
                          createdAt: serverTimestamp(),
                          userId: currentUser?.uid || null,
                        });
                        setReferFriendIgSubmitted(true);
                      } catch (err) {
                        console.error('Error saving refer submission:', err);
                        setReferFriendIgError('Something went wrong. Please try again.');
                      }
                    }}
                  >
                    <input
                      type="text"
                      className="feed-tile-detail-apply-input"
                      placeholder="@username"
                      value={referFriendIg}
                      onChange={(e) => {
                        setReferFriendIg(e.target.value);
                        setReferFriendIgError('');
                      }}
                      aria-label="Friend's IG handle"
                      autoComplete="off"
                      disabled={referFriendIgSubmitted}
                    />
                    {referFriendIgError && (
                      <p className="feed-tile-detail-apply-error" role="alert">
                        {referFriendIgError}
                      </p>
                    )}
                    <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendIgSubmitted}>
                      {referFriendIgSubmitted ? 'Received!' : 'Send'}
                    </button>
                  </form>
                  {referFriendIgSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll reach out to them!</p>}
                </>
              ) : (
                <>
                  <button type="button" className="feed-tile-detail-back" onClick={closeUserMenuPrimaryReferPopup} aria-label="Back">
                    ‹ Back
                  </button>
                  <h2 id="user-menu-primary-refer-title" className="feed-tile-detail-title">
                    SHARE YOUR LUV PACK
                  </h2>
                  <div className="shared-poster-refer-options">
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                      onClick={() => setShowReferEmailInput(true)}
                    >
                      Enter your friend&apos;s email
                    </button>
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-ig"
                      onClick={() => setShowReferIgInput(true)}
                    >
                      Enter their IG handle
                    </button>
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                      onClick={async () => {
                        try {
                          const posterId = userMenuPrimaryReferPosterId;
                          const link = `${window.location.origin}/poster/${posterId}?primaryShare=1`;
                          const copied = await copyToClipboard(link);
                          if (!copied) alert(`Link created! Copy it manually: ${link}`);
                          setFeedReferLinkCopied(true);
                          setTimeout(() => setFeedReferLinkCopied(false), 2000);
                        } catch {
                          setFeedReferLinkCopied(true);
                          setTimeout(() => setFeedReferLinkCopied(false), 2000);
                        }
                      }}
                    >
                      {feedReferLinkCopied ? 'Link copied!' : 'Share link'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {showFriendCollageReferPopup && (
        <div
          className="feed-tile-detail-overlay"
          onClick={closeFriendCollageReferPopupToRewards}
          role="dialog"
          aria-modal="true"
          aria-labelledby="friend-collage-refer-title"
        >
          <div className="feed-tile-detail-popup feed-tile-detail-popup--feed" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="feed-tile-detail-close" onClick={closeFriendCollageReferPopupToRewards} aria-label="Close">
              ×
            </button>
            <div className="shared-poster-apply-content">
              {friendCollageReferPhase === 'email' ? (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-back"
                    onClick={() => {
                      setFriendCollageReferPhase('menu');
                      setReferFriendEmail('');
                      setReferFriendEmailError('');
                      setReferFriendSubmitted(false);
                    }}
                    aria-label="Back"
                  >
                    ‹ Back
                  </button>
                  <h2 id="friend-collage-refer-title" className="feed-tile-detail-title">
                    Enter your friend&apos;s email
                  </h2>
                  <form
                    className="feed-tile-detail-apply-form"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const email = (referFriendEmail || '').trim().toLowerCase();
                      const emailErr = referFriendEmailValidationError(email);
                      if (emailErr) {
                        setReferFriendEmailError(emailErr);
                        return;
                      }
                      setReferFriendEmailError('');
                      const referPosterId = friendCollageReferPosterId || editingSavedPosterId;
                      try {
                        await addDoc(collection(db, 'referSubmissions'), {
                          posterId: referPosterId || null,
                          friendEmail: email,
                          createdAt: serverTimestamp(),
                          userId: currentUser?.uid || null,
                          source: 'friend_collage_editor',
                        });
                        if (currentUser?.uid && referPosterId) {
                          try {
                            await appendCollageForFriendContact(db, currentUser.uid, referPosterId, { friendEmail: email });
                          } catch (cfErr) {
                            console.error('collageForFriend email append:', cfErr);
                          }
                        }
                        setReferFriendSubmitted(true);
                      } catch (err) {
                        console.error('Error saving refer submission:', err);
                        setReferFriendEmailError('Something went wrong. Please try again.');
                      }
                    }}
                  >
                    <input
                      type="email"
                      className="feed-tile-detail-apply-input"
                      placeholder="friend@example.com"
                      value={referFriendEmail}
                      onChange={(e) => {
                        setReferFriendEmail(e.target.value);
                        setReferFriendEmailError('');
                      }}
                      aria-label="Friend's email"
                      autoComplete="email"
                      disabled={referFriendSubmitted}
                    />
                    {referFriendEmailError && (
                      <p className="feed-tile-detail-apply-error" role="alert">
                        {referFriendEmailError}
                      </p>
                    )}
                    <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendSubmitted}>
                      {referFriendSubmitted ? 'Received!' : 'Send'}
                    </button>
                  </form>
                  {referFriendSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll send them an invite!</p>}
                </>
              ) : friendCollageReferPhase === 'ig' ? (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-back"
                    onClick={() => {
                      setFriendCollageReferPhase('menu');
                      setReferFriendIg('');
                      setReferFriendIgError('');
                      setReferFriendIgSubmitted(false);
                    }}
                    aria-label="Back"
                  >
                    ‹ Back
                  </button>
                  <h2 id="friend-collage-refer-title" className="feed-tile-detail-title">
                    Enter their IG handle
                  </h2>
                  <form
                    className="feed-tile-detail-apply-form"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const handle = (referFriendIg || '').trim().replace(/^@/, '');
                      if (!handle) {
                        setReferFriendIgError('Please enter an IG handle.');
                        return;
                      }
                      setReferFriendIgError('');
                      const referPosterId = friendCollageReferPosterId || editingSavedPosterId;
                      try {
                        await addDoc(collection(db, 'referSubmissions'), {
                          posterId: referPosterId || null,
                          friendIgHandle: handle,
                          createdAt: serverTimestamp(),
                          userId: currentUser?.uid || null,
                          source: 'friend_collage_editor',
                        });
                        if (currentUser?.uid && referPosterId) {
                          try {
                            await appendCollageForFriendContact(db, currentUser.uid, referPosterId, { friendIgHandle: handle });
                          } catch (cfErr) {
                            console.error('collageForFriend IG append:', cfErr);
                          }
                        }
                        setReferFriendIgSubmitted(true);
                      } catch (err) {
                        console.error('Error saving refer submission:', err);
                        setReferFriendIgError('Something went wrong. Please try again.');
                      }
                    }}
                  >
                    <input
                      type="text"
                      className="feed-tile-detail-apply-input"
                      placeholder="@username"
                      value={referFriendIg}
                      onChange={(e) => {
                        setReferFriendIg(e.target.value);
                        setReferFriendIgError('');
                      }}
                      aria-label="Friend's IG handle"
                      autoComplete="off"
                      disabled={referFriendIgSubmitted}
                    />
                    {referFriendIgError && (
                      <p className="feed-tile-detail-apply-error" role="alert">
                        {referFriendIgError}
                      </p>
                    )}
                    <button type="submit" className="feed-tile-detail-btn feed-tile-detail-btn-apply" disabled={referFriendIgSubmitted}>
                      {referFriendIgSubmitted ? 'Received!' : 'Send'}
                    </button>
                  </form>
                  {referFriendIgSubmitted && <p className="feed-tile-detail-thank-you">We&apos;ll reach out to them!</p>}
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="feed-tile-detail-back"
                    onClick={backFriendCollageReferPopupToEditor}
                    aria-label="Back"
                  >
                    ‹ Back
                  </button>
                  <h2 id="friend-collage-refer-title" className="feed-tile-detail-title">
                    SHARE COLLAGE
                  </h2>
                  <p className="feed-tile-detail-apply-prompt">
                    {(() => {
                      const referPid = friendCollageReferPosterId || editingSavedPosterId;
                      const referPoster = (Array.isArray(savedPosters) ? savedPosters : []).find((p) => p.id === referPid);
                      const bountyLine = matchFriendPromptBountyDollars(referPoster);
                      if (bountyLine) {
                        return (
                          <>
                            Match a friend - get {bountyLine}. We&apos;ll send them an invite to join.
                          </>
                        );
                      }
                      return <>We&apos;ll send them an invite to join.</>;
                    })()}
                  </p>
                  <div className="shared-poster-refer-options">
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-apply"
                      onClick={() => {
                        const invite = collageFriendInviteEmail && String(collageFriendInviteEmail).trim();
                        setReferFriendEmail((prev) => (String(prev || '').trim() ? prev : invite || ''));
                        setFriendCollageReferPhase('email');
                      }}
                    >
                      Enter your friend&apos;s email
                    </button>
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-ig"
                      onClick={() => setFriendCollageReferPhase('ig')}
                    >
                      Enter their IG handle
                    </button>
                    <button
                      type="button"
                      className="feed-tile-detail-btn feed-tile-detail-btn-refer"
                      onClick={async () => {
                        const referPosterId = friendCollageReferPosterId || editingSavedPosterId;
                        if (!referPosterId) {
                          window.alert('Save your collage first to get a shareable link.');
                          return;
                        }
                        const link = `${window.location.origin}/poster/${referPosterId}`;
                        try {
                          const copied = await copyToClipboard(link);
                          if (!copied) window.alert(`Copy this link: ${link}`);
                          setFriendCollageReferLinkCopied(true);
                          setTimeout(() => setFriendCollageReferLinkCopied(false), 2000);
                        } catch {
                          setFriendCollageReferLinkCopied(true);
                          setTimeout(() => setFriendCollageReferLinkCopied(false), 2000);
                        }
                      }}
                    >
                      {friendCollageReferLinkCopied ? 'Link copied!' : 'Share link'}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default HomePage; 